
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3j1mV", function(module, exports) {

$parcel$export(module.exports, "useConfluencePageAri", () => $4fb0a6929b7f9ec7$export$baf23e7d4a1078c1);

var $gwFzn = parcelRequire("gwFzn");

var $ayhth = parcelRequire("ayhth");
var $ixUm0 = parcelRequire("ixUm0");
var $iILKK = parcelRequire("iILKK");
const $4fb0a6929b7f9ec7$export$baf23e7d4a1078c1 = (siteId, contentId, contentType)=>{
    const pageAri = (0, $gwFzn.useMemo)(()=>{
        try {
            switch(contentType){
                case 'page':
                    return (0, $ixUm0.ConfluencePageAri).create({
                        siteId: siteId,
                        pageId: contentId
                    }).toString();
                case 'blogpost':
                    return (0, $ayhth.ConfluenceBlogpostAri).create({
                        siteId: siteId,
                        blogpostId: contentId
                    }).toString();
                case 'whiteboard':
                    return (0, $iILKK.ConfluenceWhiteboardAri).create({
                        siteId: siteId,
                        whiteboardId: contentId
                    }).toString();
            }
        } catch  {
            return null;
        }
    }, [
        contentType,
        siteId,
        contentId
    ]);
    return {
        pageAri: pageAri
    };
};

});

parcelRegister("kAaxz", function(module, exports) {

$parcel$export(module.exports, "ConvoAIResponseState", () => $a6056237f8f2f3cc$export$5ad15ff4d6b74b3f);
$parcel$export(module.exports, "getDefaultConvoAIStreamingState", () => $a6056237f8f2f3cc$export$c25f824513be9f8a);
var $a6056237f8f2f3cc$export$5ad15ff4d6b74b3f = /*#__PURE__*/ function(ConvoAIResponseState) {
    ConvoAIResponseState["Initialization"] = "Initialization";
    ConvoAIResponseState["ChannelId"] = "ChannelId";
    ConvoAIResponseState["AnswerPart"] = "AnswerPart";
    ConvoAIResponseState["FinalResponse"] = "FinalResponse";
    ConvoAIResponseState["FollowUp"] = "FollowUp";
    ConvoAIResponseState["Error"] = "Error";
    return ConvoAIResponseState;
}({});
function $a6056237f8f2f3cc$export$c25f824513be9f8a() {
    return {
        content: null,
        responseState: "Initialization"
    };
}

});

parcelRegister("d3UlG", function(module, exports) {

$parcel$export(module.exports, "useConvoAIStreaming", () => $d7c3e272b37735b1$export$d6e2ae1e990d7e71);

var $gwFzn = parcelRequire("gwFzn");

var $3CH4j = parcelRequire("3CH4j");

var $iIEgX = parcelRequire("iIEgX");
var $6yCLg = parcelRequire("6yCLg");

var $cPtvM = parcelRequire("cPtvM");

var $kAaxz = parcelRequire("kAaxz");
function $d7c3e272b37735b1$export$d6e2ae1e990d7e71(request, config, onStateChange) {
    const refetchId = (0, $gwFzn.useRef)(crypto.randomUUID());
    const [state, setState] = (0, $6yCLg.useStatefulObservableEffect)((0, $cPtvM.convoAIStreamingEffect), (0, $kAaxz.getDefaultConvoAIStreamingState)(), [
        request,
        config,
        refetchId.current
    ]);
    (0, $iIEgX.useObservableEffect)((input$)=>input$.pipe((0, $3CH4j.tap)(([nextState, onStateChangeCalback])=>onStateChangeCalback?.(nextState))), [
        state,
        onStateChange
    ]);
    const refetch = (0, $gwFzn.useCallback)(()=>{
        refetchId.current = crypto.randomUUID();
        setState({
            inputs: [
                request,
                config,
                refetchId.current
            ],
            state: (0, $kAaxz.getDefaultConvoAIStreamingState)()
        });
    }, [
        request,
        config,
        setState
    ]);
    return [
        state,
        refetch
    ];
}

});
parcelRegister("iIEgX", function(module, exports) {

$parcel$export(module.exports, "useObservableEffect", () => $5805e7f3f1b14b04$export$42102e336cc49836);

var $gwFzn = parcelRequire("gwFzn");

var $cC77I = parcelRequire("cC77I");
function $5805e7f3f1b14b04$export$42102e336cc49836(onObservableInit, inputs) {
    const [inputSubject$] = (0, $gwFzn.useState)(()=>new (0, $cC77I.Subject)());
    const [observable$] = (0, $gwFzn.useState)(()=>onObservableInit(inputSubject$));
    (0, $gwFzn.useEffect)(()=>{
        const subscription$ = observable$.subscribe();
        return ()=>{
            subscription$.unsubscribe();
        };
    }, [
        observable$
    ]);
    const callback = (0, $gwFzn.useCallback)((nextState)=>inputSubject$.next(nextState), [
        inputSubject$
    ]);
    (0, $gwFzn.useEffect)(()=>{
        inputSubject$.next(inputs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, inputs);
    return [
        callback
    ];
}

});

parcelRegister("6yCLg", function(module, exports) {

$parcel$export(module.exports, "useStatefulObservableEffect", () => $725c584c19c66c44$export$916f6bbdfa1987d0);

var $gwFzn = parcelRequire("gwFzn");

var $aXpOY = parcelRequire("aXpOY");
function $725c584c19c66c44$export$916f6bbdfa1987d0(onObservableInit, initialState, inputs) {
    const [state, callback] = (0, $aXpOY.useStatefulObservableLazyEffect)(onObservableInit, initialState);
    (0, $gwFzn.useEffect)(()=>{
        callback({
            inputs: inputs,
            state: initialState
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, inputs);
    return [
        state,
        callback
    ];
}

});
parcelRegister("aXpOY", function(module, exports) {

$parcel$export(module.exports, "useStatefulObservableLazyEffect", () => $e8269ad00759219d$export$7e63706be514842f);

var $gwFzn = parcelRequire("gwFzn");

var $eH9u1 = parcelRequire("eH9u1");

var $cC77I = parcelRequire("cC77I");
function $e8269ad00759219d$export$7e63706be514842f(onObservableInit, initialState) {
    const [inputSubject$] = (0, $gwFzn.useState)(()=>new (0, $cC77I.Subject)());
    const [observable$] = (0, $gwFzn.useState)(()=>onObservableInit(inputSubject$));
    const stateSnapshot = (0, $gwFzn.useRef)(initialState);
    const subscribe = (0, $gwFzn.useCallback)((handleStoreChange)=>{
        const subscription = observable$.subscribe({
            next: (nextState)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($eH9u1)))(nextState, stateSnapshot.current)) {
                    stateSnapshot.current = nextState;
                    handleStoreChange();
                }
            },
            // eslint-disable-next-line no-console
            error: (err)=>console.error(err),
            complete: ()=>inputSubject$.complete()
        });
        return ()=>subscription.unsubscribe();
    }, [
        inputSubject$,
        observable$
    ]);
    const getSnapshot = (0, $gwFzn.useCallback)(()=>{
        return stateSnapshot.current;
    }, [
        stateSnapshot
    ]);
    const callback = (0, $gwFzn.useCallback)((nextState)=>{
        inputSubject$.next(nextState);
    }, [
        inputSubject$
    ]);
    const state = (0, $gwFzn.useSyncExternalStore)(subscribe, getSnapshot);
    return [
        state,
        callback
    ];
}

});


parcelRegister("cPtvM", function(module, exports) {

$parcel$export(module.exports, "convoAIStreamingEffect", () => $00c22fcadb546387$export$a0d56a856e9914d2);

var $eH9u1 = parcelRequire("eH9u1");

var $guQFZ = parcelRequire("guQFZ");

var $2C39U = parcelRequire("2C39U");

var $eJ5lO = parcelRequire("eJ5lO");

var $4iZtC = parcelRequire("4iZtC");

var $7CiAC = parcelRequire("7CiAC");

var $2HUA6 = parcelRequire("2HUA6");

var $eByKY = parcelRequire("eByKY");

var $69nRD = parcelRequire("69nRD");

var $kkxph = parcelRequire("kkxph");

var $8EEqM = parcelRequire("8EEqM");

var $bTavj = parcelRequire("bTavj");

var $93WqG = parcelRequire("93WqG");

var $bmfL4 = parcelRequire("bmfL4");

var $i66k0 = parcelRequire("i66k0");

var $LzBwp = parcelRequire("LzBwp");

var $2864f = parcelRequire("2864f");

var $aOfhe = parcelRequire("aOfhe");

var $kAaxz = parcelRequire("kAaxz");
function $00c22fcadb546387$export$a0d56a856e9914d2(input$) {
    return input$.pipe((0, $69nRD.skipWhile)(({ inputs: [_, { skip: skip }] })=>!!skip), (0, $7CiAC.distinctUntilChanged)(({ inputs: [prevRequest, prevConfig, prevRefetchId] }, { inputs: [nextRequest, nextConfig, nextRefetchId] })=>(0, (/*@__PURE__*/$parcel$interopDefault($eH9u1)))(prevRequest, nextRequest) && (0, (/*@__PURE__*/$parcel$interopDefault($eH9u1)))(prevConfig, nextConfig) && prevRefetchId === nextRefetchId), (0, $eByKY.map)(({ inputs: [request, config] })=>({
            config: (0, $i66k0.getDefaultConvoAIConfigWithUserSettings)(config),
            request: request
        })), (0, $eByKY.map)(({ request: request, config: config })=>({
            requestConfig: (0, $bmfL4.createConvoAIRequestConfig)(request, config),
            config: config
        })), (0, $kkxph.switchMap)(({ requestConfig: requestConfig, config: config })=>{
        (0, $aOfhe.logConvoAIInfo)('pre request data', config, requestConfig);
        let $request = (0, $LzBwp.makeConvoAIStreamRequest)(requestConfig);
        if (config.timeoutDelay) return $request.pipe((0, $bTavj.timeout)(config.timeoutDelay), (0, $eByKY.map)((state)=>({
                config: config,
                state: state
            })));
        return $request.pipe((0, $eByKY.map)((state)=>({
                config: config,
                state: state
            })));
    }))// pipe() has an apparent limit of 9 operators
    // https://github.com/ReactiveX/rxjs/issues/4221#issuecomment-426774631
    .pipe((0, $2HUA6.filter)(({ config: config, state: state })=>!(!config.enableFollowUp && state.responseState === (0, $kAaxz.ConvoAIResponseState).FollowUp)), (0, $eByKY.map)(({ config: config, state: state })=>{
        (0, $aOfhe.logConvoAIInfo)('response data', config, state);
        const nextState = (0, $2864f.parsePartialConvoAIJsonIfNeeded)(state, config);
        (0, $aOfhe.logConvoAIInfo)('post json parsing content', config, state);
        return {
            state: nextState,
            config: config
        };
    }), (0, $8EEqM.timeInterval)(), (0, $eJ5lO.concatMap)(({ value: { state: state, config: config }, interval: interval })=>{
        if (!config.delayChunkUpdate) return (0, $guQFZ.of)(state);
        const { time: time, gap: gap } = config.delayChunkUpdate;
        if (interval < gap) return (0, $guQFZ.of)(state).pipe((0, $4iZtC.delay)(time));
        return (0, $guQFZ.of)(state);
    }), (0, $2C39U.catchError)((error)=>{
        if (error.name === 'TimeoutError') {
            const timeoutErrorState = {
                responseState: (0, $kAaxz.ConvoAIResponseState).Error,
                content: null,
                answerChunkIndex: undefined,
                error: {
                    type: 'ERROR',
                    message: {
                        content: error.message,
                        message_template: (0, $93WqG.ConvoAIErrorMessage).TIMEOUT,
                        status_code: (0, $93WqG.CONVOAI_DEFAULT_ERROR_CODE)
                    }
                }
            };
            return (0, $guQFZ.of)(timeoutErrorState);
        }
        const unexpectedErrorState = {
            responseState: (0, $kAaxz.ConvoAIResponseState).Error,
            content: null,
            error: {
                type: 'ERROR',
                message: {
                    content: error.message,
                    message_template: (0, $93WqG.ConvoAIErrorMessage).UNEXPECTED,
                    status_code: (0, $93WqG.CONVOAI_DEFAULT_ERROR_CODE)
                }
            }
        };
        return (0, $guQFZ.of)(unexpectedErrorState);
    }));
}

});
parcelRegister("93WqG", function(module, exports) {

$parcel$export(module.exports, "ConvoAIErrorMessage", () => $855f7e526aba7e75$export$cb6667e6b65615);
$parcel$export(module.exports, "CONVOAI_DEFAULT_ERROR_CODE", () => $855f7e526aba7e75$export$26a36d98cab4996b);
var $855f7e526aba7e75$export$cb6667e6b65615 = /*#__PURE__*/ function(ConvoAIErrorMessage) {
    ConvoAIErrorMessage["RATE_LIMIT"] = "RATE_LIMIT";
    ConvoAIErrorMessage["ANSWER_UNAVAILABLE_FOR_CONTENT"] = "ANSWER_UNAVAILABLE_FOR_CONTENT";
    ConvoAIErrorMessage["ACCEPTABLE_USE_VIOLATIONS"] = "ACCEPTABLE_USE_VIOLATIONS";
    ConvoAIErrorMessage["NOT_ENOUGH_CONTENT_ERROR"] = "NOT_ENOUGH_CONTENT_ERROR";
    ConvoAIErrorMessage["NOT_FOUND"] = "NOT_FOUND";
    ConvoAIErrorMessage["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
    ConvoAIErrorMessage["BAD_REQUEST"] = "BAD_REQUEST";
    ConvoAIErrorMessage["UNEXPECTED"] = "UNEXPECTED";
    ConvoAIErrorMessage["TIMEOUT"] = "TIMEOUT";
    return ConvoAIErrorMessage;
}({});
const $855f7e526aba7e75$export$26a36d98cab4996b = 0;

});

parcelRegister("bmfL4", function(module, exports) {

$parcel$export(module.exports, "createConvoAIRequestConfig", () => $616a3b6034357a30$export$39a530c281991f7b);
const $616a3b6034357a30$export$39a530c281991f7b = (request, config)=>{
    const requestInitParams = {
        method: 'POST',
        headers: new Headers({
            ...config.headers
        }),
        body: JSON.stringify(request)
    };
    return {
        requestInitParams: requestInitParams,
        url: `${config.baseUrl}/${config.apiPath}`
    };
};

});

parcelRegister("i66k0", function(module, exports) {

$parcel$export(module.exports, "getDefaultConvoAIConfigWithUserSettings", () => $7087f936648f12b4$export$98f0249d9632eade);

var $iQFRZ = parcelRequire("iQFRZ");

var $gyqrs = parcelRequire("gyqrs");
const $7087f936648f12b4$var$baseUrl = (0, $iQFRZ.Lens).fromNullableProp()('baseUrl', (0, $gyqrs.BASE_STREAM_URL));
const $7087f936648f12b4$var$enablePartialJson = (0, $iQFRZ.Lens).fromNullableProp()('enablePartialJson', false);
const $7087f936648f12b4$var$enableFollowUp = (0, $iQFRZ.Lens).fromNullableProp()('enableFollowUp', false);
const $7087f936648f12b4$var$enableLocalVerboseLogs = (0, $iQFRZ.Lens).fromNullableProp()('enableLocalVerboseLogs', false);
const $7087f936648f12b4$var$skip = (0, $iQFRZ.Lens).fromNullableProp()('skip', false);
const $7087f936648f12b4$var$contentType = (0, $iQFRZ.Lens).fromNullableProp()('content-type', 'application/json;charset=UTF-8');
const $7087f936648f12b4$var$xIssyntheticTraffic = (0, $iQFRZ.Lens).fromNullableProp()('x-issynthetic-traffic', 'false');
function $7087f936648f12b4$var$getHeaders(config) {
    const headers = {
        'content-type': $7087f936648f12b4$var$contentType.get(config.headers),
        'x-product': config.headers['x-product'],
        'x-experience-id': config.headers['x-experience-id'],
        'x-issynthetic-traffic': $7087f936648f12b4$var$xIssyntheticTraffic.get(config.headers)
    };
    if (config.headers['x-channel-id']) headers['x-channel-id'] = config.headers['x-channel-id'];
    return headers;
}
const $7087f936648f12b4$export$98f0249d9632eade = (config)=>({
        baseUrl: $7087f936648f12b4$var$baseUrl.get(config),
        apiPath: config.apiPath,
        enablePartialJson: $7087f936648f12b4$var$enablePartialJson.get(config),
        enableFollowUp: $7087f936648f12b4$var$enableFollowUp.get(config),
        enableLocalVerboseLogs: $7087f936648f12b4$var$enableLocalVerboseLogs.get(config),
        timeoutDelay: config.timeoutDelay,
        skip: $7087f936648f12b4$var$skip.get(config),
        headers: $7087f936648f12b4$var$getHeaders(config)
    });

});
parcelRegister("iQFRZ", function(module, exports) {

$parcel$export(module.exports, "Lens", () => Lens);
/**
 * @since 1.0.0
 */ 
var $cgdoB = parcelRequire("cgdoB");

var $fFgN5 = parcelRequire("fFgN5");

var $72EOc = parcelRequire("72EOc");

var $1Te5W = parcelRequire("1Te5W");

var $bxsNd = parcelRequire("bxsNd");

var $30crt = parcelRequire("30crt");

var $4O2fb = parcelRequire("4O2fb");

var $5kHfR = parcelRequire("5kHfR");

var $2oRqE = parcelRequire("2oRqE");

var $40vng = parcelRequire("40vng");

var $43LA8 = parcelRequire("43LA8");

var $ftUJ4 = parcelRequire("ftUJ4");

var $7NEBD = parcelRequire("7NEBD");
//
// compat
//
var fromIso = function(iso) {
    return new Iso(iso.get, iso.reverseGet);
};
var fromLens = function(lens) {
    return new Lens(lens.get, lens.set);
};
var fromPrism = function(prism) {
    return new Prism(prism.getOption, prism.reverseGet);
};
var fromOptional = function(optional) {
    return new Optional(optional.getOption, optional.set);
};
var fromTraversal = function(traversal) {
    return new Traversal(traversal.modifyF);
};
var fromAt = function(at) {
    return new At(function(i) {
        return fromLens(at.at(i));
    });
};
var fromIndex = function(ix) {
    return new Index(function(i) {
        return fromOptional(ix.index(i));
    });
};
//
// old APIs
//
var update = function(o, k, a) {
    var _a;
    return a === o[k] ? o : Object.assign({}, o, (_a = {}, _a[k] = a, _a));
};
/**
 * Laws:
 * 1. `reverseGet(get(s)) = s`
 * 2. `get(reversetGet(a)) = a`
 *
 * @category constructor
 * @since 1.0.0
 */ var Iso = /** @class */ function() {
    function Iso(get, reverseGet) {
        this.get = get;
        this.reverseGet = reverseGet;
        /**
         * @since 1.0.0
         */ this._tag = 'Iso';
        /**
         * @since 1.0.0
         */ this.unwrap = this.get;
        /**
         * @since 1.0.0
         */ this.to = this.get;
        /**
         * @since 1.0.0
         */ this.wrap = this.reverseGet;
        /**
         * @since 1.0.0
         */ this.from = this.reverseGet;
    }
    /**
     * reverse the `Iso`: the source becomes the target and the target becomes the source
     * @since 1.0.0
     */ Iso.prototype.reverse = function() {
        return fromIso($5kHfR.reverse(this));
    };
    /**
     * @since 1.0.0
     */ Iso.prototype.modify = function(f) {
        return $5kHfR.modify(f)(this);
    };
    /**
     * view an `Iso` as a `Lens`
     *
     * @since 1.0.0
     */ Iso.prototype.asLens = function() {
        return fromLens($5kHfR.asLens(this));
    };
    /**
     * view an `Iso` as a `Prism`
     *
     * @since 1.0.0
     */ Iso.prototype.asPrism = function() {
        return fromPrism($5kHfR.asPrism(this));
    };
    /**
     * view an `Iso` as a `Optional`
     *
     * @since 1.0.0
     */ Iso.prototype.asOptional = function() {
        return fromOptional($5kHfR.asOptional(this));
    };
    /**
     * view an `Iso` as a `Traversal`
     *
     * @since 1.0.0
     */ Iso.prototype.asTraversal = function() {
        return fromTraversal($5kHfR.asTraversal(this));
    };
    /**
     * view an `Iso` as a `Fold`
     *
     * @since 1.0.0
     */ Iso.prototype.asFold = function() {
        var _this = this;
        return new Fold(function() {
            return function(f) {
                return function(s) {
                    return f(_this.get(s));
                };
            };
        });
    };
    /**
     * view an `Iso` as a `Getter`
     *
     * @since 1.0.0
     */ Iso.prototype.asGetter = function() {
        var _this = this;
        return new Getter(function(s) {
            return _this.get(s);
        });
    };
    /**
     * view an `Iso` as a `Setter`
     *
     * @since 1.0.0
     */ Iso.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * compose an `Iso` with an `Iso`
     *
     * @since 1.0.0
     */ Iso.prototype.compose = function(ab) {
        return fromIso($5kHfR.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Iso.prototype.composeIso = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose an `Iso` with a `Lens `
     *
     * @since 1.0.0
     */ Iso.prototype.composeLens = function(ab) {
        return fromLens((0, $30crt.pipe)(this, $5kHfR.asLens, $40vng.compose(ab)));
    };
    /**
     * compose an `Iso` with a `Prism`
     *
     * @since 1.0.0
     */ Iso.prototype.composePrism = function(ab) {
        return fromPrism((0, $30crt.pipe)(this, $5kHfR.asPrism, $ftUJ4.compose(ab)));
    };
    /**
     * compose an `Iso` with an `Optional`
     *
     * @since 1.0.0
     */ Iso.prototype.composeOptional = function(ab) {
        return fromOptional((0, $30crt.pipe)(this, $5kHfR.asOptional, $43LA8.compose(ab)));
    };
    /**
     * compose an `Iso` with a `Traversal`
     *
     * @since 1.0.0
     */ Iso.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $30crt.pipe)(this, $5kHfR.asTraversal, $7NEBD.compose(ab)));
    };
    /**
     * compose an `Iso` with a `Fold`
     *
     * @since 1.0.0
     */ Iso.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose an `Iso` with a `Getter`
     *
     * @since 1.0.0
     */ Iso.prototype.composeGetter = function(ab) {
        return this.asGetter().compose(ab);
    };
    /**
     * compose an `Iso` with a `Setter`
     *
     * @since 1.0.0
     */ Iso.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    return Iso;
}();
/**
 * Laws:
 * 1. `get(set(a)(s)) = a`
 * 2. `set(get(s))(s) = s`
 * 3. `set(a)(set(a)(s)) = set(a)(s)`
 *
 * @category constructor
 * @since 1.0.0
 */ var Lens = /** @class */ function() {
    function Lens(get, set) {
        this.get = get;
        this.set = set;
        /**
         * @since 1.0.0
         */ this._tag = 'Lens';
    }
    /**
     * @example
     * import { Lens } from 'monocle-ts'
     *
     * type Person = {
     *   name: string
     *   age: number
     *   address: {
     *     city: string
     *   }
     * }
     *
     * const city = Lens.fromPath<Person>()(['address', 'city'])
     *
     * const person: Person = { name: 'Giulio', age: 43, address: { city: 'Milan' } }
     *
     * assert.strictEqual(city.get(person), 'Milan')
     * assert.deepStrictEqual(city.set('London')(person), { name: 'Giulio', age: 43, address: { city: 'London' } })
     *
     * @since 1.0.0
     */ Lens.fromPath = function() {
        var fromProp = Lens.fromProp();
        return function(path) {
            var lens = fromProp(path[0]);
            return path.slice(1).reduce(function(acc, prop) {
                return acc.compose(fromProp(prop));
            }, lens);
        };
    };
    /**
     * Returns a `Lens` from a type and a prop
     *
     * @example
     * import { Lens } from 'monocle-ts'
     *
     * type Person = {
     *   name: string
     *   age: number
     * }
     *
     * const age = Lens.fromProp<Person>()('age')
     *
     * const person: Person = { name: 'Giulio', age: 43 }
     *
     * assert.strictEqual(age.get(person), 43)
     * assert.deepStrictEqual(age.set(44)(person), { name: 'Giulio', age: 44 })
     *
     * @since 1.0.0
     */ Lens.fromProp = function() {
        return function(prop) {
            return fromLens((0, $30crt.pipe)($40vng.id(), $40vng.prop(prop)));
        };
    };
    Lens.fromProps = function() {
        return function(props) {
            return fromLens((0, $30crt.pipe)($40vng.id(), $40vng.props.apply($40vng, props)));
        };
    };
    /**
     * Returns a `Lens` from a nullable (`A | null | undefined`) prop
     *
     * @example
     * import { Lens } from 'monocle-ts'
     *
     * interface Outer {
     *   inner?: Inner
     * }
     *
     * interface Inner {
     *   value: number
     *   foo: string
     * }
     *
     * const inner = Lens.fromNullableProp<Outer>()('inner', { value: 0, foo: 'foo' })
     * const value = Lens.fromProp<Inner>()('value')
     * const lens = inner.compose(value)
     *
     * assert.deepStrictEqual(lens.set(1)({}), { inner: { value: 1, foo: 'foo' } })
     * assert.strictEqual(lens.get({}), 0)
     * assert.deepStrictEqual(lens.set(1)({ inner: { value: 1, foo: 'bar' } }), { inner: { value: 1, foo: 'bar' } })
     * assert.strictEqual(lens.get({ inner: { value: 1, foo: 'bar' } }), 1)
     *
     * @since 1.0.0
     */ Lens.fromNullableProp = function() {
        return function(k, defaultValue) {
            return new Lens(function(s) {
                var osk = (0, $bxsNd.fromNullable)(s[k]);
                if ((0, $bxsNd.isNone)(osk)) return defaultValue;
                else return osk.value;
            }, function(a) {
                return function(s) {
                    return update(s, k, a);
                };
            });
        };
    };
    /**
     * @since 1.0.0
     */ Lens.prototype.modify = function(f) {
        return $40vng.modify(f)(this);
    };
    /**
     * view a `Lens` as a Optional
     *
     * @since 1.0.0
     */ Lens.prototype.asOptional = function() {
        return fromOptional($40vng.asOptional(this));
    };
    /**
     * view a `Lens` as a `Traversal`
     *
     * @since 1.0.0
     */ Lens.prototype.asTraversal = function() {
        return fromTraversal($40vng.asTraversal(this));
    };
    /**
     * view a `Lens` as a `Setter`
     *
     * @since 1.0.0
     */ Lens.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * view a `Lens` as a `Getter`
     *
     * @since 1.0.0
     */ Lens.prototype.asGetter = function() {
        var _this = this;
        return new Getter(function(s) {
            return _this.get(s);
        });
    };
    /**
     * view a `Lens` as a `Fold`
     *
     * @since 1.0.0
     */ Lens.prototype.asFold = function() {
        var _this = this;
        return new Fold(function() {
            return function(f) {
                return function(s) {
                    return f(_this.get(s));
                };
            };
        });
    };
    /**
     * compose a `Lens` with a `Lens`
     *
     * @since 1.0.0
     */ Lens.prototype.compose = function(ab) {
        return fromLens($40vng.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Lens.prototype.composeLens = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Lens` with a `Getter`
     *
     * @since 1.0.0
     */ Lens.prototype.composeGetter = function(ab) {
        return this.asGetter().compose(ab);
    };
    /**
     * compose a `Lens` with a `Fold`
     *
     * @since 1.0.0
     */ Lens.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Lens` with an `Optional`
     *
     * @since 1.0.0
     */ Lens.prototype.composeOptional = function(ab) {
        return fromOptional((0, $30crt.pipe)(this, $40vng.asOptional, $43LA8.compose(ab)));
    };
    /**
     * compose a `Lens` with an `Traversal`
     *
     * @since 1.0.0
     */ Lens.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $30crt.pipe)(this, $40vng.asTraversal, $7NEBD.compose(ab)));
    };
    /**
     * compose a `Lens` with an `Setter`
     *
     * @since 1.0.0
     */ Lens.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose a `Lens` with an `Iso`
     *
     * @since 1.0.0
     */ Lens.prototype.composeIso = function(ab) {
        return fromLens((0, $30crt.pipe)(this, $40vng.compose((0, $30crt.pipe)(ab, $5kHfR.asLens))));
    };
    /**
     * compose a `Lens` with a `Prism`
     *
     * @since 1.0.0
     */ Lens.prototype.composePrism = function(ab) {
        return fromOptional($40vng.composePrism(ab)(this));
    };
    return Lens;
}();
/**
 * Laws:
 * 1. `pipe(getOption(s), fold(() => s, reverseGet)) = s`
 * 2. `getOption(reverseGet(a)) = some(a)`
 *
 * @category constructor
 * @since 1.0.0
 */ var Prism = /** @class */ function() {
    function Prism(getOption, reverseGet) {
        this.getOption = getOption;
        this.reverseGet = reverseGet;
        /**
         * @since 1.0.0
         */ this._tag = 'Prism';
    }
    Prism.fromPredicate = function(predicate) {
        return fromPrism($ftUJ4.fromPredicate(predicate));
    };
    /**
     * @since 1.0.0
     */ Prism.some = function() {
        return somePrism;
    };
    /**
     * @since 1.0.0
     */ Prism.prototype.modify = function(f) {
        var _this = this;
        return function(s) {
            var os = _this.modifyOption(f)(s);
            if ((0, $bxsNd.isNone)(os)) return s;
            else return os.value;
        };
    };
    /**
     * @since 1.0.0
     */ Prism.prototype.modifyOption = function(f) {
        var _this = this;
        return function(s) {
            return (0, $bxsNd.option).map(_this.getOption(s), function(v) {
                var n = f(v);
                return n === v ? s : _this.reverseGet(n);
            });
        };
    };
    /**
     * set the target of a `Prism` with a value
     *
     * @since 1.0.0
     */ Prism.prototype.set = function(a) {
        return this.modify(function() {
            return a;
        });
    };
    /**
     * view a `Prism` as a `Optional`
     *
     * @since 1.0.0
     */ Prism.prototype.asOptional = function() {
        return fromOptional($ftUJ4.asOptional(this));
    };
    /**
     * view a `Prism` as a `Traversal`
     *
     * @since 1.0.0
     */ Prism.prototype.asTraversal = function() {
        return fromTraversal($ftUJ4.asTraversal(this));
    };
    /**
     * view a `Prism` as a `Setter`
     *
     * @since 1.0.0
     */ Prism.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * view a `Prism` as a `Fold`
     *
     * @since 1.0.0
     */ Prism.prototype.asFold = function() {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return function(s) {
                    var oa = _this.getOption(s);
                    return (0, $bxsNd.isNone)(oa) ? M.empty : f(oa.value);
                };
            };
        });
    };
    /**
     * compose a `Prism` with a `Prism`
     *
     * @since 1.0.0
     */ Prism.prototype.compose = function(ab) {
        return fromPrism($ftUJ4.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Prism.prototype.composePrism = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Prism` with a `Optional`
     *
     * @since 1.0.0
     */ Prism.prototype.composeOptional = function(ab) {
        return fromOptional((0, $30crt.pipe)(this, $ftUJ4.asOptional, $43LA8.compose(ab)));
    };
    /**
     * compose a `Prism` with a `Traversal`
     *
     * @since 1.0.0
     */ Prism.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $30crt.pipe)(this, $ftUJ4.asTraversal, $7NEBD.compose(ab)));
    };
    /**
     * compose a `Prism` with a `Fold`
     *
     * @since 1.0.0
     */ Prism.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Prism` with a `Setter`
     *
     * @since 1.0.0
     */ Prism.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose a `Prism` with a `Iso`
     *
     * @since 1.0.0
     */ Prism.prototype.composeIso = function(ab) {
        return fromPrism((0, $30crt.pipe)(this, $ftUJ4.compose((0, $30crt.pipe)(ab, $5kHfR.asPrism))));
    };
    /**
     * compose a `Prism` with a `Lens`
     *
     * @since 1.0.0
     */ Prism.prototype.composeLens = function(ab) {
        return fromOptional($ftUJ4.composeLens(ab)(this));
    };
    /**
     * compose a `Prism` with a `Getter`
     *
     * @since 1.0.0
     */ Prism.prototype.composeGetter = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Prism;
}();
var somePrism = /*#__PURE__*/ new Prism((0, $72EOc.identity), (0, $bxsNd.some));
/**
 * Laws:
 * 1. `pipe(getOption(s), fold(() => s, a => set(a)(s))) = s`
 * 2. `getOption(set(a)(s)) = pipe(getOption(s), map(_ => a))`
 * 3. `set(a)(set(a)(s)) = set(a)(s)`
 *
 * @category constructor
 * @since 1.0.0
 */ var Optional = /** @class */ function() {
    function Optional(getOption, set) {
        this.getOption = getOption;
        this.set = set;
        /**
         * @since 1.0.0
         */ this._tag = 'Optional';
    }
    /**
     * Returns an `Optional` from a nullable (`A | null | undefined`) prop
     *
     * @example
     * import { Optional } from 'monocle-ts'
     *
     * interface Phone {
     *   number: string
     * }
     * interface Employment {
     *   phone?: Phone
     * }
     * interface Info {
     *   employment?: Employment
     * }
     * interface Response {
     *   info?: Info
     * }
     *
     * const numberFromResponse = Optional.fromPath<Response>()(['info', 'employment', 'phone', 'number'])
     *
     * const response1: Response = {
     *   info: {
     *     employment: {
     *       phone: {
     *         number: '555-1234'
     *       }
     *     }
     *   }
     * }
     * const response2: Response = {
     *   info: {
     *     employment: {}
     *   }
     * }
     *
     * numberFromResponse.getOption(response1) // some('555-1234')
     * numberFromResponse.getOption(response2) // none
     *
     * @since 2.1.0
     */ Optional.fromPath = function() {
        var fromNullableProp = Optional.fromNullableProp();
        return function(path) {
            var optional = fromNullableProp(path[0]);
            return path.slice(1).reduce(function(acc, prop) {
                return acc.compose(fromNullableProp(prop));
            }, optional);
        };
    };
    /**
     * @example
     * import { Optional } from 'monocle-ts'
     *
     * interface S {
     *   a: number | undefined | null
     * }
     *
     * const optional = Optional.fromNullableProp<S>()('a')
     *
     * const s1: S = { a: undefined }
     * const s2: S = { a: null }
     * const s3: S = { a: 1 }
     *
     * assert.deepStrictEqual(optional.set(2)(s1), s1)
     * assert.deepStrictEqual(optional.set(2)(s2), s2)
     * assert.deepStrictEqual(optional.set(2)(s3), { a: 2 })
     *
     * @since 1.0.0
     */ Optional.fromNullableProp = function() {
        return function(k) {
            return new Optional(function(s) {
                return (0, $bxsNd.fromNullable)(s[k]);
            }, function(a) {
                return function(s) {
                    return s[k] == null ? s : update(s, k, a);
                };
            });
        };
    };
    /**
     * Returns an `Optional` from an option (`Option<A>`) prop
     *
     * @example
     * import { Optional } from 'monocle-ts'
     * import * as O from 'fp-ts/Option'
     *
     * interface S {
     *   a: O.Option<number>
     * }
     *
     * const optional = Optional.fromOptionProp<S>()('a')
     * const s1: S = { a: O.none }
     * const s2: S = { a: O.some(1) }
     * assert.deepStrictEqual(optional.set(2)(s1), s1)
     * assert.deepStrictEqual(optional.set(2)(s2), { a: O.some(2) })
     *
     * @since 1.0.0
     */ Optional.fromOptionProp = function() {
        var formProp = Lens.fromProp();
        return function(prop) {
            return formProp(prop).composePrism(somePrism);
        };
    };
    /**
     * @since 1.0.0
     */ Optional.prototype.modify = function(f) {
        return $43LA8.modify(f)(this);
    };
    /**
     * @since 1.0.0
     */ Optional.prototype.modifyOption = function(f) {
        return $43LA8.modifyOption(f)(this);
    };
    /**
     * view a `Optional` as a `Traversal`
     *
     * @since 1.0.0
     */ Optional.prototype.asTraversal = function() {
        return fromTraversal($43LA8.asTraversal(this));
    };
    /**
     * view an `Optional` as a `Fold`
     *
     * @since 1.0.0
     */ Optional.prototype.asFold = function() {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return function(s) {
                    var oa = _this.getOption(s);
                    return (0, $bxsNd.isNone)(oa) ? M.empty : f(oa.value);
                };
            };
        });
    };
    /**
     * view an `Optional` as a `Setter`
     *
     * @since 1.0.0
     */ Optional.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * compose a `Optional` with a `Optional`
     *
     * @since 1.0.0
     */ Optional.prototype.compose = function(ab) {
        return fromOptional($43LA8.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Optional.prototype.composeOptional = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose an `Optional` with a `Traversal`
     *
     * @since 1.0.0
     */ Optional.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $30crt.pipe)(this, $43LA8.asTraversal, $7NEBD.compose(ab)));
    };
    /**
     * compose an `Optional` with a `Fold`
     *
     * @since 1.0.0
     */ Optional.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose an `Optional` with a `Setter`
     *
     * @since 1.0.0
     */ Optional.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose an `Optional` with a `Lens`
     *
     * @since 1.0.0
     */ Optional.prototype.composeLens = function(ab) {
        return fromOptional((0, $30crt.pipe)(this, $43LA8.compose((0, $30crt.pipe)(ab, $40vng.asOptional))));
    };
    /**
     * compose an `Optional` with a `Prism`
     *
     * @since 1.0.0
     */ Optional.prototype.composePrism = function(ab) {
        return fromOptional((0, $30crt.pipe)(this, $43LA8.compose((0, $30crt.pipe)(ab, $ftUJ4.asOptional))));
    };
    /**
     * compose an `Optional` with a `Iso`
     *
     * @since 1.0.0
     */ Optional.prototype.composeIso = function(ab) {
        return fromOptional((0, $30crt.pipe)(this, $43LA8.compose((0, $30crt.pipe)(ab, $5kHfR.asOptional))));
    };
    /**
     * compose an `Optional` with a `Getter`
     *
     * @since 1.0.0
     */ Optional.prototype.composeGetter = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Optional;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Traversal = /** @class */ function() {
    function Traversal(// Van Laarhoven representation
    modifyF) {
        this.modifyF = modifyF;
        /**
         * @since 1.0.0
         */ this._tag = 'Traversal';
    }
    /**
     * @since 1.0.0
     */ Traversal.prototype.modify = function(f) {
        return $7NEBD.modify(f)(this);
    };
    /**
     * @since 1.0.0
     */ Traversal.prototype.set = function(a) {
        return $7NEBD.set(a)(this);
    };
    Traversal.prototype.filter = function(predicate) {
        return fromTraversal($7NEBD.filter(predicate)(this));
    };
    /**
     * view a `Traversal` as a `Fold`
     *
     * @since 1.0.0
     */ Traversal.prototype.asFold = function() {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return _this.modifyF((0, $fFgN5.getApplicative)(M))(function(a) {
                    return (0, $fFgN5.make)(f(a));
                });
            };
        });
    };
    /**
     * view a `Traversal` as a `Setter`
     *
     * @since 1.0.0
     */ Traversal.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * compose a `Traversal` with a `Traversal`
     *
     * @since 1.0.0
     */ Traversal.prototype.compose = function(ab) {
        return fromTraversal($7NEBD.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeTraversal = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Traversal` with a `Fold`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Traversal` with a `Setter`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose a `Traversal` with a `Optional`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeOptional = function(ab) {
        return this.compose(ab.asTraversal());
    };
    /**
     * compose a `Traversal` with a `Lens`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeLens = function(ab) {
        return fromTraversal((0, $30crt.pipe)(this, $7NEBD.compose((0, $30crt.pipe)(ab, $40vng.asTraversal))));
    };
    /**
     * compose a `Traversal` with a `Prism`
     *
     * @since 1.0.0
     */ Traversal.prototype.composePrism = function(ab) {
        return fromTraversal((0, $30crt.pipe)(this, $7NEBD.compose((0, $30crt.pipe)(ab, $ftUJ4.asTraversal))));
    };
    /**
     * compose a `Traversal` with a `Iso`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeIso = function(ab) {
        return fromTraversal((0, $30crt.pipe)(this, $7NEBD.compose((0, $30crt.pipe)(ab, $5kHfR.asTraversal))));
    };
    /**
     * compose a `Traversal` with a `Getter`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeGetter = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Traversal;
}();
/**
 * @category constructor
 * @since 1.2.0
 */ var At = /** @class */ function() {
    function At(at) {
        this.at = at;
        /**
         * @since 1.0.0
         */ this._tag = 'At';
    }
    /**
     * lift an instance of `At` using an `Iso`
     *
     * @since 1.2.0
     */ At.prototype.fromIso = function(iso) {
        return fromAt($4O2fb.fromIso(iso)(this));
    };
    return At;
}();
/**
 * @category constructor
 * @since 1.2.0
 */ var Index = /** @class */ function() {
    function Index(index) {
        this.index = index;
        /**
         * @since 1.0.0
         */ this._tag = 'Index';
    }
    /**
     * @since 1.2.0
     */ Index.fromAt = function(at) {
        return fromIndex($2oRqE.fromAt(at));
    };
    /**
     * lift an instance of `Index` using an `Iso`
     *
     * @since 1.2.0
     */ Index.prototype.fromIso = function(iso) {
        return fromIndex($2oRqE.fromIso(iso)(this));
    };
    return Index;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Getter = /** @class */ function() {
    function Getter(get) {
        this.get = get;
        /**
         * @since 1.0.0
         */ this._tag = 'Getter';
    }
    /**
     * view a `Getter` as a `Fold`
     *
     * @since 1.0.0
     */ Getter.prototype.asFold = function() {
        var _this = this;
        return new Fold(function() {
            return function(f) {
                return function(s) {
                    return f(_this.get(s));
                };
            };
        });
    };
    /**
     * compose a `Getter` with a `Getter`
     *
     * @since 1.0.0
     */ Getter.prototype.compose = function(ab) {
        var _this = this;
        return new Getter(function(s) {
            return ab.get(_this.get(s));
        });
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Getter.prototype.composeGetter = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Getter` with a `Fold`
     *
     * @since 1.0.0
     */ Getter.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Getter` with a `Lens`
     *
     * @since 1.0.0
     */ Getter.prototype.composeLens = function(ab) {
        return this.compose(ab.asGetter());
    };
    /**
     * compose a `Getter` with a `Iso`
     *
     * @since 1.0.0
     */ Getter.prototype.composeIso = function(ab) {
        return this.compose(ab.asGetter());
    };
    /**
     * compose a `Getter` with a `Optional`
     *
     * @since 1.0.0
     */ Getter.prototype.composeTraversal = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    /**
     * compose a `Getter` with a `Optional`
     *
     * @since 1.0.0
     */ Getter.prototype.composeOptional = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    /**
     * compose a `Getter` with a `Prism`
     *
     * @since 1.0.0
     */ Getter.prototype.composePrism = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Getter;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Fold = /** @class */ function() {
    function Fold(foldMap) {
        this.foldMap = foldMap;
        /**
         * @since 1.0.0
         */ this._tag = 'Fold';
        this.getAll = foldMap($cgdoB.getMonoid())($cgdoB.of);
        this.exist = foldMap((0, $1Te5W.monoidAny));
        this.all = foldMap((0, $1Te5W.monoidAll));
        this.foldMapFirst = foldMap((0, $bxsNd.getFirstMonoid)());
    }
    /**
     * compose a `Fold` with a `Fold`
     *
     * @since 1.0.0
     */ Fold.prototype.compose = function(ab) {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return _this.foldMap(M)(ab.foldMap(M)(f));
            };
        });
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Fold.prototype.composeFold = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Fold` with a `Getter`
     *
     * @since 1.0.0
     */ Fold.prototype.composeGetter = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Traversal`
     *
     * @since 1.0.0
     */ Fold.prototype.composeTraversal = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Optional`
     *
     * @since 1.0.0
     */ Fold.prototype.composeOptional = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Lens`
     *
     * @since 1.0.0
     */ Fold.prototype.composeLens = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Prism`
     *
     * @since 1.0.0
     */ Fold.prototype.composePrism = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Iso`
     *
     * @since 1.0.0
     */ Fold.prototype.composeIso = function(ab) {
        return this.compose(ab.asFold());
    };
    Fold.prototype.find = function(p) {
        return this.foldMapFirst((0, $bxsNd.fromPredicate)(p));
    };
    /**
     * get the first target of a `Fold`
     *
     * @since 1.0.0
     */ Fold.prototype.headOption = function(s) {
        return this.find(function() {
            return true;
        })(s);
    };
    return Fold;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Setter = /** @class */ function() {
    function Setter(modify) {
        this.modify = modify;
        /**
         * @since 1.0.0
         */ this._tag = 'Setter';
    }
    /**
     * @since 1.0.0
     */ Setter.prototype.set = function(a) {
        return this.modify((0, $72EOc.constant)(a));
    };
    /**
     * compose a `Setter` with a `Setter`
     *
     * @since 1.0.0
     */ Setter.prototype.compose = function(ab) {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(ab.modify(f));
        });
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Setter.prototype.composeSetter = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Setter` with a `Traversal`
     *
     * @since 1.0.0
     */ Setter.prototype.composeTraversal = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Optional`
     *
     * @since 1.0.0
     */ Setter.prototype.composeOptional = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Lens`
     *
     * @since 1.0.0
     */ Setter.prototype.composeLens = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Prism`
     *
     * @since 1.0.0
     */ Setter.prototype.composePrism = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Iso`
     *
     * @since 1.0.0
     */ Setter.prototype.composeIso = function(ab) {
        return this.compose(ab.asSetter());
    };
    return Setter;
}();
function fromTraversable(T) {
    var f = $7NEBD.fromTraversable(T);
    return function() {
        return fromTraversal(f());
    };
}
function fromFoldable(F) {
    return function() {
        return new Fold(function(M) {
            var foldMapFM = F.foldMap(M);
            return function(f) {
                return function(s) {
                    return foldMapFM(s, f);
                };
            };
        });
    };
}

});
parcelRegister("cgdoB", function(module, exports) {

$parcel$export(module.exports, "of", () => $8ed15ecb979cdc0d$export$ba255e9e49e00608);
$parcel$export(module.exports, "getMonoid", () => $8ed15ecb979cdc0d$export$c2a7ef2cc9b32b31);

var $aYN4d = parcelRequire("aYN4d");

var $kgj0x = parcelRequire("kgj0x");

var $jFfj2 = parcelRequire("jFfj2");

var $72EOc = parcelRequire("72EOc");

var $cpwuW = parcelRequire("cpwuW");

var $EfnK2 = parcelRequire("EfnK2");

var $96Xjv = parcelRequire("96Xjv");

var $8yI6w = parcelRequire("8yI6w");

var $1HSKK = parcelRequire("1HSKK");

var $jNYdc = parcelRequire("jNYdc");

var $3n81G = parcelRequire("3n81G");
var $8ed15ecb979cdc0d$export$dd1bc94b04021eeb = function(as) {
    return as.length === 0;
};
var $8ed15ecb979cdc0d$export$a978c53b4062a525 = $96Xjv.isNonEmpty;
var $8ed15ecb979cdc0d$export$68159836694e22c1 = $96Xjv.prepend;
var $8ed15ecb979cdc0d$export$c4c4d41eab625797 = $96Xjv.prependW;
var $8ed15ecb979cdc0d$export$10d8903dec122b9d = $96Xjv.append;
var $8ed15ecb979cdc0d$export$19903a1bf1942f6 = $96Xjv.appendW;
var $8ed15ecb979cdc0d$export$849fbdcc2211fcde = function(n, f) {
    return n <= 0 ? [] : $96Xjv.makeBy(f)(n);
};
var $8ed15ecb979cdc0d$export$606959e7ccb797f0 = function(n, a) {
    return $8ed15ecb979cdc0d$export$849fbdcc2211fcde(n, function() {
        return a;
    });
};
function $8ed15ecb979cdc0d$export$23f31c55d7162b91(predicate) {
    return function(a) {
        return predicate(a) ? [
            a
        ] : [];
    };
}
var $8ed15ecb979cdc0d$export$172ec0a6ebfeb6fa = function(ma) {
    return $EfnK2.isNone(ma) ? [] : [
        ma.value
    ];
};
var $8ed15ecb979cdc0d$export$80c878c9b1d77917 = function(e) {
    return $EfnK2.isLeft(e) ? [] : [
        e.right
    ];
};
var $8ed15ecb979cdc0d$export$2d55ea551c238330 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $8ed15ecb979cdc0d$export$a978c53b4062a525(as) ? onNonEmpty(as) : onEmpty();
    };
};
var $8ed15ecb979cdc0d$export$4659b591c19bdf3d = $8ed15ecb979cdc0d$export$2d55ea551c238330;
var $8ed15ecb979cdc0d$export$ebbe93aa91e3abdc = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $8ed15ecb979cdc0d$export$a978c53b4062a525(as) ? onNonEmpty($96Xjv.head(as), $96Xjv.tail(as)) : onEmpty();
    };
};
var $8ed15ecb979cdc0d$export$6280271dfaec4919 = $8ed15ecb979cdc0d$export$ebbe93aa91e3abdc;
var $8ed15ecb979cdc0d$export$f3163a37d0ef5927 = $8ed15ecb979cdc0d$export$6280271dfaec4919;
var $8ed15ecb979cdc0d$export$364f7f2cc8473008 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $8ed15ecb979cdc0d$export$a978c53b4062a525(as) ? onNonEmpty($96Xjv.init(as), $96Xjv.last(as)) : onEmpty();
    };
};
var $8ed15ecb979cdc0d$export$b1cacb83a5c6bd02 = $8ed15ecb979cdc0d$export$364f7f2cc8473008;
var $8ed15ecb979cdc0d$export$77fa89c00b331c4c = $8ed15ecb979cdc0d$export$b1cacb83a5c6bd02;
var $8ed15ecb979cdc0d$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        var out = [];
        for(var i = 0; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $8ed15ecb979cdc0d$export$555ac70de528b074 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[0] = b;
        for(var i = 0; i < len; i++)out[i + 1] = f(out[i], as[i]);
        return out;
    };
};
var $8ed15ecb979cdc0d$export$d799959bdf780177 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[len] = b;
        for(var i = len - 1; i >= 0; i--)out[i] = f(as[i], out[i + 1]);
        return out;
    };
};
var $8ed15ecb979cdc0d$export$346677f925de839c = function(as) {
    return as.length;
};
var $8ed15ecb979cdc0d$export$2fde0b1c54fc39b9 = $96Xjv.isOutOfBound;
var $8ed15ecb979cdc0d$export$dfc7155ac0343b8 = $8yI6w.lookup;
var $8ed15ecb979cdc0d$export$5fd5031fecdacec3 = $8yI6w.head;
var $8ed15ecb979cdc0d$export$4c7897fafd92b108 = $8yI6w.last;
var $8ed15ecb979cdc0d$export$c01875f616615628 = function(as) {
    return $8ed15ecb979cdc0d$export$a978c53b4062a525(as) ? $EfnK2.some($96Xjv.tail(as)) : $EfnK2.none;
};
var $8ed15ecb979cdc0d$export$2cd8252107eb640b = function(as) {
    return $8ed15ecb979cdc0d$export$a978c53b4062a525(as) ? $EfnK2.some($96Xjv.init(as)) : $EfnK2.none;
};
var $8ed15ecb979cdc0d$export$8ea13dbc737d576b = function(n) {
    return function(as) {
        return $8ed15ecb979cdc0d$export$2fde0b1c54fc39b9(n, as) ? $8ed15ecb979cdc0d$export$784d13d8ee351f07(as) : as.slice(0, n);
    };
};
var $8ed15ecb979cdc0d$export$1bbc425ddca7f2c6 = function(n) {
    return function(as) {
        return $8ed15ecb979cdc0d$export$2fde0b1c54fc39b9(n, as) ? $8ed15ecb979cdc0d$export$784d13d8ee351f07(as) : n === 0 ? [] : as.slice(-n);
    };
};
function $8ed15ecb979cdc0d$export$5b0b82239a6f6d94(predicate) {
    return function(as) {
        var out = [];
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            if (!predicate(a)) break;
            out.push(a);
        }
        return out;
    };
}
var $8ed15ecb979cdc0d$var$spanLeftIndex = function(as, predicate) {
    var l = as.length;
    var i = 0;
    for(; i < l; i++){
        if (!predicate(as[i])) break;
    }
    return i;
};
function $8ed15ecb979cdc0d$export$104948d9b1d3fb14(predicate) {
    return function(as) {
        var _a = $8ed15ecb979cdc0d$export$b0d75975ac0be0e1($8ed15ecb979cdc0d$var$spanLeftIndex(as, predicate))(as), init = _a[0], rest = _a[1];
        return {
            init: init,
            rest: rest
        };
    };
}
var $8ed15ecb979cdc0d$export$738250583454396 = function(n) {
    return function(as) {
        return n <= 0 || $8ed15ecb979cdc0d$export$dd1bc94b04021eeb(as) ? $8ed15ecb979cdc0d$export$784d13d8ee351f07(as) : n >= as.length ? [] : as.slice(n, as.length);
    };
};
var $8ed15ecb979cdc0d$export$6ba801e3e123536e = function(n) {
    return function(as) {
        return n <= 0 || $8ed15ecb979cdc0d$export$dd1bc94b04021eeb(as) ? $8ed15ecb979cdc0d$export$784d13d8ee351f07(as) : n >= as.length ? [] : as.slice(0, as.length - n);
    };
};
function $8ed15ecb979cdc0d$export$d265ccd398ee49c9(predicate) {
    return function(as) {
        return as.slice($8ed15ecb979cdc0d$var$spanLeftIndex(as, predicate));
    };
}
var $8ed15ecb979cdc0d$export$de3a4d4a0d731119 = $8yI6w.findIndex;
function $8ed15ecb979cdc0d$export$9a2f228bed5035c2(predicate) {
    return $8yI6w.findFirst(predicate);
}
var $8ed15ecb979cdc0d$export$a86c11c94d794a95 = $8yI6w.findFirstMap;
function $8ed15ecb979cdc0d$export$296de88ccac4bedb(predicate) {
    return $8yI6w.findLast(predicate);
}
var $8ed15ecb979cdc0d$export$8b5e6d6ad82284fa = $8yI6w.findLastMap;
var $8ed15ecb979cdc0d$export$8855a8be7bd3e9f8 = $8yI6w.findLastIndex;
var $8ed15ecb979cdc0d$export$784d13d8ee351f07 = function(as) {
    return as.slice();
};
var $8ed15ecb979cdc0d$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $EfnK2.none : $EfnK2.some($8ed15ecb979cdc0d$export$f4863e1822a1860c(i, a, as));
    };
};
var $8ed15ecb979cdc0d$export$b6d8713d53419d4c = function(i, a) {
    return $8ed15ecb979cdc0d$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $8ed15ecb979cdc0d$export$90f9093465da3136 = function(i) {
    return function(as) {
        return $8ed15ecb979cdc0d$export$2fde0b1c54fc39b9(i, as) ? $EfnK2.none : $EfnK2.some($8ed15ecb979cdc0d$export$4937fde8dfc38dbd(i, as));
    };
};
var $8ed15ecb979cdc0d$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $8ed15ecb979cdc0d$export$2fde0b1c54fc39b9(i, as) ? $EfnK2.none : $EfnK2.some($8ed15ecb979cdc0d$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $8ed15ecb979cdc0d$export$66c1ae025e96b4bc = function(as) {
    return $8ed15ecb979cdc0d$export$dd1bc94b04021eeb(as) ? [] : as.slice().reverse();
};
var $8ed15ecb979cdc0d$export$cae945d60b6cbe50 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Right') r.push(a.right);
    }
    return r;
};
var $8ed15ecb979cdc0d$export$837c95301ebad184 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Left') r.push(a.left);
    }
    return r;
};
var $8ed15ecb979cdc0d$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.length <= 1 ? $8ed15ecb979cdc0d$export$784d13d8ee351f07(as) : as.slice().sort(O.compare);
    };
};
var $8ed15ecb979cdc0d$export$b634740ce272acb5 = function(fa, fb, f) {
    var fc = [];
    var len = Math.min(fa.length, fb.length);
    for(var i = 0; i < len; i++)fc[i] = f(fa[i], fb[i]);
    return fc;
};
function $8ed15ecb979cdc0d$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $8ed15ecb979cdc0d$export$8901015135f2fb22(bs, as);
    };
    return $8ed15ecb979cdc0d$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $8ed15ecb979cdc0d$export$23c8d3f8757cab88 = function(as) {
    var fa = [];
    var fb = [];
    for(var i = 0; i < as.length; i++){
        fa[i] = as[i][0];
        fb[i] = as[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $8ed15ecb979cdc0d$export$849c7567cbd62acc = function(middle) {
    var f = $96Xjv.prependAll(middle);
    return function(as) {
        return $8ed15ecb979cdc0d$export$a978c53b4062a525(as) ? f(as) : [];
    };
};
var $8ed15ecb979cdc0d$export$af200dcf8b7cb5de = function(middle) {
    var f = $96Xjv.intersperse(middle);
    return function(as) {
        return $8ed15ecb979cdc0d$export$a978c53b4062a525(as) ? f(as) : $8ed15ecb979cdc0d$export$784d13d8ee351f07(as);
    };
};
var $8ed15ecb979cdc0d$export$bb628a54ab399bc9 = function(n) {
    var f = $96Xjv.rotate(n);
    return function(as) {
        return $8ed15ecb979cdc0d$export$a978c53b4062a525(as) ? f(as) : $8ed15ecb979cdc0d$export$784d13d8ee351f07(as);
    };
};
var $8ed15ecb979cdc0d$export$5bf96401662340b7 = $8yI6w.elem;
var $8ed15ecb979cdc0d$export$f70730c3d1fc524e = function(E) {
    var f = $96Xjv.uniq(E);
    return function(as) {
        return $8ed15ecb979cdc0d$export$a978c53b4062a525(as) ? f(as) : $8ed15ecb979cdc0d$export$784d13d8ee351f07(as);
    };
};
var $8ed15ecb979cdc0d$export$b035e44d7bb4278f = function(ords) {
    var f = $96Xjv.sortBy(ords);
    return function(as) {
        return $8ed15ecb979cdc0d$export$a978c53b4062a525(as) ? f(as) : $8ed15ecb979cdc0d$export$784d13d8ee351f07(as);
    };
};
var $8ed15ecb979cdc0d$export$433fe05b12ba833f = function(f) {
    var g = $96Xjv.chop(f);
    return function(as) {
        return $8ed15ecb979cdc0d$export$a978c53b4062a525(as) ? g(as) : [];
    };
};
var $8ed15ecb979cdc0d$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        return n >= 1 && $8ed15ecb979cdc0d$export$a978c53b4062a525(as) ? $96Xjv.splitAt(n)(as) : $8ed15ecb979cdc0d$export$dd1bc94b04021eeb(as) ? [
            $8ed15ecb979cdc0d$export$784d13d8ee351f07(as),
            []
        ] : [
            [],
            $8ed15ecb979cdc0d$export$784d13d8ee351f07(as)
        ];
    };
};
var $8ed15ecb979cdc0d$export$2f0184d5df52135f = function(n) {
    var f = $96Xjv.chunksOf(n);
    return function(as) {
        return $8ed15ecb979cdc0d$export$a978c53b4062a525(as) ? f(as) : [];
    };
};
var $8ed15ecb979cdc0d$export$a907462f448b49f8 = function(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $8ed15ecb979cdc0d$export$172ec0a6ebfeb6fa(f.apply(void 0, a));
    };
};
function $8ed15ecb979cdc0d$export$105c199d42fdf965(input, f, g) {
    if (g === void 0) g = function() {
        return true;
    };
    var go = function(scope, input) {
        return $8ed15ecb979cdc0d$export$a978c53b4062a525(input) ? $8ed15ecb979cdc0d$export$5b8affa63fc6df16($96Xjv.head(input), function(a) {
            return go((0, $72EOc.pipe)(scope, $8ed15ecb979cdc0d$export$10d8903dec122b9d(a)), $96Xjv.tail(input));
        }) : g.apply(void 0, scope) ? [
            f.apply(void 0, scope)
        ] : [];
    };
    return go([], input);
}
var $8ed15ecb979cdc0d$export$c8c959650bbe80e2 = function(second) {
    return function(first) {
        return $8ed15ecb979cdc0d$export$dd1bc94b04021eeb(first) ? $8ed15ecb979cdc0d$export$784d13d8ee351f07(second) : $8ed15ecb979cdc0d$export$dd1bc94b04021eeb(second) ? $8ed15ecb979cdc0d$export$784d13d8ee351f07(first) : first.concat(second);
    };
};
var $8ed15ecb979cdc0d$export$ee1b3e54f0441b22 = $8ed15ecb979cdc0d$export$c8c959650bbe80e2;
function $8ed15ecb979cdc0d$export$971dd5b0dfd021b6(E) {
    var unionE = $96Xjv.union(E);
    return function(first, second) {
        if (second === undefined) {
            var unionE_1 = $8ed15ecb979cdc0d$export$971dd5b0dfd021b6(E);
            return function(second) {
                return unionE_1(second, first);
            };
        }
        return $8ed15ecb979cdc0d$export$a978c53b4062a525(first) && $8ed15ecb979cdc0d$export$a978c53b4062a525(second) ? unionE(second)(first) : $8ed15ecb979cdc0d$export$a978c53b4062a525(first) ? $8ed15ecb979cdc0d$export$784d13d8ee351f07(first) : $8ed15ecb979cdc0d$export$784d13d8ee351f07(second);
    };
}
function $8ed15ecb979cdc0d$export$bc86dfbf7795668c(E) {
    var elemE = $8ed15ecb979cdc0d$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var intersectionE_1 = $8ed15ecb979cdc0d$export$bc86dfbf7795668c(E);
            return function(ys) {
                return intersectionE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return elemE(a, ys);
        });
    };
}
function $8ed15ecb979cdc0d$export$acaf96a27438246b(E) {
    var elemE = $8ed15ecb979cdc0d$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var differenceE_1 = $8ed15ecb979cdc0d$export$acaf96a27438246b(E);
            return function(ys) {
                return differenceE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return !elemE(a, ys);
        });
    };
}
var $8ed15ecb979cdc0d$var$_map = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_mapWithIndex = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$8f07ddce13659f50(f));
};
var $8ed15ecb979cdc0d$var$_ap = function(fab, fa) {
    return (0, $72EOc.pipe)(fab, $8ed15ecb979cdc0d$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_filter = function(fa, predicate) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$3dea766d36a8935f(predicate));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_filterMap = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$a04c6c6965dd4709(f));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_partition = function(fa, predicate) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$b29f828819edca8d(predicate));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_partitionMap = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$3117e3f9ececb6bc(f));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_partitionWithIndex = function(fa, predicateWithIndex) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$dad5e500f2bab9bc(predicateWithIndex));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_partitionMapWithIndex = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$bc7c0794b9c6f3ba(f));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_alt = function(fa, that) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$228be17d80722ab(that));
};
var $8ed15ecb979cdc0d$var$_reduce = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_foldMap = function(M) {
    var foldMapM = $8ed15ecb979cdc0d$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $72EOc.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_reduceRight = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$7fef8bcdbb34f435(b, f));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$bbd3ef8720e22369(b, f));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $8ed15ecb979cdc0d$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $72EOc.pipe)(fa, foldMapWithIndexM(f));
    };
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$ce2b2fe0b88ccd0a(b, f));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_filterMapWithIndex = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$30c5cbe848021e97(f));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_filterWithIndex = function(fa, predicateWithIndex) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$36e42aef19fc7171(predicateWithIndex));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_extend = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_traverse = function(F) {
    var traverseF = $8ed15ecb979cdc0d$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $72EOc.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $8ed15ecb979cdc0d$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $8ed15ecb979cdc0d$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $72EOc.pipe)(ta, traverseWithIndexF(f));
    };
};
var $8ed15ecb979cdc0d$var$_chainRecDepthFirst = $8yI6w._chainRecDepthFirst;
var $8ed15ecb979cdc0d$var$_chainRecBreadthFirst = $8yI6w._chainRecBreadthFirst;
var $8ed15ecb979cdc0d$export$ba255e9e49e00608 = $96Xjv.of;
var $8ed15ecb979cdc0d$export$7f9972325ebfd559 = function() {
    return [];
};
var $8ed15ecb979cdc0d$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return fa.map(function(a) {
            return f(a);
        });
    };
};
var $8ed15ecb979cdc0d$export$2f6ca3d3b1f80bf5 = function(fa) {
    return $8ed15ecb979cdc0d$export$5b8affa63fc6df16(function(f) {
        return (0, $72EOc.pipe)(fa, $8ed15ecb979cdc0d$export$871de8747c9eaa88(f));
    });
};
var $8ed15ecb979cdc0d$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $72EOc.dual)(2, function(ma, f) {
    return (0, $72EOc.pipe)(ma, $8ed15ecb979cdc0d$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $8ed15ecb979cdc0d$export$bffa455ba8c619a6 = /*#__PURE__*/ $8ed15ecb979cdc0d$export$5b8affa63fc6df16((0, $72EOc.identity));
var $8ed15ecb979cdc0d$export$8f07ddce13659f50 = function(f) {
    return function(fa) {
        return fa.map(function(a, i) {
            return f(i, a);
        });
    };
};
var $8ed15ecb979cdc0d$export$30c5cbe848021e97 = function(f) {
    return function(fa) {
        var out = [];
        for(var i = 0; i < fa.length; i++){
            var optionB = f(i, fa[i]);
            if ($EfnK2.isSome(optionB)) out.push(optionB.value);
        }
        return out;
    };
};
var $8ed15ecb979cdc0d$export$a04c6c6965dd4709 = function(f) {
    return $8ed15ecb979cdc0d$export$30c5cbe848021e97(function(_, a) {
        return f(a);
    });
};
var $8ed15ecb979cdc0d$export$8e16b83750b44988 = /*#__PURE__*/ $8ed15ecb979cdc0d$export$a04c6c6965dd4709((0, $72EOc.identity));
var $8ed15ecb979cdc0d$export$709f6946f4e97408 = function(fa) {
    var left = [];
    var right = [];
    for(var _i = 0, fa_1 = fa; _i < fa_1.length; _i++){
        var e = fa_1[_i];
        if (e._tag === 'Left') left.push(e.left);
        else right.push(e.right);
    }
    return (0, $1HSKK.separated)(left, right);
};
var $8ed15ecb979cdc0d$export$3dea766d36a8935f = function(predicate) {
    return function(as) {
        return as.filter(predicate);
    };
};
var $8ed15ecb979cdc0d$export$b29f828819edca8d = function(predicate) {
    return $8ed15ecb979cdc0d$export$dad5e500f2bab9bc(function(_, a) {
        return predicate(a);
    });
};
var $8ed15ecb979cdc0d$export$dad5e500f2bab9bc = function(predicateWithIndex) {
    return function(as) {
        var left = [];
        var right = [];
        for(var i = 0; i < as.length; i++){
            var b = as[i];
            if (predicateWithIndex(i, b)) right.push(b);
            else left.push(b);
        }
        return (0, $1HSKK.separated)(left, right);
    };
};
var $8ed15ecb979cdc0d$export$3117e3f9ececb6bc = function(f) {
    return $8ed15ecb979cdc0d$export$bc7c0794b9c6f3ba(function(_, a) {
        return f(a);
    });
};
var $8ed15ecb979cdc0d$export$bc7c0794b9c6f3ba = function(f) {
    return function(fa) {
        var left = [];
        var right = [];
        for(var i = 0; i < fa.length; i++){
            var e = f(i, fa[i]);
            if (e._tag === 'Left') left.push(e.left);
            else right.push(e.right);
        }
        return (0, $1HSKK.separated)(left, right);
    };
};
var $8ed15ecb979cdc0d$export$1517cca7889d6aaa = function(that) {
    return function(fa) {
        return fa.concat(that());
    };
};
var $8ed15ecb979cdc0d$export$228be17d80722ab = $8ed15ecb979cdc0d$export$1517cca7889d6aaa;
var $8ed15ecb979cdc0d$export$36e42aef19fc7171 = function(predicateWithIndex) {
    return function(as) {
        return as.filter(function(b, i) {
            return predicateWithIndex(i, b);
        });
    };
};
var $8ed15ecb979cdc0d$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return wa.map(function(_, i) {
            return f(wa.slice(i));
        });
    };
};
var $8ed15ecb979cdc0d$export$ecd5e8ace626722c = /*#__PURE__*/ $8ed15ecb979cdc0d$export$8b58be045bf06082((0, $72EOc.identity));
var $8ed15ecb979cdc0d$export$b66cdc0497d8a99a = $8yI6w.foldMap;
var $8ed15ecb979cdc0d$export$18153bb1181268e5 = $8yI6w.foldMapWithIndex;
var $8ed15ecb979cdc0d$export$533b26079ad0b4b = $8yI6w.reduce;
var $8ed15ecb979cdc0d$export$bbd3ef8720e22369 = $8yI6w.reduceWithIndex;
var $8ed15ecb979cdc0d$export$7fef8bcdbb34f435 = $8yI6w.reduceRight;
var $8ed15ecb979cdc0d$export$ce2b2fe0b88ccd0a = $8yI6w.reduceRightWithIndex;
var $8ed15ecb979cdc0d$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $8ed15ecb979cdc0d$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $8ed15ecb979cdc0d$export$49bb65c2ea163039 = function(F) {
    return function(ta) {
        return $8ed15ecb979cdc0d$var$_reduce(ta, F.of($8ed15ecb979cdc0d$export$7f9972325ebfd559()), function(fas, fa) {
            return F.ap(F.map(fas, function(as) {
                return function(a) {
                    return (0, $72EOc.pipe)(as, $8ed15ecb979cdc0d$export$10d8903dec122b9d(a));
                };
            }), fa);
        });
    };
};
var $8ed15ecb979cdc0d$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return $8ed15ecb979cdc0d$export$bbd3ef8720e22369(F.of($8ed15ecb979cdc0d$export$7f9972325ebfd559()), function(i, fbs, a) {
            return F.ap(F.map(fbs, function(bs) {
                return function(b) {
                    return (0, $72EOc.pipe)(bs, $8ed15ecb979cdc0d$export$10d8903dec122b9d(b));
                };
            }), f(i, a));
        });
    };
};
var $8ed15ecb979cdc0d$export$6c36d01819ecdb31 = function(F) {
    var _witherF = $8ed15ecb979cdc0d$var$_wither(F);
    return function(f) {
        return function(fa) {
            return _witherF(fa, f);
        };
    };
};
var $8ed15ecb979cdc0d$export$2439a3bc02b13b03 = function(F) {
    var _wiltF = $8ed15ecb979cdc0d$var$_wilt(F);
    return function(f) {
        return function(fa) {
            return _wiltF(fa, f);
        };
    };
};
var $8ed15ecb979cdc0d$export$c48e357c1a89b78d = function(b, f) {
    var out = [];
    var bb = b;
    // eslint-disable-next-line no-constant-condition
    while(true){
        var mt = f(bb);
        if ($EfnK2.isSome(mt)) {
            var _a = mt.value, a = _a[0], b_1 = _a[1];
            out.push(a);
            bb = b_1;
        } else break;
    }
    return out;
};
var $8ed15ecb979cdc0d$export$9156e739aa33e19f = 'Array';
var $8ed15ecb979cdc0d$export$3cb5cd7f7776c81 = $8yI6w.getShow;
var $8ed15ecb979cdc0d$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return first.concat(second);
        }
    };
};
var $8ed15ecb979cdc0d$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $8ed15ecb979cdc0d$export$e759a9a7f8d04692().concat,
        empty: []
    };
};
var $8ed15ecb979cdc0d$export$804fed467fde44e4 = $8yI6w.getEq;
var $8ed15ecb979cdc0d$export$1af51209b1b91d07 = $8yI6w.getOrd;
var $8ed15ecb979cdc0d$export$baca17b4aff42f82 = function(E) {
    var unionE = $8ed15ecb979cdc0d$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $8ed15ecb979cdc0d$export$c487aac9f4157837 = function(E) {
    return {
        concat: $8ed15ecb979cdc0d$export$baca17b4aff42f82(E).concat,
        empty: []
    };
};
var $8ed15ecb979cdc0d$export$d379a869a72e4055 = function(E) {
    var intersectionE = $8ed15ecb979cdc0d$export$bc86dfbf7795668c(E);
    return {
        concat: function(first, second) {
            return intersectionE(second)(first);
        }
    };
};
var $8ed15ecb979cdc0d$export$fdb3296ca0a124e3 = function(E) {
    var differenceE = $8ed15ecb979cdc0d$export$acaf96a27438246b(E);
    return {
        concat: function(first, second) {
            return differenceE(second)(first);
        }
    };
};
var $8ed15ecb979cdc0d$export$bd5b6bfc5fa2ee61 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map
};
var $8ed15ecb979cdc0d$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $cpwuW.flap)($8ed15ecb979cdc0d$export$bd5b6bfc5fa2ee61);
var $8ed15ecb979cdc0d$export$59a71046037e6c20 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    of: $8ed15ecb979cdc0d$export$ba255e9e49e00608
};
var $8ed15ecb979cdc0d$export$9fdffe0fe1e91cad = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    mapWithIndex: $8ed15ecb979cdc0d$var$_mapWithIndex
};
var $8ed15ecb979cdc0d$export$efc21ddc6aeb363d = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    ap: $8ed15ecb979cdc0d$var$_ap
};
var $8ed15ecb979cdc0d$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $aYN4d.apFirst)($8ed15ecb979cdc0d$export$efc21ddc6aeb363d);
var $8ed15ecb979cdc0d$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $aYN4d.apSecond)($8ed15ecb979cdc0d$export$efc21ddc6aeb363d);
var $8ed15ecb979cdc0d$export$1279d2b7807629fd = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    ap: $8ed15ecb979cdc0d$var$_ap,
    of: $8ed15ecb979cdc0d$export$ba255e9e49e00608
};
var $8ed15ecb979cdc0d$export$f18d5acc27d70423 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    ap: $8ed15ecb979cdc0d$var$_ap,
    chain: $8ed15ecb979cdc0d$export$5b8affa63fc6df16
};
var $8ed15ecb979cdc0d$export$e3821ef4970c339c = /*#__PURE__*/ (0, $kgj0x.chainFirst)($8ed15ecb979cdc0d$export$f18d5acc27d70423);
var $8ed15ecb979cdc0d$export$fb641926d034ac7d = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    ap: $8ed15ecb979cdc0d$var$_ap,
    of: $8ed15ecb979cdc0d$export$ba255e9e49e00608,
    chain: $8ed15ecb979cdc0d$export$5b8affa63fc6df16
};
var $8ed15ecb979cdc0d$export$8fa953f00d3b093 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    unfold: $8ed15ecb979cdc0d$export$c48e357c1a89b78d
};
var $8ed15ecb979cdc0d$export$25ba4469a069167 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    alt: $8ed15ecb979cdc0d$var$_alt
};
var $8ed15ecb979cdc0d$export$aaef8a3eae948f03 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    zero: $8ed15ecb979cdc0d$export$7f9972325ebfd559
};
var $8ed15ecb979cdc0d$export$864d727b48066337 = /*#__PURE__*/ (0, $3n81G.guard)($8ed15ecb979cdc0d$export$aaef8a3eae948f03, $8ed15ecb979cdc0d$export$59a71046037e6c20);
var $8ed15ecb979cdc0d$export$4acb47accde578d2 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    ap: $8ed15ecb979cdc0d$var$_ap,
    of: $8ed15ecb979cdc0d$export$ba255e9e49e00608,
    alt: $8ed15ecb979cdc0d$var$_alt,
    zero: $8ed15ecb979cdc0d$export$7f9972325ebfd559
};
var $8ed15ecb979cdc0d$export$5b5dd0e212d2a5bc = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    extend: $8ed15ecb979cdc0d$var$_extend
};
var $8ed15ecb979cdc0d$export$4a21ac48141ac3c9 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    compact: $8ed15ecb979cdc0d$export$8e16b83750b44988,
    separate: $8ed15ecb979cdc0d$export$709f6946f4e97408
};
var $8ed15ecb979cdc0d$export$d00e1c48fb621173 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    compact: $8ed15ecb979cdc0d$export$8e16b83750b44988,
    separate: $8ed15ecb979cdc0d$export$709f6946f4e97408,
    filter: $8ed15ecb979cdc0d$var$_filter,
    filterMap: $8ed15ecb979cdc0d$var$_filterMap,
    partition: $8ed15ecb979cdc0d$var$_partition,
    partitionMap: $8ed15ecb979cdc0d$var$_partitionMap
};
var $8ed15ecb979cdc0d$export$c29a647071e542ec = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    mapWithIndex: $8ed15ecb979cdc0d$var$_mapWithIndex,
    compact: $8ed15ecb979cdc0d$export$8e16b83750b44988,
    separate: $8ed15ecb979cdc0d$export$709f6946f4e97408,
    filter: $8ed15ecb979cdc0d$var$_filter,
    filterMap: $8ed15ecb979cdc0d$var$_filterMap,
    partition: $8ed15ecb979cdc0d$var$_partition,
    partitionMap: $8ed15ecb979cdc0d$var$_partitionMap,
    partitionMapWithIndex: $8ed15ecb979cdc0d$var$_partitionMapWithIndex,
    partitionWithIndex: $8ed15ecb979cdc0d$var$_partitionWithIndex,
    filterMapWithIndex: $8ed15ecb979cdc0d$var$_filterMapWithIndex,
    filterWithIndex: $8ed15ecb979cdc0d$var$_filterWithIndex
};
var $8ed15ecb979cdc0d$export$41404b31838667c9 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    reduce: $8ed15ecb979cdc0d$var$_reduce,
    foldMap: $8ed15ecb979cdc0d$var$_foldMap,
    reduceRight: $8ed15ecb979cdc0d$var$_reduceRight
};
var $8ed15ecb979cdc0d$export$e8f7d17aaff345cb = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    reduce: $8ed15ecb979cdc0d$var$_reduce,
    foldMap: $8ed15ecb979cdc0d$var$_foldMap,
    reduceRight: $8ed15ecb979cdc0d$var$_reduceRight,
    reduceWithIndex: $8ed15ecb979cdc0d$var$_reduceWithIndex,
    foldMapWithIndex: $8ed15ecb979cdc0d$var$_foldMapWithIndex,
    reduceRightWithIndex: $8ed15ecb979cdc0d$var$_reduceRightWithIndex
};
var $8ed15ecb979cdc0d$export$a0202666c3bda011 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    reduce: $8ed15ecb979cdc0d$var$_reduce,
    foldMap: $8ed15ecb979cdc0d$var$_foldMap,
    reduceRight: $8ed15ecb979cdc0d$var$_reduceRight,
    traverse: $8ed15ecb979cdc0d$var$_traverse,
    sequence: $8ed15ecb979cdc0d$export$49bb65c2ea163039
};
var $8ed15ecb979cdc0d$export$bd7b528d8c36ec41 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    mapWithIndex: $8ed15ecb979cdc0d$var$_mapWithIndex,
    reduce: $8ed15ecb979cdc0d$var$_reduce,
    foldMap: $8ed15ecb979cdc0d$var$_foldMap,
    reduceRight: $8ed15ecb979cdc0d$var$_reduceRight,
    reduceWithIndex: $8ed15ecb979cdc0d$var$_reduceWithIndex,
    foldMapWithIndex: $8ed15ecb979cdc0d$var$_foldMapWithIndex,
    reduceRightWithIndex: $8ed15ecb979cdc0d$var$_reduceRightWithIndex,
    traverse: $8ed15ecb979cdc0d$var$_traverse,
    sequence: $8ed15ecb979cdc0d$export$49bb65c2ea163039,
    traverseWithIndex: $8ed15ecb979cdc0d$var$_traverseWithIndex
};
var $8ed15ecb979cdc0d$var$_wither = /*#__PURE__*/ (0, $jNYdc.witherDefault)($8ed15ecb979cdc0d$export$a0202666c3bda011, $8ed15ecb979cdc0d$export$4a21ac48141ac3c9);
var $8ed15ecb979cdc0d$var$_wilt = /*#__PURE__*/ (0, $jNYdc.wiltDefault)($8ed15ecb979cdc0d$export$a0202666c3bda011, $8ed15ecb979cdc0d$export$4a21ac48141ac3c9);
var $8ed15ecb979cdc0d$export$748d317b4c426f96 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    compact: $8ed15ecb979cdc0d$export$8e16b83750b44988,
    separate: $8ed15ecb979cdc0d$export$709f6946f4e97408,
    filter: $8ed15ecb979cdc0d$var$_filter,
    filterMap: $8ed15ecb979cdc0d$var$_filterMap,
    partition: $8ed15ecb979cdc0d$var$_partition,
    partitionMap: $8ed15ecb979cdc0d$var$_partitionMap,
    reduce: $8ed15ecb979cdc0d$var$_reduce,
    foldMap: $8ed15ecb979cdc0d$var$_foldMap,
    reduceRight: $8ed15ecb979cdc0d$var$_reduceRight,
    traverse: $8ed15ecb979cdc0d$var$_traverse,
    sequence: $8ed15ecb979cdc0d$export$49bb65c2ea163039,
    wither: $8ed15ecb979cdc0d$var$_wither,
    wilt: $8ed15ecb979cdc0d$var$_wilt
};
var $8ed15ecb979cdc0d$export$f855115a79f70c1a = $8yI6w.chainRecDepthFirst;
var $8ed15ecb979cdc0d$export$7d808dfaa6d54634 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    ap: $8ed15ecb979cdc0d$var$_ap,
    chain: $8ed15ecb979cdc0d$export$5b8affa63fc6df16,
    chainRec: $8ed15ecb979cdc0d$var$_chainRecDepthFirst
};
var $8ed15ecb979cdc0d$export$bffee57bb00a6859 = $8yI6w.chainRecBreadthFirst;
var $8ed15ecb979cdc0d$export$57f3a385c7e59628 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    map: $8ed15ecb979cdc0d$var$_map,
    ap: $8ed15ecb979cdc0d$var$_ap,
    chain: $8ed15ecb979cdc0d$export$5b8affa63fc6df16,
    chainRec: $8ed15ecb979cdc0d$var$_chainRecBreadthFirst
};
var $8ed15ecb979cdc0d$export$c40604f35db61519 = /*#__PURE__*/ (0, $jNYdc.filterE)($8ed15ecb979cdc0d$export$748d317b4c426f96);
var $8ed15ecb979cdc0d$export$825ea6cb6fc48d49 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    fromEither: $8ed15ecb979cdc0d$export$80c878c9b1d77917
};
var $8ed15ecb979cdc0d$export$8138b0ae92c9b5d8 = /*#__PURE__*/ (0, $jFfj2.fromEitherK)($8ed15ecb979cdc0d$export$825ea6cb6fc48d49);
var $8ed15ecb979cdc0d$export$f4863e1822a1860c = $96Xjv.unsafeInsertAt;
var $8ed15ecb979cdc0d$export$9c0c6889b1fa9bfc = function(i, a, as) {
    return $8ed15ecb979cdc0d$export$a978c53b4062a525(as) ? $96Xjv.unsafeUpdateAt(i, a, as) : [];
};
var $8ed15ecb979cdc0d$export$4937fde8dfc38dbd = function(i, as) {
    var xs = as.slice();
    xs.splice(i, 1);
    return xs;
};
var $8ed15ecb979cdc0d$export$7ecc1a3b11b57dab = $8yI6w.every;
var $8ed15ecb979cdc0d$export$ad14ef4001db2bcd = function(predicate) {
    return function(as) {
        return as.some(predicate);
    };
};
var $8ed15ecb979cdc0d$export$f7e9f41ea797a17 = $8ed15ecb979cdc0d$export$ad14ef4001db2bcd;
var $8ed15ecb979cdc0d$export$739ec22334c44788 = $8yI6w.intercalate;
var $8ed15ecb979cdc0d$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $8ed15ecb979cdc0d$export$ba255e9e49e00608($EfnK2.emptyRecord);
var $8ed15ecb979cdc0d$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $cpwuW.bindTo)($8ed15ecb979cdc0d$export$bd5b6bfc5fa2ee61);
var $8ed15ecb979cdc0d$export$5d537b797c421217 = /*#__PURE__*/ (0, $cpwuW.let)($8ed15ecb979cdc0d$export$bd5b6bfc5fa2ee61);
var $8ed15ecb979cdc0d$export$2385a24977818dd0 = /*#__PURE__*/ (0, $kgj0x.bind)($8ed15ecb979cdc0d$export$f18d5acc27d70423);
var $8ed15ecb979cdc0d$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $aYN4d.apS)($8ed15ecb979cdc0d$export$efc21ddc6aeb363d);
var $8ed15ecb979cdc0d$export$e08e3b67e392101e = $8ed15ecb979cdc0d$export$5b8affa63fc6df16;
var $8ed15ecb979cdc0d$export$d02631cccf789723 = $96Xjv.range;
var $8ed15ecb979cdc0d$export$6e22c362a0406a2c = [];
var $8ed15ecb979cdc0d$export$8327ebbef2a0ba76 = $96Xjv.cons;
var $8ed15ecb979cdc0d$export$c40cf5aab899f397 = $96Xjv.snoc;
var $8ed15ecb979cdc0d$export$baeb00bf1e27e233 = $8ed15ecb979cdc0d$export$849c7567cbd62acc;
var $8ed15ecb979cdc0d$export$2f23118c22fb2630 = {
    URI: $8ed15ecb979cdc0d$export$9156e739aa33e19f,
    compact: $8ed15ecb979cdc0d$export$8e16b83750b44988,
    separate: $8ed15ecb979cdc0d$export$709f6946f4e97408,
    map: $8ed15ecb979cdc0d$var$_map,
    ap: $8ed15ecb979cdc0d$var$_ap,
    of: $8ed15ecb979cdc0d$export$ba255e9e49e00608,
    chain: $8ed15ecb979cdc0d$export$5b8affa63fc6df16,
    filter: $8ed15ecb979cdc0d$var$_filter,
    filterMap: $8ed15ecb979cdc0d$var$_filterMap,
    partition: $8ed15ecb979cdc0d$var$_partition,
    partitionMap: $8ed15ecb979cdc0d$var$_partitionMap,
    mapWithIndex: $8ed15ecb979cdc0d$var$_mapWithIndex,
    partitionMapWithIndex: $8ed15ecb979cdc0d$var$_partitionMapWithIndex,
    partitionWithIndex: $8ed15ecb979cdc0d$var$_partitionWithIndex,
    filterMapWithIndex: $8ed15ecb979cdc0d$var$_filterMapWithIndex,
    filterWithIndex: $8ed15ecb979cdc0d$var$_filterWithIndex,
    alt: $8ed15ecb979cdc0d$var$_alt,
    zero: $8ed15ecb979cdc0d$export$7f9972325ebfd559,
    unfold: $8ed15ecb979cdc0d$export$c48e357c1a89b78d,
    reduce: $8ed15ecb979cdc0d$var$_reduce,
    foldMap: $8ed15ecb979cdc0d$var$_foldMap,
    reduceRight: $8ed15ecb979cdc0d$var$_reduceRight,
    traverse: $8ed15ecb979cdc0d$var$_traverse,
    sequence: $8ed15ecb979cdc0d$export$49bb65c2ea163039,
    reduceWithIndex: $8ed15ecb979cdc0d$var$_reduceWithIndex,
    foldMapWithIndex: $8ed15ecb979cdc0d$var$_foldMapWithIndex,
    reduceRightWithIndex: $8ed15ecb979cdc0d$var$_reduceRightWithIndex,
    traverseWithIndex: $8ed15ecb979cdc0d$var$_traverseWithIndex,
    extend: $8ed15ecb979cdc0d$var$_extend,
    wither: $8ed15ecb979cdc0d$var$_wither,
    wilt: $8ed15ecb979cdc0d$var$_wilt
};

});
parcelRegister("aYN4d", function(module, exports) {

$parcel$export(module.exports, "ap", () => $7fe591a84c8a55d0$export$2f6ca3d3b1f80bf5);
$parcel$export(module.exports, "apFirst", () => $7fe591a84c8a55d0$export$5f28d9feedcfd46e);
$parcel$export(module.exports, "apSecond", () => $7fe591a84c8a55d0$export$ed01bc59c3d06bf3);
$parcel$export(module.exports, "apS", () => $7fe591a84c8a55d0$export$8cbfc0239f42bb49);
$parcel$export(module.exports, "getApplySemigroup", () => $7fe591a84c8a55d0$export$18979a515d2a828e);
/**
 * The `Apply` class provides the `ap` which is used to apply a function to an argument under a type constructor.
 *
 * `Apply` can be used to lift functions of two or more arguments to work on values wrapped with the type constructor
 * `f`.
 *
 * Instances must satisfy the following law in addition to the `Functor` laws:
 *
 * 1. Associative composition: `F.ap(F.ap(F.map(fbc, bc => ab => a => bc(ab(a))), fab), fa) <-> F.ap(fbc, F.ap(fab, fa))`
 *
 * Formally, `Apply` represents a strong lax semi-monoidal endofunctor.
 *
 * @example
 * import * as O from 'fp-ts/Option'
 * import { pipe } from 'fp-ts/function'
 *
 * const f = (a: string) => (b: number) => (c: boolean) => a + String(b) + String(c)
 * const fa: O.Option<string> = O.some('s')
 * const fb: O.Option<number> = O.some(1)
 * const fc: O.Option<boolean> = O.some(true)
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     // lift a function
 *     O.some(f),
 *     // apply the first argument
 *     O.ap(fa),
 *     // apply the second argument
 *     O.ap(fb),
 *     // apply the third argument
 *     O.ap(fc)
 *   ),
 *   O.some('s1true')
 * )
 *
 * @since 2.0.0
 */ 
var $72EOc = parcelRequire("72EOc");

var $EfnK2 = parcelRequire("EfnK2");
function $7fe591a84c8a55d0$export$2f6ca3d3b1f80bf5(F, G) {
    return function(fa) {
        return function(fab) {
            return F.ap(F.map(fab, function(gab) {
                return function(ga) {
                    return G.ap(gab, ga);
                };
            }), fa);
        };
    };
}
function $7fe591a84c8a55d0$export$5f28d9feedcfd46e(A) {
    return function(second) {
        return function(first) {
            return A.ap(A.map(first, function(a) {
                return function() {
                    return a;
                };
            }), second);
        };
    };
}
function $7fe591a84c8a55d0$export$ed01bc59c3d06bf3(A) {
    return function(second) {
        return function(first) {
            return A.ap(A.map(first, function() {
                return function(b) {
                    return b;
                };
            }), second);
        };
    };
}
function $7fe591a84c8a55d0$export$8cbfc0239f42bb49(F) {
    return function(name, fb) {
        return function(fa) {
            return F.ap(F.map(fa, function(a) {
                return function(b) {
                    var _a;
                    return Object.assign({}, a, (_a = {}, _a[name] = b, _a));
                };
            }), fb);
        };
    };
}
function $7fe591a84c8a55d0$export$18979a515d2a828e(F) {
    return function(S) {
        return {
            concat: function(first, second) {
                return F.ap(F.map(first, function(x) {
                    return function(y) {
                        return S.concat(x, y);
                    };
                }), second);
            }
        };
    };
}
function $7fe591a84c8a55d0$var$curried(f, n, acc) {
    return function(x) {
        var combined = Array(acc.length + 1);
        for(var i = 0; i < acc.length; i++)combined[i] = acc[i];
        combined[acc.length] = x;
        return n === 0 ? f.apply(null, combined) : $7fe591a84c8a55d0$var$curried(f, n - 1, combined);
    };
}
var $7fe591a84c8a55d0$var$tupleConstructors = {
    1: function(a) {
        return [
            a
        ];
    },
    2: function(a) {
        return function(b) {
            return [
                a,
                b
            ];
        };
    },
    3: function(a) {
        return function(b) {
            return function(c) {
                return [
                    a,
                    b,
                    c
                ];
            };
        };
    },
    4: function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return [
                        a,
                        b,
                        c,
                        d
                    ];
                };
            };
        };
    },
    5: function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return [
                            a,
                            b,
                            c,
                            d,
                            e
                        ];
                    };
                };
            };
        };
    }
};
function $7fe591a84c8a55d0$var$getTupleConstructor(len) {
    if (!$EfnK2.has.call($7fe591a84c8a55d0$var$tupleConstructors, len)) $7fe591a84c8a55d0$var$tupleConstructors[len] = $7fe591a84c8a55d0$var$curried((0, $72EOc.tuple), len - 1, []);
    return $7fe591a84c8a55d0$var$tupleConstructors[len];
}
function $7fe591a84c8a55d0$export$6ec24752b7e97e26(F) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var len = args.length;
        var f = $7fe591a84c8a55d0$var$getTupleConstructor(len);
        var fas = F.map(args[0], f);
        for(var i = 1; i < len; i++)fas = F.ap(fas, args[i]);
        return fas;
    };
}
function $7fe591a84c8a55d0$var$getRecordConstructor(keys) {
    var len = keys.length;
    switch(len){
        case 1:
            return function(a) {
                var _a;
                return _a = {}, _a[keys[0]] = a, _a;
            };
        case 2:
            return function(a) {
                return function(b) {
                    var _a;
                    return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a;
                };
            };
        case 3:
            return function(a) {
                return function(b) {
                    return function(c) {
                        var _a;
                        return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a;
                    };
                };
            };
        case 4:
            return function(a) {
                return function(b) {
                    return function(c) {
                        return function(d) {
                            var _a;
                            return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a[keys[3]] = d, _a;
                        };
                    };
                };
            };
        case 5:
            return function(a) {
                return function(b) {
                    return function(c) {
                        return function(d) {
                            return function(e) {
                                var _a;
                                return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a[keys[3]] = d, _a[keys[4]] = e, _a;
                            };
                        };
                    };
                };
            };
        default:
            return $7fe591a84c8a55d0$var$curried(function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var r = {};
                for(var i = 0; i < len; i++)r[keys[i]] = args[i];
                return r;
            }, len - 1, []);
    }
}
function $7fe591a84c8a55d0$export$d04bd2c3b28691e(F) {
    return function(r) {
        var keys = Object.keys(r);
        var len = keys.length;
        var f = $7fe591a84c8a55d0$var$getRecordConstructor(keys);
        var fr = F.map(r[keys[0]], f);
        for(var i = 1; i < len; i++)fr = F.ap(fr, r[keys[i]]);
        return fr;
    };
}

});
parcelRegister("72EOc", function(module, exports) {

$parcel$export(module.exports, "getSemigroup", () => $5208601174ca67ff$export$e759a9a7f8d04692);
$parcel$export(module.exports, "getMonoid", () => $5208601174ca67ff$export$c2a7ef2cc9b32b31);
$parcel$export(module.exports, "identity", () => $5208601174ca67ff$export$f0954fd7d5368655);
$parcel$export(module.exports, "unsafeCoerce", () => $5208601174ca67ff$export$401372c57776dc);
$parcel$export(module.exports, "constant", () => $5208601174ca67ff$export$c983f826f44ff86);
$parcel$export(module.exports, "constTrue", () => $5208601174ca67ff$export$a68382d9631f6c53);
$parcel$export(module.exports, "constFalse", () => $5208601174ca67ff$export$7349232f2648ca80);
$parcel$export(module.exports, "constNull", () => $5208601174ca67ff$export$243c2ee5e7d8b05c);
$parcel$export(module.exports, "constUndefined", () => $5208601174ca67ff$export$3d16a43570087548);
$parcel$export(module.exports, "flow", () => $5208601174ca67ff$export$ccc7b0636abaffc3);
$parcel$export(module.exports, "tuple", () => $5208601174ca67ff$export$65e3907585753458);
$parcel$export(module.exports, "pipe", () => $5208601174ca67ff$export$a4627e546088548d);
$parcel$export(module.exports, "SK", () => $5208601174ca67ff$export$5f584391ee0d99b4);
$parcel$export(module.exports, "dual", () => $5208601174ca67ff$export$d1699a1bbdf17835);
var $5208601174ca67ff$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $5208601174ca67ff$export$f37f1abb2c955577 = function(B) {
    return function() {
        return {
            meet: function(x, y) {
                return function(a) {
                    return B.meet(x(a), y(a));
                };
            },
            join: function(x, y) {
                return function(a) {
                    return B.join(x(a), y(a));
                };
            },
            zero: function() {
                return B.zero;
            },
            one: function() {
                return B.one;
            },
            implies: function(x, y) {
                return function(a) {
                    return B.implies(x(a), y(a));
                };
            },
            not: function(x) {
                return function(a) {
                    return B.not(x(a));
                };
            }
        };
    };
};
var $5208601174ca67ff$export$e759a9a7f8d04692 = function(S) {
    return function() {
        return {
            concat: function(f, g) {
                return function(a) {
                    return S.concat(f(a), g(a));
                };
            }
        };
    };
};
var $5208601174ca67ff$export$c2a7ef2cc9b32b31 = function(M) {
    var getSemigroupM = $5208601174ca67ff$export$e759a9a7f8d04692(M);
    return function() {
        return {
            concat: getSemigroupM().concat,
            empty: function() {
                return M.empty;
            }
        };
    };
};
var $5208601174ca67ff$export$3d48c7fefc7b8ec2 = function(S) {
    return {
        add: function(f, g) {
            return function(x) {
                return S.add(f(x), g(x));
            };
        },
        zero: function() {
            return S.zero;
        },
        mul: function(f, g) {
            return function(x) {
                return S.mul(f(x), g(x));
            };
        },
        one: function() {
            return S.one;
        }
    };
};
var $5208601174ca67ff$export$575097c1c561f76f = function(R) {
    var S = $5208601174ca67ff$export$3d48c7fefc7b8ec2(R);
    return {
        add: S.add,
        mul: S.mul,
        one: S.one,
        zero: S.zero,
        sub: function(f, g) {
            return function(x) {
                return R.sub(f(x), g(x));
            };
        }
    };
};
var $5208601174ca67ff$export$5635d7ef4b8fee1c = function(a) {
    return function(f) {
        return f(a);
    };
};
function $5208601174ca67ff$export$f0954fd7d5368655(a) {
    return a;
}
var $5208601174ca67ff$export$401372c57776dc = $5208601174ca67ff$export$f0954fd7d5368655;
function $5208601174ca67ff$export$c983f826f44ff86(a) {
    return function() {
        return a;
    };
}
var $5208601174ca67ff$export$a68382d9631f6c53 = /*#__PURE__*/ $5208601174ca67ff$export$c983f826f44ff86(true);
var $5208601174ca67ff$export$7349232f2648ca80 = /*#__PURE__*/ $5208601174ca67ff$export$c983f826f44ff86(false);
var $5208601174ca67ff$export$243c2ee5e7d8b05c = /*#__PURE__*/ $5208601174ca67ff$export$c983f826f44ff86(null);
var $5208601174ca67ff$export$3d16a43570087548 = /*#__PURE__*/ $5208601174ca67ff$export$c983f826f44ff86(undefined);
var $5208601174ca67ff$export$fe2a8306a887c223 = $5208601174ca67ff$export$3d16a43570087548;
function $5208601174ca67ff$export$8a83211c878a3f1f(f) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (args.length > 1) return f(args[1], args[0]);
        return function(a) {
            return f(a)(args[0]);
        };
    };
}
function $5208601174ca67ff$export$ccc7b0636abaffc3(ab, bc, cd, de, ef, fg, gh, hi, ij) {
    switch(arguments.length){
        case 1:
            return ab;
        case 2:
            return function() {
                return bc(ab.apply(this, arguments));
            };
        case 3:
            return function() {
                return cd(bc(ab.apply(this, arguments)));
            };
        case 4:
            return function() {
                return de(cd(bc(ab.apply(this, arguments))));
            };
        case 5:
            return function() {
                return ef(de(cd(bc(ab.apply(this, arguments)))));
            };
        case 6:
            return function() {
                return fg(ef(de(cd(bc(ab.apply(this, arguments))))));
            };
        case 7:
            return function() {
                return gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))));
            };
        case 8:
            return function() {
                return hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments))))))));
            };
        case 9:
            return function() {
                return ij(hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))))));
            };
    }
    return;
}
function $5208601174ca67ff$export$65e3907585753458() {
    var t = [];
    for(var _i = 0; _i < arguments.length; _i++)t[_i] = arguments[_i];
    return t;
}
function $5208601174ca67ff$export$a2647aa13413c947(n) {
    return n + 1;
}
function $5208601174ca67ff$export$8f85cc9753f280aa(n) {
    return n - 1;
}
function $5208601174ca67ff$export$f172309911142386(_) {
    throw new Error('Called `absurd` function which should be uncallable');
}
function $5208601174ca67ff$export$91744c046de1af50(f) {
    return function(a) {
        return f.apply(void 0, a);
    };
}
function $5208601174ca67ff$export$db52c4d43c315cb5(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return f(a);
    };
}
function $5208601174ca67ff$export$a4627e546088548d(a, ab, bc, cd, de, ef, fg, gh, hi) {
    switch(arguments.length){
        case 1:
            return a;
        case 2:
            return ab(a);
        case 3:
            return bc(ab(a));
        case 4:
            return cd(bc(ab(a)));
        case 5:
            return de(cd(bc(ab(a))));
        case 6:
            return ef(de(cd(bc(ab(a)))));
        case 7:
            return fg(ef(de(cd(bc(ab(a))))));
        case 8:
            return gh(fg(ef(de(cd(bc(ab(a)))))));
        case 9:
            return hi(gh(fg(ef(de(cd(bc(ab(a))))))));
        default:
            var ret = arguments[0];
            for(var i = 1; i < arguments.length; i++)ret = arguments[i](ret);
            return ret;
    }
}
var $5208601174ca67ff$export$5cc5fd8bb7edf254 = $5208601174ca67ff$export$f172309911142386;
var $5208601174ca67ff$export$5f584391ee0d99b4 = function(_, b) {
    return b;
};
function $5208601174ca67ff$export$6003a5f097c73977(predicate) {
    return function(a) {
        return !predicate(a);
    };
}
var $5208601174ca67ff$export$5c6d2e402d334f37 = function() {
    return {
        concat: function(first, second) {
            return $5208601174ca67ff$export$ccc7b0636abaffc3(first, second);
        },
        empty: $5208601174ca67ff$export$f0954fd7d5368655
    };
};
var $5208601174ca67ff$export$d1699a1bbdf17835 = function(arity, body) {
    var isDataFirst = typeof arity === 'number' ? function(args) {
        return args.length >= arity;
    } : arity;
    return function() {
        var args = Array.from(arguments);
        if (isDataFirst(arguments)) return body.apply(this, args);
        return function(self) {
            return body.apply(void 0, $5208601174ca67ff$var$__spreadArray([
                self
            ], args, false));
        };
    };
};

});

parcelRegister("EfnK2", function(module, exports) {

$parcel$export(module.exports, "isNone", () => $078fab1278725f43$export$e56af863d5645d5f);
$parcel$export(module.exports, "isSome", () => $078fab1278725f43$export$5d7e502287836e58);
$parcel$export(module.exports, "none", () => $078fab1278725f43$export$f883a24d5edde77c);
$parcel$export(module.exports, "some", () => $078fab1278725f43$export$ad14ef4001db2bcd);
$parcel$export(module.exports, "isLeft", () => $078fab1278725f43$export$d649b6842e09f2b);
$parcel$export(module.exports, "isRight", () => $078fab1278725f43$export$a9d71693f0c1a85d);
$parcel$export(module.exports, "left", () => $078fab1278725f43$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "right", () => $078fab1278725f43$export$79ffe56a765070d2);
$parcel$export(module.exports, "singleton", () => $078fab1278725f43$export$439306a4dcaafbb9);
$parcel$export(module.exports, "isNonEmpty", () => $078fab1278725f43$export$a978c53b4062a525);
$parcel$export(module.exports, "head", () => $078fab1278725f43$export$5fd5031fecdacec3);
$parcel$export(module.exports, "tail", () => $078fab1278725f43$export$c01875f616615628);
$parcel$export(module.exports, "emptyReadonlyArray", () => $078fab1278725f43$export$6ca726a2417e0f3f);
$parcel$export(module.exports, "emptyRecord", () => $078fab1278725f43$export$4de80339753b012b);
$parcel$export(module.exports, "has", () => $078fab1278725f43$export$a4f4bb6b1453fff5);
$parcel$export(module.exports, "fromReadonlyNonEmptyArray", () => $078fab1278725f43$export$7e77326b0f0e268c);
$parcel$export(module.exports, "liftNullable", () => $078fab1278725f43$export$cd139e14432f317b);
$parcel$export(module.exports, "liftOption", () => $078fab1278725f43$export$ea4a22f93200df79);
$parcel$export(module.exports, "flatMapNullable", () => $078fab1278725f43$export$1a0515933c5c84fe);
$parcel$export(module.exports, "flatMapOption", () => $078fab1278725f43$export$b5f02b7beb8ed7d8);

var $72EOc = parcelRequire("72EOc");
var $078fab1278725f43$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $078fab1278725f43$export$e56af863d5645d5f = function(fa) {
    return fa._tag === 'None';
};
var $078fab1278725f43$export$5d7e502287836e58 = function(fa) {
    return fa._tag === 'Some';
};
var $078fab1278725f43$export$f883a24d5edde77c = {
    _tag: 'None'
};
var $078fab1278725f43$export$ad14ef4001db2bcd = function(a) {
    return {
        _tag: 'Some',
        value: a
    };
};
var $078fab1278725f43$export$d649b6842e09f2b = function(ma) {
    return ma._tag === 'Left';
};
var $078fab1278725f43$export$a9d71693f0c1a85d = function(ma) {
    return ma._tag === 'Right';
};
var $078fab1278725f43$export$eabcd2c8791e7bf4 = function(e) {
    return {
        _tag: 'Left',
        left: e
    };
};
var $078fab1278725f43$export$79ffe56a765070d2 = function(a) {
    return {
        _tag: 'Right',
        right: a
    };
};
var $078fab1278725f43$export$439306a4dcaafbb9 = function(a) {
    return [
        a
    ];
};
var $078fab1278725f43$export$a978c53b4062a525 = function(as) {
    return as.length > 0;
};
var $078fab1278725f43$export$5fd5031fecdacec3 = function(as) {
    return as[0];
};
var $078fab1278725f43$export$c01875f616615628 = function(as) {
    return as.slice(1);
};
var $078fab1278725f43$export$6ca726a2417e0f3f = [];
var $078fab1278725f43$export$4de80339753b012b = {};
var $078fab1278725f43$export$a4f4bb6b1453fff5 = Object.prototype.hasOwnProperty;
var $078fab1278725f43$export$7e77326b0f0e268c = function(as) {
    return $078fab1278725f43$var$__spreadArray([
        as[0]
    ], as.slice(1), true);
};
var $078fab1278725f43$export$cd139e14432f317b = function(F) {
    return function(f, onNullable) {
        return function() {
            var a = [];
            for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
            var o = f.apply(void 0, a);
            return F.fromEither(o == null ? $078fab1278725f43$export$eabcd2c8791e7bf4(onNullable.apply(void 0, a)) : $078fab1278725f43$export$79ffe56a765070d2(o));
        };
    };
};
var $078fab1278725f43$export$ea4a22f93200df79 = function(F) {
    return function(f, onNone) {
        return function() {
            var a = [];
            for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
            var o = f.apply(void 0, a);
            return F.fromEither($078fab1278725f43$export$e56af863d5645d5f(o) ? $078fab1278725f43$export$eabcd2c8791e7bf4(onNone.apply(void 0, a)) : $078fab1278725f43$export$79ffe56a765070d2(o.value));
        };
    };
};
var $078fab1278725f43$export$1a0515933c5c84fe = function(F, M) {
    return /*#__PURE__*/ (0, $72EOc.dual)(3, function(self, f, onNullable) {
        return M.flatMap(self, $078fab1278725f43$export$cd139e14432f317b(F)(f, onNullable));
    });
};
var $078fab1278725f43$export$b5f02b7beb8ed7d8 = function(F, M) {
    return /*#__PURE__*/ (0, $72EOc.dual)(3, function(self, f, onNone) {
        return M.flatMap(self, $078fab1278725f43$export$ea4a22f93200df79(F)(f, onNone));
    });
};
var $078fab1278725f43$export$979f2bb6a976172d = function(F, M) {
    return /*#__PURE__*/ (0, $72EOc.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromEither(f(a));
        });
    });
};
var $078fab1278725f43$export$8b635ef81222764c = function(F, M) {
    return /*#__PURE__*/ (0, $72EOc.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromIO(f(a));
        });
    });
};
var $078fab1278725f43$export$43849ff3f7ffa51c = function(F, M) {
    return /*#__PURE__*/ (0, $72EOc.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromTask(f(a));
        });
    });
};
var $078fab1278725f43$export$6481f4ccd0f47bbd = function(F, M) {
    return /*#__PURE__*/ (0, $72EOc.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromReader(f(a));
        });
    });
};

});


parcelRegister("kgj0x", function(module, exports) {

$parcel$export(module.exports, "chainFirst", () => $ec040bc836e1dc38$export$e3821ef4970c339c);
$parcel$export(module.exports, "tap", () => $ec040bc836e1dc38$export$3f23594af5f37336);
$parcel$export(module.exports, "bind", () => $ec040bc836e1dc38$export$2385a24977818dd0);
function $ec040bc836e1dc38$export$e3821ef4970c339c(M) {
    var tapM = $ec040bc836e1dc38$export$3f23594af5f37336(M);
    return function(f) {
        return function(first) {
            return tapM(first, f);
        };
    };
}
function $ec040bc836e1dc38$export$3f23594af5f37336(M) {
    return function(first, f) {
        return M.chain(first, function(a) {
            return M.map(f(a), function() {
                return a;
            });
        });
    };
}
function $ec040bc836e1dc38$export$2385a24977818dd0(M) {
    return function(name, f) {
        return function(ma) {
            return M.chain(ma, function(a) {
                return M.map(f(a), function(b) {
                    var _a;
                    return Object.assign({}, a, (_a = {}, _a[name] = b, _a));
                });
            });
        };
    };
}

});

parcelRegister("jFfj2", function(module, exports) {

$parcel$export(module.exports, "fromOption", () => $e50db819b062999e$export$172ec0a6ebfeb6fa);
$parcel$export(module.exports, "fromPredicate", () => $e50db819b062999e$export$23f31c55d7162b91);
$parcel$export(module.exports, "fromOptionK", () => $e50db819b062999e$export$a907462f448b49f8);
$parcel$export(module.exports, "chainOptionK", () => $e50db819b062999e$export$12d26179deb6a68a);
$parcel$export(module.exports, "fromEitherK", () => $e50db819b062999e$export$8138b0ae92c9b5d8);
$parcel$export(module.exports, "chainEitherK", () => $e50db819b062999e$export$a3eef2eba9908c3e);
$parcel$export(module.exports, "tapEither", () => $e50db819b062999e$export$be3ff275bb5a8ac9);
$parcel$export(module.exports, "filterOrElse", () => $e50db819b062999e$export$30af8ca9498ddf5b);
/**
 * The `FromEither` type class represents those data types which support errors.
 *
 * @since 2.10.0
 */ 
var $kgj0x = parcelRequire("kgj0x");

var $72EOc = parcelRequire("72EOc");

var $EfnK2 = parcelRequire("EfnK2");
function $e50db819b062999e$export$172ec0a6ebfeb6fa(F) {
    return function(onNone) {
        return function(ma) {
            return F.fromEither($EfnK2.isNone(ma) ? $EfnK2.left(onNone()) : $EfnK2.right(ma.value));
        };
    };
}
function $e50db819b062999e$export$23f31c55d7162b91(F) {
    return function(predicate, onFalse) {
        return function(a) {
            return F.fromEither(predicate(a) ? $EfnK2.right(a) : $EfnK2.left(onFalse(a)));
        };
    };
}
function $e50db819b062999e$export$a907462f448b49f8(F) {
    var fromOptionF = $e50db819b062999e$export$172ec0a6ebfeb6fa(F);
    return function(onNone) {
        var from = fromOptionF(onNone);
        return function(f) {
            return (0, $72EOc.flow)(f, from);
        };
    };
}
function $e50db819b062999e$export$12d26179deb6a68a(F, M) {
    var fromOptionKF = $e50db819b062999e$export$a907462f448b49f8(F);
    return function(onNone) {
        var from = fromOptionKF(onNone);
        return function(f) {
            return function(ma) {
                return M.chain(ma, from(f));
            };
        };
    };
}
function $e50db819b062999e$export$8138b0ae92c9b5d8(F) {
    return function(f) {
        return (0, $72EOc.flow)(f, F.fromEither);
    };
}
function $e50db819b062999e$export$a3eef2eba9908c3e(F, M) {
    var fromEitherKF = $e50db819b062999e$export$8138b0ae92c9b5d8(F);
    return function(f) {
        return function(ma) {
            return M.chain(ma, fromEitherKF(f));
        };
    };
}
function $e50db819b062999e$export$c5f2bdbf9b43f0c0(F, M) {
    var tapEitherM = $e50db819b062999e$export$be3ff275bb5a8ac9(F, M);
    return function(f) {
        return function(ma) {
            return tapEitherM(ma, f);
        };
    };
}
function $e50db819b062999e$export$30af8ca9498ddf5b(F, M) {
    return function(predicate, onFalse) {
        return function(ma) {
            return M.chain(ma, function(a) {
                return F.fromEither(predicate(a) ? $EfnK2.right(a) : $EfnK2.left(onFalse(a)));
            });
        };
    };
}
function $e50db819b062999e$export$be3ff275bb5a8ac9(F, M) {
    var fromEither = $e50db819b062999e$export$8138b0ae92c9b5d8(F);
    var tapM = (0, $kgj0x.tap)(M);
    return function(self, f) {
        return tapM(self, fromEither(f));
    };
}

});

parcelRegister("cpwuW", function(module, exports) {

$parcel$export(module.exports, "flap", () => $90910745238aeb40$export$18c957606d8bdf09);
$parcel$export(module.exports, "bindTo", () => $90910745238aeb40$export$7c052ae73f8acff0);
$parcel$export(module.exports, "let", () => $90910745238aeb40$export$5d537b797c421217);
$parcel$export(module.exports, "getFunctorComposition", () => $90910745238aeb40$export$7b0f6fce42e2b480);
$parcel$export(module.exports, "as", () => $90910745238aeb40$export$6554612db691658e);
$parcel$export(module.exports, "asUnit", () => $90910745238aeb40$export$9284b360ca18a0fd);
/**
 * A `Functor` is a type constructor which supports a mapping operation `map`.
 *
 * `map` can be used to turn functions `a -> b` into functions `f a -> f b` whose argument and return types use the type
 * constructor `f` to represent some computational context.
 *
 * Instances must satisfy the following laws:
 *
 * 1. Identity: `F.map(fa, a => a) <-> fa`
 * 2. Composition: `F.map(fa, a => bc(ab(a))) <-> F.map(F.map(fa, ab), bc)`
 *
 * @since 2.0.0
 */ 
var $72EOc = parcelRequire("72EOc");
function $90910745238aeb40$export$871de8747c9eaa88(F, G) {
    return function(f) {
        return function(fa) {
            return F.map(fa, function(ga) {
                return G.map(ga, f);
            });
        };
    };
}
function $90910745238aeb40$export$18c957606d8bdf09(F) {
    return function(a) {
        return function(fab) {
            return F.map(fab, function(f) {
                return f(a);
            });
        };
    };
}
function $90910745238aeb40$export$7c052ae73f8acff0(F) {
    return function(name) {
        return function(fa) {
            return F.map(fa, function(a) {
                var _a;
                return _a = {}, _a[name] = a, _a;
            });
        };
    };
}
function $90910745238aeb40$export$5d537b797c421217(F) {
    return function(name, f) {
        return function(fa) {
            return F.map(fa, function(a) {
                var _a;
                return Object.assign({}, a, (_a = {}, _a[name] = f(a), _a));
            });
        };
    };
}
function $90910745238aeb40$export$7b0f6fce42e2b480(F, G) {
    var _map = $90910745238aeb40$export$871de8747c9eaa88(F, G);
    return {
        map: function(fga, f) {
            return (0, $72EOc.pipe)(fga, _map(f));
        }
    };
}
function $90910745238aeb40$export$6554612db691658e(F) {
    return function(self, b) {
        return F.map(self, function() {
            return b;
        });
    };
}
function $90910745238aeb40$export$9284b360ca18a0fd(F) {
    var asM = $90910745238aeb40$export$6554612db691658e(F);
    return function(self) {
        return asM(self, undefined);
    };
}

});

parcelRegister("96Xjv", function(module, exports) {

$parcel$export(module.exports, "isNonEmpty", () => $6a22af06192636c3$export$a978c53b4062a525);
$parcel$export(module.exports, "isOutOfBound", () => $6a22af06192636c3$export$2fde0b1c54fc39b9);
$parcel$export(module.exports, "prependW", () => $6a22af06192636c3$export$c4c4d41eab625797);
$parcel$export(module.exports, "prepend", () => $6a22af06192636c3$export$68159836694e22c1);
$parcel$export(module.exports, "appendW", () => $6a22af06192636c3$export$19903a1bf1942f6);
$parcel$export(module.exports, "append", () => $6a22af06192636c3$export$10d8903dec122b9d);
$parcel$export(module.exports, "unsafeInsertAt", () => $6a22af06192636c3$export$f4863e1822a1860c);
$parcel$export(module.exports, "unsafeUpdateAt", () => $6a22af06192636c3$export$9c0c6889b1fa9bfc);
$parcel$export(module.exports, "uniq", () => $6a22af06192636c3$export$f70730c3d1fc524e);
$parcel$export(module.exports, "head", () => $6a22af06192636c3$export$5fd5031fecdacec3);
$parcel$export(module.exports, "tail", () => $6a22af06192636c3$export$c01875f616615628);
$parcel$export(module.exports, "sortBy", () => $6a22af06192636c3$export$b035e44d7bb4278f);
$parcel$export(module.exports, "union", () => $6a22af06192636c3$export$971dd5b0dfd021b6);
$parcel$export(module.exports, "rotate", () => $6a22af06192636c3$export$bb628a54ab399bc9);
$parcel$export(module.exports, "splitAt", () => $6a22af06192636c3$export$b0d75975ac0be0e1);
$parcel$export(module.exports, "makeBy", () => $6a22af06192636c3$export$849fbdcc2211fcde);
$parcel$export(module.exports, "range", () => $6a22af06192636c3$export$d02631cccf789723);
$parcel$export(module.exports, "init", () => $6a22af06192636c3$export$2cd8252107eb640b);
$parcel$export(module.exports, "last", () => $6a22af06192636c3$export$4c7897fafd92b108);
$parcel$export(module.exports, "of", () => $6a22af06192636c3$export$ba255e9e49e00608);
$parcel$export(module.exports, "prependAll", () => $6a22af06192636c3$export$849c7567cbd62acc);
$parcel$export(module.exports, "intersperse", () => $6a22af06192636c3$export$af200dcf8b7cb5de);
$parcel$export(module.exports, "chop", () => $6a22af06192636c3$export$433fe05b12ba833f);
$parcel$export(module.exports, "chunksOf", () => $6a22af06192636c3$export$2f0184d5df52135f);
$parcel$export(module.exports, "cons", () => $6a22af06192636c3$export$8327ebbef2a0ba76);
$parcel$export(module.exports, "snoc", () => $6a22af06192636c3$export$c40cf5aab899f397);

var $aYN4d = parcelRequire("aYN4d");

var $kgj0x = parcelRequire("kgj0x");

var $72EOc = parcelRequire("72EOc");

var $cpwuW = parcelRequire("cpwuW");

var $EfnK2 = parcelRequire("EfnK2");

var $gcR1C = parcelRequire("gcR1C");

var $ecsM6 = parcelRequire("ecsM6");
var $6a22af06192636c3$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $6a22af06192636c3$export$a978c53b4062a525 = function(as) {
    return as.length > 0;
};
var $6a22af06192636c3$export$2fde0b1c54fc39b9 = function(i, as) {
    return i < 0 || i >= as.length;
};
var $6a22af06192636c3$export$c4c4d41eab625797 = function(head) {
    return function(tail) {
        return $6a22af06192636c3$var$__spreadArray([
            head
        ], tail, true);
    };
};
var $6a22af06192636c3$export$68159836694e22c1 = $6a22af06192636c3$export$c4c4d41eab625797;
var $6a22af06192636c3$export$19903a1bf1942f6 = function(end) {
    return function(init) {
        return $6a22af06192636c3$var$__spreadArray($6a22af06192636c3$var$__spreadArray([], init, true), [
            end
        ], false);
    };
};
var $6a22af06192636c3$export$10d8903dec122b9d = $6a22af06192636c3$export$19903a1bf1942f6;
var $6a22af06192636c3$export$f4863e1822a1860c = function(i, a, as) {
    if ($6a22af06192636c3$export$a978c53b4062a525(as)) {
        var xs = $6a22af06192636c3$export$7e77326b0f0e268c(as);
        xs.splice(i, 0, a);
        return xs;
    }
    return [
        a
    ];
};
var $6a22af06192636c3$export$9c0c6889b1fa9bfc = function(i, a, as) {
    var xs = $6a22af06192636c3$export$7e77326b0f0e268c(as);
    xs[i] = a;
    return xs;
};
var $6a22af06192636c3$export$f70730c3d1fc524e = function(E) {
    return function(as) {
        if (as.length === 1) return $6a22af06192636c3$export$784d13d8ee351f07(as);
        var out = [
            $6a22af06192636c3$export$5fd5031fecdacec3(as)
        ];
        var rest = $6a22af06192636c3$export$c01875f616615628(as);
        var _loop_1 = function(a) {
            if (out.every(function(o) {
                return !E.equals(o, a);
            })) out.push(a);
        };
        for(var _i = 0, rest_1 = rest; _i < rest_1.length; _i++){
            var a = rest_1[_i];
            _loop_1(a);
        }
        return out;
    };
};
var $6a22af06192636c3$export$b035e44d7bb4278f = function(ords) {
    if ($6a22af06192636c3$export$a978c53b4062a525(ords)) {
        var M = (0, $gcR1C.getMonoid)();
        return $6a22af06192636c3$export$97db5808d8f88186(ords.reduce(M.concat, M.empty));
    }
    return $6a22af06192636c3$export$784d13d8ee351f07;
};
var $6a22af06192636c3$export$971dd5b0dfd021b6 = function(E) {
    var uniqE = $6a22af06192636c3$export$f70730c3d1fc524e(E);
    return function(second) {
        return function(first) {
            return uniqE((0, $72EOc.pipe)(first, $6a22af06192636c3$export$ee1b3e54f0441b22(second)));
        };
    };
};
var $6a22af06192636c3$export$bb628a54ab399bc9 = function(n) {
    return function(as) {
        var len = as.length;
        var m = Math.round(n) % len;
        if ($6a22af06192636c3$export$2fde0b1c54fc39b9(Math.abs(m), as) || m === 0) return $6a22af06192636c3$export$784d13d8ee351f07(as);
        if (m < 0) {
            var _a = $6a22af06192636c3$export$b0d75975ac0be0e1(-m)(as), f = _a[0], s = _a[1];
            return (0, $72EOc.pipe)(s, $6a22af06192636c3$export$ee1b3e54f0441b22(f));
        } else return $6a22af06192636c3$export$bb628a54ab399bc9(m - len)(as);
    };
};
var $6a22af06192636c3$export$7e77326b0f0e268c = $EfnK2.fromReadonlyNonEmptyArray;
var $6a22af06192636c3$export$571d59b505e6bb4e = function(as) {
    return $6a22af06192636c3$export$a978c53b4062a525(as) ? $EfnK2.some(as) : $EfnK2.none;
};
var $6a22af06192636c3$export$849fbdcc2211fcde = function(f) {
    return function(n) {
        var j = Math.max(0, Math.floor(n));
        var out = [
            f(0)
        ];
        for(var i = 1; i < j; i++)out.push(f(i));
        return out;
    };
};
var $6a22af06192636c3$export$606959e7ccb797f0 = function(a) {
    return $6a22af06192636c3$export$849fbdcc2211fcde(function() {
        return a;
    });
};
var $6a22af06192636c3$export$d02631cccf789723 = function(start, end) {
    return start <= end ? $6a22af06192636c3$export$849fbdcc2211fcde(function(i) {
        return start + i;
    })(end - start + 1) : [
        start
    ];
};
var $6a22af06192636c3$export$c04edabe9c8d994f = function(as) {
    return [
        $6a22af06192636c3$export$5fd5031fecdacec3(as),
        $6a22af06192636c3$export$c01875f616615628(as)
    ];
};
var $6a22af06192636c3$export$89a97afc72a83708 = function(as) {
    return [
        $6a22af06192636c3$export$2cd8252107eb640b(as),
        $6a22af06192636c3$export$4c7897fafd92b108(as)
    ];
};
function $6a22af06192636c3$export$c8c959650bbe80e2(second) {
    return function(first) {
        return first.concat(second);
    };
}
function $6a22af06192636c3$export$ee1b3e54f0441b22(x, y) {
    return y ? x.concat(y) : function(y) {
        return y.concat(x);
    };
}
var $6a22af06192636c3$export$66c1ae025e96b4bc = function(as) {
    return $6a22af06192636c3$var$__spreadArray([
        $6a22af06192636c3$export$4c7897fafd92b108(as)
    ], as.slice(0, -1).reverse(), true);
};
function $6a22af06192636c3$export$e5e25fbcc1f7affe(E) {
    return function(as) {
        var len = as.length;
        if (len === 0) return [];
        var out = [];
        var head = as[0];
        var nea = [
            head
        ];
        for(var i = 1; i < len; i++){
            var a = as[i];
            if (E.equals(a, head)) nea.push(a);
            else {
                out.push(nea);
                head = a;
                nea = [
                    head
                ];
            }
        }
        out.push(nea);
        return out;
    };
}
var $6a22af06192636c3$export$3f063810d7bf01bd = function(f) {
    return function(as) {
        var out = {};
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            var k = f(a);
            if ($EfnK2.has.call(out, k)) out[k].push(a);
            else out[k] = [
                a
            ];
        }
        return out;
    };
};
var $6a22af06192636c3$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.slice().sort(O.compare);
    };
};
var $6a22af06192636c3$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $EfnK2.none : $EfnK2.some($6a22af06192636c3$export$f4863e1822a1860c(i, a, as));
    };
};
var $6a22af06192636c3$export$b6d8713d53419d4c = function(i, a) {
    return $6a22af06192636c3$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $6a22af06192636c3$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $6a22af06192636c3$export$2fde0b1c54fc39b9(i, as) ? $EfnK2.none : $EfnK2.some($6a22af06192636c3$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $6a22af06192636c3$export$784d13d8ee351f07 = $6a22af06192636c3$export$7e77326b0f0e268c;
var $6a22af06192636c3$export$ba255e9e49e00608 = function(a) {
    return [
        a
    ];
};
var $6a22af06192636c3$export$b634740ce272acb5 = function(as, bs, f) {
    var cs = [
        f(as[0], bs[0])
    ];
    var len = Math.min(as.length, bs.length);
    for(var i = 1; i < len; i++)cs[i] = f(as[i], bs[i]);
    return cs;
};
function $6a22af06192636c3$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $6a22af06192636c3$export$8901015135f2fb22(bs, as);
    };
    return $6a22af06192636c3$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $6a22af06192636c3$export$23c8d3f8757cab88 = function(abs) {
    var fa = [
        abs[0][0]
    ];
    var fb = [
        abs[0][1]
    ];
    for(var i = 1; i < abs.length; i++){
        fa[i] = abs[i][0];
        fb[i] = abs[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $6a22af06192636c3$export$849c7567cbd62acc = function(middle) {
    return function(as) {
        var out = [
            middle,
            as[0]
        ];
        for(var i = 1; i < as.length; i++)out.push(middle, as[i]);
        return out;
    };
};
var $6a22af06192636c3$export$af200dcf8b7cb5de = function(middle) {
    return function(as) {
        var rest = $6a22af06192636c3$export$c01875f616615628(as);
        return $6a22af06192636c3$export$a978c53b4062a525(rest) ? (0, $72EOc.pipe)(rest, $6a22af06192636c3$export$849c7567cbd62acc(middle), $6a22af06192636c3$export$68159836694e22c1($6a22af06192636c3$export$5fd5031fecdacec3(as))) : $6a22af06192636c3$export$784d13d8ee351f07(as);
    };
};
var $6a22af06192636c3$export$18153bb1181268e5 = $ecsM6.foldMapWithIndex;
var $6a22af06192636c3$export$b66cdc0497d8a99a = $ecsM6.foldMap;
var $6a22af06192636c3$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        var out = $6a22af06192636c3$export$7e77326b0f0e268c(f(0, $6a22af06192636c3$export$5fd5031fecdacec3(as)));
        for(var i = 1; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $6a22af06192636c3$export$433fe05b12ba833f = function(f) {
    return function(as) {
        var _a = f(as), b = _a[0], rest = _a[1];
        var out = [
            b
        ];
        var next = rest;
        while($6a22af06192636c3$export$a978c53b4062a525(next)){
            var _b = f(next), b_1 = _b[0], rest_2 = _b[1];
            out.push(b_1);
            next = rest_2;
        }
        return out;
    };
};
var $6a22af06192636c3$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        var m = Math.max(1, n);
        return m >= as.length ? [
            $6a22af06192636c3$export$784d13d8ee351f07(as),
            []
        ] : [
            (0, $72EOc.pipe)(as.slice(1, m), $6a22af06192636c3$export$68159836694e22c1($6a22af06192636c3$export$5fd5031fecdacec3(as))),
            as.slice(m)
        ];
    };
};
var $6a22af06192636c3$export$2f0184d5df52135f = function(n) {
    return $6a22af06192636c3$export$433fe05b12ba833f($6a22af06192636c3$export$b0d75975ac0be0e1(n));
};
/* istanbul ignore next */ var $6a22af06192636c3$var$_map = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $6a22af06192636c3$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $6a22af06192636c3$var$_mapWithIndex = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $6a22af06192636c3$export$8f07ddce13659f50(f));
};
/* istanbul ignore next */ var $6a22af06192636c3$var$_ap = function(fab, fa) {
    return (0, $72EOc.pipe)(fab, $6a22af06192636c3$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $6a22af06192636c3$var$_extend = function(wa, f) {
    return (0, $72EOc.pipe)(wa, $6a22af06192636c3$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $6a22af06192636c3$var$_reduce = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $6a22af06192636c3$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $6a22af06192636c3$var$_foldMap = function(M) {
    var foldMapM = $6a22af06192636c3$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $72EOc.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $6a22af06192636c3$var$_reduceRight = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $6a22af06192636c3$export$7fef8bcdbb34f435(b, f));
};
/* istanbul ignore next */ var $6a22af06192636c3$var$_traverse = function(F) {
    var traverseF = $6a22af06192636c3$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $72EOc.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $6a22af06192636c3$var$_alt = function(fa, that) {
    return (0, $72EOc.pipe)(fa, $6a22af06192636c3$export$228be17d80722ab(that));
};
/* istanbul ignore next */ var $6a22af06192636c3$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $6a22af06192636c3$export$bbd3ef8720e22369(b, f));
};
/* istanbul ignore next */ var $6a22af06192636c3$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $6a22af06192636c3$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $72EOc.pipe)(fa, foldMapWithIndexM(f));
    };
};
/* istanbul ignore next */ var $6a22af06192636c3$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $6a22af06192636c3$export$ce2b2fe0b88ccd0a(b, f));
};
/* istanbul ignore next */ var $6a22af06192636c3$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $6a22af06192636c3$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $72EOc.pipe)(ta, traverseWithIndexF(f));
    };
};
var $6a22af06192636c3$export$1517cca7889d6aaa = function(that) {
    return function(as) {
        return (0, $72EOc.pipe)(as, $6a22af06192636c3$export$c8c959650bbe80e2(that()));
    };
};
var $6a22af06192636c3$export$228be17d80722ab = $6a22af06192636c3$export$1517cca7889d6aaa;
var $6a22af06192636c3$export$2f6ca3d3b1f80bf5 = function(as) {
    return $6a22af06192636c3$export$5b8affa63fc6df16(function(f) {
        return (0, $72EOc.pipe)(as, $6a22af06192636c3$export$871de8747c9eaa88(f));
    });
};
var $6a22af06192636c3$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $72EOc.dual)(2, function(ma, f) {
    return (0, $72EOc.pipe)(ma, $6a22af06192636c3$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $6a22af06192636c3$export$8b58be045bf06082 = function(f) {
    return function(as) {
        var next = $6a22af06192636c3$export$c01875f616615628(as);
        var out = [
            f(as)
        ];
        while($6a22af06192636c3$export$a978c53b4062a525(next)){
            out.push(f(next));
            next = $6a22af06192636c3$export$c01875f616615628(next);
        }
        return out;
    };
};
var $6a22af06192636c3$export$ecd5e8ace626722c = /*#__PURE__*/ $6a22af06192636c3$export$8b58be045bf06082((0, $72EOc.identity));
var $6a22af06192636c3$export$bffa455ba8c619a6 = /*#__PURE__*/ $6a22af06192636c3$export$5b8affa63fc6df16((0, $72EOc.identity));
var $6a22af06192636c3$export$871de8747c9eaa88 = function(f) {
    return $6a22af06192636c3$export$8f07ddce13659f50(function(_, a) {
        return f(a);
    });
};
var $6a22af06192636c3$export$8f07ddce13659f50 = function(f) {
    return function(as) {
        var out = [
            f(0, $6a22af06192636c3$export$5fd5031fecdacec3(as))
        ];
        for(var i = 1; i < as.length; i++)out.push(f(i, as[i]));
        return out;
    };
};
var $6a22af06192636c3$export$533b26079ad0b4b = $ecsM6.reduce;
var $6a22af06192636c3$export$bbd3ef8720e22369 = $ecsM6.reduceWithIndex;
var $6a22af06192636c3$export$7fef8bcdbb34f435 = $ecsM6.reduceRight;
var $6a22af06192636c3$export$ce2b2fe0b88ccd0a = $ecsM6.reduceRightWithIndex;
var $6a22af06192636c3$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $6a22af06192636c3$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $6a22af06192636c3$export$49bb65c2ea163039 = function(F) {
    return $6a22af06192636c3$export$955fdc0d24efa249(F)(function(_, a) {
        return a;
    });
};
var $6a22af06192636c3$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return function(as) {
            var out = F.map(f(0, $6a22af06192636c3$export$5fd5031fecdacec3(as)), $6a22af06192636c3$export$ba255e9e49e00608);
            for(var i = 1; i < as.length; i++)out = F.ap(F.map(out, function(bs) {
                return function(b) {
                    return (0, $72EOc.pipe)(bs, $6a22af06192636c3$export$10d8903dec122b9d(b));
                };
            }), f(i, as[i]));
            return out;
        };
    };
};
var $6a22af06192636c3$export$f9380c9a627682d3 = $ecsM6.head;
var $6a22af06192636c3$export$9156e739aa33e19f = 'NonEmptyArray';
var $6a22af06192636c3$export$3cb5cd7f7776c81 = $ecsM6.getShow;
var $6a22af06192636c3$export$e759a9a7f8d04692 = function() {
    return {
        concat: $6a22af06192636c3$export$ee1b3e54f0441b22
    };
};
var $6a22af06192636c3$export$804fed467fde44e4 = $ecsM6.getEq;
var $6a22af06192636c3$export$baca17b4aff42f82 = function(E) {
    var unionE = $6a22af06192636c3$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $6a22af06192636c3$export$bd5b6bfc5fa2ee61 = {
    URI: $6a22af06192636c3$export$9156e739aa33e19f,
    map: $6a22af06192636c3$var$_map
};
var $6a22af06192636c3$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $cpwuW.flap)($6a22af06192636c3$export$bd5b6bfc5fa2ee61);
var $6a22af06192636c3$export$59a71046037e6c20 = {
    URI: $6a22af06192636c3$export$9156e739aa33e19f,
    of: $6a22af06192636c3$export$ba255e9e49e00608
};
var $6a22af06192636c3$export$9fdffe0fe1e91cad = {
    URI: $6a22af06192636c3$export$9156e739aa33e19f,
    map: $6a22af06192636c3$var$_map,
    mapWithIndex: $6a22af06192636c3$var$_mapWithIndex
};
var $6a22af06192636c3$export$efc21ddc6aeb363d = {
    URI: $6a22af06192636c3$export$9156e739aa33e19f,
    map: $6a22af06192636c3$var$_map,
    ap: $6a22af06192636c3$var$_ap
};
var $6a22af06192636c3$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $aYN4d.apFirst)($6a22af06192636c3$export$efc21ddc6aeb363d);
var $6a22af06192636c3$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $aYN4d.apSecond)($6a22af06192636c3$export$efc21ddc6aeb363d);
var $6a22af06192636c3$export$1279d2b7807629fd = {
    URI: $6a22af06192636c3$export$9156e739aa33e19f,
    map: $6a22af06192636c3$var$_map,
    ap: $6a22af06192636c3$var$_ap,
    of: $6a22af06192636c3$export$ba255e9e49e00608
};
var $6a22af06192636c3$export$f18d5acc27d70423 = {
    URI: $6a22af06192636c3$export$9156e739aa33e19f,
    map: $6a22af06192636c3$var$_map,
    ap: $6a22af06192636c3$var$_ap,
    chain: $6a22af06192636c3$export$5b8affa63fc6df16
};
var $6a22af06192636c3$export$e3821ef4970c339c = /*#__PURE__*/ (0, $kgj0x.chainFirst)($6a22af06192636c3$export$f18d5acc27d70423);
var $6a22af06192636c3$export$fb641926d034ac7d = {
    URI: $6a22af06192636c3$export$9156e739aa33e19f,
    map: $6a22af06192636c3$var$_map,
    ap: $6a22af06192636c3$var$_ap,
    of: $6a22af06192636c3$export$ba255e9e49e00608,
    chain: $6a22af06192636c3$export$5b8affa63fc6df16
};
var $6a22af06192636c3$export$41404b31838667c9 = {
    URI: $6a22af06192636c3$export$9156e739aa33e19f,
    reduce: $6a22af06192636c3$var$_reduce,
    foldMap: $6a22af06192636c3$var$_foldMap,
    reduceRight: $6a22af06192636c3$var$_reduceRight
};
var $6a22af06192636c3$export$e8f7d17aaff345cb = {
    URI: $6a22af06192636c3$export$9156e739aa33e19f,
    reduce: $6a22af06192636c3$var$_reduce,
    foldMap: $6a22af06192636c3$var$_foldMap,
    reduceRight: $6a22af06192636c3$var$_reduceRight,
    reduceWithIndex: $6a22af06192636c3$var$_reduceWithIndex,
    foldMapWithIndex: $6a22af06192636c3$var$_foldMapWithIndex,
    reduceRightWithIndex: $6a22af06192636c3$var$_reduceRightWithIndex
};
var $6a22af06192636c3$export$a0202666c3bda011 = {
    URI: $6a22af06192636c3$export$9156e739aa33e19f,
    map: $6a22af06192636c3$var$_map,
    reduce: $6a22af06192636c3$var$_reduce,
    foldMap: $6a22af06192636c3$var$_foldMap,
    reduceRight: $6a22af06192636c3$var$_reduceRight,
    traverse: $6a22af06192636c3$var$_traverse,
    sequence: $6a22af06192636c3$export$49bb65c2ea163039
};
var $6a22af06192636c3$export$bd7b528d8c36ec41 = {
    URI: $6a22af06192636c3$export$9156e739aa33e19f,
    map: $6a22af06192636c3$var$_map,
    mapWithIndex: $6a22af06192636c3$var$_mapWithIndex,
    reduce: $6a22af06192636c3$var$_reduce,
    foldMap: $6a22af06192636c3$var$_foldMap,
    reduceRight: $6a22af06192636c3$var$_reduceRight,
    traverse: $6a22af06192636c3$var$_traverse,
    sequence: $6a22af06192636c3$export$49bb65c2ea163039,
    reduceWithIndex: $6a22af06192636c3$var$_reduceWithIndex,
    foldMapWithIndex: $6a22af06192636c3$var$_foldMapWithIndex,
    reduceRightWithIndex: $6a22af06192636c3$var$_reduceRightWithIndex,
    traverseWithIndex: $6a22af06192636c3$var$_traverseWithIndex
};
var $6a22af06192636c3$export$25ba4469a069167 = {
    URI: $6a22af06192636c3$export$9156e739aa33e19f,
    map: $6a22af06192636c3$var$_map,
    alt: $6a22af06192636c3$var$_alt
};
var $6a22af06192636c3$export$fdd73124b9f1de36 = {
    URI: $6a22af06192636c3$export$9156e739aa33e19f,
    map: $6a22af06192636c3$var$_map,
    extend: $6a22af06192636c3$var$_extend,
    extract: $6a22af06192636c3$export$f9380c9a627682d3
};
var $6a22af06192636c3$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $6a22af06192636c3$export$ba255e9e49e00608($EfnK2.emptyRecord);
var $6a22af06192636c3$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $cpwuW.bindTo)($6a22af06192636c3$export$bd5b6bfc5fa2ee61);
var $6a22af06192636c3$export$5d537b797c421217 = /*#__PURE__*/ (0, $cpwuW.let)($6a22af06192636c3$export$bd5b6bfc5fa2ee61);
var $6a22af06192636c3$export$2385a24977818dd0 = /*#__PURE__*/ (0, $kgj0x.bind)($6a22af06192636c3$export$f18d5acc27d70423);
var $6a22af06192636c3$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $aYN4d.apS)($6a22af06192636c3$export$efc21ddc6aeb363d);
var $6a22af06192636c3$export$5fd5031fecdacec3 = $ecsM6.head;
var $6a22af06192636c3$export$c01875f616615628 = function(as) {
    return as.slice(1);
};
var $6a22af06192636c3$export$4c7897fafd92b108 = $ecsM6.last;
var $6a22af06192636c3$export$2cd8252107eb640b = function(as) {
    return as.slice(0, -1);
};
var $6a22af06192636c3$export$96ec731ed4dcb222 = $ecsM6.min;
var $6a22af06192636c3$export$8960430cfd85939f = $ecsM6.max;
var $6a22af06192636c3$export$b314777ae20abca9 = function(S) {
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $6a22af06192636c3$export$6280271dfaec4919 = function(f) {
    return function(as) {
        return f($6a22af06192636c3$export$5fd5031fecdacec3(as), $6a22af06192636c3$export$c01875f616615628(as));
    };
};
var $6a22af06192636c3$export$b1cacb83a5c6bd02 = function(f) {
    return function(as) {
        return f($6a22af06192636c3$export$2cd8252107eb640b(as), $6a22af06192636c3$export$4c7897fafd92b108(as));
    };
};
var $6a22af06192636c3$export$5c7327d4e64ef2aa = function(f) {
    return function(as) {
        return $6a22af06192636c3$var$__spreadArray([
            f($6a22af06192636c3$export$5fd5031fecdacec3(as))
        ], $6a22af06192636c3$export$c01875f616615628(as), true);
    };
};
var $6a22af06192636c3$export$20ca6ad9f7762931 = function(a) {
    return $6a22af06192636c3$export$5c7327d4e64ef2aa(function() {
        return a;
    });
};
var $6a22af06192636c3$export$302ad361c463800a = function(f) {
    return function(as) {
        return (0, $72EOc.pipe)($6a22af06192636c3$export$2cd8252107eb640b(as), $6a22af06192636c3$export$10d8903dec122b9d(f($6a22af06192636c3$export$4c7897fafd92b108(as))));
    };
};
var $6a22af06192636c3$export$d3affa0a0a83d946 = function(a) {
    return $6a22af06192636c3$export$302ad361c463800a(function() {
        return a;
    });
};
var $6a22af06192636c3$export$739ec22334c44788 = $ecsM6.intercalate;
var $6a22af06192636c3$export$e08e3b67e392101e = $6a22af06192636c3$export$5b8affa63fc6df16;
function $6a22af06192636c3$export$103ce2c0a67e4e61(O) {
    var sortO = $6a22af06192636c3$export$97db5808d8f88186(O);
    var groupO = $6a22af06192636c3$export$e5e25fbcc1f7affe(O);
    return function(as) {
        return $6a22af06192636c3$export$a978c53b4062a525(as) ? groupO(sortO(as)) : [];
    };
}
function $6a22af06192636c3$export$3dea766d36a8935f(predicate) {
    return $6a22af06192636c3$export$36e42aef19fc7171(function(_, a) {
        return predicate(a);
    });
}
var $6a22af06192636c3$export$36e42aef19fc7171 = function(predicate) {
    return function(as) {
        return $6a22af06192636c3$export$571d59b505e6bb4e(as.filter(function(a, i) {
            return predicate(i, a);
        }));
    };
};
var $6a22af06192636c3$export$b446f6baa3bb1430 = $6a22af06192636c3$export$c04edabe9c8d994f;
var $6a22af06192636c3$export$712962e076096ed4 = $6a22af06192636c3$export$89a97afc72a83708;
function $6a22af06192636c3$export$8327ebbef2a0ba76(head, tail) {
    return tail === undefined ? $6a22af06192636c3$export$68159836694e22c1(head) : (0, $72EOc.pipe)(tail, $6a22af06192636c3$export$68159836694e22c1(head));
}
var $6a22af06192636c3$export$c40cf5aab899f397 = function(init, end) {
    return (0, $72EOc.pipe)(init, $6a22af06192636c3$export$10d8903dec122b9d(end));
};
var $6a22af06192636c3$export$baeb00bf1e27e233 = $6a22af06192636c3$export$849c7567cbd62acc;
var $6a22af06192636c3$export$93e2b83da34ff82a = $ecsM6.concatAll;
var $6a22af06192636c3$export$a5383a53b408af94 = {
    URI: $6a22af06192636c3$export$9156e739aa33e19f,
    of: $6a22af06192636c3$export$ba255e9e49e00608,
    map: $6a22af06192636c3$var$_map,
    mapWithIndex: $6a22af06192636c3$var$_mapWithIndex,
    ap: $6a22af06192636c3$var$_ap,
    chain: $6a22af06192636c3$export$5b8affa63fc6df16,
    extend: $6a22af06192636c3$var$_extend,
    extract: $6a22af06192636c3$export$f9380c9a627682d3,
    reduce: $6a22af06192636c3$var$_reduce,
    foldMap: $6a22af06192636c3$var$_foldMap,
    reduceRight: $6a22af06192636c3$var$_reduceRight,
    traverse: $6a22af06192636c3$var$_traverse,
    sequence: $6a22af06192636c3$export$49bb65c2ea163039,
    reduceWithIndex: $6a22af06192636c3$var$_reduceWithIndex,
    foldMapWithIndex: $6a22af06192636c3$var$_foldMapWithIndex,
    reduceRightWithIndex: $6a22af06192636c3$var$_reduceRightWithIndex,
    traverseWithIndex: $6a22af06192636c3$var$_traverseWithIndex,
    alt: $6a22af06192636c3$var$_alt
};

});
parcelRegister("gcR1C", function(module, exports) {

$parcel$export(module.exports, "fromCompare", () => $bcc6e5fd0afe4f22$export$aa9e0de96ff2f1fd);
$parcel$export(module.exports, "getMonoid", () => $bcc6e5fd0afe4f22$export$c2a7ef2cc9b32b31);
$parcel$export(module.exports, "min", () => $bcc6e5fd0afe4f22$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $bcc6e5fd0afe4f22$export$8960430cfd85939f);

var $3Md1m = parcelRequire("3Md1m");

var $72EOc = parcelRequire("72EOc");
var $bcc6e5fd0afe4f22$export$19fbc5aa8790347c = function(compare) {
    return function(first, second) {
        return first === second || compare(first, second) === 0;
    };
};
var $bcc6e5fd0afe4f22$export$aa9e0de96ff2f1fd = function(compare) {
    return {
        equals: $bcc6e5fd0afe4f22$export$19fbc5aa8790347c(compare),
        compare: function(first, second) {
            return first === second ? 0 : compare(first, second);
        }
    };
};
var $bcc6e5fd0afe4f22$export$65e3907585753458 = function() {
    var ords = [];
    for(var _i = 0; _i < arguments.length; _i++)ords[_i] = arguments[_i];
    return $bcc6e5fd0afe4f22$export$aa9e0de96ff2f1fd(function(first, second) {
        var i = 0;
        for(; i < ords.length - 1; i++){
            var r = ords[i].compare(first[i], second[i]);
            if (r !== 0) return r;
        }
        return ords[i].compare(first[i], second[i]);
    });
};
var $bcc6e5fd0afe4f22$export$66c1ae025e96b4bc = function(O) {
    return $bcc6e5fd0afe4f22$export$aa9e0de96ff2f1fd(function(first, second) {
        return O.compare(second, first);
    });
};
/* istanbul ignore next */ var $bcc6e5fd0afe4f22$var$contramap_ = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $bcc6e5fd0afe4f22$export$53b696d27ecb7ba7(f));
};
var $bcc6e5fd0afe4f22$export$53b696d27ecb7ba7 = function(f) {
    return function(fa) {
        return $bcc6e5fd0afe4f22$export$aa9e0de96ff2f1fd(function(first, second) {
            return fa.compare(f(first), f(second));
        });
    };
};
var $bcc6e5fd0afe4f22$export$9156e739aa33e19f = 'Ord';
var $bcc6e5fd0afe4f22$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return $bcc6e5fd0afe4f22$export$aa9e0de96ff2f1fd(function(a, b) {
                var ox = first.compare(a, b);
                return ox !== 0 ? ox : second.compare(a, b);
            });
        }
    };
};
var $bcc6e5fd0afe4f22$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $bcc6e5fd0afe4f22$export$e759a9a7f8d04692().concat,
        empty: $bcc6e5fd0afe4f22$export$aa9e0de96ff2f1fd(function() {
            return 0;
        })
    };
};
var $bcc6e5fd0afe4f22$export$def901a57d5539c3 = {
    URI: $bcc6e5fd0afe4f22$export$9156e739aa33e19f,
    contramap: $bcc6e5fd0afe4f22$var$contramap_
};
var $bcc6e5fd0afe4f22$export$e5bb9f0f2dedbef6 = {
    equals: (0, $72EOc.constTrue),
    compare: /*#__PURE__*/ (0, $72EOc.constant)(0)
};
var $bcc6e5fd0afe4f22$export$e9bab7fafb253603 = function(O) {
    return function(second) {
        return function(first) {
            return first === second || O.compare(first, second) === 0;
        };
    };
};
var $bcc6e5fd0afe4f22$export$b961576059b7aeb6 = function(O) {
    return function(first, second) {
        return O.compare(first, second) === -1;
    };
};
var $bcc6e5fd0afe4f22$export$dafeacbfe3530cd9 = function(O) {
    return function(first, second) {
        return O.compare(first, second) === 1;
    };
};
var $bcc6e5fd0afe4f22$export$8c5f3ec5d3a940d = function(O) {
    return function(first, second) {
        return O.compare(first, second) !== 1;
    };
};
var $bcc6e5fd0afe4f22$export$61f00a763551642c = function(O) {
    return function(first, second) {
        return O.compare(first, second) !== -1;
    };
};
var $bcc6e5fd0afe4f22$export$96ec731ed4dcb222 = function(O) {
    return function(first, second) {
        return first === second || O.compare(first, second) < 1 ? first : second;
    };
};
var $bcc6e5fd0afe4f22$export$8960430cfd85939f = function(O) {
    return function(first, second) {
        return first === second || O.compare(first, second) > -1 ? first : second;
    };
};
var $bcc6e5fd0afe4f22$export$7d15b64cf5a3a4c4 = function(O) {
    var minO = $bcc6e5fd0afe4f22$export$96ec731ed4dcb222(O);
    var maxO = $bcc6e5fd0afe4f22$export$8960430cfd85939f(O);
    return function(low, hi) {
        return function(a) {
            return maxO(minO(a, hi), low);
        };
    };
};
var $bcc6e5fd0afe4f22$export$cf95c51b03f10bae = function(O) {
    var ltO = $bcc6e5fd0afe4f22$export$b961576059b7aeb6(O);
    var gtO = $bcc6e5fd0afe4f22$export$dafeacbfe3530cd9(O);
    return function(low, hi) {
        return function(a) {
            return ltO(a, low) || gtO(a, hi) ? false : true;
        };
    };
};
var $bcc6e5fd0afe4f22$export$c41db498223b95e9 = $bcc6e5fd0afe4f22$export$65e3907585753458;
var $bcc6e5fd0afe4f22$export$35315ebcdff1b05c = $bcc6e5fd0afe4f22$export$66c1ae025e96b4bc;
var $bcc6e5fd0afe4f22$export$ad12338f1fefb50e = $bcc6e5fd0afe4f22$export$def901a57d5539c3;
// default compare for primitive types
function $bcc6e5fd0afe4f22$var$compare(first, second) {
    return first < second ? -1 : first > second ? 1 : 0;
}
var $bcc6e5fd0afe4f22$var$strictOrd = {
    equals: (0, $3Md1m.eqStrict).equals,
    compare: $bcc6e5fd0afe4f22$var$compare
};
var $bcc6e5fd0afe4f22$export$ef759d57a4e44836 = $bcc6e5fd0afe4f22$var$strictOrd;
var $bcc6e5fd0afe4f22$export$c5f2758e49b2b86a = $bcc6e5fd0afe4f22$var$strictOrd;
var $bcc6e5fd0afe4f22$export$5ed021ff2336715c = $bcc6e5fd0afe4f22$var$strictOrd;
var $bcc6e5fd0afe4f22$export$722593c82468f9f4 = /*#__PURE__*/ (0, $72EOc.pipe)($bcc6e5fd0afe4f22$export$5ed021ff2336715c, /*#__PURE__*/ $bcc6e5fd0afe4f22$export$53b696d27ecb7ba7(function(date) {
    return date.valueOf();
}));

});
parcelRegister("3Md1m", function(module, exports) {

$parcel$export(module.exports, "fromEquals", () => $2bfff480dbab3bcc$export$fec6acd8d60e8568);
$parcel$export(module.exports, "eqStrict", () => $2bfff480dbab3bcc$export$37a88d8211c10fd3);

var $72EOc = parcelRequire("72EOc");
var $2bfff480dbab3bcc$export$fec6acd8d60e8568 = function(equals) {
    return {
        equals: function(x, y) {
            return x === y || equals(x, y);
        }
    };
};
var $2bfff480dbab3bcc$export$8cf3da7c1c9174ea = function(eqs) {
    return $2bfff480dbab3bcc$export$fec6acd8d60e8568(function(first, second) {
        for(var key in eqs){
            if (!eqs[key].equals(first[key], second[key])) return false;
        }
        return true;
    });
};
var $2bfff480dbab3bcc$export$65e3907585753458 = function() {
    var eqs = [];
    for(var _i = 0; _i < arguments.length; _i++)eqs[_i] = arguments[_i];
    return $2bfff480dbab3bcc$export$fec6acd8d60e8568(function(first, second) {
        return eqs.every(function(E, i) {
            return E.equals(first[i], second[i]);
        });
    });
};
/* istanbul ignore next */ var $2bfff480dbab3bcc$var$contramap_ = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $2bfff480dbab3bcc$export$53b696d27ecb7ba7(f));
};
var $2bfff480dbab3bcc$export$53b696d27ecb7ba7 = function(f) {
    return function(fa) {
        return $2bfff480dbab3bcc$export$fec6acd8d60e8568(function(x, y) {
            return fa.equals(f(x), f(y));
        });
    };
};
var $2bfff480dbab3bcc$export$9156e739aa33e19f = 'Eq';
var $2bfff480dbab3bcc$export$37a88d8211c10fd3 = {
    equals: function(a, b) {
        return a === b;
    }
};
var $2bfff480dbab3bcc$var$empty = {
    equals: function() {
        return true;
    }
};
var $2bfff480dbab3bcc$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(x, y) {
            return $2bfff480dbab3bcc$export$fec6acd8d60e8568(function(a, b) {
                return x.equals(a, b) && y.equals(a, b);
            });
        }
    };
};
var $2bfff480dbab3bcc$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $2bfff480dbab3bcc$export$e759a9a7f8d04692().concat,
        empty: $2bfff480dbab3bcc$var$empty
    };
};
var $2bfff480dbab3bcc$export$def901a57d5539c3 = {
    URI: $2bfff480dbab3bcc$export$9156e739aa33e19f,
    contramap: $2bfff480dbab3bcc$var$contramap_
};
var $2bfff480dbab3bcc$export$1a50cb133a346493 = $2bfff480dbab3bcc$export$65e3907585753458;
var $2bfff480dbab3bcc$export$b35b2bde1875587a = $2bfff480dbab3bcc$export$8cf3da7c1c9174ea;
var $2bfff480dbab3bcc$export$24d177074f8dc6ef = $2bfff480dbab3bcc$export$37a88d8211c10fd3.equals;
var $2bfff480dbab3bcc$export$9663ddc1cf085b32 = $2bfff480dbab3bcc$export$def901a57d5539c3;
var $2bfff480dbab3bcc$export$d7927e8ffc1afb48 = $2bfff480dbab3bcc$export$37a88d8211c10fd3;
var $2bfff480dbab3bcc$export$fa624555ca2acbc8 = $2bfff480dbab3bcc$export$37a88d8211c10fd3;
var $2bfff480dbab3bcc$export$e24978670be1e4f3 = $2bfff480dbab3bcc$export$37a88d8211c10fd3;
var $2bfff480dbab3bcc$export$4eced57d6183c43d = {
    equals: function(first, second) {
        return first.valueOf() === second.valueOf();
    }
};

});


parcelRegister("ecsM6", function(module, exports) {

$parcel$export(module.exports, "empty", () => $a56881c4a03fdb98$export$6e22c362a0406a2c);
$parcel$export(module.exports, "isNonEmpty", () => $a56881c4a03fdb98$export$a978c53b4062a525);
$parcel$export(module.exports, "isOutOfBound", () => $a56881c4a03fdb98$export$2fde0b1c54fc39b9);
$parcel$export(module.exports, "prependW", () => $a56881c4a03fdb98$export$c4c4d41eab625797);
$parcel$export(module.exports, "prepend", () => $a56881c4a03fdb98$export$68159836694e22c1);
$parcel$export(module.exports, "appendW", () => $a56881c4a03fdb98$export$19903a1bf1942f6);
$parcel$export(module.exports, "append", () => $a56881c4a03fdb98$export$10d8903dec122b9d);
$parcel$export(module.exports, "unsafeInsertAt", () => $a56881c4a03fdb98$export$f4863e1822a1860c);
$parcel$export(module.exports, "unsafeUpdateAt", () => $a56881c4a03fdb98$export$9c0c6889b1fa9bfc);
$parcel$export(module.exports, "uniq", () => $a56881c4a03fdb98$export$f70730c3d1fc524e);
$parcel$export(module.exports, "head", () => $a56881c4a03fdb98$export$5fd5031fecdacec3);
$parcel$export(module.exports, "tail", () => $a56881c4a03fdb98$export$c01875f616615628);
$parcel$export(module.exports, "sortBy", () => $a56881c4a03fdb98$export$b035e44d7bb4278f);
$parcel$export(module.exports, "union", () => $a56881c4a03fdb98$export$971dd5b0dfd021b6);
$parcel$export(module.exports, "rotate", () => $a56881c4a03fdb98$export$bb628a54ab399bc9);
$parcel$export(module.exports, "splitAt", () => $a56881c4a03fdb98$export$b0d75975ac0be0e1);
$parcel$export(module.exports, "makeBy", () => $a56881c4a03fdb98$export$849fbdcc2211fcde);
$parcel$export(module.exports, "range", () => $a56881c4a03fdb98$export$d02631cccf789723);
$parcel$export(module.exports, "init", () => $a56881c4a03fdb98$export$2cd8252107eb640b);
$parcel$export(module.exports, "last", () => $a56881c4a03fdb98$export$4c7897fafd92b108);
$parcel$export(module.exports, "prependAll", () => $a56881c4a03fdb98$export$849c7567cbd62acc);
$parcel$export(module.exports, "intersperse", () => $a56881c4a03fdb98$export$af200dcf8b7cb5de);
$parcel$export(module.exports, "chop", () => $a56881c4a03fdb98$export$433fe05b12ba833f);
$parcel$export(module.exports, "chunksOf", () => $a56881c4a03fdb98$export$2f0184d5df52135f);
$parcel$export(module.exports, "reduce", () => $a56881c4a03fdb98$export$533b26079ad0b4b);
$parcel$export(module.exports, "foldMap", () => $a56881c4a03fdb98$export$b66cdc0497d8a99a);
$parcel$export(module.exports, "reduceRight", () => $a56881c4a03fdb98$export$7fef8bcdbb34f435);
$parcel$export(module.exports, "reduceWithIndex", () => $a56881c4a03fdb98$export$bbd3ef8720e22369);
$parcel$export(module.exports, "foldMapWithIndex", () => $a56881c4a03fdb98$export$18153bb1181268e5);
$parcel$export(module.exports, "reduceRightWithIndex", () => $a56881c4a03fdb98$export$ce2b2fe0b88ccd0a);
$parcel$export(module.exports, "of", () => $a56881c4a03fdb98$export$ba255e9e49e00608);
$parcel$export(module.exports, "getShow", () => $a56881c4a03fdb98$export$3cb5cd7f7776c81);
$parcel$export(module.exports, "getEq", () => $a56881c4a03fdb98$export$804fed467fde44e4);
$parcel$export(module.exports, "min", () => $a56881c4a03fdb98$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $a56881c4a03fdb98$export$8960430cfd85939f);
$parcel$export(module.exports, "concatAll", () => $a56881c4a03fdb98$export$b314777ae20abca9);
$parcel$export(module.exports, "intercalate", () => $a56881c4a03fdb98$export$739ec22334c44788);
$parcel$export(module.exports, "cons", () => $a56881c4a03fdb98$export$8327ebbef2a0ba76);
$parcel$export(module.exports, "snoc", () => $a56881c4a03fdb98$export$c40cf5aab899f397);

var $aYN4d = parcelRequire("aYN4d");

var $kgj0x = parcelRequire("kgj0x");

var $3Md1m = parcelRequire("3Md1m");

var $72EOc = parcelRequire("72EOc");

var $cpwuW = parcelRequire("cpwuW");

var $EfnK2 = parcelRequire("EfnK2");

var $gcR1C = parcelRequire("gcR1C");

var $58DQ5 = parcelRequire("58DQ5");
var $a56881c4a03fdb98$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $a56881c4a03fdb98$export$6e22c362a0406a2c = $EfnK2.emptyReadonlyArray;
var $a56881c4a03fdb98$export$a978c53b4062a525 = $EfnK2.isNonEmpty;
var $a56881c4a03fdb98$export$2fde0b1c54fc39b9 = function(i, as) {
    return i < 0 || i >= as.length;
};
var $a56881c4a03fdb98$export$c4c4d41eab625797 = function(head) {
    return function(tail) {
        return $a56881c4a03fdb98$var$__spreadArray([
            head
        ], tail, true);
    };
};
var $a56881c4a03fdb98$export$68159836694e22c1 = $a56881c4a03fdb98$export$c4c4d41eab625797;
var $a56881c4a03fdb98$export$19903a1bf1942f6 = function(end) {
    return function(init) {
        return $a56881c4a03fdb98$var$__spreadArray($a56881c4a03fdb98$var$__spreadArray([], init, true), [
            end
        ], false);
    };
};
var $a56881c4a03fdb98$export$10d8903dec122b9d = $a56881c4a03fdb98$export$19903a1bf1942f6;
var $a56881c4a03fdb98$export$f4863e1822a1860c = function(i, a, as) {
    if ($a56881c4a03fdb98$export$a978c53b4062a525(as)) {
        var xs = $EfnK2.fromReadonlyNonEmptyArray(as);
        xs.splice(i, 0, a);
        return xs;
    }
    return [
        a
    ];
};
var $a56881c4a03fdb98$export$9c0c6889b1fa9bfc = function(i, a, as) {
    if (as[i] === a) return as;
    else {
        var xs = $EfnK2.fromReadonlyNonEmptyArray(as);
        xs[i] = a;
        return xs;
    }
};
var $a56881c4a03fdb98$export$f70730c3d1fc524e = function(E) {
    return function(as) {
        if (as.length === 1) return as;
        var out = [
            $a56881c4a03fdb98$export$5fd5031fecdacec3(as)
        ];
        var rest = $a56881c4a03fdb98$export$c01875f616615628(as);
        var _loop_1 = function(a) {
            if (out.every(function(o) {
                return !E.equals(o, a);
            })) out.push(a);
        };
        for(var _i = 0, rest_1 = rest; _i < rest_1.length; _i++){
            var a = rest_1[_i];
            _loop_1(a);
        }
        return out;
    };
};
var $a56881c4a03fdb98$export$b035e44d7bb4278f = function(ords) {
    if ($a56881c4a03fdb98$export$a978c53b4062a525(ords)) {
        var M = (0, $gcR1C.getMonoid)();
        return $a56881c4a03fdb98$export$97db5808d8f88186(ords.reduce(M.concat, M.empty));
    }
    return 0, $72EOc.identity;
};
var $a56881c4a03fdb98$export$971dd5b0dfd021b6 = function(E) {
    var uniqE = $a56881c4a03fdb98$export$f70730c3d1fc524e(E);
    return function(second) {
        return function(first) {
            return uniqE((0, $72EOc.pipe)(first, $a56881c4a03fdb98$export$ee1b3e54f0441b22(second)));
        };
    };
};
var $a56881c4a03fdb98$export$bb628a54ab399bc9 = function(n) {
    return function(as) {
        var len = as.length;
        var m = Math.round(n) % len;
        if ($a56881c4a03fdb98$export$2fde0b1c54fc39b9(Math.abs(m), as) || m === 0) return as;
        if (m < 0) {
            var _a = $a56881c4a03fdb98$export$b0d75975ac0be0e1(-m)(as), f = _a[0], s = _a[1];
            return (0, $72EOc.pipe)(s, $a56881c4a03fdb98$export$ee1b3e54f0441b22(f));
        } else return $a56881c4a03fdb98$export$bb628a54ab399bc9(m - len)(as);
    };
};
var $a56881c4a03fdb98$export$9288e031f1846591 = function(as) {
    return $a56881c4a03fdb98$export$a978c53b4062a525(as) ? $EfnK2.some(as) : $EfnK2.none;
};
var $a56881c4a03fdb98$export$849fbdcc2211fcde = function(f) {
    return function(n) {
        var j = Math.max(0, Math.floor(n));
        var out = [
            f(0)
        ];
        for(var i = 1; i < j; i++)out.push(f(i));
        return out;
    };
};
var $a56881c4a03fdb98$export$606959e7ccb797f0 = function(a) {
    return $a56881c4a03fdb98$export$849fbdcc2211fcde(function() {
        return a;
    });
};
var $a56881c4a03fdb98$export$d02631cccf789723 = function(start, end) {
    return start <= end ? $a56881c4a03fdb98$export$849fbdcc2211fcde(function(i) {
        return start + i;
    })(end - start + 1) : [
        start
    ];
};
var $a56881c4a03fdb98$export$c04edabe9c8d994f = function(as) {
    return [
        $a56881c4a03fdb98$export$5fd5031fecdacec3(as),
        $a56881c4a03fdb98$export$c01875f616615628(as)
    ];
};
var $a56881c4a03fdb98$export$89a97afc72a83708 = function(as) {
    return [
        $a56881c4a03fdb98$export$2cd8252107eb640b(as),
        $a56881c4a03fdb98$export$4c7897fafd92b108(as)
    ];
};
var $a56881c4a03fdb98$export$571d59b505e6bb4e = function(as) {
    return $a56881c4a03fdb98$export$9288e031f1846591(as.slice());
};
function $a56881c4a03fdb98$export$c8c959650bbe80e2(second) {
    return function(first) {
        return first.concat(second);
    };
}
function $a56881c4a03fdb98$export$ee1b3e54f0441b22(x, y) {
    return y ? x.concat(y) : function(y) {
        return y.concat(x);
    };
}
var $a56881c4a03fdb98$export$66c1ae025e96b4bc = function(as) {
    return as.length === 1 ? as : $a56881c4a03fdb98$var$__spreadArray([
        $a56881c4a03fdb98$export$4c7897fafd92b108(as)
    ], as.slice(0, -1).reverse(), true);
};
function $a56881c4a03fdb98$export$e5e25fbcc1f7affe(E) {
    return function(as) {
        var len = as.length;
        if (len === 0) return $a56881c4a03fdb98$export$6e22c362a0406a2c;
        var out = [];
        var head = as[0];
        var nea = [
            head
        ];
        for(var i = 1; i < len; i++){
            var a = as[i];
            if (E.equals(a, head)) nea.push(a);
            else {
                out.push(nea);
                head = a;
                nea = [
                    head
                ];
            }
        }
        out.push(nea);
        return out;
    };
}
var $a56881c4a03fdb98$export$3f063810d7bf01bd = function(f) {
    return function(as) {
        var out = {};
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            var k = f(a);
            if ($EfnK2.has.call(out, k)) out[k].push(a);
            else out[k] = [
                a
            ];
        }
        return out;
    };
};
var $a56881c4a03fdb98$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.length === 1 ? as : as.slice().sort(O.compare);
    };
};
var $a56881c4a03fdb98$export$b6d8713d53419d4c = function(i, a) {
    return $a56881c4a03fdb98$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $a56881c4a03fdb98$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $a56881c4a03fdb98$export$2fde0b1c54fc39b9(i, as) ? $EfnK2.none : $EfnK2.some($a56881c4a03fdb98$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $a56881c4a03fdb98$export$b634740ce272acb5 = function(as, bs, f) {
    var cs = [
        f(as[0], bs[0])
    ];
    var len = Math.min(as.length, bs.length);
    for(var i = 1; i < len; i++)cs[i] = f(as[i], bs[i]);
    return cs;
};
function $a56881c4a03fdb98$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $a56881c4a03fdb98$export$8901015135f2fb22(bs, as);
    };
    return $a56881c4a03fdb98$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $a56881c4a03fdb98$export$23c8d3f8757cab88 = function(abs) {
    var fa = [
        abs[0][0]
    ];
    var fb = [
        abs[0][1]
    ];
    for(var i = 1; i < abs.length; i++){
        fa[i] = abs[i][0];
        fb[i] = abs[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $a56881c4a03fdb98$export$849c7567cbd62acc = function(middle) {
    return function(as) {
        var out = [
            middle,
            as[0]
        ];
        for(var i = 1; i < as.length; i++)out.push(middle, as[i]);
        return out;
    };
};
var $a56881c4a03fdb98$export$af200dcf8b7cb5de = function(middle) {
    return function(as) {
        var rest = $a56881c4a03fdb98$export$c01875f616615628(as);
        return $a56881c4a03fdb98$export$a978c53b4062a525(rest) ? (0, $72EOc.pipe)(rest, $a56881c4a03fdb98$export$849c7567cbd62acc(middle), $a56881c4a03fdb98$export$68159836694e22c1($a56881c4a03fdb98$export$5fd5031fecdacec3(as))) : as;
    };
};
var $a56881c4a03fdb98$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        var out = $EfnK2.fromReadonlyNonEmptyArray(f(0, $a56881c4a03fdb98$export$5fd5031fecdacec3(as)));
        for(var i = 1; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $a56881c4a03fdb98$export$433fe05b12ba833f = function(f) {
    return function(as) {
        var _a = f(as), b = _a[0], rest = _a[1];
        var out = [
            b
        ];
        var next = rest;
        while($a56881c4a03fdb98$export$a978c53b4062a525(next)){
            var _b = f(next), b_1 = _b[0], rest_2 = _b[1];
            out.push(b_1);
            next = rest_2;
        }
        return out;
    };
};
var $a56881c4a03fdb98$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        var m = Math.max(1, n);
        return m >= as.length ? [
            as,
            $a56881c4a03fdb98$export$6e22c362a0406a2c
        ] : [
            (0, $72EOc.pipe)(as.slice(1, m), $a56881c4a03fdb98$export$68159836694e22c1($a56881c4a03fdb98$export$5fd5031fecdacec3(as))),
            as.slice(m)
        ];
    };
};
var $a56881c4a03fdb98$export$2f0184d5df52135f = function(n) {
    return $a56881c4a03fdb98$export$433fe05b12ba833f($a56881c4a03fdb98$export$b0d75975ac0be0e1(n));
};
var $a56881c4a03fdb98$var$_map = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $a56881c4a03fdb98$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $a56881c4a03fdb98$var$_mapWithIndex = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $a56881c4a03fdb98$export$8f07ddce13659f50(f));
};
var $a56881c4a03fdb98$var$_ap = function(fab, fa) {
    return (0, $72EOc.pipe)(fab, $a56881c4a03fdb98$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $a56881c4a03fdb98$var$_extend = function(wa, f) {
    return (0, $72EOc.pipe)(wa, $a56881c4a03fdb98$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $a56881c4a03fdb98$var$_reduce = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $a56881c4a03fdb98$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $a56881c4a03fdb98$var$_foldMap = function(M) {
    var foldMapM = $a56881c4a03fdb98$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $72EOc.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $a56881c4a03fdb98$var$_reduceRight = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $a56881c4a03fdb98$export$7fef8bcdbb34f435(b, f));
};
/* istanbul ignore next */ var $a56881c4a03fdb98$var$_traverse = function(F) {
    var traverseF = $a56881c4a03fdb98$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $72EOc.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $a56881c4a03fdb98$var$_alt = function(fa, that) {
    return (0, $72EOc.pipe)(fa, $a56881c4a03fdb98$export$228be17d80722ab(that));
};
/* istanbul ignore next */ var $a56881c4a03fdb98$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $a56881c4a03fdb98$export$bbd3ef8720e22369(b, f));
};
/* istanbul ignore next */ var $a56881c4a03fdb98$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $a56881c4a03fdb98$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $72EOc.pipe)(fa, foldMapWithIndexM(f));
    };
};
/* istanbul ignore next */ var $a56881c4a03fdb98$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $a56881c4a03fdb98$export$ce2b2fe0b88ccd0a(b, f));
};
/* istanbul ignore next */ var $a56881c4a03fdb98$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $a56881c4a03fdb98$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $72EOc.pipe)(ta, traverseWithIndexF(f));
    };
};
var $a56881c4a03fdb98$export$ba255e9e49e00608 = $EfnK2.singleton;
var $a56881c4a03fdb98$export$1517cca7889d6aaa = function(that) {
    return function(as) {
        return (0, $72EOc.pipe)(as, $a56881c4a03fdb98$export$c8c959650bbe80e2(that()));
    };
};
var $a56881c4a03fdb98$export$228be17d80722ab = $a56881c4a03fdb98$export$1517cca7889d6aaa;
var $a56881c4a03fdb98$export$2f6ca3d3b1f80bf5 = function(as) {
    return $a56881c4a03fdb98$export$5b8affa63fc6df16(function(f) {
        return (0, $72EOc.pipe)(as, $a56881c4a03fdb98$export$871de8747c9eaa88(f));
    });
};
var $a56881c4a03fdb98$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $72EOc.dual)(2, function(ma, f) {
    return (0, $72EOc.pipe)(ma, $a56881c4a03fdb98$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $a56881c4a03fdb98$export$8b58be045bf06082 = function(f) {
    return function(as) {
        var next = $a56881c4a03fdb98$export$c01875f616615628(as);
        var out = [
            f(as)
        ];
        while($a56881c4a03fdb98$export$a978c53b4062a525(next)){
            out.push(f(next));
            next = $a56881c4a03fdb98$export$c01875f616615628(next);
        }
        return out;
    };
};
var $a56881c4a03fdb98$export$ecd5e8ace626722c = /*#__PURE__*/ $a56881c4a03fdb98$export$8b58be045bf06082((0, $72EOc.identity));
var $a56881c4a03fdb98$export$bffa455ba8c619a6 = /*#__PURE__*/ $a56881c4a03fdb98$export$5b8affa63fc6df16((0, $72EOc.identity));
var $a56881c4a03fdb98$export$871de8747c9eaa88 = function(f) {
    return $a56881c4a03fdb98$export$8f07ddce13659f50(function(_, a) {
        return f(a);
    });
};
var $a56881c4a03fdb98$export$8f07ddce13659f50 = function(f) {
    return function(as) {
        var out = [
            f(0, $a56881c4a03fdb98$export$5fd5031fecdacec3(as))
        ];
        for(var i = 1; i < as.length; i++)out.push(f(i, as[i]));
        return out;
    };
};
var $a56881c4a03fdb98$export$533b26079ad0b4b = function(b, f) {
    return $a56881c4a03fdb98$export$bbd3ef8720e22369(b, function(_, b, a) {
        return f(b, a);
    });
};
var $a56881c4a03fdb98$export$b66cdc0497d8a99a = function(S) {
    return function(f) {
        return function(as) {
            return as.slice(1).reduce(function(s, a) {
                return S.concat(s, f(a));
            }, f(as[0]));
        };
    };
};
var $a56881c4a03fdb98$export$7fef8bcdbb34f435 = function(b, f) {
    return $a56881c4a03fdb98$export$ce2b2fe0b88ccd0a(b, function(_, b, a) {
        return f(b, a);
    });
};
var $a56881c4a03fdb98$export$bbd3ef8720e22369 = function(b, f) {
    return function(as) {
        return as.reduce(function(b, a, i) {
            return f(i, b, a);
        }, b);
    };
};
var $a56881c4a03fdb98$export$18153bb1181268e5 = function(S) {
    return function(f) {
        return function(as) {
            return as.slice(1).reduce(function(s, a, i) {
                return S.concat(s, f(i + 1, a));
            }, f(0, as[0]));
        };
    };
};
var $a56881c4a03fdb98$export$ce2b2fe0b88ccd0a = function(b, f) {
    return function(as) {
        return as.reduceRight(function(b, a, i) {
            return f(i, a, b);
        }, b);
    };
};
var $a56881c4a03fdb98$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $a56881c4a03fdb98$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $a56881c4a03fdb98$export$49bb65c2ea163039 = function(F) {
    return $a56881c4a03fdb98$export$955fdc0d24efa249(F)((0, $72EOc.SK));
};
var $a56881c4a03fdb98$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return function(as) {
            var out = F.map(f(0, $a56881c4a03fdb98$export$5fd5031fecdacec3(as)), $a56881c4a03fdb98$export$ba255e9e49e00608);
            for(var i = 1; i < as.length; i++)out = F.ap(F.map(out, function(bs) {
                return function(b) {
                    return (0, $72EOc.pipe)(bs, $a56881c4a03fdb98$export$10d8903dec122b9d(b));
                };
            }), f(i, as[i]));
            return out;
        };
    };
};
var $a56881c4a03fdb98$export$f9380c9a627682d3 = $EfnK2.head;
var $a56881c4a03fdb98$export$9156e739aa33e19f = 'ReadonlyNonEmptyArray';
var $a56881c4a03fdb98$export$3cb5cd7f7776c81 = function(S) {
    return {
        show: function(as) {
            return "[".concat(as.map(S.show).join(', '), "]");
        }
    };
};
var $a56881c4a03fdb98$export$e759a9a7f8d04692 = function() {
    return {
        concat: $a56881c4a03fdb98$export$ee1b3e54f0441b22
    };
};
var $a56881c4a03fdb98$export$804fed467fde44e4 = function(E) {
    return (0, $3Md1m.fromEquals)(function(xs, ys) {
        return xs.length === ys.length && xs.every(function(x, i) {
            return E.equals(x, ys[i]);
        });
    });
};
var $a56881c4a03fdb98$export$baca17b4aff42f82 = function(E) {
    var unionE = $a56881c4a03fdb98$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $a56881c4a03fdb98$export$bd5b6bfc5fa2ee61 = {
    URI: $a56881c4a03fdb98$export$9156e739aa33e19f,
    map: $a56881c4a03fdb98$var$_map
};
var $a56881c4a03fdb98$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $cpwuW.flap)($a56881c4a03fdb98$export$bd5b6bfc5fa2ee61);
var $a56881c4a03fdb98$export$59a71046037e6c20 = {
    URI: $a56881c4a03fdb98$export$9156e739aa33e19f,
    of: $a56881c4a03fdb98$export$ba255e9e49e00608
};
var $a56881c4a03fdb98$export$9fdffe0fe1e91cad = {
    URI: $a56881c4a03fdb98$export$9156e739aa33e19f,
    map: $a56881c4a03fdb98$var$_map,
    mapWithIndex: $a56881c4a03fdb98$var$_mapWithIndex
};
var $a56881c4a03fdb98$export$efc21ddc6aeb363d = {
    URI: $a56881c4a03fdb98$export$9156e739aa33e19f,
    map: $a56881c4a03fdb98$var$_map,
    ap: $a56881c4a03fdb98$var$_ap
};
var $a56881c4a03fdb98$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $aYN4d.apFirst)($a56881c4a03fdb98$export$efc21ddc6aeb363d);
var $a56881c4a03fdb98$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $aYN4d.apSecond)($a56881c4a03fdb98$export$efc21ddc6aeb363d);
var $a56881c4a03fdb98$export$1279d2b7807629fd = {
    URI: $a56881c4a03fdb98$export$9156e739aa33e19f,
    map: $a56881c4a03fdb98$var$_map,
    ap: $a56881c4a03fdb98$var$_ap,
    of: $a56881c4a03fdb98$export$ba255e9e49e00608
};
var $a56881c4a03fdb98$export$f18d5acc27d70423 = {
    URI: $a56881c4a03fdb98$export$9156e739aa33e19f,
    map: $a56881c4a03fdb98$var$_map,
    ap: $a56881c4a03fdb98$var$_ap,
    chain: $a56881c4a03fdb98$export$5b8affa63fc6df16
};
var $a56881c4a03fdb98$export$e3821ef4970c339c = /*#__PURE__*/ (0, $kgj0x.chainFirst)($a56881c4a03fdb98$export$f18d5acc27d70423);
var $a56881c4a03fdb98$export$fb641926d034ac7d = {
    URI: $a56881c4a03fdb98$export$9156e739aa33e19f,
    map: $a56881c4a03fdb98$var$_map,
    ap: $a56881c4a03fdb98$var$_ap,
    of: $a56881c4a03fdb98$export$ba255e9e49e00608,
    chain: $a56881c4a03fdb98$export$5b8affa63fc6df16
};
var $a56881c4a03fdb98$export$41404b31838667c9 = {
    URI: $a56881c4a03fdb98$export$9156e739aa33e19f,
    reduce: $a56881c4a03fdb98$var$_reduce,
    foldMap: $a56881c4a03fdb98$var$_foldMap,
    reduceRight: $a56881c4a03fdb98$var$_reduceRight
};
var $a56881c4a03fdb98$export$e8f7d17aaff345cb = {
    URI: $a56881c4a03fdb98$export$9156e739aa33e19f,
    reduce: $a56881c4a03fdb98$var$_reduce,
    foldMap: $a56881c4a03fdb98$var$_foldMap,
    reduceRight: $a56881c4a03fdb98$var$_reduceRight,
    reduceWithIndex: $a56881c4a03fdb98$var$_reduceWithIndex,
    foldMapWithIndex: $a56881c4a03fdb98$var$_foldMapWithIndex,
    reduceRightWithIndex: $a56881c4a03fdb98$var$_reduceRightWithIndex
};
var $a56881c4a03fdb98$export$a0202666c3bda011 = {
    URI: $a56881c4a03fdb98$export$9156e739aa33e19f,
    map: $a56881c4a03fdb98$var$_map,
    reduce: $a56881c4a03fdb98$var$_reduce,
    foldMap: $a56881c4a03fdb98$var$_foldMap,
    reduceRight: $a56881c4a03fdb98$var$_reduceRight,
    traverse: $a56881c4a03fdb98$var$_traverse,
    sequence: $a56881c4a03fdb98$export$49bb65c2ea163039
};
var $a56881c4a03fdb98$export$bd7b528d8c36ec41 = {
    URI: $a56881c4a03fdb98$export$9156e739aa33e19f,
    map: $a56881c4a03fdb98$var$_map,
    mapWithIndex: $a56881c4a03fdb98$var$_mapWithIndex,
    reduce: $a56881c4a03fdb98$var$_reduce,
    foldMap: $a56881c4a03fdb98$var$_foldMap,
    reduceRight: $a56881c4a03fdb98$var$_reduceRight,
    traverse: $a56881c4a03fdb98$var$_traverse,
    sequence: $a56881c4a03fdb98$export$49bb65c2ea163039,
    reduceWithIndex: $a56881c4a03fdb98$var$_reduceWithIndex,
    foldMapWithIndex: $a56881c4a03fdb98$var$_foldMapWithIndex,
    reduceRightWithIndex: $a56881c4a03fdb98$var$_reduceRightWithIndex,
    traverseWithIndex: $a56881c4a03fdb98$var$_traverseWithIndex
};
var $a56881c4a03fdb98$export$25ba4469a069167 = {
    URI: $a56881c4a03fdb98$export$9156e739aa33e19f,
    map: $a56881c4a03fdb98$var$_map,
    alt: $a56881c4a03fdb98$var$_alt
};
var $a56881c4a03fdb98$export$fdd73124b9f1de36 = {
    URI: $a56881c4a03fdb98$export$9156e739aa33e19f,
    map: $a56881c4a03fdb98$var$_map,
    extend: $a56881c4a03fdb98$var$_extend,
    extract: $a56881c4a03fdb98$export$f9380c9a627682d3
};
var $a56881c4a03fdb98$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $a56881c4a03fdb98$export$ba255e9e49e00608($EfnK2.emptyRecord);
var $a56881c4a03fdb98$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $cpwuW.bindTo)($a56881c4a03fdb98$export$bd5b6bfc5fa2ee61);
var $a56881c4a03fdb98$export$5d537b797c421217 = /*#__PURE__*/ (0, $cpwuW.let)($a56881c4a03fdb98$export$bd5b6bfc5fa2ee61);
var $a56881c4a03fdb98$export$2385a24977818dd0 = /*#__PURE__*/ (0, $kgj0x.bind)($a56881c4a03fdb98$export$f18d5acc27d70423);
var $a56881c4a03fdb98$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $aYN4d.apS)($a56881c4a03fdb98$export$efc21ddc6aeb363d);
var $a56881c4a03fdb98$export$5fd5031fecdacec3 = $a56881c4a03fdb98$export$f9380c9a627682d3;
var $a56881c4a03fdb98$export$c01875f616615628 = $EfnK2.tail;
var $a56881c4a03fdb98$export$4c7897fafd92b108 = function(as) {
    return as[as.length - 1];
};
var $a56881c4a03fdb98$export$2cd8252107eb640b = function(as) {
    return as.slice(0, -1);
};
var $a56881c4a03fdb98$export$96ec731ed4dcb222 = function(O) {
    var S = $58DQ5.min(O);
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $a56881c4a03fdb98$export$8960430cfd85939f = function(O) {
    var S = $58DQ5.max(O);
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $a56881c4a03fdb98$export$b314777ae20abca9 = function(S) {
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $a56881c4a03fdb98$export$6280271dfaec4919 = function(f) {
    return function(as) {
        return f($a56881c4a03fdb98$export$5fd5031fecdacec3(as), $a56881c4a03fdb98$export$c01875f616615628(as));
    };
};
var $a56881c4a03fdb98$export$b1cacb83a5c6bd02 = function(f) {
    return function(as) {
        return f($a56881c4a03fdb98$export$2cd8252107eb640b(as), $a56881c4a03fdb98$export$4c7897fafd92b108(as));
    };
};
var $a56881c4a03fdb98$export$5c7327d4e64ef2aa = function(f) {
    return function(as) {
        return $a56881c4a03fdb98$var$__spreadArray([
            f($a56881c4a03fdb98$export$5fd5031fecdacec3(as))
        ], $a56881c4a03fdb98$export$c01875f616615628(as), true);
    };
};
var $a56881c4a03fdb98$export$20ca6ad9f7762931 = function(a) {
    return $a56881c4a03fdb98$export$5c7327d4e64ef2aa(function() {
        return a;
    });
};
var $a56881c4a03fdb98$export$302ad361c463800a = function(f) {
    return function(as) {
        return (0, $72EOc.pipe)($a56881c4a03fdb98$export$2cd8252107eb640b(as), $a56881c4a03fdb98$export$10d8903dec122b9d(f($a56881c4a03fdb98$export$4c7897fafd92b108(as))));
    };
};
var $a56881c4a03fdb98$export$d3affa0a0a83d946 = function(a) {
    return $a56881c4a03fdb98$export$302ad361c463800a(function() {
        return a;
    });
};
var $a56881c4a03fdb98$export$739ec22334c44788 = function(S) {
    var concatAllS = $a56881c4a03fdb98$export$b314777ae20abca9(S);
    return function(middle) {
        return (0, $72EOc.flow)($a56881c4a03fdb98$export$af200dcf8b7cb5de(middle), concatAllS);
    };
};
var $a56881c4a03fdb98$export$e08e3b67e392101e = $a56881c4a03fdb98$export$5b8affa63fc6df16;
function $a56881c4a03fdb98$export$103ce2c0a67e4e61(O) {
    var sortO = $a56881c4a03fdb98$export$97db5808d8f88186(O);
    var groupO = $a56881c4a03fdb98$export$e5e25fbcc1f7affe(O);
    return function(as) {
        return $a56881c4a03fdb98$export$a978c53b4062a525(as) ? groupO(sortO(as)) : $a56881c4a03fdb98$export$6e22c362a0406a2c;
    };
}
function $a56881c4a03fdb98$export$3dea766d36a8935f(predicate) {
    return $a56881c4a03fdb98$export$36e42aef19fc7171(function(_, a) {
        return predicate(a);
    });
}
var $a56881c4a03fdb98$export$36e42aef19fc7171 = function(predicate) {
    return function(as) {
        return $a56881c4a03fdb98$export$9288e031f1846591(as.filter(function(a, i) {
            return predicate(i, a);
        }));
    };
};
var $a56881c4a03fdb98$export$b446f6baa3bb1430 = $a56881c4a03fdb98$export$c04edabe9c8d994f;
var $a56881c4a03fdb98$export$712962e076096ed4 = $a56881c4a03fdb98$export$89a97afc72a83708;
function $a56881c4a03fdb98$export$8327ebbef2a0ba76(head, tail) {
    return tail === undefined ? $a56881c4a03fdb98$export$68159836694e22c1(head) : (0, $72EOc.pipe)(tail, $a56881c4a03fdb98$export$68159836694e22c1(head));
}
var $a56881c4a03fdb98$export$c40cf5aab899f397 = function(init, end) {
    return (0, $72EOc.pipe)(init, $a56881c4a03fdb98$export$ee1b3e54f0441b22([
        end
    ]));
};
var $a56881c4a03fdb98$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $EfnK2.none : $EfnK2.some($a56881c4a03fdb98$export$f4863e1822a1860c(i, a, as));
    };
};
var $a56881c4a03fdb98$export$baeb00bf1e27e233 = $a56881c4a03fdb98$export$849c7567cbd62acc;
var $a56881c4a03fdb98$export$93e2b83da34ff82a = $a56881c4a03fdb98$export$b314777ae20abca9;
var $a56881c4a03fdb98$export$3c6c57333e3dca24 = {
    URI: $a56881c4a03fdb98$export$9156e739aa33e19f,
    of: $a56881c4a03fdb98$export$ba255e9e49e00608,
    map: $a56881c4a03fdb98$var$_map,
    mapWithIndex: $a56881c4a03fdb98$var$_mapWithIndex,
    ap: $a56881c4a03fdb98$var$_ap,
    chain: $a56881c4a03fdb98$export$5b8affa63fc6df16,
    extend: $a56881c4a03fdb98$var$_extend,
    extract: $a56881c4a03fdb98$export$f9380c9a627682d3,
    reduce: $a56881c4a03fdb98$var$_reduce,
    foldMap: $a56881c4a03fdb98$var$_foldMap,
    reduceRight: $a56881c4a03fdb98$var$_reduceRight,
    traverse: $a56881c4a03fdb98$var$_traverse,
    sequence: $a56881c4a03fdb98$export$49bb65c2ea163039,
    reduceWithIndex: $a56881c4a03fdb98$var$_reduceWithIndex,
    foldMapWithIndex: $a56881c4a03fdb98$var$_foldMapWithIndex,
    reduceRightWithIndex: $a56881c4a03fdb98$var$_reduceRightWithIndex,
    traverseWithIndex: $a56881c4a03fdb98$var$_traverseWithIndex,
    alt: $a56881c4a03fdb98$var$_alt
};

});
parcelRegister("58DQ5", function(module, exports) {

$parcel$export(module.exports, "min", () => $3bdc9a4cfa1f6a4e$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $3bdc9a4cfa1f6a4e$export$8960430cfd85939f);
$parcel$export(module.exports, "constant", () => $3bdc9a4cfa1f6a4e$export$c983f826f44ff86);
$parcel$export(module.exports, "reverse", () => $3bdc9a4cfa1f6a4e$export$66c1ae025e96b4bc);
$parcel$export(module.exports, "struct", () => $3bdc9a4cfa1f6a4e$export$8cf3da7c1c9174ea);
$parcel$export(module.exports, "tuple", () => $3bdc9a4cfa1f6a4e$export$65e3907585753458);
$parcel$export(module.exports, "intercalate", () => $3bdc9a4cfa1f6a4e$export$739ec22334c44788);
$parcel$export(module.exports, "first", () => $3bdc9a4cfa1f6a4e$export$43128fadae87b74a);
$parcel$export(module.exports, "last", () => $3bdc9a4cfa1f6a4e$export$4c7897fafd92b108);
$parcel$export(module.exports, "concatAll", () => $3bdc9a4cfa1f6a4e$export$b314777ae20abca9);
$parcel$export(module.exports, "semigroupVoid", () => $3bdc9a4cfa1f6a4e$export$36aabcd6b6e45f3b);
$parcel$export(module.exports, "getObjectSemigroup", () => $3bdc9a4cfa1f6a4e$export$2f965793fef2fb8a);
$parcel$export(module.exports, "getLastSemigroup", () => $3bdc9a4cfa1f6a4e$export$edb0acd3f464ffc5);
$parcel$export(module.exports, "getFirstSemigroup", () => $3bdc9a4cfa1f6a4e$export$84a57d7a8bf6c3ea);
$parcel$export(module.exports, "getTupleSemigroup", () => $3bdc9a4cfa1f6a4e$export$bd94daf2735ef9c);
$parcel$export(module.exports, "getStructSemigroup", () => $3bdc9a4cfa1f6a4e$export$98d1814f8ed74e13);
$parcel$export(module.exports, "getDualSemigroup", () => $3bdc9a4cfa1f6a4e$export$e0cea6c43ec66a1);
$parcel$export(module.exports, "getJoinSemigroup", () => $3bdc9a4cfa1f6a4e$export$4278e54cd9769e6d);
$parcel$export(module.exports, "getMeetSemigroup", () => $3bdc9a4cfa1f6a4e$export$7baccd77d16d1a41);
$parcel$export(module.exports, "getIntercalateSemigroup", () => $3bdc9a4cfa1f6a4e$export$fcc2cca196b2daf0);
$parcel$export(module.exports, "fold", () => $3bdc9a4cfa1f6a4e$export$93e2b83da34ff82a);
$parcel$export(module.exports, "semigroupAll", () => $3bdc9a4cfa1f6a4e$export$e8f9875ab703bdff);
$parcel$export(module.exports, "semigroupAny", () => $3bdc9a4cfa1f6a4e$export$9511aba5be5ac81b);
$parcel$export(module.exports, "getFunctionSemigroup", () => $3bdc9a4cfa1f6a4e$export$b2ecf5de014857c2);
$parcel$export(module.exports, "semigroupString", () => $3bdc9a4cfa1f6a4e$export$d9b7100b101f2c5b);
$parcel$export(module.exports, "semigroupSum", () => $3bdc9a4cfa1f6a4e$export$1481126044ad2de0);
$parcel$export(module.exports, "semigroupProduct", () => $3bdc9a4cfa1f6a4e$export$a22a2283cc3aa839);
/**
 * If a type `A` can form a `Semigroup` it has an **associative** binary operation.
 *
 * ```ts
 * interface Semigroup<A> {
 *   readonly concat: (x: A, y: A) => A
 * }
 * ```
 *
 * Associativity means the following equality must hold for any choice of `x`, `y`, and `z`.
 *
 * ```ts
 * concat(x, concat(y, z)) = concat(concat(x, y), z)
 * ```
 *
 * A common example of a semigroup is the type `string` with the operation `+`.
 *
 * ```ts
 * import { Semigroup } from 'fp-ts/Semigroup'
 *
 * const semigroupString: Semigroup<string> = {
 *   concat: (x, y) => x + y
 * }
 *
 * const x = 'x'
 * const y = 'y'
 * const z = 'z'
 *
 * semigroupString.concat(x, y) // 'xy'
 *
 * semigroupString.concat(x, semigroupString.concat(y, z)) // 'xyz'
 *
 * semigroupString.concat(semigroupString.concat(x, y), z) // 'xyz'
 * ```
 *
 * *Adapted from https://typelevel.org/cats*
 *
 * @since 2.0.0
 */ 
var $72EOc = parcelRequire("72EOc");

var $EfnK2 = parcelRequire("EfnK2");

var $dvJYF = parcelRequire("dvJYF");

var $gcR1C = parcelRequire("gcR1C");
var $3bdc9a4cfa1f6a4e$export$96ec731ed4dcb222 = function(O) {
    return {
        concat: $gcR1C.min(O)
    };
};
var $3bdc9a4cfa1f6a4e$export$8960430cfd85939f = function(O) {
    return {
        concat: $gcR1C.max(O)
    };
};
var $3bdc9a4cfa1f6a4e$export$c983f826f44ff86 = function(a) {
    return {
        concat: function() {
            return a;
        }
    };
};
var $3bdc9a4cfa1f6a4e$export$66c1ae025e96b4bc = $dvJYF.reverse;
var $3bdc9a4cfa1f6a4e$export$8cf3da7c1c9174ea = function(semigroups) {
    return {
        concat: function(first, second) {
            var r = {};
            for(var k in semigroups)if ($EfnK2.has.call(semigroups, k)) r[k] = semigroups[k].concat(first[k], second[k]);
            return r;
        }
    };
};
var $3bdc9a4cfa1f6a4e$export$65e3907585753458 = function() {
    var semigroups = [];
    for(var _i = 0; _i < arguments.length; _i++)semigroups[_i] = arguments[_i];
    return {
        concat: function(first, second) {
            return semigroups.map(function(s, i) {
                return s.concat(first[i], second[i]);
            });
        }
    };
};
var $3bdc9a4cfa1f6a4e$export$739ec22334c44788 = function(middle) {
    return function(S) {
        return {
            concat: function(x, y) {
                return S.concat(x, S.concat(middle, y));
            }
        };
    };
};
var $3bdc9a4cfa1f6a4e$export$43128fadae87b74a = function() {
    return {
        concat: (0, $72EOc.identity)
    };
};
var $3bdc9a4cfa1f6a4e$export$4c7897fafd92b108 = function() {
    return {
        concat: function(_, y) {
            return y;
        }
    };
};
var $3bdc9a4cfa1f6a4e$export$b314777ae20abca9 = $dvJYF.concatAll;
var $3bdc9a4cfa1f6a4e$export$36aabcd6b6e45f3b = $3bdc9a4cfa1f6a4e$export$c983f826f44ff86(undefined);
var $3bdc9a4cfa1f6a4e$export$2f965793fef2fb8a = function() {
    return {
        concat: function(first, second) {
            return Object.assign({}, first, second);
        }
    };
};
var $3bdc9a4cfa1f6a4e$export$edb0acd3f464ffc5 = $3bdc9a4cfa1f6a4e$export$4c7897fafd92b108;
var $3bdc9a4cfa1f6a4e$export$84a57d7a8bf6c3ea = $3bdc9a4cfa1f6a4e$export$43128fadae87b74a;
var $3bdc9a4cfa1f6a4e$export$bd94daf2735ef9c = $3bdc9a4cfa1f6a4e$export$65e3907585753458;
var $3bdc9a4cfa1f6a4e$export$98d1814f8ed74e13 = $3bdc9a4cfa1f6a4e$export$8cf3da7c1c9174ea;
var $3bdc9a4cfa1f6a4e$export$e0cea6c43ec66a1 = $3bdc9a4cfa1f6a4e$export$66c1ae025e96b4bc;
var $3bdc9a4cfa1f6a4e$export$4278e54cd9769e6d = $3bdc9a4cfa1f6a4e$export$8960430cfd85939f;
var $3bdc9a4cfa1f6a4e$export$7baccd77d16d1a41 = $3bdc9a4cfa1f6a4e$export$96ec731ed4dcb222;
var $3bdc9a4cfa1f6a4e$export$fcc2cca196b2daf0 = $3bdc9a4cfa1f6a4e$export$739ec22334c44788;
function $3bdc9a4cfa1f6a4e$export$93e2b83da34ff82a(S) {
    var concatAllS = $3bdc9a4cfa1f6a4e$export$b314777ae20abca9(S);
    return function(startWith, as) {
        return as === undefined ? concatAllS(startWith) : concatAllS(startWith)(as);
    };
}
var $3bdc9a4cfa1f6a4e$export$e8f9875ab703bdff = {
    concat: function(x, y) {
        return x && y;
    }
};
var $3bdc9a4cfa1f6a4e$export$9511aba5be5ac81b = {
    concat: function(x, y) {
        return x || y;
    }
};
var $3bdc9a4cfa1f6a4e$export$b2ecf5de014857c2 = (0, $72EOc.getSemigroup);
var $3bdc9a4cfa1f6a4e$export$d9b7100b101f2c5b = {
    concat: function(x, y) {
        return x + y;
    }
};
var $3bdc9a4cfa1f6a4e$export$1481126044ad2de0 = {
    concat: function(x, y) {
        return x + y;
    }
};
var $3bdc9a4cfa1f6a4e$export$a22a2283cc3aa839 = {
    concat: function(x, y) {
        return x * y;
    }
};

});
parcelRegister("dvJYF", function(module, exports) {

$parcel$export(module.exports, "reverse", () => $9d61d5c37892c0ce$export$66c1ae025e96b4bc);
$parcel$export(module.exports, "concatAll", () => $9d61d5c37892c0ce$export$b314777ae20abca9);
/**
 * A `Magma` is a pair `(A, concat)` in which `A` is a non-empty set and `concat` is a binary operation on `A`
 *
 * See [Semigroup](https://gcanti.github.io/fp-ts/modules/Semigroup.ts.html) for some instances.
 *
 * @since 2.0.0
 */ // -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * The dual of a `Magma`, obtained by swapping the arguments of `concat`.
 *
 * @example
 * import { reverse, concatAll } from 'fp-ts/Magma'
 * import * as N from 'fp-ts/number'
 *
 * const subAll = concatAll(reverse(N.MagmaSub))(0)
 *
 * assert.deepStrictEqual(subAll([1, 2, 3]), 2)
 *
 * @since 2.11.0
 */ var $9d61d5c37892c0ce$export$66c1ae025e96b4bc = function(M) {
    return {
        concat: function(first, second) {
            return M.concat(second, first);
        }
    };
};
var $9d61d5c37892c0ce$export$33379f09626d85d4 = function(predicate) {
    return function(M) {
        return {
            concat: function(first, second) {
                return predicate(first) ? M.concat(first, second) : second;
            }
        };
    };
};
var $9d61d5c37892c0ce$export$dfdff08f074d9f6c = function(predicate) {
    return function(M) {
        return {
            concat: function(first, second) {
                return predicate(second) ? M.concat(first, second) : first;
            }
        };
    };
};
var $9d61d5c37892c0ce$export$235e42f0cd5f5e93 = function(f) {
    return function(M) {
        return {
            concat: function(first, second) {
                return M.concat(f(first), f(second));
            }
        };
    };
};
var $9d61d5c37892c0ce$export$b314777ae20abca9 = function(M) {
    return function(startWith) {
        return function(as) {
            return as.reduce(function(a, acc) {
                return M.concat(a, acc);
            }, startWith);
        };
    };
};

});




parcelRegister("8yI6w", function(module, exports) {

$parcel$export(module.exports, "lookup", () => $63b3b5db92dfece4$export$dfc7155ac0343b8);
$parcel$export(module.exports, "head", () => $63b3b5db92dfece4$export$5fd5031fecdacec3);
$parcel$export(module.exports, "last", () => $63b3b5db92dfece4$export$4c7897fafd92b108);
$parcel$export(module.exports, "findIndex", () => $63b3b5db92dfece4$export$de3a4d4a0d731119);
$parcel$export(module.exports, "findFirst", () => $63b3b5db92dfece4$export$9a2f228bed5035c2);
$parcel$export(module.exports, "findFirstMap", () => $63b3b5db92dfece4$export$a86c11c94d794a95);
$parcel$export(module.exports, "findLast", () => $63b3b5db92dfece4$export$296de88ccac4bedb);
$parcel$export(module.exports, "findLastMap", () => $63b3b5db92dfece4$export$8b5e6d6ad82284fa);
$parcel$export(module.exports, "findLastIndex", () => $63b3b5db92dfece4$export$8855a8be7bd3e9f8);
$parcel$export(module.exports, "unsafeUpdateAt", () => $63b3b5db92dfece4$export$9c0c6889b1fa9bfc);
$parcel$export(module.exports, "elem", () => $63b3b5db92dfece4$export$5bf96401662340b7);
$parcel$export(module.exports, "reduce", () => $63b3b5db92dfece4$export$533b26079ad0b4b);
$parcel$export(module.exports, "foldMap", () => $63b3b5db92dfece4$export$b66cdc0497d8a99a);
$parcel$export(module.exports, "reduceRight", () => $63b3b5db92dfece4$export$7fef8bcdbb34f435);
$parcel$export(module.exports, "reduceWithIndex", () => $63b3b5db92dfece4$export$bbd3ef8720e22369);
$parcel$export(module.exports, "foldMapWithIndex", () => $63b3b5db92dfece4$export$18153bb1181268e5);
$parcel$export(module.exports, "reduceRightWithIndex", () => $63b3b5db92dfece4$export$ce2b2fe0b88ccd0a);
$parcel$export(module.exports, "_chainRecDepthFirst", () => $63b3b5db92dfece4$export$c5c44f872d8af73);
$parcel$export(module.exports, "chainRecDepthFirst", () => $63b3b5db92dfece4$export$f855115a79f70c1a);
$parcel$export(module.exports, "_chainRecBreadthFirst", () => $63b3b5db92dfece4$export$b9909b62ceeab991);
$parcel$export(module.exports, "chainRecBreadthFirst", () => $63b3b5db92dfece4$export$bffee57bb00a6859);
$parcel$export(module.exports, "of", () => $63b3b5db92dfece4$export$ba255e9e49e00608);
$parcel$export(module.exports, "getShow", () => $63b3b5db92dfece4$export$3cb5cd7f7776c81);
$parcel$export(module.exports, "getMonoid", () => $63b3b5db92dfece4$export$c2a7ef2cc9b32b31);
$parcel$export(module.exports, "getEq", () => $63b3b5db92dfece4$export$804fed467fde44e4);
$parcel$export(module.exports, "getOrd", () => $63b3b5db92dfece4$export$1af51209b1b91d07);
$parcel$export(module.exports, "every", () => $63b3b5db92dfece4$export$7ecc1a3b11b57dab);
$parcel$export(module.exports, "intercalate", () => $63b3b5db92dfece4$export$739ec22334c44788);

var $aYN4d = parcelRequire("aYN4d");

var $kgj0x = parcelRequire("kgj0x");

var $3Md1m = parcelRequire("3Md1m");

var $jFfj2 = parcelRequire("jFfj2");

var $72EOc = parcelRequire("72EOc");

var $cpwuW = parcelRequire("cpwuW");

var $EfnK2 = parcelRequire("EfnK2");

var $RoEDj = parcelRequire("RoEDj");

var $gcR1C = parcelRequire("gcR1C");

var $ecsM6 = parcelRequire("ecsM6");

var $1HSKK = parcelRequire("1HSKK");

var $jNYdc = parcelRequire("jNYdc");

var $3n81G = parcelRequire("3n81G");
var $63b3b5db92dfece4$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $63b3b5db92dfece4$export$dd1bc94b04021eeb = function(as) {
    return as.length === 0;
};
var $63b3b5db92dfece4$export$a978c53b4062a525 = $ecsM6.isNonEmpty;
var $63b3b5db92dfece4$export$68159836694e22c1 = $ecsM6.prepend;
var $63b3b5db92dfece4$export$c4c4d41eab625797 = $ecsM6.prependW;
var $63b3b5db92dfece4$export$10d8903dec122b9d = $ecsM6.append;
var $63b3b5db92dfece4$export$19903a1bf1942f6 = $ecsM6.appendW;
var $63b3b5db92dfece4$export$849fbdcc2211fcde = function(n, f) {
    return n <= 0 ? $63b3b5db92dfece4$export$6e22c362a0406a2c : $ecsM6.makeBy(f)(n);
};
var $63b3b5db92dfece4$export$606959e7ccb797f0 = function(n, a) {
    return $63b3b5db92dfece4$export$849fbdcc2211fcde(n, function() {
        return a;
    });
};
function $63b3b5db92dfece4$export$23f31c55d7162b91(predicate) {
    return function(a) {
        return predicate(a) ? [
            a
        ] : $63b3b5db92dfece4$export$6e22c362a0406a2c;
    };
}
var $63b3b5db92dfece4$export$172ec0a6ebfeb6fa = function(ma) {
    return $EfnK2.isNone(ma) ? $63b3b5db92dfece4$export$6e22c362a0406a2c : [
        ma.value
    ];
};
var $63b3b5db92dfece4$export$80c878c9b1d77917 = function(e) {
    return $EfnK2.isLeft(e) ? $63b3b5db92dfece4$export$6e22c362a0406a2c : [
        e.right
    ];
};
var $63b3b5db92dfece4$export$2d55ea551c238330 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? onNonEmpty(as) : onEmpty();
    };
};
var $63b3b5db92dfece4$export$4659b591c19bdf3d = $63b3b5db92dfece4$export$2d55ea551c238330;
var $63b3b5db92dfece4$export$ebbe93aa91e3abdc = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? onNonEmpty($ecsM6.head(as), $ecsM6.tail(as)) : onEmpty();
    };
};
var $63b3b5db92dfece4$export$6280271dfaec4919 = $63b3b5db92dfece4$export$ebbe93aa91e3abdc;
var $63b3b5db92dfece4$export$f3163a37d0ef5927 = $63b3b5db92dfece4$export$6280271dfaec4919;
var $63b3b5db92dfece4$export$364f7f2cc8473008 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? onNonEmpty($ecsM6.init(as), $ecsM6.last(as)) : onEmpty();
    };
};
var $63b3b5db92dfece4$export$b1cacb83a5c6bd02 = $63b3b5db92dfece4$export$364f7f2cc8473008;
var $63b3b5db92dfece4$export$77fa89c00b331c4c = $63b3b5db92dfece4$export$b1cacb83a5c6bd02;
var $63b3b5db92dfece4$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        if ($63b3b5db92dfece4$export$dd1bc94b04021eeb(as)) return $63b3b5db92dfece4$export$6e22c362a0406a2c;
        var out = [];
        for(var i = 0; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $63b3b5db92dfece4$export$555ac70de528b074 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[0] = b;
        for(var i = 0; i < len; i++)out[i + 1] = f(out[i], as[i]);
        return out;
    };
};
var $63b3b5db92dfece4$export$d799959bdf780177 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[len] = b;
        for(var i = len - 1; i >= 0; i--)out[i] = f(as[i], out[i + 1]);
        return out;
    };
};
var $63b3b5db92dfece4$export$346677f925de839c = function(as) {
    return as.length;
};
var $63b3b5db92dfece4$export$2fde0b1c54fc39b9 = $ecsM6.isOutOfBound;
function $63b3b5db92dfece4$export$dfc7155ac0343b8(i, as) {
    return as === undefined ? function(as) {
        return $63b3b5db92dfece4$export$dfc7155ac0343b8(i, as);
    } : $63b3b5db92dfece4$export$2fde0b1c54fc39b9(i, as) ? $EfnK2.none : $EfnK2.some(as[i]);
}
var $63b3b5db92dfece4$export$5fd5031fecdacec3 = function(as) {
    return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? $EfnK2.some($ecsM6.head(as)) : $EfnK2.none;
};
var $63b3b5db92dfece4$export$4c7897fafd92b108 = function(as) {
    return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? $EfnK2.some($ecsM6.last(as)) : $EfnK2.none;
};
var $63b3b5db92dfece4$export$c01875f616615628 = function(as) {
    return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? $EfnK2.some($ecsM6.tail(as)) : $EfnK2.none;
};
var $63b3b5db92dfece4$export$2cd8252107eb640b = function(as) {
    return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? $EfnK2.some($ecsM6.init(as)) : $EfnK2.none;
};
var $63b3b5db92dfece4$export$8ea13dbc737d576b = function(n) {
    return function(as) {
        return $63b3b5db92dfece4$export$2fde0b1c54fc39b9(n, as) ? as : n === 0 ? $63b3b5db92dfece4$export$6e22c362a0406a2c : as.slice(0, n);
    };
};
var $63b3b5db92dfece4$export$1bbc425ddca7f2c6 = function(n) {
    return function(as) {
        return $63b3b5db92dfece4$export$2fde0b1c54fc39b9(n, as) ? as : n === 0 ? $63b3b5db92dfece4$export$6e22c362a0406a2c : as.slice(-n);
    };
};
function $63b3b5db92dfece4$export$5b0b82239a6f6d94(predicate) {
    return function(as) {
        var out = [];
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            if (!predicate(a)) break;
            out.push(a);
        }
        var len = out.length;
        return len === as.length ? as : len === 0 ? $63b3b5db92dfece4$export$6e22c362a0406a2c : out;
    };
}
var $63b3b5db92dfece4$var$spanLeftIndex = function(as, predicate) {
    var l = as.length;
    var i = 0;
    for(; i < l; i++){
        if (!predicate(as[i])) break;
    }
    return i;
};
function $63b3b5db92dfece4$export$104948d9b1d3fb14(predicate) {
    return function(as) {
        var _a = $63b3b5db92dfece4$export$b0d75975ac0be0e1($63b3b5db92dfece4$var$spanLeftIndex(as, predicate))(as), init = _a[0], rest = _a[1];
        return {
            init: init,
            rest: rest
        };
    };
}
var $63b3b5db92dfece4$export$738250583454396 = function(n) {
    return function(as) {
        return n <= 0 || $63b3b5db92dfece4$export$dd1bc94b04021eeb(as) ? as : n >= as.length ? $63b3b5db92dfece4$export$6e22c362a0406a2c : as.slice(n, as.length);
    };
};
var $63b3b5db92dfece4$export$6ba801e3e123536e = function(n) {
    return function(as) {
        return n <= 0 || $63b3b5db92dfece4$export$dd1bc94b04021eeb(as) ? as : n >= as.length ? $63b3b5db92dfece4$export$6e22c362a0406a2c : as.slice(0, as.length - n);
    };
};
function $63b3b5db92dfece4$export$d265ccd398ee49c9(predicate) {
    return function(as) {
        var i = $63b3b5db92dfece4$var$spanLeftIndex(as, predicate);
        return i === 0 ? as : i === as.length ? $63b3b5db92dfece4$export$6e22c362a0406a2c : as.slice(i);
    };
}
var $63b3b5db92dfece4$export$de3a4d4a0d731119 = function(predicate) {
    return function(as) {
        for(var i = 0; i < as.length; i++){
            if (predicate(as[i])) return $EfnK2.some(i);
        }
        return $EfnK2.none;
    };
};
function $63b3b5db92dfece4$export$9a2f228bed5035c2(predicate) {
    return function(as) {
        for(var i = 0; i < as.length; i++){
            if (predicate(as[i])) return $EfnK2.some(as[i]);
        }
        return $EfnK2.none;
    };
}
var $63b3b5db92dfece4$export$a86c11c94d794a95 = function(f) {
    return function(as) {
        for(var i = 0; i < as.length; i++){
            var out = f(as[i]);
            if ($EfnK2.isSome(out)) return out;
        }
        return $EfnK2.none;
    };
};
function $63b3b5db92dfece4$export$296de88ccac4bedb(predicate) {
    return function(as) {
        for(var i = as.length - 1; i >= 0; i--){
            if (predicate(as[i])) return $EfnK2.some(as[i]);
        }
        return $EfnK2.none;
    };
}
var $63b3b5db92dfece4$export$8b5e6d6ad82284fa = function(f) {
    return function(as) {
        for(var i = as.length - 1; i >= 0; i--){
            var out = f(as[i]);
            if ($EfnK2.isSome(out)) return out;
        }
        return $EfnK2.none;
    };
};
var $63b3b5db92dfece4$export$8855a8be7bd3e9f8 = function(predicate) {
    return function(as) {
        for(var i = as.length - 1; i >= 0; i--){
            if (predicate(as[i])) return $EfnK2.some(i);
        }
        return $EfnK2.none;
    };
};
var $63b3b5db92dfece4$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $EfnK2.none : $EfnK2.some($ecsM6.unsafeInsertAt(i, a, as));
    };
};
var $63b3b5db92dfece4$export$b6d8713d53419d4c = function(i, a) {
    return $63b3b5db92dfece4$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $63b3b5db92dfece4$export$90f9093465da3136 = function(i) {
    return function(as) {
        return $63b3b5db92dfece4$export$2fde0b1c54fc39b9(i, as) ? $EfnK2.none : $EfnK2.some($63b3b5db92dfece4$export$4937fde8dfc38dbd(i, as));
    };
};
var $63b3b5db92dfece4$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $63b3b5db92dfece4$export$2fde0b1c54fc39b9(i, as) ? $EfnK2.none : $EfnK2.some($63b3b5db92dfece4$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $63b3b5db92dfece4$export$66c1ae025e96b4bc = function(as) {
    return as.length <= 1 ? as : as.slice().reverse();
};
var $63b3b5db92dfece4$export$cae945d60b6cbe50 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Right') r.push(a.right);
    }
    return r;
};
var $63b3b5db92dfece4$export$837c95301ebad184 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Left') r.push(a.left);
    }
    return r;
};
var $63b3b5db92dfece4$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.length <= 1 ? as : as.slice().sort(O.compare);
    };
};
var $63b3b5db92dfece4$export$b634740ce272acb5 = function(fa, fb, f) {
    var fc = [];
    var len = Math.min(fa.length, fb.length);
    for(var i = 0; i < len; i++)fc[i] = f(fa[i], fb[i]);
    return fc;
};
function $63b3b5db92dfece4$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $63b3b5db92dfece4$export$8901015135f2fb22(bs, as);
    };
    return $63b3b5db92dfece4$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $63b3b5db92dfece4$export$23c8d3f8757cab88 = function(as) {
    var fa = [];
    var fb = [];
    for(var i = 0; i < as.length; i++){
        fa[i] = as[i][0];
        fb[i] = as[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $63b3b5db92dfece4$export$849c7567cbd62acc = function(middle) {
    var f = $ecsM6.prependAll(middle);
    return function(as) {
        return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $63b3b5db92dfece4$export$af200dcf8b7cb5de = function(middle) {
    var f = $ecsM6.intersperse(middle);
    return function(as) {
        return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $63b3b5db92dfece4$export$bb628a54ab399bc9 = function(n) {
    var f = $ecsM6.rotate(n);
    return function(as) {
        return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
function $63b3b5db92dfece4$export$5bf96401662340b7(E) {
    return function(a, as) {
        if (as === undefined) {
            var elemE_1 = $63b3b5db92dfece4$export$5bf96401662340b7(E);
            return function(as) {
                return elemE_1(a, as);
            };
        }
        var predicate = function(element) {
            return E.equals(element, a);
        };
        var i = 0;
        for(; i < as.length; i++){
            if (predicate(as[i])) return true;
        }
        return false;
    };
}
var $63b3b5db92dfece4$export$f70730c3d1fc524e = function(E) {
    var f = $ecsM6.uniq(E);
    return function(as) {
        return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $63b3b5db92dfece4$export$b035e44d7bb4278f = function(ords) {
    var f = $ecsM6.sortBy(ords);
    return function(as) {
        return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $63b3b5db92dfece4$export$433fe05b12ba833f = function(f) {
    var g = $ecsM6.chop(f);
    return function(as) {
        return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? g(as) : $63b3b5db92dfece4$export$6e22c362a0406a2c;
    };
};
var $63b3b5db92dfece4$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        return n >= 1 && $63b3b5db92dfece4$export$a978c53b4062a525(as) ? $ecsM6.splitAt(n)(as) : $63b3b5db92dfece4$export$dd1bc94b04021eeb(as) ? [
            as,
            $63b3b5db92dfece4$export$6e22c362a0406a2c
        ] : [
            $63b3b5db92dfece4$export$6e22c362a0406a2c,
            as
        ];
    };
};
var $63b3b5db92dfece4$export$2f0184d5df52135f = function(n) {
    var f = $ecsM6.chunksOf(n);
    return function(as) {
        return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? f(as) : $63b3b5db92dfece4$export$6e22c362a0406a2c;
    };
};
var $63b3b5db92dfece4$export$a907462f448b49f8 = function(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $63b3b5db92dfece4$export$172ec0a6ebfeb6fa(f.apply(void 0, a));
    };
};
function $63b3b5db92dfece4$export$105c199d42fdf965(input, f, g) {
    if (g === void 0) g = function() {
        return true;
    };
    var go = function(scope, input) {
        return $63b3b5db92dfece4$export$a978c53b4062a525(input) ? $63b3b5db92dfece4$export$5b8affa63fc6df16($ecsM6.head(input), function(a) {
            return go((0, $72EOc.pipe)(scope, $63b3b5db92dfece4$export$10d8903dec122b9d(a)), $ecsM6.tail(input));
        }) : g.apply(void 0, scope) ? [
            f.apply(void 0, scope)
        ] : $63b3b5db92dfece4$export$6e22c362a0406a2c;
    };
    return go($63b3b5db92dfece4$export$6e22c362a0406a2c, input);
}
var $63b3b5db92dfece4$export$c8c959650bbe80e2 = function(second) {
    return function(first) {
        return $63b3b5db92dfece4$export$dd1bc94b04021eeb(first) ? second : $63b3b5db92dfece4$export$dd1bc94b04021eeb(second) ? first : first.concat(second);
    };
};
var $63b3b5db92dfece4$export$ee1b3e54f0441b22 = $63b3b5db92dfece4$export$c8c959650bbe80e2;
function $63b3b5db92dfece4$export$971dd5b0dfd021b6(E) {
    var unionE = $ecsM6.union(E);
    return function(first, second) {
        if (second === undefined) {
            var unionE_1 = $63b3b5db92dfece4$export$971dd5b0dfd021b6(E);
            return function(second) {
                return unionE_1(second, first);
            };
        }
        return $63b3b5db92dfece4$export$a978c53b4062a525(first) && $63b3b5db92dfece4$export$a978c53b4062a525(second) ? unionE(second)(first) : $63b3b5db92dfece4$export$a978c53b4062a525(first) ? first : second;
    };
}
function $63b3b5db92dfece4$export$bc86dfbf7795668c(E) {
    var elemE = $63b3b5db92dfece4$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var intersectionE_1 = $63b3b5db92dfece4$export$bc86dfbf7795668c(E);
            return function(ys) {
                return intersectionE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return elemE(a, ys);
        });
    };
}
function $63b3b5db92dfece4$export$acaf96a27438246b(E) {
    var elemE = $63b3b5db92dfece4$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var differenceE_1 = $63b3b5db92dfece4$export$acaf96a27438246b(E);
            return function(ys) {
                return differenceE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return !elemE(a, ys);
        });
    };
}
var $63b3b5db92dfece4$var$_map = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$871de8747c9eaa88(f));
};
var $63b3b5db92dfece4$var$_mapWithIndex = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$8f07ddce13659f50(f));
};
var $63b3b5db92dfece4$var$_ap = function(fab, fa) {
    return (0, $72EOc.pipe)(fab, $63b3b5db92dfece4$export$2f6ca3d3b1f80bf5(fa));
};
var $63b3b5db92dfece4$var$_filter = function(fa, predicate) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$3dea766d36a8935f(predicate));
};
var $63b3b5db92dfece4$var$_filterMap = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$a04c6c6965dd4709(f));
};
var $63b3b5db92dfece4$var$_partition = function(fa, predicate) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$b29f828819edca8d(predicate));
};
var $63b3b5db92dfece4$var$_partitionMap = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$3117e3f9ececb6bc(f));
};
var $63b3b5db92dfece4$var$_partitionWithIndex = function(fa, predicateWithIndex) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$dad5e500f2bab9bc(predicateWithIndex));
};
var $63b3b5db92dfece4$var$_partitionMapWithIndex = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$bc7c0794b9c6f3ba(f));
};
var $63b3b5db92dfece4$var$_alt = function(fa, that) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$228be17d80722ab(that));
};
var $63b3b5db92dfece4$var$_reduce = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$533b26079ad0b4b(b, f));
};
var $63b3b5db92dfece4$var$_foldMap = function(M) {
    var foldMapM = $63b3b5db92dfece4$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $72EOc.pipe)(fa, foldMapM(f));
    };
};
var $63b3b5db92dfece4$var$_reduceRight = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$7fef8bcdbb34f435(b, f));
};
var $63b3b5db92dfece4$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$bbd3ef8720e22369(b, f));
};
var $63b3b5db92dfece4$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $63b3b5db92dfece4$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $72EOc.pipe)(fa, foldMapWithIndexM(f));
    };
};
var $63b3b5db92dfece4$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$ce2b2fe0b88ccd0a(b, f));
};
var $63b3b5db92dfece4$var$_filterMapWithIndex = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$30c5cbe848021e97(f));
};
var $63b3b5db92dfece4$var$_filterWithIndex = function(fa, predicateWithIndex) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$36e42aef19fc7171(predicateWithIndex));
};
var $63b3b5db92dfece4$var$_extend = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$8b58be045bf06082(f));
};
var $63b3b5db92dfece4$var$_traverse = function(F) {
    var traverseF = $63b3b5db92dfece4$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $72EOc.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $63b3b5db92dfece4$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $63b3b5db92dfece4$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $72EOc.pipe)(ta, traverseWithIndexF(f));
    };
};
var $63b3b5db92dfece4$export$c5c44f872d8af73 = function(a, f) {
    return (0, $72EOc.pipe)(a, $63b3b5db92dfece4$export$f855115a79f70c1a(f));
};
var $63b3b5db92dfece4$export$b9909b62ceeab991 = function(a, f) {
    return (0, $72EOc.pipe)(a, $63b3b5db92dfece4$export$bffee57bb00a6859(f));
};
var $63b3b5db92dfece4$export$ba255e9e49e00608 = $ecsM6.of;
var $63b3b5db92dfece4$export$7f9972325ebfd559 = function() {
    return $63b3b5db92dfece4$export$6e22c362a0406a2c;
};
var $63b3b5db92dfece4$export$1517cca7889d6aaa = function(that) {
    return function(fa) {
        return fa.concat(that());
    };
};
var $63b3b5db92dfece4$export$228be17d80722ab = $63b3b5db92dfece4$export$1517cca7889d6aaa;
var $63b3b5db92dfece4$export$2f6ca3d3b1f80bf5 = function(fa) {
    return $63b3b5db92dfece4$export$5b8affa63fc6df16(function(f) {
        return (0, $72EOc.pipe)(fa, $63b3b5db92dfece4$export$871de8747c9eaa88(f));
    });
};
var $63b3b5db92dfece4$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $72EOc.dual)(2, function(ma, f) {
    return (0, $72EOc.pipe)(ma, $63b3b5db92dfece4$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $63b3b5db92dfece4$export$bffa455ba8c619a6 = /*#__PURE__*/ $63b3b5db92dfece4$export$5b8affa63fc6df16((0, $72EOc.identity));
var $63b3b5db92dfece4$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return fa.map(function(a) {
            return f(a);
        });
    };
};
var $63b3b5db92dfece4$export$8f07ddce13659f50 = function(f) {
    return function(fa) {
        return fa.map(function(a, i) {
            return f(i, a);
        });
    };
};
var $63b3b5db92dfece4$export$709f6946f4e97408 = function(fa) {
    var left = [];
    var right = [];
    for(var _i = 0, fa_1 = fa; _i < fa_1.length; _i++){
        var e = fa_1[_i];
        if (e._tag === 'Left') left.push(e.left);
        else right.push(e.right);
    }
    return (0, $1HSKK.separated)(left, right);
};
var $63b3b5db92dfece4$export$3dea766d36a8935f = function(predicate) {
    return function(as) {
        return as.filter(predicate);
    };
};
var $63b3b5db92dfece4$export$30c5cbe848021e97 = function(f) {
    return function(fa) {
        var out = [];
        for(var i = 0; i < fa.length; i++){
            var optionB = f(i, fa[i]);
            if ($EfnK2.isSome(optionB)) out.push(optionB.value);
        }
        return out;
    };
};
var $63b3b5db92dfece4$export$a04c6c6965dd4709 = function(f) {
    return $63b3b5db92dfece4$export$30c5cbe848021e97(function(_, a) {
        return f(a);
    });
};
var $63b3b5db92dfece4$export$8e16b83750b44988 = /*#__PURE__*/ $63b3b5db92dfece4$export$a04c6c6965dd4709((0, $72EOc.identity));
var $63b3b5db92dfece4$export$b29f828819edca8d = function(predicate) {
    return $63b3b5db92dfece4$export$dad5e500f2bab9bc(function(_, a) {
        return predicate(a);
    });
};
var $63b3b5db92dfece4$export$dad5e500f2bab9bc = function(predicateWithIndex) {
    return function(as) {
        var left = [];
        var right = [];
        for(var i = 0; i < as.length; i++){
            var a = as[i];
            if (predicateWithIndex(i, a)) right.push(a);
            else left.push(a);
        }
        return (0, $1HSKK.separated)(left, right);
    };
};
var $63b3b5db92dfece4$export$3117e3f9ececb6bc = function(f) {
    return $63b3b5db92dfece4$export$bc7c0794b9c6f3ba(function(_, a) {
        return f(a);
    });
};
var $63b3b5db92dfece4$export$bc7c0794b9c6f3ba = function(f) {
    return function(fa) {
        var left = [];
        var right = [];
        for(var i = 0; i < fa.length; i++){
            var e = f(i, fa[i]);
            if (e._tag === 'Left') left.push(e.left);
            else right.push(e.right);
        }
        return (0, $1HSKK.separated)(left, right);
    };
};
var $63b3b5db92dfece4$export$36e42aef19fc7171 = function(predicateWithIndex) {
    return function(as) {
        return as.filter(function(a, i) {
            return predicateWithIndex(i, a);
        });
    };
};
var $63b3b5db92dfece4$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return wa.map(function(_, i) {
            return f(wa.slice(i));
        });
    };
};
var $63b3b5db92dfece4$export$ecd5e8ace626722c = /*#__PURE__*/ $63b3b5db92dfece4$export$8b58be045bf06082((0, $72EOc.identity));
var $63b3b5db92dfece4$export$18153bb1181268e5 = function(M) {
    return function(f) {
        return function(fa) {
            return fa.reduce(function(b, a, i) {
                return M.concat(b, f(i, a));
            }, M.empty);
        };
    };
};
var $63b3b5db92dfece4$export$533b26079ad0b4b = function(b, f) {
    return $63b3b5db92dfece4$export$bbd3ef8720e22369(b, function(_, b, a) {
        return f(b, a);
    });
};
var $63b3b5db92dfece4$export$b66cdc0497d8a99a = function(M) {
    var foldMapWithIndexM = $63b3b5db92dfece4$export$18153bb1181268e5(M);
    return function(f) {
        return foldMapWithIndexM(function(_, a) {
            return f(a);
        });
    };
};
var $63b3b5db92dfece4$export$bbd3ef8720e22369 = function(b, f) {
    return function(fa) {
        var len = fa.length;
        var out = b;
        for(var i = 0; i < len; i++)out = f(i, out, fa[i]);
        return out;
    };
};
var $63b3b5db92dfece4$export$7fef8bcdbb34f435 = function(b, f) {
    return $63b3b5db92dfece4$export$ce2b2fe0b88ccd0a(b, function(_, a, b) {
        return f(a, b);
    });
};
var $63b3b5db92dfece4$export$ce2b2fe0b88ccd0a = function(b, f) {
    return function(fa) {
        return fa.reduceRight(function(b, a, i) {
            return f(i, a, b);
        }, b);
    };
};
var $63b3b5db92dfece4$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $63b3b5db92dfece4$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $63b3b5db92dfece4$export$49bb65c2ea163039 = function(F) {
    return function(ta) {
        return $63b3b5db92dfece4$var$_reduce(ta, F.of($63b3b5db92dfece4$export$7f9972325ebfd559()), function(fas, fa) {
            return F.ap(F.map(fas, function(as) {
                return function(a) {
                    return (0, $72EOc.pipe)(as, $63b3b5db92dfece4$export$10d8903dec122b9d(a));
                };
            }), fa);
        });
    };
};
var $63b3b5db92dfece4$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return $63b3b5db92dfece4$export$bbd3ef8720e22369(F.of($63b3b5db92dfece4$export$7f9972325ebfd559()), function(i, fbs, a) {
            return F.ap(F.map(fbs, function(bs) {
                return function(b) {
                    return (0, $72EOc.pipe)(bs, $63b3b5db92dfece4$export$10d8903dec122b9d(b));
                };
            }), f(i, a));
        });
    };
};
var $63b3b5db92dfece4$export$6c36d01819ecdb31 = function(F) {
    var _witherF = $63b3b5db92dfece4$var$_wither(F);
    return function(f) {
        return function(fa) {
            return _witherF(fa, f);
        };
    };
};
var $63b3b5db92dfece4$export$2439a3bc02b13b03 = function(F) {
    var _wiltF = $63b3b5db92dfece4$var$_wilt(F);
    return function(f) {
        return function(fa) {
            return _wiltF(fa, f);
        };
    };
};
var $63b3b5db92dfece4$export$c48e357c1a89b78d = function(b, f) {
    var out = [];
    var bb = b;
    // eslint-disable-next-line no-constant-condition
    while(true){
        var mt = f(bb);
        if ($EfnK2.isSome(mt)) {
            var _a = mt.value, a = _a[0], b_1 = _a[1];
            out.push(a);
            bb = b_1;
        } else break;
    }
    return out;
};
var $63b3b5db92dfece4$export$9156e739aa33e19f = 'ReadonlyArray';
var $63b3b5db92dfece4$export$3cb5cd7f7776c81 = function(S) {
    return {
        show: function(as) {
            return "[".concat(as.map(S.show).join(', '), "]");
        }
    };
};
var $63b3b5db92dfece4$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return $63b3b5db92dfece4$export$dd1bc94b04021eeb(first) ? second : $63b3b5db92dfece4$export$dd1bc94b04021eeb(second) ? first : first.concat(second);
        }
    };
};
var $63b3b5db92dfece4$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $63b3b5db92dfece4$export$e759a9a7f8d04692().concat,
        empty: $63b3b5db92dfece4$export$6e22c362a0406a2c
    };
};
var $63b3b5db92dfece4$export$804fed467fde44e4 = function(E) {
    return (0, $3Md1m.fromEquals)(function(xs, ys) {
        return xs.length === ys.length && xs.every(function(x, i) {
            return E.equals(x, ys[i]);
        });
    });
};
var $63b3b5db92dfece4$export$1af51209b1b91d07 = function(O) {
    return (0, $gcR1C.fromCompare)(function(a, b) {
        var aLen = a.length;
        var bLen = b.length;
        var len = Math.min(aLen, bLen);
        for(var i = 0; i < len; i++){
            var ordering = O.compare(a[i], b[i]);
            if (ordering !== 0) return ordering;
        }
        return $RoEDj.Ord.compare(aLen, bLen);
    });
};
var $63b3b5db92dfece4$export$baca17b4aff42f82 = function(E) {
    var unionE = $63b3b5db92dfece4$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $63b3b5db92dfece4$export$c487aac9f4157837 = function(E) {
    return {
        concat: $63b3b5db92dfece4$export$baca17b4aff42f82(E).concat,
        empty: $63b3b5db92dfece4$export$6e22c362a0406a2c
    };
};
var $63b3b5db92dfece4$export$d379a869a72e4055 = function(E) {
    var intersectionE = $63b3b5db92dfece4$export$bc86dfbf7795668c(E);
    return {
        concat: function(first, second) {
            return intersectionE(second)(first);
        }
    };
};
var $63b3b5db92dfece4$export$fdb3296ca0a124e3 = function(E) {
    var differenceE = $63b3b5db92dfece4$export$acaf96a27438246b(E);
    return {
        concat: function(first, second) {
            return differenceE(second)(first);
        }
    };
};
var $63b3b5db92dfece4$export$bd5b6bfc5fa2ee61 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map
};
var $63b3b5db92dfece4$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $cpwuW.flap)($63b3b5db92dfece4$export$bd5b6bfc5fa2ee61);
var $63b3b5db92dfece4$export$59a71046037e6c20 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    of: $63b3b5db92dfece4$export$ba255e9e49e00608
};
var $63b3b5db92dfece4$export$9fdffe0fe1e91cad = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    mapWithIndex: $63b3b5db92dfece4$var$_mapWithIndex
};
var $63b3b5db92dfece4$export$efc21ddc6aeb363d = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    ap: $63b3b5db92dfece4$var$_ap
};
var $63b3b5db92dfece4$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $aYN4d.apFirst)($63b3b5db92dfece4$export$efc21ddc6aeb363d);
var $63b3b5db92dfece4$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $aYN4d.apSecond)($63b3b5db92dfece4$export$efc21ddc6aeb363d);
var $63b3b5db92dfece4$export$1279d2b7807629fd = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    ap: $63b3b5db92dfece4$var$_ap,
    of: $63b3b5db92dfece4$export$ba255e9e49e00608
};
var $63b3b5db92dfece4$export$f18d5acc27d70423 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    ap: $63b3b5db92dfece4$var$_ap,
    chain: $63b3b5db92dfece4$export$5b8affa63fc6df16
};
var $63b3b5db92dfece4$export$fb641926d034ac7d = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    ap: $63b3b5db92dfece4$var$_ap,
    of: $63b3b5db92dfece4$export$ba255e9e49e00608,
    chain: $63b3b5db92dfece4$export$5b8affa63fc6df16
};
var $63b3b5db92dfece4$export$e3821ef4970c339c = /*#__PURE__*/ (0, $kgj0x.chainFirst)($63b3b5db92dfece4$export$f18d5acc27d70423);
var $63b3b5db92dfece4$export$8fa953f00d3b093 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    unfold: $63b3b5db92dfece4$export$c48e357c1a89b78d
};
var $63b3b5db92dfece4$export$25ba4469a069167 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    alt: $63b3b5db92dfece4$var$_alt
};
var $63b3b5db92dfece4$export$aaef8a3eae948f03 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    zero: $63b3b5db92dfece4$export$7f9972325ebfd559
};
var $63b3b5db92dfece4$export$864d727b48066337 = /*#__PURE__*/ (0, $3n81G.guard)($63b3b5db92dfece4$export$aaef8a3eae948f03, $63b3b5db92dfece4$export$59a71046037e6c20);
var $63b3b5db92dfece4$export$4acb47accde578d2 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    ap: $63b3b5db92dfece4$var$_ap,
    of: $63b3b5db92dfece4$export$ba255e9e49e00608,
    alt: $63b3b5db92dfece4$var$_alt,
    zero: $63b3b5db92dfece4$export$7f9972325ebfd559
};
var $63b3b5db92dfece4$export$5b5dd0e212d2a5bc = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    extend: $63b3b5db92dfece4$var$_extend
};
var $63b3b5db92dfece4$export$4a21ac48141ac3c9 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    compact: $63b3b5db92dfece4$export$8e16b83750b44988,
    separate: $63b3b5db92dfece4$export$709f6946f4e97408
};
var $63b3b5db92dfece4$export$d00e1c48fb621173 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    compact: $63b3b5db92dfece4$export$8e16b83750b44988,
    separate: $63b3b5db92dfece4$export$709f6946f4e97408,
    filter: $63b3b5db92dfece4$var$_filter,
    filterMap: $63b3b5db92dfece4$var$_filterMap,
    partition: $63b3b5db92dfece4$var$_partition,
    partitionMap: $63b3b5db92dfece4$var$_partitionMap
};
var $63b3b5db92dfece4$export$c29a647071e542ec = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    mapWithIndex: $63b3b5db92dfece4$var$_mapWithIndex,
    compact: $63b3b5db92dfece4$export$8e16b83750b44988,
    separate: $63b3b5db92dfece4$export$709f6946f4e97408,
    filter: $63b3b5db92dfece4$var$_filter,
    filterMap: $63b3b5db92dfece4$var$_filterMap,
    partition: $63b3b5db92dfece4$var$_partition,
    partitionMap: $63b3b5db92dfece4$var$_partitionMap,
    partitionMapWithIndex: $63b3b5db92dfece4$var$_partitionMapWithIndex,
    partitionWithIndex: $63b3b5db92dfece4$var$_partitionWithIndex,
    filterMapWithIndex: $63b3b5db92dfece4$var$_filterMapWithIndex,
    filterWithIndex: $63b3b5db92dfece4$var$_filterWithIndex
};
var $63b3b5db92dfece4$export$41404b31838667c9 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    reduce: $63b3b5db92dfece4$var$_reduce,
    foldMap: $63b3b5db92dfece4$var$_foldMap,
    reduceRight: $63b3b5db92dfece4$var$_reduceRight
};
var $63b3b5db92dfece4$export$e8f7d17aaff345cb = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    reduce: $63b3b5db92dfece4$var$_reduce,
    foldMap: $63b3b5db92dfece4$var$_foldMap,
    reduceRight: $63b3b5db92dfece4$var$_reduceRight,
    reduceWithIndex: $63b3b5db92dfece4$var$_reduceWithIndex,
    foldMapWithIndex: $63b3b5db92dfece4$var$_foldMapWithIndex,
    reduceRightWithIndex: $63b3b5db92dfece4$var$_reduceRightWithIndex
};
var $63b3b5db92dfece4$export$a0202666c3bda011 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    reduce: $63b3b5db92dfece4$var$_reduce,
    foldMap: $63b3b5db92dfece4$var$_foldMap,
    reduceRight: $63b3b5db92dfece4$var$_reduceRight,
    traverse: $63b3b5db92dfece4$var$_traverse,
    sequence: $63b3b5db92dfece4$export$49bb65c2ea163039
};
var $63b3b5db92dfece4$export$bd7b528d8c36ec41 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    mapWithIndex: $63b3b5db92dfece4$var$_mapWithIndex,
    reduce: $63b3b5db92dfece4$var$_reduce,
    foldMap: $63b3b5db92dfece4$var$_foldMap,
    reduceRight: $63b3b5db92dfece4$var$_reduceRight,
    reduceWithIndex: $63b3b5db92dfece4$var$_reduceWithIndex,
    foldMapWithIndex: $63b3b5db92dfece4$var$_foldMapWithIndex,
    reduceRightWithIndex: $63b3b5db92dfece4$var$_reduceRightWithIndex,
    traverse: $63b3b5db92dfece4$var$_traverse,
    sequence: $63b3b5db92dfece4$export$49bb65c2ea163039,
    traverseWithIndex: $63b3b5db92dfece4$var$_traverseWithIndex
};
var $63b3b5db92dfece4$export$f855115a79f70c1a = function(f) {
    return function(a) {
        var todo = $63b3b5db92dfece4$var$__spreadArray([], f(a), true);
        var out = [];
        while(todo.length > 0){
            var e = todo.shift();
            if ($EfnK2.isLeft(e)) todo.unshift.apply(todo, f(e.left));
            else out.push(e.right);
        }
        return out;
    };
};
var $63b3b5db92dfece4$export$7d808dfaa6d54634 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    ap: $63b3b5db92dfece4$var$_ap,
    chain: $63b3b5db92dfece4$export$5b8affa63fc6df16,
    chainRec: $63b3b5db92dfece4$export$c5c44f872d8af73
};
var $63b3b5db92dfece4$export$bffee57bb00a6859 = function(f) {
    return function(a) {
        var initial = f(a);
        var todo = [];
        var out = [];
        function go(e) {
            if ($EfnK2.isLeft(e)) f(e.left).forEach(function(v) {
                return todo.push(v);
            });
            else out.push(e.right);
        }
        for(var _i = 0, initial_1 = initial; _i < initial_1.length; _i++){
            var e = initial_1[_i];
            go(e);
        }
        while(todo.length > 0)go(todo.shift());
        return out;
    };
};
var $63b3b5db92dfece4$export$57f3a385c7e59628 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    ap: $63b3b5db92dfece4$var$_ap,
    chain: $63b3b5db92dfece4$export$5b8affa63fc6df16,
    chainRec: $63b3b5db92dfece4$export$b9909b62ceeab991
};
var $63b3b5db92dfece4$var$_wither = /*#__PURE__*/ (0, $jNYdc.witherDefault)($63b3b5db92dfece4$export$a0202666c3bda011, $63b3b5db92dfece4$export$4a21ac48141ac3c9);
var $63b3b5db92dfece4$var$_wilt = /*#__PURE__*/ (0, $jNYdc.wiltDefault)($63b3b5db92dfece4$export$a0202666c3bda011, $63b3b5db92dfece4$export$4a21ac48141ac3c9);
var $63b3b5db92dfece4$export$748d317b4c426f96 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    map: $63b3b5db92dfece4$var$_map,
    compact: $63b3b5db92dfece4$export$8e16b83750b44988,
    separate: $63b3b5db92dfece4$export$709f6946f4e97408,
    filter: $63b3b5db92dfece4$var$_filter,
    filterMap: $63b3b5db92dfece4$var$_filterMap,
    partition: $63b3b5db92dfece4$var$_partition,
    partitionMap: $63b3b5db92dfece4$var$_partitionMap,
    reduce: $63b3b5db92dfece4$var$_reduce,
    foldMap: $63b3b5db92dfece4$var$_foldMap,
    reduceRight: $63b3b5db92dfece4$var$_reduceRight,
    traverse: $63b3b5db92dfece4$var$_traverse,
    sequence: $63b3b5db92dfece4$export$49bb65c2ea163039,
    wither: $63b3b5db92dfece4$var$_wither,
    wilt: $63b3b5db92dfece4$var$_wilt
};
var $63b3b5db92dfece4$export$c40604f35db61519 = /*#__PURE__*/ (0, $jNYdc.filterE)($63b3b5db92dfece4$export$748d317b4c426f96);
var $63b3b5db92dfece4$export$825ea6cb6fc48d49 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    fromEither: $63b3b5db92dfece4$export$80c878c9b1d77917
};
var $63b3b5db92dfece4$export$8138b0ae92c9b5d8 = /*#__PURE__*/ (0, $jFfj2.fromEitherK)($63b3b5db92dfece4$export$825ea6cb6fc48d49);
var $63b3b5db92dfece4$export$f4863e1822a1860c = $ecsM6.unsafeInsertAt;
var $63b3b5db92dfece4$export$9c0c6889b1fa9bfc = function(i, a, as) {
    return $63b3b5db92dfece4$export$a978c53b4062a525(as) ? $ecsM6.unsafeUpdateAt(i, a, as) : as;
};
var $63b3b5db92dfece4$export$4937fde8dfc38dbd = function(i, as) {
    var xs = as.slice();
    xs.splice(i, 1);
    return xs;
};
var $63b3b5db92dfece4$export$45b10814cc054894 = function(as) {
    return as.slice();
};
var $63b3b5db92dfece4$export$571d59b505e6bb4e = function(as) {
    return $63b3b5db92dfece4$export$dd1bc94b04021eeb(as) ? $63b3b5db92dfece4$export$6e22c362a0406a2c : as.slice();
};
var $63b3b5db92dfece4$export$6e22c362a0406a2c = $ecsM6.empty;
function $63b3b5db92dfece4$export$7ecc1a3b11b57dab(predicate) {
    return function(as) {
        return as.every(predicate);
    };
}
var $63b3b5db92dfece4$export$ad14ef4001db2bcd = function(predicate) {
    return function(as) {
        return as.some(predicate);
    };
};
var $63b3b5db92dfece4$export$f7e9f41ea797a17 = $63b3b5db92dfece4$export$ad14ef4001db2bcd;
var $63b3b5db92dfece4$export$739ec22334c44788 = function(M) {
    var intercalateM = $ecsM6.intercalate(M);
    return function(middle) {
        return $63b3b5db92dfece4$export$4659b591c19bdf3d(function() {
            return M.empty;
        }, intercalateM(middle));
    };
};
var $63b3b5db92dfece4$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $63b3b5db92dfece4$export$ba255e9e49e00608($EfnK2.emptyRecord);
var $63b3b5db92dfece4$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $cpwuW.bindTo)($63b3b5db92dfece4$export$bd5b6bfc5fa2ee61);
var $63b3b5db92dfece4$export$5d537b797c421217 = /*#__PURE__*/ (0, $cpwuW.let)($63b3b5db92dfece4$export$bd5b6bfc5fa2ee61);
var $63b3b5db92dfece4$export$2385a24977818dd0 = /*#__PURE__*/ (0, $kgj0x.bind)($63b3b5db92dfece4$export$f18d5acc27d70423);
var $63b3b5db92dfece4$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $aYN4d.apS)($63b3b5db92dfece4$export$efc21ddc6aeb363d);
var $63b3b5db92dfece4$export$e08e3b67e392101e = $63b3b5db92dfece4$export$5b8affa63fc6df16;
var $63b3b5db92dfece4$export$d02631cccf789723 = $ecsM6.range;
var $63b3b5db92dfece4$export$8327ebbef2a0ba76 = $ecsM6.cons;
var $63b3b5db92dfece4$export$c40cf5aab899f397 = $ecsM6.snoc;
var $63b3b5db92dfece4$export$baeb00bf1e27e233 = $63b3b5db92dfece4$export$849c7567cbd62acc;
var $63b3b5db92dfece4$export$95ca155af9fd5713 = {
    URI: $63b3b5db92dfece4$export$9156e739aa33e19f,
    compact: $63b3b5db92dfece4$export$8e16b83750b44988,
    separate: $63b3b5db92dfece4$export$709f6946f4e97408,
    map: $63b3b5db92dfece4$var$_map,
    ap: $63b3b5db92dfece4$var$_ap,
    of: $63b3b5db92dfece4$export$ba255e9e49e00608,
    chain: $63b3b5db92dfece4$export$5b8affa63fc6df16,
    filter: $63b3b5db92dfece4$var$_filter,
    filterMap: $63b3b5db92dfece4$var$_filterMap,
    partition: $63b3b5db92dfece4$var$_partition,
    partitionMap: $63b3b5db92dfece4$var$_partitionMap,
    mapWithIndex: $63b3b5db92dfece4$var$_mapWithIndex,
    partitionMapWithIndex: $63b3b5db92dfece4$var$_partitionMapWithIndex,
    partitionWithIndex: $63b3b5db92dfece4$var$_partitionWithIndex,
    filterMapWithIndex: $63b3b5db92dfece4$var$_filterMapWithIndex,
    filterWithIndex: $63b3b5db92dfece4$var$_filterWithIndex,
    alt: $63b3b5db92dfece4$var$_alt,
    zero: $63b3b5db92dfece4$export$7f9972325ebfd559,
    unfold: $63b3b5db92dfece4$export$c48e357c1a89b78d,
    reduce: $63b3b5db92dfece4$var$_reduce,
    foldMap: $63b3b5db92dfece4$var$_foldMap,
    reduceRight: $63b3b5db92dfece4$var$_reduceRight,
    traverse: $63b3b5db92dfece4$var$_traverse,
    sequence: $63b3b5db92dfece4$export$49bb65c2ea163039,
    reduceWithIndex: $63b3b5db92dfece4$var$_reduceWithIndex,
    foldMapWithIndex: $63b3b5db92dfece4$var$_foldMapWithIndex,
    reduceRightWithIndex: $63b3b5db92dfece4$var$_reduceRightWithIndex,
    traverseWithIndex: $63b3b5db92dfece4$var$_traverseWithIndex,
    extend: $63b3b5db92dfece4$var$_extend,
    wither: $63b3b5db92dfece4$var$_wither,
    wilt: $63b3b5db92dfece4$var$_wilt
};

});
parcelRegister("RoEDj", function(module, exports) {

$parcel$export(module.exports, "Ord", () => $0a08133259714bc1$export$ee8aa95bfab51c5);
// -------------------------------------------------------------------------------------
// refinements
// -------------------------------------------------------------------------------------
/**
 * @category refinements
 * @since 2.11.0
 */ var $0a08133259714bc1$export$7e4aa119212bc614 = function(u) {
    return typeof u === 'number';
};
var $0a08133259714bc1$export$a2050e5b0c4dcf10 = {
    equals: function(first, second) {
        return first === second;
    }
};
var $0a08133259714bc1$export$ee8aa95bfab51c5 = {
    equals: $0a08133259714bc1$export$a2050e5b0c4dcf10.equals,
    compare: function(first, second) {
        return first < second ? -1 : first > second ? 1 : 0;
    }
};
var $0a08133259714bc1$export$88f31472ebc405c8 = {
    equals: $0a08133259714bc1$export$a2050e5b0c4dcf10.equals,
    compare: $0a08133259714bc1$export$ee8aa95bfab51c5.compare,
    top: Infinity,
    bottom: -Infinity
};
var $0a08133259714bc1$export$f6a3d19be20f5819 = {
    show: function(n) {
        return JSON.stringify(n);
    }
};
var $0a08133259714bc1$export$d423c79a04b3ae25 = {
    concat: function(first, second) {
        return first - second;
    }
};
var $0a08133259714bc1$export$e5fae4f686b09c06 = {
    concat: function(first, second) {
        return first + second;
    }
};
var $0a08133259714bc1$export$5b0bccec79556292 = {
    concat: function(first, second) {
        return first * second;
    }
};
var $0a08133259714bc1$export$2517c0450e71e789 = {
    concat: $0a08133259714bc1$export$e5fae4f686b09c06.concat,
    empty: 0
};
var $0a08133259714bc1$export$ee1a63590489b690 = {
    concat: $0a08133259714bc1$export$5b0bccec79556292.concat,
    empty: 1
};
var $0a08133259714bc1$export$a455218a85c89869 = {
    add: $0a08133259714bc1$export$e5fae4f686b09c06.concat,
    zero: 0,
    mul: $0a08133259714bc1$export$5b0bccec79556292.concat,
    one: 1,
    sub: $0a08133259714bc1$export$d423c79a04b3ae25.concat,
    degree: function(_) {
        return 1;
    },
    div: function(first, second) {
        return first / second;
    },
    mod: function(first, second) {
        return first % second;
    }
};

});

parcelRegister("1HSKK", function(module, exports) {

$parcel$export(module.exports, "separated", () => $13e44761c4ec866c$export$beaabdf62f4a639d);
/**
 * ```ts
 * interface Separated<E, A> {
 *    readonly left: E
 *    readonly right: A
 * }
 * ```
 *
 * Represents a result of separating a whole into two parts.
 *
 * @since 2.10.0
 */ 
var $72EOc = parcelRequire("72EOc");

var $cpwuW = parcelRequire("cpwuW");
var $13e44761c4ec866c$export$beaabdf62f4a639d = function(left, right) {
    return {
        left: left,
        right: right
    };
};
var $13e44761c4ec866c$var$_map = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $13e44761c4ec866c$export$871de8747c9eaa88(f));
};
var $13e44761c4ec866c$var$_mapLeft = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $13e44761c4ec866c$export$472de43a55e4aa49(f));
};
var $13e44761c4ec866c$var$_bimap = function(fa, g, f) {
    return (0, $72EOc.pipe)(fa, $13e44761c4ec866c$export$eb54baf0b342cb1d(g, f));
};
var $13e44761c4ec866c$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $13e44761c4ec866c$export$beaabdf62f4a639d($13e44761c4ec866c$export$eabcd2c8791e7bf4(fa), f($13e44761c4ec866c$export$79ffe56a765070d2(fa)));
    };
};
var $13e44761c4ec866c$export$472de43a55e4aa49 = function(f) {
    return function(fa) {
        return $13e44761c4ec866c$export$beaabdf62f4a639d(f($13e44761c4ec866c$export$eabcd2c8791e7bf4(fa)), $13e44761c4ec866c$export$79ffe56a765070d2(fa));
    };
};
var $13e44761c4ec866c$export$eb54baf0b342cb1d = function(f, g) {
    return function(fa) {
        return $13e44761c4ec866c$export$beaabdf62f4a639d(f($13e44761c4ec866c$export$eabcd2c8791e7bf4(fa)), g($13e44761c4ec866c$export$79ffe56a765070d2(fa)));
    };
};
var $13e44761c4ec866c$export$9156e739aa33e19f = 'Separated';
var $13e44761c4ec866c$export$fd0fe42029639505 = {
    URI: $13e44761c4ec866c$export$9156e739aa33e19f,
    mapLeft: $13e44761c4ec866c$var$_mapLeft,
    bimap: $13e44761c4ec866c$var$_bimap
};
var $13e44761c4ec866c$export$bd5b6bfc5fa2ee61 = {
    URI: $13e44761c4ec866c$export$9156e739aa33e19f,
    map: $13e44761c4ec866c$var$_map
};
var $13e44761c4ec866c$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $cpwuW.flap)($13e44761c4ec866c$export$bd5b6bfc5fa2ee61);
var $13e44761c4ec866c$export$eabcd2c8791e7bf4 = function(s) {
    return s.left;
};
var $13e44761c4ec866c$export$79ffe56a765070d2 = function(s) {
    return s.right;
};

});

parcelRegister("jNYdc", function(module, exports) {

$parcel$export(module.exports, "wiltDefault", () => $03b8897efe5e6a0f$export$f4cb42390e44d1d2);
$parcel$export(module.exports, "witherDefault", () => $03b8897efe5e6a0f$export$1f5c6f948d11a182);
$parcel$export(module.exports, "filterE", () => $03b8897efe5e6a0f$export$c40604f35db61519);

var $EfnK2 = parcelRequire("EfnK2");
function $03b8897efe5e6a0f$export$f4cb42390e44d1d2(T, C) {
    return function(F) {
        var traverseF = T.traverse(F);
        return function(wa, f) {
            return F.map(traverseF(wa, f), C.separate);
        };
    };
}
function $03b8897efe5e6a0f$export$1f5c6f948d11a182(T, C) {
    return function(F) {
        var traverseF = T.traverse(F);
        return function(wa, f) {
            return F.map(traverseF(wa, f), C.compact);
        };
    };
}
function $03b8897efe5e6a0f$export$c40604f35db61519(W) {
    return function(F) {
        var witherF = W.wither(F);
        return function(predicate) {
            return function(ga) {
                return witherF(ga, function(a) {
                    return F.map(predicate(a), function(b) {
                        return b ? $EfnK2.some(a) : $EfnK2.none;
                    });
                });
            };
        };
    };
}

});

parcelRegister("3n81G", function(module, exports) {

$parcel$export(module.exports, "guard", () => $2749bee247d49a72$export$864d727b48066337);
function $2749bee247d49a72$export$864d727b48066337(F, P) {
    return function(b) {
        return b ? P.of(undefined) : F.zero();
    };
}

});



parcelRegister("fFgN5", function(module, exports) {

$parcel$export(module.exports, "make", () => $b677b5a03c897589$export$dd44f18ab656f3bb);
$parcel$export(module.exports, "getApplicative", () => $b677b5a03c897589$export$1402880adb2295a7);

var $72EOc = parcelRequire("72EOc");

var $cpwuW = parcelRequire("cpwuW");
var $b677b5a03c897589$export$dd44f18ab656f3bb = (0, $72EOc.unsafeCoerce);
function $b677b5a03c897589$export$3cb5cd7f7776c81(S) {
    return {
        show: function(c) {
            return "make(".concat(S.show(c), ")");
        }
    };
}
var $b677b5a03c897589$export$804fed467fde44e4 = (0, $72EOc.identity);
var $b677b5a03c897589$export$1af51209b1b91d07 = (0, $72EOc.identity);
var $b677b5a03c897589$export$c55397fc301c5a = (0, $72EOc.identity);
var $b677b5a03c897589$export$e759a9a7f8d04692 = (0, $72EOc.identity);
var $b677b5a03c897589$export$c2a7ef2cc9b32b31 = (0, $72EOc.identity);
var $b677b5a03c897589$export$3d48c7fefc7b8ec2 = (0, $72EOc.identity);
var $b677b5a03c897589$export$575097c1c561f76f = (0, $72EOc.identity);
var $b677b5a03c897589$export$2e73cb3f0f25ed55 = (0, $72EOc.identity);
var $b677b5a03c897589$export$f37f1abb2c955577 = (0, $72EOc.identity);
function $b677b5a03c897589$export$81090df2aa47ff12(S) {
    return {
        URI: $b677b5a03c897589$export$9156e739aa33e19f,
        _E: undefined,
        map: $b677b5a03c897589$var$_map,
        ap: function(fab, fa) {
            return $b677b5a03c897589$export$dd44f18ab656f3bb(S.concat(fab, fa));
        }
    };
}
function $b677b5a03c897589$export$1402880adb2295a7(M) {
    var A = $b677b5a03c897589$export$81090df2aa47ff12(M);
    return {
        URI: $b677b5a03c897589$export$9156e739aa33e19f,
        _E: undefined,
        map: A.map,
        ap: A.ap,
        of: function() {
            return $b677b5a03c897589$export$dd44f18ab656f3bb(M.empty);
        }
    };
}
var $b677b5a03c897589$var$_contramap = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $b677b5a03c897589$export$53b696d27ecb7ba7(f));
};
/* istanbul ignore next */ var $b677b5a03c897589$var$_map = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $b677b5a03c897589$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $b677b5a03c897589$var$_bimap = function(fa, f, g) {
    return (0, $72EOc.pipe)(fa, $b677b5a03c897589$export$eb54baf0b342cb1d(f, g));
};
/* istanbul ignore next */ var $b677b5a03c897589$var$_mapLeft = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $b677b5a03c897589$export$472de43a55e4aa49(f));
};
var $b677b5a03c897589$export$53b696d27ecb7ba7 = function() {
    return 0, $72EOc.unsafeCoerce;
};
var $b677b5a03c897589$export$871de8747c9eaa88 = function() {
    return 0, $72EOc.unsafeCoerce;
};
var $b677b5a03c897589$export$eb54baf0b342cb1d = function(f) {
    return function(fa) {
        return $b677b5a03c897589$export$dd44f18ab656f3bb(f(fa));
    };
};
var $b677b5a03c897589$export$472de43a55e4aa49 = function(f) {
    return function(fa) {
        return $b677b5a03c897589$export$dd44f18ab656f3bb(f(fa));
    };
};
var $b677b5a03c897589$export$9156e739aa33e19f = 'Const';
var $b677b5a03c897589$export$bd5b6bfc5fa2ee61 = {
    URI: $b677b5a03c897589$export$9156e739aa33e19f,
    map: $b677b5a03c897589$var$_map
};
var $b677b5a03c897589$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $cpwuW.flap)($b677b5a03c897589$export$bd5b6bfc5fa2ee61);
var $b677b5a03c897589$export$def901a57d5539c3 = {
    URI: $b677b5a03c897589$export$9156e739aa33e19f,
    contramap: $b677b5a03c897589$var$_contramap
};
var $b677b5a03c897589$export$fd0fe42029639505 = {
    URI: $b677b5a03c897589$export$9156e739aa33e19f,
    bimap: $b677b5a03c897589$var$_bimap,
    mapLeft: $b677b5a03c897589$var$_mapLeft
};
var $b677b5a03c897589$export$dfdd8a9a12668b21 = {
    URI: $b677b5a03c897589$export$9156e739aa33e19f,
    map: $b677b5a03c897589$var$_map,
    contramap: $b677b5a03c897589$var$_contramap,
    bimap: $b677b5a03c897589$var$_bimap,
    mapLeft: $b677b5a03c897589$var$_mapLeft
};

});

parcelRegister("1Te5W", function(module, exports) {

$parcel$export(module.exports, "monoidAll", () => $1605dc6b7f5aa7d2$export$ea84ccdc68daa647);
$parcel$export(module.exports, "monoidAny", () => $1605dc6b7f5aa7d2$export$c147905ca5134122);

var $7Ievk = parcelRequire("7Ievk");

var $72EOc = parcelRequire("72EOc");

var $EfnK2 = parcelRequire("EfnK2");

var $58DQ5 = parcelRequire("58DQ5");
var $1605dc6b7f5aa7d2$export$96ec731ed4dcb222 = function(B) {
    return {
        concat: $58DQ5.min(B).concat,
        empty: B.top
    };
};
var $1605dc6b7f5aa7d2$export$8960430cfd85939f = function(B) {
    return {
        concat: $58DQ5.max(B).concat,
        empty: B.bottom
    };
};
var $1605dc6b7f5aa7d2$export$66c1ae025e96b4bc = function(M) {
    return {
        concat: $58DQ5.reverse(M).concat,
        empty: M.empty
    };
};
var $1605dc6b7f5aa7d2$export$8cf3da7c1c9174ea = function(monoids) {
    var empty = {};
    for(var k in monoids)if ($EfnK2.has.call(monoids, k)) empty[k] = monoids[k].empty;
    return {
        concat: $58DQ5.struct(monoids).concat,
        empty: empty
    };
};
var $1605dc6b7f5aa7d2$export$65e3907585753458 = function() {
    var monoids = [];
    for(var _i = 0; _i < arguments.length; _i++)monoids[_i] = arguments[_i];
    return {
        concat: $58DQ5.tuple.apply($58DQ5, monoids).concat,
        empty: monoids.map(function(m) {
            return m.empty;
        })
    };
};
var $1605dc6b7f5aa7d2$export$b314777ae20abca9 = function(M) {
    return $58DQ5.concatAll(M)(M.empty);
};
var $1605dc6b7f5aa7d2$export$50d82750fd26461d = {
    concat: $58DQ5.semigroupVoid.concat,
    empty: undefined
};
var $1605dc6b7f5aa7d2$export$4ab04e39033ac22a = $1605dc6b7f5aa7d2$export$65e3907585753458;
var $1605dc6b7f5aa7d2$export$dfc91d1e5b77420b = $1605dc6b7f5aa7d2$export$8cf3da7c1c9174ea;
var $1605dc6b7f5aa7d2$export$5ca84f9b29f1c1a2 = $1605dc6b7f5aa7d2$export$66c1ae025e96b4bc;
var $1605dc6b7f5aa7d2$export$9cc0388793460b00 = $1605dc6b7f5aa7d2$export$8960430cfd85939f;
var $1605dc6b7f5aa7d2$export$6d1c667712a51996 = $1605dc6b7f5aa7d2$export$96ec731ed4dcb222;
var $1605dc6b7f5aa7d2$export$93e2b83da34ff82a = $1605dc6b7f5aa7d2$export$b314777ae20abca9;
var $1605dc6b7f5aa7d2$export$ea84ccdc68daa647 = {
    concat: $58DQ5.semigroupAll.concat,
    empty: true
};
var $1605dc6b7f5aa7d2$export$c147905ca5134122 = {
    concat: $58DQ5.semigroupAny.concat,
    empty: false
};
var $1605dc6b7f5aa7d2$export$616ba591d6210ed8 = (0, $72EOc.getMonoid);
var $1605dc6b7f5aa7d2$export$5c6d2e402d334f37 = function() {
    return $1605dc6b7f5aa7d2$export$66c1ae025e96b4bc((0, $7Ievk.getMonoid)());
};
var $1605dc6b7f5aa7d2$export$fc39f3d77fa2e58a = {
    concat: $58DQ5.semigroupString.concat,
    empty: ''
};
var $1605dc6b7f5aa7d2$export$8f9c64d4a92a9eb6 = {
    concat: $58DQ5.semigroupSum.concat,
    empty: 0
};
var $1605dc6b7f5aa7d2$export$cb362f92c995f3b8 = {
    concat: $58DQ5.semigroupProduct.concat,
    empty: 1
};

});
parcelRegister("7Ievk", function(module, exports) {

$parcel$export(module.exports, "getMonoid", () => $59d7e4b4896d2e87$export$c2a7ef2cc9b32b31);
/**
 * @since 2.11.0
 */ 
var $72EOc = parcelRequire("72EOc");
var $59d7e4b4896d2e87$export$9156e739aa33e19f = 'Endomorphism';
var $59d7e4b4896d2e87$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return (0, $72EOc.flow)(first, second);
        }
    };
};
var $59d7e4b4896d2e87$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $59d7e4b4896d2e87$export$e759a9a7f8d04692().concat,
        empty: (0, $72EOc.identity)
    };
};

});


parcelRegister("bxsNd", function(module, exports) {

$parcel$export(module.exports, "none", () => $86691c66edf4fb98$export$f883a24d5edde77c);
$parcel$export(module.exports, "some", () => $86691c66edf4fb98$export$ad14ef4001db2bcd);
$parcel$export(module.exports, "fromPredicate", () => $86691c66edf4fb98$export$23f31c55d7162b91);
$parcel$export(module.exports, "map", () => $86691c66edf4fb98$export$871de8747c9eaa88);
$parcel$export(module.exports, "isNone", () => $86691c66edf4fb98$export$e56af863d5645d5f);
$parcel$export(module.exports, "fromEither", () => $86691c66edf4fb98$export$80c878c9b1d77917);
$parcel$export(module.exports, "fold", () => $86691c66edf4fb98$export$93e2b83da34ff82a);
$parcel$export(module.exports, "getOrElse", () => $86691c66edf4fb98$export$8832081647a02ee7);
$parcel$export(module.exports, "fromNullable", () => $86691c66edf4fb98$export$b601f49376b4621a);
$parcel$export(module.exports, "chain", () => $86691c66edf4fb98$export$e08e3b67e392101e);
$parcel$export(module.exports, "option", () => $86691c66edf4fb98$export$a75d1723e6bda2ec);
$parcel$export(module.exports, "getFirstMonoid", () => $86691c66edf4fb98$export$56cd0d85e73e688f);

var $9xys1 = parcelRequire("9xys1");

var $aYN4d = parcelRequire("aYN4d");

var $kgj0x = parcelRequire("kgj0x");

var $jFfj2 = parcelRequire("jFfj2");

var $72EOc = parcelRequire("72EOc");

var $cpwuW = parcelRequire("cpwuW");

var $EfnK2 = parcelRequire("EfnK2");

var $9RniI = parcelRequire("9RniI");

var $58DQ5 = parcelRequire("58DQ5");

var $1HSKK = parcelRequire("1HSKK");

var $jNYdc = parcelRequire("jNYdc");

var $3n81G = parcelRequire("3n81G");
var $86691c66edf4fb98$export$f883a24d5edde77c = $EfnK2.none;
var $86691c66edf4fb98$export$ad14ef4001db2bcd = $EfnK2.some;
function $86691c66edf4fb98$export$23f31c55d7162b91(predicate) {
    return function(a) {
        return predicate(a) ? $86691c66edf4fb98$export$ad14ef4001db2bcd(a) : $86691c66edf4fb98$export$f883a24d5edde77c;
    };
}
var $86691c66edf4fb98$export$da405662c16fca8e = function(ma) {
    return ma._tag === 'Right' ? $86691c66edf4fb98$export$f883a24d5edde77c : $86691c66edf4fb98$export$ad14ef4001db2bcd(ma.left);
};
var $86691c66edf4fb98$export$482f3615ecf01dc6 = function(ma) {
    return ma._tag === 'Left' ? $86691c66edf4fb98$export$f883a24d5edde77c : $86691c66edf4fb98$export$ad14ef4001db2bcd(ma.right);
};
var $86691c66edf4fb98$var$_map = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $86691c66edf4fb98$export$871de8747c9eaa88(f));
};
var $86691c66edf4fb98$var$_ap = function(fab, fa) {
    return (0, $72EOc.pipe)(fab, $86691c66edf4fb98$export$2f6ca3d3b1f80bf5(fa));
};
var $86691c66edf4fb98$var$_reduce = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $86691c66edf4fb98$export$533b26079ad0b4b(b, f));
};
var $86691c66edf4fb98$var$_foldMap = function(M) {
    var foldMapM = $86691c66edf4fb98$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $72EOc.pipe)(fa, foldMapM(f));
    };
};
var $86691c66edf4fb98$var$_reduceRight = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $86691c66edf4fb98$export$7fef8bcdbb34f435(b, f));
};
var $86691c66edf4fb98$var$_traverse = function(F) {
    var traverseF = $86691c66edf4fb98$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $72EOc.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $86691c66edf4fb98$var$_alt = function(fa, that) {
    return (0, $72EOc.pipe)(fa, $86691c66edf4fb98$export$228be17d80722ab(that));
};
var $86691c66edf4fb98$var$_filter = function(fa, predicate) {
    return (0, $72EOc.pipe)(fa, $86691c66edf4fb98$export$3dea766d36a8935f(predicate));
};
/* istanbul ignore next */ var $86691c66edf4fb98$var$_filterMap = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $86691c66edf4fb98$export$a04c6c6965dd4709(f));
};
/* istanbul ignore next */ var $86691c66edf4fb98$var$_extend = function(wa, f) {
    return (0, $72EOc.pipe)(wa, $86691c66edf4fb98$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $86691c66edf4fb98$var$_partition = function(fa, predicate) {
    return (0, $72EOc.pipe)(fa, $86691c66edf4fb98$export$b29f828819edca8d(predicate));
};
/* istanbul ignore next */ var $86691c66edf4fb98$var$_partitionMap = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $86691c66edf4fb98$export$3117e3f9ececb6bc(f));
};
var $86691c66edf4fb98$export$9156e739aa33e19f = 'Option';
var $86691c66edf4fb98$export$3cb5cd7f7776c81 = function(S) {
    return {
        show: function(ma) {
            return $86691c66edf4fb98$export$e56af863d5645d5f(ma) ? 'none' : "some(".concat(S.show(ma.value), ")");
        }
    };
};
var $86691c66edf4fb98$export$804fed467fde44e4 = function(E) {
    return {
        equals: function(x, y) {
            return x === y || ($86691c66edf4fb98$export$e56af863d5645d5f(x) ? $86691c66edf4fb98$export$e56af863d5645d5f(y) : $86691c66edf4fb98$export$e56af863d5645d5f(y) ? false : E.equals(x.value, y.value));
        }
    };
};
var $86691c66edf4fb98$export$1af51209b1b91d07 = function(O) {
    return {
        equals: $86691c66edf4fb98$export$804fed467fde44e4(O).equals,
        compare: function(x, y) {
            return x === y ? 0 : $86691c66edf4fb98$export$5d7e502287836e58(x) ? $86691c66edf4fb98$export$5d7e502287836e58(y) ? O.compare(x.value, y.value) : 1 : -1;
        }
    };
};
var $86691c66edf4fb98$export$c2a7ef2cc9b32b31 = function(S) {
    return {
        concat: function(x, y) {
            return $86691c66edf4fb98$export$e56af863d5645d5f(x) ? y : $86691c66edf4fb98$export$e56af863d5645d5f(y) ? x : $86691c66edf4fb98$export$ad14ef4001db2bcd(S.concat(x.value, y.value));
        },
        empty: $86691c66edf4fb98$export$f883a24d5edde77c
    };
};
var $86691c66edf4fb98$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $86691c66edf4fb98$export$e56af863d5645d5f(fa) ? $86691c66edf4fb98$export$f883a24d5edde77c : $86691c66edf4fb98$export$ad14ef4001db2bcd(f(fa.value));
    };
};
var $86691c66edf4fb98$export$bd5b6bfc5fa2ee61 = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    map: $86691c66edf4fb98$var$_map
};
var $86691c66edf4fb98$export$6554612db691658e = (0, $72EOc.dual)(2, (0, $cpwuW.as)($86691c66edf4fb98$export$bd5b6bfc5fa2ee61));
var $86691c66edf4fb98$export$9284b360ca18a0fd = (0, $cpwuW.asUnit)($86691c66edf4fb98$export$bd5b6bfc5fa2ee61);
var $86691c66edf4fb98$export$ba255e9e49e00608 = $86691c66edf4fb98$export$ad14ef4001db2bcd;
var $86691c66edf4fb98$export$59a71046037e6c20 = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    of: $86691c66edf4fb98$export$ba255e9e49e00608
};
var $86691c66edf4fb98$export$2f6ca3d3b1f80bf5 = function(fa) {
    return function(fab) {
        return $86691c66edf4fb98$export$e56af863d5645d5f(fab) ? $86691c66edf4fb98$export$f883a24d5edde77c : $86691c66edf4fb98$export$e56af863d5645d5f(fa) ? $86691c66edf4fb98$export$f883a24d5edde77c : $86691c66edf4fb98$export$ad14ef4001db2bcd(fab.value(fa.value));
    };
};
var $86691c66edf4fb98$export$efc21ddc6aeb363d = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    map: $86691c66edf4fb98$var$_map,
    ap: $86691c66edf4fb98$var$_ap
};
var $86691c66edf4fb98$export$1279d2b7807629fd = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    map: $86691c66edf4fb98$var$_map,
    ap: $86691c66edf4fb98$var$_ap,
    of: $86691c66edf4fb98$export$ba255e9e49e00608
};
var $86691c66edf4fb98$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $72EOc.dual)(2, function(ma, f) {
    return $86691c66edf4fb98$export$e56af863d5645d5f(ma) ? $86691c66edf4fb98$export$f883a24d5edde77c : f(ma.value);
});
var $86691c66edf4fb98$export$f18d5acc27d70423 = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    map: $86691c66edf4fb98$var$_map,
    ap: $86691c66edf4fb98$var$_ap,
    chain: $86691c66edf4fb98$export$5b8affa63fc6df16
};
var $86691c66edf4fb98$export$fb641926d034ac7d = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    map: $86691c66edf4fb98$var$_map,
    ap: $86691c66edf4fb98$var$_ap,
    of: $86691c66edf4fb98$export$ba255e9e49e00608,
    chain: $86691c66edf4fb98$export$5b8affa63fc6df16
};
var $86691c66edf4fb98$export$533b26079ad0b4b = function(b, f) {
    return function(fa) {
        return $86691c66edf4fb98$export$e56af863d5645d5f(fa) ? b : f(b, fa.value);
    };
};
var $86691c66edf4fb98$export$b66cdc0497d8a99a = function(M) {
    return function(f) {
        return function(fa) {
            return $86691c66edf4fb98$export$e56af863d5645d5f(fa) ? M.empty : f(fa.value);
        };
    };
};
var $86691c66edf4fb98$export$7fef8bcdbb34f435 = function(b, f) {
    return function(fa) {
        return $86691c66edf4fb98$export$e56af863d5645d5f(fa) ? b : f(fa.value, b);
    };
};
var $86691c66edf4fb98$export$41404b31838667c9 = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    reduce: $86691c66edf4fb98$var$_reduce,
    foldMap: $86691c66edf4fb98$var$_foldMap,
    reduceRight: $86691c66edf4fb98$var$_reduceRight
};
var $86691c66edf4fb98$export$41d1a04d78e7b141 = (0, $72EOc.dual)(2, function(self, that) {
    return $86691c66edf4fb98$export$e56af863d5645d5f(self) ? that() : self;
});
var $86691c66edf4fb98$export$1517cca7889d6aaa = $86691c66edf4fb98$export$41d1a04d78e7b141;
var $86691c66edf4fb98$export$228be17d80722ab = $86691c66edf4fb98$export$41d1a04d78e7b141;
var $86691c66edf4fb98$export$25ba4469a069167 = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    map: $86691c66edf4fb98$var$_map,
    alt: $86691c66edf4fb98$var$_alt
};
var $86691c66edf4fb98$export$7f9972325ebfd559 = function() {
    return $86691c66edf4fb98$export$f883a24d5edde77c;
};
var $86691c66edf4fb98$export$aaef8a3eae948f03 = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    zero: $86691c66edf4fb98$export$7f9972325ebfd559
};
var $86691c66edf4fb98$export$864d727b48066337 = /*#__PURE__*/ (0, $3n81G.guard)($86691c66edf4fb98$export$aaef8a3eae948f03, $86691c66edf4fb98$export$59a71046037e6c20);
var $86691c66edf4fb98$export$4acb47accde578d2 = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    map: $86691c66edf4fb98$var$_map,
    ap: $86691c66edf4fb98$var$_ap,
    of: $86691c66edf4fb98$export$ba255e9e49e00608,
    alt: $86691c66edf4fb98$var$_alt,
    zero: $86691c66edf4fb98$export$7f9972325ebfd559
};
var $86691c66edf4fb98$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return $86691c66edf4fb98$export$e56af863d5645d5f(wa) ? $86691c66edf4fb98$export$f883a24d5edde77c : $86691c66edf4fb98$export$ad14ef4001db2bcd(f(wa));
    };
};
var $86691c66edf4fb98$export$5b5dd0e212d2a5bc = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    map: $86691c66edf4fb98$var$_map,
    extend: $86691c66edf4fb98$var$_extend
};
var $86691c66edf4fb98$export$8e16b83750b44988 = /*#__PURE__*/ $86691c66edf4fb98$export$5b8affa63fc6df16((0, $72EOc.identity));
var $86691c66edf4fb98$var$defaultSeparated = /*#__PURE__*/ (0, $1HSKK.separated)($86691c66edf4fb98$export$f883a24d5edde77c, $86691c66edf4fb98$export$f883a24d5edde77c);
var $86691c66edf4fb98$export$709f6946f4e97408 = function(ma) {
    return $86691c66edf4fb98$export$e56af863d5645d5f(ma) ? $86691c66edf4fb98$var$defaultSeparated : (0, $1HSKK.separated)($86691c66edf4fb98$export$da405662c16fca8e(ma.value), $86691c66edf4fb98$export$482f3615ecf01dc6(ma.value));
};
var $86691c66edf4fb98$export$4a21ac48141ac3c9 = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    compact: $86691c66edf4fb98$export$8e16b83750b44988,
    separate: $86691c66edf4fb98$export$709f6946f4e97408
};
var $86691c66edf4fb98$export$3dea766d36a8935f = function(predicate) {
    return function(fa) {
        return $86691c66edf4fb98$export$e56af863d5645d5f(fa) ? $86691c66edf4fb98$export$f883a24d5edde77c : predicate(fa.value) ? fa : $86691c66edf4fb98$export$f883a24d5edde77c;
    };
};
var $86691c66edf4fb98$export$a04c6c6965dd4709 = function(f) {
    return function(fa) {
        return $86691c66edf4fb98$export$e56af863d5645d5f(fa) ? $86691c66edf4fb98$export$f883a24d5edde77c : f(fa.value);
    };
};
var $86691c66edf4fb98$export$b29f828819edca8d = function(predicate) {
    return function(fa) {
        return (0, $1HSKK.separated)($86691c66edf4fb98$var$_filter(fa, (0, $9RniI.not)(predicate)), $86691c66edf4fb98$var$_filter(fa, predicate));
    };
};
var $86691c66edf4fb98$export$3117e3f9ececb6bc = function(f) {
    return (0, $72EOc.flow)($86691c66edf4fb98$export$871de8747c9eaa88(f), $86691c66edf4fb98$export$709f6946f4e97408);
};
var $86691c66edf4fb98$export$d00e1c48fb621173 = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    map: $86691c66edf4fb98$var$_map,
    compact: $86691c66edf4fb98$export$8e16b83750b44988,
    separate: $86691c66edf4fb98$export$709f6946f4e97408,
    filter: $86691c66edf4fb98$var$_filter,
    filterMap: $86691c66edf4fb98$var$_filterMap,
    partition: $86691c66edf4fb98$var$_partition,
    partitionMap: $86691c66edf4fb98$var$_partitionMap
};
var $86691c66edf4fb98$export$df3f009e3d155b20 = function(F) {
    return function(f) {
        return function(ta) {
            return $86691c66edf4fb98$export$e56af863d5645d5f(ta) ? F.of($86691c66edf4fb98$export$f883a24d5edde77c) : F.map(f(ta.value), $86691c66edf4fb98$export$ad14ef4001db2bcd);
        };
    };
};
var $86691c66edf4fb98$export$49bb65c2ea163039 = function(F) {
    return function(ta) {
        return $86691c66edf4fb98$export$e56af863d5645d5f(ta) ? F.of($86691c66edf4fb98$export$f883a24d5edde77c) : F.map(ta.value, $86691c66edf4fb98$export$ad14ef4001db2bcd);
    };
};
var $86691c66edf4fb98$export$a0202666c3bda011 = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    map: $86691c66edf4fb98$var$_map,
    reduce: $86691c66edf4fb98$var$_reduce,
    foldMap: $86691c66edf4fb98$var$_foldMap,
    reduceRight: $86691c66edf4fb98$var$_reduceRight,
    traverse: $86691c66edf4fb98$var$_traverse,
    sequence: $86691c66edf4fb98$export$49bb65c2ea163039
};
var $86691c66edf4fb98$var$_wither = /*#__PURE__*/ (0, $jNYdc.witherDefault)($86691c66edf4fb98$export$a0202666c3bda011, $86691c66edf4fb98$export$4a21ac48141ac3c9);
var $86691c66edf4fb98$var$_wilt = /*#__PURE__*/ (0, $jNYdc.wiltDefault)($86691c66edf4fb98$export$a0202666c3bda011, $86691c66edf4fb98$export$4a21ac48141ac3c9);
var $86691c66edf4fb98$export$6c36d01819ecdb31 = function(F) {
    var _witherF = $86691c66edf4fb98$var$_wither(F);
    return function(f) {
        return function(fa) {
            return _witherF(fa, f);
        };
    };
};
var $86691c66edf4fb98$export$2439a3bc02b13b03 = function(F) {
    var _wiltF = $86691c66edf4fb98$var$_wilt(F);
    return function(f) {
        return function(fa) {
            return _wiltF(fa, f);
        };
    };
};
var $86691c66edf4fb98$export$748d317b4c426f96 = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    map: $86691c66edf4fb98$var$_map,
    reduce: $86691c66edf4fb98$var$_reduce,
    foldMap: $86691c66edf4fb98$var$_foldMap,
    reduceRight: $86691c66edf4fb98$var$_reduceRight,
    traverse: $86691c66edf4fb98$var$_traverse,
    sequence: $86691c66edf4fb98$export$49bb65c2ea163039,
    compact: $86691c66edf4fb98$export$8e16b83750b44988,
    separate: $86691c66edf4fb98$export$709f6946f4e97408,
    filter: $86691c66edf4fb98$var$_filter,
    filterMap: $86691c66edf4fb98$var$_filterMap,
    partition: $86691c66edf4fb98$var$_partition,
    partitionMap: $86691c66edf4fb98$var$_partitionMap,
    wither: $86691c66edf4fb98$var$_wither,
    wilt: $86691c66edf4fb98$var$_wilt
};
var $86691c66edf4fb98$export$8bf7aba4a9e09055 = function() {
    return $86691c66edf4fb98$export$f883a24d5edde77c;
};
var $86691c66edf4fb98$export$5f956d47d0619c3a = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    map: $86691c66edf4fb98$var$_map,
    ap: $86691c66edf4fb98$var$_ap,
    of: $86691c66edf4fb98$export$ba255e9e49e00608,
    chain: $86691c66edf4fb98$export$5b8affa63fc6df16,
    throwError: $86691c66edf4fb98$export$8bf7aba4a9e09055
};
var $86691c66edf4fb98$export$80c878c9b1d77917 = $86691c66edf4fb98$export$482f3615ecf01dc6;
var $86691c66edf4fb98$export$825ea6cb6fc48d49 = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    fromEither: $86691c66edf4fb98$export$80c878c9b1d77917
};
var $86691c66edf4fb98$export$5d7e502287836e58 = $EfnK2.isSome;
var $86691c66edf4fb98$export$e56af863d5645d5f = function(fa) {
    return fa._tag === 'None';
};
var $86691c66edf4fb98$export$2d55ea551c238330 = function(onNone, onSome) {
    return function(ma) {
        return $86691c66edf4fb98$export$e56af863d5645d5f(ma) ? onNone() : onSome(ma.value);
    };
};
var $86691c66edf4fb98$export$ccb09033cefa61e8 = $86691c66edf4fb98$export$2d55ea551c238330;
var $86691c66edf4fb98$export$4659b591c19bdf3d = $86691c66edf4fb98$export$2d55ea551c238330;
var $86691c66edf4fb98$export$93e2b83da34ff82a = $86691c66edf4fb98$export$4659b591c19bdf3d;
var $86691c66edf4fb98$export$d8a997ff0e6436f3 = function(onNone) {
    return function(ma) {
        return $86691c66edf4fb98$export$e56af863d5645d5f(ma) ? onNone() : ma.value;
    };
};
var $86691c66edf4fb98$export$8832081647a02ee7 = $86691c66edf4fb98$export$d8a997ff0e6436f3;
var $86691c66edf4fb98$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $cpwuW.flap)($86691c66edf4fb98$export$bd5b6bfc5fa2ee61);
var $86691c66edf4fb98$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $aYN4d.apFirst)($86691c66edf4fb98$export$efc21ddc6aeb363d);
var $86691c66edf4fb98$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $aYN4d.apSecond)($86691c66edf4fb98$export$efc21ddc6aeb363d);
var $86691c66edf4fb98$export$bffa455ba8c619a6 = $86691c66edf4fb98$export$8e16b83750b44988;
var $86691c66edf4fb98$export$3f23594af5f37336 = /*#__PURE__*/ (0, $72EOc.dual)(2, $kgj0x.tap($86691c66edf4fb98$export$f18d5acc27d70423));
var $86691c66edf4fb98$export$be3ff275bb5a8ac9 = /*#__PURE__*/ (0, $72EOc.dual)(2, (0, $jFfj2.tapEither)($86691c66edf4fb98$export$825ea6cb6fc48d49, $86691c66edf4fb98$export$f18d5acc27d70423));
var $86691c66edf4fb98$export$ecd5e8ace626722c = /*#__PURE__*/ $86691c66edf4fb98$export$8b58be045bf06082((0, $72EOc.identity));
var $86691c66edf4fb98$export$8138b0ae92c9b5d8 = /*#__PURE__*/ (0, $jFfj2.fromEitherK)($86691c66edf4fb98$export$825ea6cb6fc48d49);
var $86691c66edf4fb98$export$a3eef2eba9908c3e = /*#__PURE__*/ (0, $jFfj2.chainEitherK)($86691c66edf4fb98$export$825ea6cb6fc48d49, $86691c66edf4fb98$export$f18d5acc27d70423);
var $86691c66edf4fb98$export$c5f2bdbf9b43f0c0 = $86691c66edf4fb98$export$be3ff275bb5a8ac9;
var $86691c66edf4fb98$export$b601f49376b4621a = function(a) {
    return a == null ? $86691c66edf4fb98$export$f883a24d5edde77c : $86691c66edf4fb98$export$ad14ef4001db2bcd(a);
};
var $86691c66edf4fb98$export$d234c058d1d4e435 = function(f) {
    try {
        return $86691c66edf4fb98$export$ad14ef4001db2bcd(f());
    } catch (e) {
        return $86691c66edf4fb98$export$f883a24d5edde77c;
    }
};
var $86691c66edf4fb98$export$7f3d23c4b0794e72 = function(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $86691c66edf4fb98$export$d234c058d1d4e435(function() {
            return f.apply(void 0, a);
        });
    };
};
var $86691c66edf4fb98$export$c69ca7b73fad45e1 = function(f) {
    return (0, $72EOc.flow)(f, $86691c66edf4fb98$export$b601f49376b4621a);
};
var $86691c66edf4fb98$export$c81f992c08fd0bf3 = function(f) {
    return function(ma) {
        return $86691c66edf4fb98$export$e56af863d5645d5f(ma) ? $86691c66edf4fb98$export$f883a24d5edde77c : $86691c66edf4fb98$export$b601f49376b4621a(f(ma.value));
    };
};
var $86691c66edf4fb98$export$b187f57ee1822bc5 = /*#__PURE__*/ $86691c66edf4fb98$export$4659b591c19bdf3d((0, $72EOc.constNull), (0, $72EOc.identity));
var $86691c66edf4fb98$export$cb585b8513fa8577 = /*#__PURE__*/ $86691c66edf4fb98$export$4659b591c19bdf3d((0, $72EOc.constUndefined), (0, $72EOc.identity));
function $86691c66edf4fb98$export$5bf96401662340b7(E) {
    return function(a, ma) {
        if (ma === undefined) {
            var elemE_1 = $86691c66edf4fb98$export$5bf96401662340b7(E);
            return function(ma) {
                return elemE_1(a, ma);
            };
        }
        return $86691c66edf4fb98$export$e56af863d5645d5f(ma) ? false : E.equals(a, ma.value);
    };
}
var $86691c66edf4fb98$export$f7e9f41ea797a17 = function(predicate) {
    return function(ma) {
        return $86691c66edf4fb98$export$e56af863d5645d5f(ma) ? false : predicate(ma.value);
    };
};
var $86691c66edf4fb98$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $86691c66edf4fb98$export$ba255e9e49e00608($EfnK2.emptyRecord);
var $86691c66edf4fb98$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $cpwuW.bindTo)($86691c66edf4fb98$export$bd5b6bfc5fa2ee61);
var $86691c66edf4fb98$export$5d537b797c421217 = /*#__PURE__*/ (0, $cpwuW.let)($86691c66edf4fb98$export$bd5b6bfc5fa2ee61);
var $86691c66edf4fb98$export$2385a24977818dd0 = /*#__PURE__*/ $kgj0x.bind($86691c66edf4fb98$export$f18d5acc27d70423);
var $86691c66edf4fb98$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $aYN4d.apS)($86691c66edf4fb98$export$efc21ddc6aeb363d);
var $86691c66edf4fb98$export$c74b6e34b2b6efb0 = /*#__PURE__*/ $86691c66edf4fb98$export$ba255e9e49e00608($EfnK2.emptyReadonlyArray);
var $86691c66edf4fb98$export$817de7d5ba7e6fab = function(f) {
    return function(as) {
        var o = f(0, $EfnK2.head(as));
        if ($86691c66edf4fb98$export$e56af863d5645d5f(o)) return $86691c66edf4fb98$export$f883a24d5edde77c;
        var out = [
            o.value
        ];
        for(var i = 1; i < as.length; i++){
            var o_1 = f(i, as[i]);
            if ($86691c66edf4fb98$export$e56af863d5645d5f(o_1)) return $86691c66edf4fb98$export$f883a24d5edde77c;
            out.push(o_1.value);
        }
        return $86691c66edf4fb98$export$ad14ef4001db2bcd(out);
    };
};
var $86691c66edf4fb98$export$d4e79db5dc14cc1 = function(f) {
    var g = $86691c66edf4fb98$export$817de7d5ba7e6fab(f);
    return function(as) {
        return $EfnK2.isNonEmpty(as) ? g(as) : $86691c66edf4fb98$export$c74b6e34b2b6efb0;
    };
};
var $86691c66edf4fb98$export$104a2841e9cbad06 = $86691c66edf4fb98$export$d4e79db5dc14cc1;
var $86691c66edf4fb98$export$64f39b2a2b79e1b1 = function(f) {
    return $86691c66edf4fb98$export$d4e79db5dc14cc1(function(_, a) {
        return f(a);
    });
};
var $86691c66edf4fb98$export$d330b60315c14cd1 = /*#__PURE__*/ $86691c66edf4fb98$export$64f39b2a2b79e1b1((0, $72EOc.identity));
var $86691c66edf4fb98$export$e08e3b67e392101e = $86691c66edf4fb98$export$5b8affa63fc6df16;
var $86691c66edf4fb98$export$e3821ef4970c339c = $86691c66edf4fb98$export$3f23594af5f37336;
function $86691c66edf4fb98$export$4a60bf88193d4686(getOption) {
    return function(a) {
        return $86691c66edf4fb98$export$5d7e502287836e58(getOption(a));
    };
}
var $86691c66edf4fb98$export$c2a8dfc107523e74 = $86691c66edf4fb98$export$c81f992c08fd0bf3;
var $86691c66edf4fb98$export$a75d1723e6bda2ec = {
    URI: $86691c66edf4fb98$export$9156e739aa33e19f,
    map: $86691c66edf4fb98$var$_map,
    of: $86691c66edf4fb98$export$ba255e9e49e00608,
    ap: $86691c66edf4fb98$var$_ap,
    chain: $86691c66edf4fb98$export$5b8affa63fc6df16,
    reduce: $86691c66edf4fb98$var$_reduce,
    foldMap: $86691c66edf4fb98$var$_foldMap,
    reduceRight: $86691c66edf4fb98$var$_reduceRight,
    traverse: $86691c66edf4fb98$var$_traverse,
    sequence: $86691c66edf4fb98$export$49bb65c2ea163039,
    zero: $86691c66edf4fb98$export$7f9972325ebfd559,
    alt: $86691c66edf4fb98$var$_alt,
    extend: $86691c66edf4fb98$var$_extend,
    compact: $86691c66edf4fb98$export$8e16b83750b44988,
    separate: $86691c66edf4fb98$export$709f6946f4e97408,
    filter: $86691c66edf4fb98$var$_filter,
    filterMap: $86691c66edf4fb98$var$_filterMap,
    partition: $86691c66edf4fb98$var$_partition,
    partitionMap: $86691c66edf4fb98$var$_partitionMap,
    wither: $86691c66edf4fb98$var$_wither,
    wilt: $86691c66edf4fb98$var$_wilt,
    throwError: $86691c66edf4fb98$export$8bf7aba4a9e09055
};
var $86691c66edf4fb98$export$18979a515d2a828e = /*#__PURE__*/ (0, $aYN4d.getApplySemigroup)($86691c66edf4fb98$export$efc21ddc6aeb363d);
var $86691c66edf4fb98$export$1b097547f7ec9bb3 = /*#__PURE__*/ (0, $9xys1.getApplicativeMonoid)($86691c66edf4fb98$export$1279d2b7807629fd);
var $86691c66edf4fb98$export$56cd0d85e73e688f = function() {
    return $86691c66edf4fb98$export$c2a7ef2cc9b32b31((0, $58DQ5.first)());
};
var $86691c66edf4fb98$export$ca391a563a1f3001 = function() {
    return $86691c66edf4fb98$export$c2a7ef2cc9b32b31((0, $58DQ5.last)());
};

});
parcelRegister("9xys1", function(module, exports) {

$parcel$export(module.exports, "getApplicativeMonoid", () => $6f21eb604bad4e3c$export$c8e1a8ea383fd0ff);
/**
 * The `Applicative` type class extends the `Apply` type class with a `of` function, which can be used to create values
 * of type `f a` from values of type `a`.
 *
 * Where `Apply` provides the ability to lift functions of two or more arguments to functions whose arguments are
 * wrapped using `f`, and `Functor` provides the ability to lift functions of one argument, `pure` can be seen as the
 * function which lifts functions of _zero_ arguments. That is, `Applicative` functors support a lifting operation for
 * any number of function arguments.
 *
 * Instances must satisfy the following laws in addition to the `Apply` laws:
 *
 * 1. Identity: `A.ap(A.of(a => a), fa) <-> fa`
 * 2. Homomorphism: `A.ap(A.of(ab), A.of(a)) <-> A.of(ab(a))`
 * 3. Interchange: `A.ap(fab, A.of(a)) <-> A.ap(A.of(ab => ab(a)), fab)`
 *
 * Note. `Functor`'s `map` can be derived: `A.map(x, f) = A.ap(A.of(f), x)`
 *
 * @since 2.0.0
 */ 
var $aYN4d = parcelRequire("aYN4d");

var $72EOc = parcelRequire("72EOc");

var $cpwuW = parcelRequire("cpwuW");
function $6f21eb604bad4e3c$export$c8e1a8ea383fd0ff(F) {
    var f = (0, $aYN4d.getApplySemigroup)(F);
    return function(M) {
        return {
            concat: f(M).concat,
            empty: F.of(M.empty)
        };
    };
}
function $6f21eb604bad4e3c$export$9833a940afed18f3(F, G) {
    var map = (0, $cpwuW.getFunctorComposition)(F, G).map;
    var _ap = (0, $aYN4d.ap)(F, G);
    return {
        map: map,
        of: function(a) {
            return F.of(G.of(a));
        },
        ap: function(fgab, fga) {
            return (0, $72EOc.pipe)(fgab, _ap(fga));
        }
    };
}

});

parcelRegister("9RniI", function(module, exports) {

$parcel$export(module.exports, "not", () => $72db235846b6a73e$export$6003a5f097c73977);

var $72EOc = parcelRequire("72EOc");
var $72db235846b6a73e$var$contramap_ = function(predicate, f) {
    return (0, $72EOc.pipe)(predicate, $72db235846b6a73e$export$53b696d27ecb7ba7(f));
};
var $72db235846b6a73e$export$53b696d27ecb7ba7 = function(f) {
    return function(predicate) {
        return (0, $72EOc.flow)(f, predicate);
    };
};
var $72db235846b6a73e$export$9156e739aa33e19f = 'Predicate';
var $72db235846b6a73e$export$45c71cec3a7e90aa = function() {
    return {
        concat: function(first, second) {
            return (0, $72EOc.pipe)(first, $72db235846b6a73e$export$252bb8b3bbdf6749(second));
        }
    };
};
var $72db235846b6a73e$export$d795ff673668f564 = function() {
    return {
        concat: $72db235846b6a73e$export$45c71cec3a7e90aa().concat,
        empty: (0, $72EOc.constFalse)
    };
};
var $72db235846b6a73e$export$d900a29579818780 = function() {
    return {
        concat: function(first, second) {
            return (0, $72EOc.pipe)(first, $72db235846b6a73e$export$21c0ac7fe1cef1b8(second));
        }
    };
};
var $72db235846b6a73e$export$4c43b04d78b174fa = function() {
    return {
        concat: $72db235846b6a73e$export$d900a29579818780().concat,
        empty: (0, $72EOc.constTrue)
    };
};
var $72db235846b6a73e$export$def901a57d5539c3 = {
    URI: $72db235846b6a73e$export$9156e739aa33e19f,
    contramap: $72db235846b6a73e$var$contramap_
};
var $72db235846b6a73e$export$6003a5f097c73977 = function(predicate) {
    return function(a) {
        return !predicate(a);
    };
};
var $72db235846b6a73e$export$252bb8b3bbdf6749 = function(second) {
    return function(first) {
        return function(a) {
            return first(a) || second(a);
        };
    };
};
var $72db235846b6a73e$export$21c0ac7fe1cef1b8 = function(second) {
    return function(first) {
        return function(a) {
            return first(a) && second(a);
        };
    };
};

});


parcelRegister("30crt", function(module, exports) {

$parcel$export(module.exports, "pipe", () => $22fb05f0a3736777$export$a4627e546088548d);

var $aYN4d = parcelRequire("aYN4d");

var $kgj0x = parcelRequire("kgj0x");

var $72EOc = parcelRequire("72EOc");
function $22fb05f0a3736777$export$871de8747c9eaa88(F) {
    return function(f) {
        return function(fa) {
            return F.map(fa, f);
        };
    };
}
function $22fb05f0a3736777$export$53b696d27ecb7ba7(F) {
    return function(f) {
        return function(fa) {
            return F.contramap(fa, f);
        };
    };
}
function $22fb05f0a3736777$export$8f07ddce13659f50(F) {
    return function(f) {
        return function(fa) {
            return F.mapWithIndex(fa, f);
        };
    };
}
function $22fb05f0a3736777$export$2f6ca3d3b1f80bf5(F) {
    return function(fa) {
        return function(fab) {
            return F.ap(fab, fa);
        };
    };
}
function $22fb05f0a3736777$export$e08e3b67e392101e(F) {
    return function(f) {
        return function(fa) {
            return F.chain(fa, f);
        };
    };
}
function $22fb05f0a3736777$export$eb54baf0b342cb1d(F) {
    return function(f, g) {
        return function(fea) {
            return F.bimap(fea, f, g);
        };
    };
}
function $22fb05f0a3736777$export$472de43a55e4aa49(F) {
    return function(f) {
        return function(fea) {
            return F.mapLeft(fea, f);
        };
    };
}
function $22fb05f0a3736777$export$8b58be045bf06082(F) {
    return function(f) {
        return function(wa) {
            return F.extend(wa, f);
        };
    };
}
function $22fb05f0a3736777$export$533b26079ad0b4b(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduce(fa, b, f);
        };
    };
}
function $22fb05f0a3736777$export$b66cdc0497d8a99a(F) {
    return function(M) {
        var foldMapM = F.foldMap(M);
        return function(f) {
            return function(fa) {
                return foldMapM(fa, f);
            };
        };
    };
}
function $22fb05f0a3736777$export$7fef8bcdbb34f435(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduceRight(fa, b, f);
        };
    };
}
function $22fb05f0a3736777$export$bbd3ef8720e22369(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduceWithIndex(fa, b, f);
        };
    };
}
function $22fb05f0a3736777$export$18153bb1181268e5(F) {
    return function(M) {
        var foldMapWithIndexM = F.foldMapWithIndex(M);
        return function(f) {
            return function(fa) {
                return foldMapWithIndexM(fa, f);
            };
        };
    };
}
function $22fb05f0a3736777$export$ce2b2fe0b88ccd0a(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduceRightWithIndex(fa, b, f);
        };
    };
}
function $22fb05f0a3736777$export$228be17d80722ab(F) {
    return function(that) {
        return function(fa) {
            return F.alt(fa, that);
        };
    };
}
function $22fb05f0a3736777$export$3dea766d36a8935f(F) {
    return function(predicate) {
        return function(fa) {
            return F.filter(fa, predicate);
        };
    };
}
function $22fb05f0a3736777$export$a04c6c6965dd4709(F) {
    return function(f) {
        return function(fa) {
            return F.filterMap(fa, f);
        };
    };
}
function $22fb05f0a3736777$export$b29f828819edca8d(F) {
    return function(f) {
        return function(fa) {
            return F.partition(fa, f);
        };
    };
}
function $22fb05f0a3736777$export$3117e3f9ececb6bc(F) {
    return function(f) {
        return function(fa) {
            return F.partitionMap(fa, f);
        };
    };
}
function $22fb05f0a3736777$export$36e42aef19fc7171(F) {
    return function(predicate) {
        return function(fa) {
            return F.filterWithIndex(fa, predicate);
        };
    };
}
function $22fb05f0a3736777$export$30c5cbe848021e97(F) {
    return function(f) {
        return function(fa) {
            return F.filterMapWithIndex(fa, f);
        };
    };
}
function $22fb05f0a3736777$export$dad5e500f2bab9bc(F) {
    return function(f) {
        return function(fa) {
            return F.partitionWithIndex(fa, f);
        };
    };
}
function $22fb05f0a3736777$export$bc7c0794b9c6f3ba(F) {
    return function(f) {
        return function(fa) {
            return F.partitionMapWithIndex(fa, f);
        };
    };
}
function $22fb05f0a3736777$export$6684e88861ab74ec(F) {
    return function(f, g) {
        return function(fbc) {
            return F.promap(fbc, f, g);
        };
    };
}
function $22fb05f0a3736777$export$f672e0b6f7222cd7(F) {
    return function(ea) {
        return function(ab) {
            return F.compose(ab, ea);
        };
    };
}
var $22fb05f0a3736777$var$isFunctor = function(I) {
    return typeof I.map === 'function';
};
var $22fb05f0a3736777$var$isContravariant = function(I) {
    return typeof I.contramap === 'function';
};
var $22fb05f0a3736777$var$isFunctorWithIndex = function(I) {
    return typeof I.mapWithIndex === 'function';
};
var $22fb05f0a3736777$var$isApply = function(I) {
    return typeof I.ap === 'function';
};
var $22fb05f0a3736777$var$isChain = function(I) {
    return typeof I.chain === 'function';
};
var $22fb05f0a3736777$var$isBifunctor = function(I) {
    return typeof I.bimap === 'function';
};
var $22fb05f0a3736777$var$isExtend = function(I) {
    return typeof I.extend === 'function';
};
var $22fb05f0a3736777$var$isFoldable = function(I) {
    return typeof I.reduce === 'function';
};
var $22fb05f0a3736777$var$isFoldableWithIndex = function(I) {
    return typeof I.reduceWithIndex === 'function';
};
var $22fb05f0a3736777$var$isAlt = function(I) {
    return typeof I.alt === 'function';
};
var $22fb05f0a3736777$var$isCompactable = function(I) {
    return typeof I.compact === 'function';
};
var $22fb05f0a3736777$var$isFilterable = function(I) {
    return typeof I.filter === 'function';
};
var $22fb05f0a3736777$var$isFilterableWithIndex = function(I) {
    return typeof I.filterWithIndex === 'function';
};
var $22fb05f0a3736777$var$isProfunctor = function(I) {
    return typeof I.promap === 'function';
};
var $22fb05f0a3736777$var$isSemigroupoid = function(I) {
    return typeof I.compose === 'function';
};
var $22fb05f0a3736777$var$isMonadThrow = function(I) {
    return typeof I.throwError === 'function';
};
function $22fb05f0a3736777$export$1124ffa357d27237(I) {
    var r = {};
    if ($22fb05f0a3736777$var$isFunctor(I)) r.map = $22fb05f0a3736777$export$871de8747c9eaa88(I);
    if ($22fb05f0a3736777$var$isContravariant(I)) r.contramap = $22fb05f0a3736777$export$53b696d27ecb7ba7(I);
    if ($22fb05f0a3736777$var$isFunctorWithIndex(I)) r.mapWithIndex = $22fb05f0a3736777$export$8f07ddce13659f50(I);
    if ($22fb05f0a3736777$var$isApply(I)) {
        r.ap = $22fb05f0a3736777$export$2f6ca3d3b1f80bf5(I);
        r.apFirst = (0, $aYN4d.apFirst)(I);
        r.apSecond = (0, $aYN4d.apSecond)(I);
    }
    if ($22fb05f0a3736777$var$isChain(I)) {
        r.chain = $22fb05f0a3736777$export$e08e3b67e392101e(I);
        r.chainFirst = (0, $kgj0x.chainFirst)(I);
        r.flatten = r.chain((0, $72EOc.identity));
    }
    if ($22fb05f0a3736777$var$isBifunctor(I)) {
        r.bimap = $22fb05f0a3736777$export$eb54baf0b342cb1d(I);
        r.mapLeft = $22fb05f0a3736777$export$472de43a55e4aa49(I);
    }
    if ($22fb05f0a3736777$var$isExtend(I)) {
        r.extend = $22fb05f0a3736777$export$8b58be045bf06082(I);
        r.duplicate = r.extend((0, $72EOc.identity));
    }
    if ($22fb05f0a3736777$var$isFoldable(I)) {
        r.reduce = $22fb05f0a3736777$export$533b26079ad0b4b(I);
        r.foldMap = $22fb05f0a3736777$export$b66cdc0497d8a99a(I);
        r.reduceRight = $22fb05f0a3736777$export$7fef8bcdbb34f435(I);
    }
    if ($22fb05f0a3736777$var$isFoldableWithIndex(I)) {
        r.reduceWithIndex = $22fb05f0a3736777$export$bbd3ef8720e22369(I);
        r.foldMapWithIndex = $22fb05f0a3736777$export$18153bb1181268e5(I);
        r.reduceRightWithIndex = $22fb05f0a3736777$export$ce2b2fe0b88ccd0a(I);
    }
    if ($22fb05f0a3736777$var$isAlt(I)) r.alt = $22fb05f0a3736777$export$228be17d80722ab(I);
    if ($22fb05f0a3736777$var$isCompactable(I)) {
        r.compact = I.compact;
        r.separate = I.separate;
    }
    if ($22fb05f0a3736777$var$isFilterable(I)) {
        r.filter = $22fb05f0a3736777$export$3dea766d36a8935f(I);
        r.filterMap = $22fb05f0a3736777$export$a04c6c6965dd4709(I);
        r.partition = $22fb05f0a3736777$export$b29f828819edca8d(I);
        r.partitionMap = $22fb05f0a3736777$export$3117e3f9ececb6bc(I);
    }
    if ($22fb05f0a3736777$var$isFilterableWithIndex(I)) {
        r.filterWithIndex = $22fb05f0a3736777$export$36e42aef19fc7171(I);
        r.filterMapWithIndex = $22fb05f0a3736777$export$30c5cbe848021e97(I);
        r.partitionWithIndex = $22fb05f0a3736777$export$dad5e500f2bab9bc(I);
        r.partitionMapWithIndex = $22fb05f0a3736777$export$bc7c0794b9c6f3ba(I);
    }
    if ($22fb05f0a3736777$var$isProfunctor(I)) r.promap = $22fb05f0a3736777$export$6684e88861ab74ec(I);
    if ($22fb05f0a3736777$var$isSemigroupoid(I)) r.compose = $22fb05f0a3736777$export$f672e0b6f7222cd7(I);
    if ($22fb05f0a3736777$var$isMonadThrow(I)) {
        var fromOption = function(onNone) {
            return function(ma) {
                return ma._tag === 'None' ? I.throwError(onNone()) : I.of(ma.value);
            };
        };
        var fromEither = function(ma) {
            return ma._tag === 'Left' ? I.throwError(ma.left) : I.of(ma.right);
        };
        var fromPredicate = function(predicate, onFalse) {
            return function(a) {
                return predicate(a) ? I.of(a) : I.throwError(onFalse(a));
            };
        };
        var filterOrElse = function(predicate, onFalse) {
            return function(ma) {
                return I.chain(ma, function(a) {
                    return predicate(a) ? I.of(a) : I.throwError(onFalse(a));
                });
            };
        };
        r.fromOption = fromOption;
        r.fromEither = fromEither;
        r.fromPredicate = fromPredicate;
        r.filterOrElse = filterOrElse;
    }
    return r;
}
var $22fb05f0a3736777$export$a4627e546088548d = (0, $72EOc.pipe);

});

parcelRegister("4O2fb", function(module, exports) {

$parcel$export(module.exports, "fromIso", () => $37fd928b21aaf2a5$export$3160d47a1ad63980);

var $bxsNd = parcelRequire("bxsNd");

var $30crt = parcelRequire("30crt");

var $4qiTD = parcelRequire("4qiTD");

var $kxnus = parcelRequire("kxnus");

var $lV5N9 = parcelRequire("lV5N9");
var $37fd928b21aaf2a5$export$493d36ec626b6698 = $lV5N9.at;
var $37fd928b21aaf2a5$export$3160d47a1ad63980 = function(iso) {
    return function(sia) {
        return $37fd928b21aaf2a5$export$493d36ec626b6698(function(i) {
            return (0, $30crt.pipe)(iso, $lV5N9.isoAsLens, $lV5N9.lensComposeLens(sia.at(i)));
        });
    };
};
var $37fd928b21aaf2a5$export$ba8573d258bae607 = $lV5N9.atReadonlyRecord;
var $37fd928b21aaf2a5$export$3d6583cb45ca961e = function(E) {
    var lookupE = $4qiTD.lookup(E);
    var deleteAtE = $4qiTD.deleteAt(E);
    var insertAtE = $4qiTD.insertAt(E);
    return function() {
        return $37fd928b21aaf2a5$export$493d36ec626b6698(function(key) {
            return $lV5N9.lens(function(s) {
                return lookupE(key, s);
            }, $bxsNd.fold(function() {
                return deleteAtE(key);
            }, function(a) {
                return insertAtE(key, a);
            }));
        });
    };
};
var $37fd928b21aaf2a5$export$388a7d8e51ea972f = function(E) {
    var elemE = $kxnus.elem(E);
    var insertE = $kxnus.insert(E);
    var removeE = $kxnus.remove(E);
    return $37fd928b21aaf2a5$export$493d36ec626b6698(function(a) {
        var insert = insertE(a);
        var remove = removeE(a);
        return $lV5N9.lens(function(s) {
            return elemE(a, s);
        }, function(b) {
            return function(s) {
                return b ? insert(s) : remove(s);
            };
        });
    });
};
var $37fd928b21aaf2a5$export$1cfc761eca4929a9 = $lV5N9.atReadonlyRecord;

});
parcelRegister("4qiTD", function(module, exports) {

$parcel$export(module.exports, "lookup", () => $33883f933227ea54$export$dfc7155ac0343b8);
$parcel$export(module.exports, "deleteAt", () => $33883f933227ea54$export$90f9093465da3136);
$parcel$export(module.exports, "insertAt", () => $33883f933227ea54$export$9f200c4466975173);

var $3Md1m = parcelRequire("3Md1m");

var $72EOc = parcelRequire("72EOc");

var $cpwuW = parcelRequire("cpwuW");

var $EfnK2 = parcelRequire("EfnK2");

var $bxsNd = parcelRequire("bxsNd");

var $1HSKK = parcelRequire("1HSKK");

var $jNYdc = parcelRequire("jNYdc");
var $33883f933227ea54$export$d81aa96f14f987cc = function(m) {
    return new Map(m);
};
function $33883f933227ea54$export$e98af36a72b77685(m) {
    return new Map(m);
}
function $33883f933227ea54$export$3cb5cd7f7776c81(SK, SA) {
    return {
        show: function(m) {
            var entries = [];
            m.forEach(function(a, k) {
                entries.push("[".concat(SK.show(k), ", ").concat(SA.show(a), "]"));
            });
            return "new Map([".concat(entries.sort().join(', '), "])");
        }
    };
}
var $33883f933227ea54$export$346677f925de839c = function(m) {
    return m.size;
};
var $33883f933227ea54$export$dd1bc94b04021eeb = function(m) {
    return m.size === 0;
};
function $33883f933227ea54$export$6a0d13241802fe80(E) {
    var lookupE = $33883f933227ea54$export$dfc7155ac0343b8(E);
    return function(k, m) {
        if (m === undefined) {
            var memberE_1 = $33883f933227ea54$export$6a0d13241802fe80(E);
            return function(m) {
                return memberE_1(k, m);
            };
        }
        return $EfnK2.isSome(lookupE(k, m));
    };
}
function $33883f933227ea54$export$5bf96401662340b7(E) {
    return function(a, m) {
        if (m === undefined) {
            var elemE_1 = $33883f933227ea54$export$5bf96401662340b7(E);
            return function(m) {
                return elemE_1(a, m);
            };
        }
        var values = m.values();
        var e;
        while(!(e = values.next()).done){
            var v = e.value;
            if (E.equals(a, v)) return true;
        }
        return false;
    };
}
var $33883f933227ea54$export$ed97f33186d4b816 = function(O) {
    return function(m) {
        return Array.from(m.keys()).sort(O.compare);
    };
};
var $33883f933227ea54$export$68c286be0e7e55b7 = function(O) {
    return function(m) {
        return Array.from(m.values()).sort(O.compare);
    };
};
function $33883f933227ea54$export$bb44f104e3c54dae(O) {
    var keysO = $33883f933227ea54$export$ed97f33186d4b816(O);
    return function(f) {
        return function(m) {
            var out = [];
            var ks = keysO(m);
            for(var _i = 0, ks_1 = ks; _i < ks_1.length; _i++){
                var key = ks_1[_i];
                out.push(f(key, m.get(key)));
            }
            return out;
        };
    };
}
var $33883f933227ea54$export$4aaa3912a3956cb7 = function(O) {
    return $33883f933227ea54$export$bb44f104e3c54dae(O)(function(k, a) {
        return [
            k,
            a
        ];
    });
};
function $33883f933227ea54$export$823be24f8766da23(ord, U) {
    var toReadonlyArrayO = $33883f933227ea54$export$4aaa3912a3956cb7(ord);
    return function(d) {
        var kas = toReadonlyArrayO(d);
        var len = kas.length;
        return U.unfold(0, function(b) {
            return b < len ? $EfnK2.some([
                kas[b],
                b + 1
            ]) : $EfnK2.none;
        });
    };
}
var $33883f933227ea54$export$ff82449ce381c54a = function(E) {
    var lookupWithKeyE = $33883f933227ea54$export$40b8019a6fc8a5ae(E);
    return function(k, a) {
        var lookupWithKeyEk = lookupWithKeyE(k);
        return function(m) {
            var found = lookupWithKeyEk(m);
            if ($EfnK2.isNone(found)) {
                var out = new Map(m);
                out.set(k, a);
                return out;
            } else if (found.value[1] !== a) {
                var out = new Map(m);
                out.set(found.value[0], a);
                return out;
            }
            return m;
        };
    };
};
var $33883f933227ea54$export$90f9093465da3136 = function(E) {
    var lookupWithKeyE = $33883f933227ea54$export$40b8019a6fc8a5ae(E);
    return function(k) {
        return function(m) {
            var found = lookupWithKeyE(k, m);
            if ($EfnK2.isSome(found)) {
                var r = new Map(m);
                r.delete(found.value[0]);
                return r;
            }
            return m;
        };
    };
};
var $33883f933227ea54$export$b6d8713d53419d4c = function(E) {
    var modifyAtE = $33883f933227ea54$export$cba09f9e3d3e58eb(E);
    return function(k, a) {
        return modifyAtE(k, function() {
            return a;
        });
    };
};
var $33883f933227ea54$export$cba09f9e3d3e58eb = function(E) {
    var lookupWithKeyE = $33883f933227ea54$export$40b8019a6fc8a5ae(E);
    return function(k, f) {
        return function(m) {
            var found = lookupWithKeyE(k, m);
            if ($EfnK2.isNone(found)) return $EfnK2.none;
            var _a = found.value, fk = _a[0], fv = _a[1];
            var next = f(fv);
            if (next === fv) return $EfnK2.some(m);
            var r = new Map(m);
            r.set(fk, next);
            return $EfnK2.some(r);
        };
    };
};
function $33883f933227ea54$export$3e41007ebfff0e64(E) {
    var lookupE = $33883f933227ea54$export$dfc7155ac0343b8(E);
    var deleteAtE = $33883f933227ea54$export$90f9093465da3136(E);
    return function(k) {
        var deleteAtEk = deleteAtE(k);
        return function(m) {
            return (0, $72EOc.pipe)(lookupE(k, m), $bxsNd.map(function(a) {
                return [
                    a,
                    deleteAtEk(m)
                ];
            }));
        };
    };
}
function $33883f933227ea54$export$40b8019a6fc8a5ae(E) {
    return function(k, m) {
        if (m === undefined) {
            var lookupWithKeyE_1 = $33883f933227ea54$export$40b8019a6fc8a5ae(E);
            return function(m) {
                return lookupWithKeyE_1(k, m);
            };
        }
        var entries = m.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, ka = _a[0], a = _a[1];
            if (E.equals(ka, k)) return $EfnK2.some([
                ka,
                a
            ]);
        }
        return $EfnK2.none;
    };
}
function $33883f933227ea54$export$dfc7155ac0343b8(E) {
    var lookupWithKeyE = $33883f933227ea54$export$40b8019a6fc8a5ae(E);
    return function(k, m) {
        if (m === undefined) {
            var lookupE_1 = $33883f933227ea54$export$dfc7155ac0343b8(E);
            return function(m) {
                return lookupE_1(k, m);
            };
        }
        return (0, $72EOc.pipe)(lookupWithKeyE(k, m), $bxsNd.map(function(_a) {
            var _ = _a[0], a = _a[1];
            return a;
        }));
    };
}
function $33883f933227ea54$export$35d0420a84c5d3ae(SK, SA) {
    var lookupWithKeyS = $33883f933227ea54$export$40b8019a6fc8a5ae(SK);
    return function(me, that) {
        if (that === undefined) {
            var isSubmapSKSA_1 = $33883f933227ea54$export$35d0420a84c5d3ae(SK, SA);
            return function(that) {
                return isSubmapSKSA_1(that, me);
            };
        }
        var entries = me.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            var d2OptA = lookupWithKeyS(k, that);
            if ($EfnK2.isNone(d2OptA) || !SK.equals(k, d2OptA.value[0]) || !SA.equals(a, d2OptA.value[1])) return false;
        }
        return true;
    };
}
var $33883f933227ea54$export$6e22c362a0406a2c = // the type annotation here is intended (otherwise it doesn't type-check)
new Map();
function $33883f933227ea54$export$804fed467fde44e4(SK, SA) {
    var isSubmapSKSA = $33883f933227ea54$export$35d0420a84c5d3ae(SK, SA);
    return (0, $3Md1m.fromEquals)(function(x, y) {
        return isSubmapSKSA(x, y) && isSubmapSKSA(y, x);
    });
}
function $33883f933227ea54$export$c2a7ef2cc9b32b31(SK, SA) {
    var lookupWithKeyS = $33883f933227ea54$export$40b8019a6fc8a5ae(SK);
    return {
        concat: function(mx, my) {
            if ($33883f933227ea54$export$dd1bc94b04021eeb(mx)) return my;
            if ($33883f933227ea54$export$dd1bc94b04021eeb(my)) return mx;
            var r = new Map(mx);
            var entries = my.entries();
            var e;
            while(!(e = entries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                var mxOptA = lookupWithKeyS(k, mx);
                if ($EfnK2.isSome(mxOptA)) r.set(mxOptA.value[0], SA.concat(mxOptA.value[1], a));
                else r.set(k, a);
            }
            return r;
        },
        empty: $33883f933227ea54$export$6e22c362a0406a2c
    };
}
var $33883f933227ea54$export$439306a4dcaafbb9 = function(k, a) {
    return new Map([
        [
            k,
            a
        ]
    ]);
};
function $33883f933227ea54$export$b7d5d9bb9ff52072(E, M, F) {
    return function(fka) {
        var lookupWithKeyE = $33883f933227ea54$export$40b8019a6fc8a5ae(E);
        return F.reduce(fka, new Map(), function(b, _a) {
            var k = _a[0], a = _a[1];
            var bOpt = lookupWithKeyE(k, b);
            if ($EfnK2.isSome(bOpt)) b.set(bOpt.value[0], M.concat(bOpt.value[1], a));
            else b.set(k, a);
            return b;
        });
    };
}
var $33883f933227ea54$var$_mapWithIndex = function(fa, f) {
    var m = new Map();
    var entries = fa.entries();
    var e;
    while(!(e = entries.next()).done){
        var _a = e.value, key = _a[0], a = _a[1];
        m.set(key, f(key, a));
    }
    return m;
};
var $33883f933227ea54$export$bc7c0794b9c6f3ba = function(f) {
    return function(fa) {
        var left = new Map();
        var right = new Map();
        var entries = fa.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            var ei = f(k, a);
            if ($EfnK2.isLeft(ei)) left.set(k, ei.left);
            else right.set(k, ei.right);
        }
        return (0, $1HSKK.separated)(left, right);
    };
};
function $33883f933227ea54$export$dad5e500f2bab9bc(predicateWithIndex) {
    return function(m) {
        var left = new Map();
        var right = new Map();
        var entries = m.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            if (predicateWithIndex(k, a)) right.set(k, a);
            else left.set(k, a);
        }
        return (0, $1HSKK.separated)(left, right);
    };
}
var $33883f933227ea54$export$30c5cbe848021e97 = function(f) {
    return function(fa) {
        var m = new Map();
        var entries = fa.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            var o = f(k, a);
            if ($EfnK2.isSome(o)) m.set(k, o.value);
        }
        return m;
    };
};
function $33883f933227ea54$export$36e42aef19fc7171(predicateWithIndex) {
    return function(m) {
        var out = new Map();
        var entries = m.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            if (predicateWithIndex(k, a)) out.set(k, a);
        }
        return out;
    };
}
var $33883f933227ea54$var$_map = function(fa, f) {
    return $33883f933227ea54$var$_mapWithIndex(fa, function(_, a) {
        return f(a);
    });
};
var $33883f933227ea54$var$_filter = function(fa, p) {
    return $33883f933227ea54$var$_filterWithIndex(fa, function(_, a) {
        return p(a);
    });
};
var $33883f933227ea54$var$_filterMap = function(fa, f) {
    return $33883f933227ea54$var$_filterMapWithIndex(fa, function(_, a) {
        return f(a);
    });
};
var $33883f933227ea54$var$_partition = function(fa, predicate) {
    return $33883f933227ea54$var$_partitionWithIndex(fa, function(_, a) {
        return predicate(a);
    });
};
var $33883f933227ea54$var$_partitionMap = function(fa, f) {
    return $33883f933227ea54$var$_partitionMapWithIndex(fa, function(_, a) {
        return f(a);
    });
};
var $33883f933227ea54$var$_filterWithIndex = function(fa, p) {
    return (0, $72EOc.pipe)(fa, $33883f933227ea54$export$36e42aef19fc7171(p));
};
var $33883f933227ea54$var$_filterMapWithIndex = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $33883f933227ea54$export$30c5cbe848021e97(f));
};
var $33883f933227ea54$var$_partitionWithIndex = function(fa, p) {
    return (0, $72EOc.pipe)(fa, $33883f933227ea54$export$dad5e500f2bab9bc(p));
};
var $33883f933227ea54$var$_partitionMapWithIndex = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $33883f933227ea54$export$bc7c0794b9c6f3ba(f));
};
var $33883f933227ea54$export$8e16b83750b44988 = function(fa) {
    var m = new Map();
    var entries = fa.entries();
    var e;
    while(!(e = entries.next()).done){
        var _a = e.value, k = _a[0], oa = _a[1];
        if ($EfnK2.isSome(oa)) m.set(k, oa.value);
    }
    return m;
};
var $33883f933227ea54$export$3dea766d36a8935f = function(predicate) {
    return function(fa) {
        return $33883f933227ea54$var$_filter(fa, predicate);
    };
};
var $33883f933227ea54$export$a04c6c6965dd4709 = function(f) {
    return function(fa) {
        return $33883f933227ea54$var$_filterMap(fa, f);
    };
};
var $33883f933227ea54$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $33883f933227ea54$var$_map(fa, f);
    };
};
var $33883f933227ea54$export$8f07ddce13659f50 = function(f) {
    return function(fa) {
        return $33883f933227ea54$var$_mapWithIndex(fa, f);
    };
};
var $33883f933227ea54$export$b29f828819edca8d = function(predicate) {
    return function(fa) {
        return $33883f933227ea54$var$_partition(fa, predicate);
    };
};
var $33883f933227ea54$export$3117e3f9ececb6bc = function(f) {
    return function(fa) {
        return $33883f933227ea54$var$_partitionMap(fa, f);
    };
};
var $33883f933227ea54$export$709f6946f4e97408 = function(fa) {
    var left = new Map();
    var right = new Map();
    var entries = fa.entries();
    var e;
    while(!(e = entries.next()).done){
        var _a = e.value, k = _a[0], ei = _a[1];
        if ($EfnK2.isLeft(ei)) left.set(k, ei.left);
        else right.set(k, ei.right);
    }
    return (0, $1HSKK.separated)(left, right);
};
var $33883f933227ea54$export$9156e739aa33e19f = 'ReadonlyMap';
var $33883f933227ea54$export$baca17b4aff42f82 = function(E, S) {
    var unionES = $33883f933227ea54$export$971dd5b0dfd021b6(E, S);
    return {
        concat: function(first, second) {
            return unionES(second)(first);
        }
    };
};
var $33883f933227ea54$export$c487aac9f4157837 = function(E, S) {
    return {
        concat: $33883f933227ea54$export$baca17b4aff42f82(E, S).concat,
        empty: $33883f933227ea54$export$6e22c362a0406a2c
    };
};
var $33883f933227ea54$export$d379a869a72e4055 = function(E, S) {
    var intersectionES = $33883f933227ea54$export$bc86dfbf7795668c(E, S);
    return {
        concat: function(first, second) {
            return intersectionES(second)(first);
        }
    };
};
var $33883f933227ea54$export$fdb3296ca0a124e3 = function(E) {
    return function() {
        var differenceE = $33883f933227ea54$export$acaf96a27438246b(E);
        return {
            concat: function(first, second) {
                return differenceE(second)(first);
            }
        };
    };
};
function $33883f933227ea54$export$d600270efcad85ac() {
    return {
        URI: $33883f933227ea54$export$9156e739aa33e19f,
        _E: undefined,
        map: $33883f933227ea54$var$_map,
        mapWithIndex: $33883f933227ea54$var$_mapWithIndex,
        compact: $33883f933227ea54$export$8e16b83750b44988,
        separate: $33883f933227ea54$export$709f6946f4e97408,
        filter: $33883f933227ea54$var$_filter,
        filterMap: $33883f933227ea54$var$_filterMap,
        partition: $33883f933227ea54$var$_partition,
        partitionMap: $33883f933227ea54$var$_partitionMap,
        partitionMapWithIndex: $33883f933227ea54$var$_partitionMapWithIndex,
        partitionWithIndex: $33883f933227ea54$var$_partitionWithIndex,
        filterMapWithIndex: $33883f933227ea54$var$_filterMapWithIndex,
        filterWithIndex: $33883f933227ea54$var$_filterWithIndex
    };
}
var $33883f933227ea54$export$bd5b6bfc5fa2ee61 = {
    URI: $33883f933227ea54$export$9156e739aa33e19f,
    map: $33883f933227ea54$var$_map
};
var $33883f933227ea54$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $cpwuW.flap)($33883f933227ea54$export$bd5b6bfc5fa2ee61);
var $33883f933227ea54$export$7c7748da5f3db60f = function() {
    return {
        URI: $33883f933227ea54$export$9156e739aa33e19f,
        _E: undefined,
        map: $33883f933227ea54$var$_map,
        mapWithIndex: $33883f933227ea54$var$_mapWithIndex
    };
};
var $33883f933227ea54$export$4a21ac48141ac3c9 = {
    URI: $33883f933227ea54$export$9156e739aa33e19f,
    compact: $33883f933227ea54$export$8e16b83750b44988,
    separate: $33883f933227ea54$export$709f6946f4e97408
};
var $33883f933227ea54$export$d00e1c48fb621173 = {
    URI: $33883f933227ea54$export$9156e739aa33e19f,
    map: $33883f933227ea54$var$_map,
    compact: $33883f933227ea54$export$8e16b83750b44988,
    separate: $33883f933227ea54$export$709f6946f4e97408,
    filter: $33883f933227ea54$var$_filter,
    filterMap: $33883f933227ea54$var$_filterMap,
    partition: $33883f933227ea54$var$_partition,
    partitionMap: $33883f933227ea54$var$_partitionMap
};
var $33883f933227ea54$export$533b26079ad0b4b = function(O) {
    var reduceWithIndexO = $33883f933227ea54$export$bbd3ef8720e22369(O);
    return function(b, f) {
        return reduceWithIndexO(b, function(_, b, a) {
            return f(b, a);
        });
    };
};
var $33883f933227ea54$export$b66cdc0497d8a99a = function(O) {
    var foldMapWithIndexO = $33883f933227ea54$export$18153bb1181268e5(O);
    return function(M) {
        var foldMapWithIndexOM = foldMapWithIndexO(M);
        return function(f) {
            return foldMapWithIndexOM(function(_, a) {
                return f(a);
            });
        };
    };
};
var $33883f933227ea54$export$7fef8bcdbb34f435 = function(O) {
    var reduceRightWithIndexO = $33883f933227ea54$export$ce2b2fe0b88ccd0a(O);
    return function(b, f) {
        return reduceRightWithIndexO(b, function(_, b, a) {
            return f(b, a);
        });
    };
};
var $33883f933227ea54$export$d544f02c7cebdaed = function(O) {
    var reduceO = $33883f933227ea54$export$533b26079ad0b4b(O);
    var foldMapO = $33883f933227ea54$export$b66cdc0497d8a99a(O);
    var reduceRightO = $33883f933227ea54$export$7fef8bcdbb34f435(O);
    return {
        URI: $33883f933227ea54$export$9156e739aa33e19f,
        _E: undefined,
        reduce: function(fa, b, f) {
            return (0, $72EOc.pipe)(fa, reduceO(b, f));
        },
        foldMap: function(M) {
            var foldMapOM = foldMapO(M);
            return function(fa, f) {
                return (0, $72EOc.pipe)(fa, foldMapOM(f));
            };
        },
        reduceRight: function(fa, b, f) {
            return (0, $72EOc.pipe)(fa, reduceRightO(b, f));
        }
    };
};
var $33883f933227ea54$export$bbd3ef8720e22369 = function(O) {
    var keysO = $33883f933227ea54$export$ed97f33186d4b816(O);
    return function(b, f) {
        return function(m) {
            var out = b;
            for(var _i = 0, _a = keysO(m); _i < _a.length; _i++){
                var k = _a[_i];
                out = f(k, out, m.get(k));
            }
            return out;
        };
    };
};
var $33883f933227ea54$export$18153bb1181268e5 = function(O) {
    var keysO = $33883f933227ea54$export$ed97f33186d4b816(O);
    return function(M) {
        return function(f) {
            return function(m) {
                var out = M.empty;
                for(var _i = 0, _a = keysO(m); _i < _a.length; _i++){
                    var k = _a[_i];
                    out = M.concat(out, f(k, m.get(k)));
                }
                return out;
            };
        };
    };
};
var $33883f933227ea54$export$ce2b2fe0b88ccd0a = function(O) {
    var keysO = $33883f933227ea54$export$ed97f33186d4b816(O);
    return function(b, f) {
        return function(m) {
            var out = b;
            var ks = keysO(m);
            var len = ks.length;
            for(var i = len - 1; i >= 0; i--){
                var k = ks[i];
                out = f(k, m.get(k), out);
            }
            return out;
        };
    };
};
var $33883f933227ea54$export$6c59d75f118e7bc9 = function(O) {
    var F = $33883f933227ea54$export$d544f02c7cebdaed(O);
    var reduceWithIndexO = $33883f933227ea54$export$bbd3ef8720e22369(O);
    var foldMapWithIndexO = $33883f933227ea54$export$18153bb1181268e5(O);
    var reduceRightWithIndexO = $33883f933227ea54$export$ce2b2fe0b88ccd0a(O);
    return {
        URI: $33883f933227ea54$export$9156e739aa33e19f,
        _E: undefined,
        reduce: F.reduce,
        foldMap: F.foldMap,
        reduceRight: F.reduceRight,
        reduceWithIndex: function(fa, b, f) {
            return (0, $72EOc.pipe)(fa, reduceWithIndexO(b, f));
        },
        foldMapWithIndex: function(M) {
            var foldMapWithIndexOM = foldMapWithIndexO(M);
            return function(fa, f) {
                return (0, $72EOc.pipe)(fa, foldMapWithIndexOM(f));
            };
        },
        reduceRightWithIndex: function(fa, b, f) {
            return (0, $72EOc.pipe)(fa, reduceRightWithIndexO(b, f));
        }
    };
};
var $33883f933227ea54$export$4e0ffba11065d2c1 = function(O) {
    var TWI = $33883f933227ea54$export$46b81797a3375b8c(O);
    var F = $33883f933227ea54$export$d544f02c7cebdaed(O);
    return {
        URI: $33883f933227ea54$export$9156e739aa33e19f,
        _E: undefined,
        map: $33883f933227ea54$var$_map,
        reduce: F.reduce,
        foldMap: F.foldMap,
        reduceRight: F.reduceRight,
        traverse: TWI.traverse,
        sequence: TWI.sequence
    };
};
var $33883f933227ea54$export$46b81797a3375b8c = function(O) {
    var FWI = $33883f933227ea54$export$6c59d75f118e7bc9(O);
    var keysO = $33883f933227ea54$export$ed97f33186d4b816(O);
    var traverseWithIndex = function(F) {
        return function(ta, f) {
            var fm = F.of(new Map());
            var ks = keysO(ta);
            var len = ks.length;
            var _loop_1 = function(i) {
                var key = ks[i];
                var a = ta.get(key);
                fm = F.ap(F.map(fm, function(m) {
                    return function(b) {
                        return m.set(key, b);
                    };
                }), f(key, a));
            };
            for(var i = 0; i < len; i++)_loop_1(i);
            return fm;
        };
    };
    var traverse = function(F) {
        var traverseWithIndexF = traverseWithIndex(F);
        return function(ta, f) {
            return traverseWithIndexF(ta, function(_, a) {
                return f(a);
            });
        };
    };
    var sequence = function(F) {
        var traverseWithIndexF = traverseWithIndex(F);
        return function(ta) {
            return traverseWithIndexF(ta, (0, $72EOc.SK));
        };
    };
    return {
        URI: $33883f933227ea54$export$9156e739aa33e19f,
        _E: undefined,
        map: $33883f933227ea54$var$_map,
        mapWithIndex: $33883f933227ea54$var$_mapWithIndex,
        reduce: FWI.reduce,
        foldMap: FWI.foldMap,
        reduceRight: FWI.reduceRight,
        reduceWithIndex: FWI.reduceWithIndex,
        foldMapWithIndex: FWI.foldMapWithIndex,
        reduceRightWithIndex: FWI.reduceRightWithIndex,
        traverse: traverse,
        sequence: sequence,
        traverseWithIndex: traverseWithIndex
    };
};
function $33883f933227ea54$export$bb8ef26a634cac7b(O) {
    var TWI = $33883f933227ea54$export$46b81797a3375b8c(O);
    return {
        URI: $33883f933227ea54$export$9156e739aa33e19f,
        _E: undefined,
        map: $33883f933227ea54$var$_map,
        compact: $33883f933227ea54$export$8e16b83750b44988,
        separate: $33883f933227ea54$export$709f6946f4e97408,
        filter: $33883f933227ea54$var$_filter,
        filterMap: $33883f933227ea54$var$_filterMap,
        partition: $33883f933227ea54$var$_partition,
        partitionMap: $33883f933227ea54$var$_partitionMap,
        reduce: TWI.reduce,
        foldMap: TWI.foldMap,
        reduceRight: TWI.reduceRight,
        traverse: TWI.traverse,
        sequence: TWI.sequence,
        mapWithIndex: $33883f933227ea54$var$_mapWithIndex,
        reduceWithIndex: TWI.reduceWithIndex,
        foldMapWithIndex: TWI.foldMapWithIndex,
        reduceRightWithIndex: TWI.reduceRightWithIndex,
        traverseWithIndex: TWI.traverseWithIndex,
        wilt: (0, $jNYdc.wiltDefault)(TWI, $33883f933227ea54$export$4a21ac48141ac3c9),
        wither: (0, $jNYdc.witherDefault)(TWI, $33883f933227ea54$export$4a21ac48141ac3c9)
    };
}
var $33883f933227ea54$export$971dd5b0dfd021b6 = function(E, M) {
    var lookupE = $33883f933227ea54$export$dfc7155ac0343b8(E);
    return function(second) {
        return function(first) {
            if ($33883f933227ea54$export$dd1bc94b04021eeb(first)) return second;
            if ($33883f933227ea54$export$dd1bc94b04021eeb(second)) return first;
            var out = new Map();
            var firstEntries = first.entries();
            var e;
            while(!(e = firstEntries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                var oka = lookupE(k)(second);
                if ($EfnK2.isSome(oka)) out.set(k, M.concat(a, oka.value));
                else out.set(k, a);
            }
            var secondEntries = second.entries();
            while(!(e = secondEntries.next()).done){
                var _b = e.value, k = _b[0], a = _b[1];
                var oka = lookupE(k)(out);
                if ($EfnK2.isNone(oka)) out.set(k, a);
            }
            return out;
        };
    };
};
var $33883f933227ea54$export$bc86dfbf7795668c = function(E, M) {
    var lookupE = $33883f933227ea54$export$dfc7155ac0343b8(E);
    return function(second) {
        return function(first) {
            if ($33883f933227ea54$export$dd1bc94b04021eeb(first) || $33883f933227ea54$export$dd1bc94b04021eeb(second)) return $33883f933227ea54$export$6e22c362a0406a2c;
            var out = new Map();
            var entries = first.entries();
            var e;
            while(!(e = entries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                var oka = lookupE(k)(second);
                if ($EfnK2.isSome(oka)) out.set(k, M.concat(a, oka.value));
            }
            return out;
        };
    };
};
var $33883f933227ea54$export$acaf96a27438246b = function(E) {
    var memberE = $33883f933227ea54$export$6a0d13241802fe80(E);
    return function(second) {
        return function(first) {
            if ($33883f933227ea54$export$dd1bc94b04021eeb(first)) return second;
            if ($33883f933227ea54$export$dd1bc94b04021eeb(second)) return first;
            var out = new Map();
            var firstEntries = first.entries();
            var e;
            while(!(e = firstEntries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                if (!memberE(k)(second)) out.set(k, a);
            }
            var secondEntries = second.entries();
            while(!(e = secondEntries.next()).done){
                var _b = e.value, k = _b[0], a = _b[1];
                if (!memberE(k)(first)) out.set(k, a);
            }
            return out;
        };
    };
};
var $33883f933227ea54$export$9f200c4466975173 = $33883f933227ea54$export$ff82449ce381c54a;
var $33883f933227ea54$export$28562fb56044e6b5 = {
    URI: $33883f933227ea54$export$9156e739aa33e19f,
    map: $33883f933227ea54$var$_map,
    compact: $33883f933227ea54$export$8e16b83750b44988,
    separate: $33883f933227ea54$export$709f6946f4e97408,
    filter: $33883f933227ea54$var$_filter,
    filterMap: $33883f933227ea54$var$_filterMap,
    partition: $33883f933227ea54$var$_partition,
    partitionMap: $33883f933227ea54$var$_partitionMap
};

});

parcelRegister("kxnus", function(module, exports) {

$parcel$export(module.exports, "elem", () => $ef391c668eef0729$export$5bf96401662340b7);
$parcel$export(module.exports, "insert", () => $ef391c668eef0729$export$21a5ca8aa77d35ff);
$parcel$export(module.exports, "remove", () => $ef391c668eef0729$export$cd7f480d6b8286c3);

var $3Md1m = parcelRequire("3Md1m");

var $72EOc = parcelRequire("72EOc");

var $9RniI = parcelRequire("9RniI");

var $1HSKK = parcelRequire("1HSKK");
var $ef391c668eef0729$export$7d98477f9d1e986f = function(s) {
    return new Set(s);
};
var $ef391c668eef0729$export$439306a4dcaafbb9 = function(a) {
    return new Set([
        a
    ]);
};
var $ef391c668eef0729$export$9288e031f1846591 = function(E) {
    return function(as) {
        var len = as.length;
        var out = new Set();
        var has = $ef391c668eef0729$export$5bf96401662340b7(E);
        for(var i = 0; i < len; i++){
            var a = as[i];
            if (!has(a, out)) out.add(a);
        }
        return out;
    };
};
function $ef391c668eef0729$export$f416efe173c6901c(s) {
    return new Set(s);
}
function $ef391c668eef0729$export$871de8747c9eaa88(E) {
    var elemE = $ef391c668eef0729$export$5bf96401662340b7(E);
    return function(f) {
        return function(set) {
            var r = new Set();
            set.forEach(function(e) {
                var v = f(e);
                if (!elemE(v, r)) r.add(v);
            });
            return r;
        };
    };
}
function $ef391c668eef0729$export$e08e3b67e392101e(E) {
    var elemE = $ef391c668eef0729$export$5bf96401662340b7(E);
    return function(f) {
        return function(set) {
            var r = new Set();
            set.forEach(function(e) {
                f(e).forEach(function(e) {
                    if (!elemE(e, r)) r.add(e);
                });
            });
            return r;
        };
    };
}
function $ef391c668eef0729$export$3dea766d36a8935f(predicate) {
    return function(set) {
        var values = set.values();
        var e;
        var r = new Set();
        while(!(e = values.next()).done){
            var a = e.value;
            if (predicate(a)) r.add(a);
        }
        return r;
    };
}
function $ef391c668eef0729$export$b29f828819edca8d(predicate) {
    return function(set) {
        var values = set.values();
        var e;
        var right = new Set();
        var left = new Set();
        while(!(e = values.next()).done){
            var a = e.value;
            if (predicate(a)) right.add(a);
            else left.add(a);
        }
        return (0, $1HSKK.separated)(left, right);
    };
}
function $ef391c668eef0729$export$971dd5b0dfd021b6(E) {
    var elemE = $ef391c668eef0729$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var unionE_1 = $ef391c668eef0729$export$971dd5b0dfd021b6(E);
            return function(that) {
                return unionE_1(me, that);
            };
        }
        if ($ef391c668eef0729$export$dd1bc94b04021eeb(me)) return that;
        if ($ef391c668eef0729$export$dd1bc94b04021eeb(that)) return me;
        var r = new Set(me);
        that.forEach(function(e) {
            if (!elemE(e, r)) r.add(e);
        });
        return r;
    };
}
function $ef391c668eef0729$export$bc86dfbf7795668c(E) {
    var elemE = $ef391c668eef0729$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var intersectionE_1 = $ef391c668eef0729$export$bc86dfbf7795668c(E);
            return function(that) {
                return intersectionE_1(that, me);
            };
        }
        if ($ef391c668eef0729$export$dd1bc94b04021eeb(me) || $ef391c668eef0729$export$dd1bc94b04021eeb(that)) return $ef391c668eef0729$export$6e22c362a0406a2c;
        var r = new Set();
        me.forEach(function(e) {
            if (elemE(e, that)) r.add(e);
        });
        return r;
    };
}
function $ef391c668eef0729$export$3117e3f9ececb6bc(EB, EC) {
    return function(f) {
        return function(set) {
            var values = set.values();
            var e;
            var left = new Set();
            var right = new Set();
            var hasB = $ef391c668eef0729$export$5bf96401662340b7(EB);
            var hasC = $ef391c668eef0729$export$5bf96401662340b7(EC);
            while(!(e = values.next()).done){
                var v = f(e.value);
                switch(v._tag){
                    case 'Left':
                        if (!hasB(v.left, left)) left.add(v.left);
                        break;
                    case 'Right':
                        if (!hasC(v.right, right)) right.add(v.right);
                        break;
                }
            }
            return (0, $1HSKK.separated)(left, right);
        };
    };
}
function $ef391c668eef0729$export$acaf96a27438246b(E) {
    var elemE = $ef391c668eef0729$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var differenceE_1 = $ef391c668eef0729$export$acaf96a27438246b(E);
            return function(that) {
                return differenceE_1(that, me);
            };
        }
        return $ef391c668eef0729$export$3dea766d36a8935f(function(a) {
            return !elemE(a, that);
        })(me);
    };
}
function $ef391c668eef0729$export$533b26079ad0b4b(O) {
    var toReadonlyArrayO = $ef391c668eef0729$export$4aaa3912a3956cb7(O);
    return function(b, f) {
        return function(fa) {
            return toReadonlyArrayO(fa).reduce(f, b);
        };
    };
}
function $ef391c668eef0729$export$b66cdc0497d8a99a(O, M) {
    var toReadonlyArrayO = $ef391c668eef0729$export$4aaa3912a3956cb7(O);
    return function(f) {
        return function(fa) {
            return toReadonlyArrayO(fa).reduce(function(b, a) {
                return M.concat(b, f(a));
            }, M.empty);
        };
    };
}
var $ef391c668eef0729$export$7fef8bcdbb34f435 = function(O) {
    var toReadonlyArrayO = $ef391c668eef0729$export$4aaa3912a3956cb7(O);
    return function(b, f) {
        return function(fa) {
            return toReadonlyArrayO(fa).reduceRight(function(b, a) {
                return f(a, b);
            }, b);
        };
    };
};
function $ef391c668eef0729$export$21a5ca8aa77d35ff(E) {
    var elemE = $ef391c668eef0729$export$5bf96401662340b7(E);
    return function(a) {
        return function(set) {
            if (!elemE(a)(set)) {
                var r = new Set(set);
                r.add(a);
                return r;
            } else return set;
        };
    };
}
var $ef391c668eef0729$export$cd7f480d6b8286c3 = function(E) {
    return function(a) {
        return function(set) {
            return $ef391c668eef0729$export$3dea766d36a8935f(function(ax) {
                return !E.equals(a, ax);
            })(set);
        };
    };
};
var $ef391c668eef0729$export$e03c1c3201ee8bb7 = function(E) {
    var elemE = $ef391c668eef0729$export$5bf96401662340b7(E);
    var removeE = $ef391c668eef0729$export$cd7f480d6b8286c3(E);
    var insertE = $ef391c668eef0729$export$21a5ca8aa77d35ff(E);
    return function(a) {
        return function(set) {
            return (elemE(a, set) ? removeE : insertE)(a)(set);
        };
    };
};
var $ef391c668eef0729$export$8e16b83750b44988 = function(E) {
    return $ef391c668eef0729$export$a04c6c6965dd4709(E)((0, $72EOc.identity));
};
function $ef391c668eef0729$export$709f6946f4e97408(EE, EA) {
    return function(fa) {
        var elemEE = $ef391c668eef0729$export$5bf96401662340b7(EE);
        var elemEA = $ef391c668eef0729$export$5bf96401662340b7(EA);
        var left = new Set();
        var right = new Set();
        fa.forEach(function(e) {
            switch(e._tag){
                case 'Left':
                    if (!elemEE(e.left, left)) left.add(e.left);
                    break;
                case 'Right':
                    if (!elemEA(e.right, right)) right.add(e.right);
                    break;
            }
        });
        return (0, $1HSKK.separated)(left, right);
    };
}
function $ef391c668eef0729$export$a04c6c6965dd4709(E) {
    var elemE = $ef391c668eef0729$export$5bf96401662340b7(E);
    return function(f) {
        return function(fa) {
            var r = new Set();
            fa.forEach(function(a) {
                var ob = f(a);
                if (ob._tag === 'Some' && !elemE(ob.value, r)) r.add(ob.value);
            });
            return r;
        };
    };
}
var $ef391c668eef0729$export$6e22c362a0406a2c = new Set();
var $ef391c668eef0729$export$dd1bc94b04021eeb = function(set) {
    return set.size === 0;
};
var $ef391c668eef0729$export$346677f925de839c = function(set) {
    return set.size;
};
var $ef391c668eef0729$export$ad14ef4001db2bcd = function(predicate) {
    return function(set) {
        var values = set.values();
        var e;
        var found = false;
        while(!found && !(e = values.next()).done)found = predicate(e.value);
        return found;
    };
};
function $ef391c668eef0729$export$7ecc1a3b11b57dab(predicate) {
    return (0, $9RniI.not)($ef391c668eef0729$export$ad14ef4001db2bcd((0, $9RniI.not)(predicate)));
}
function $ef391c668eef0729$export$af04532ec9ff13d2(E) {
    var elemE = $ef391c668eef0729$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var isSubsetE_1 = $ef391c668eef0729$export$af04532ec9ff13d2(E);
            return function(that) {
                return isSubsetE_1(that, me);
            };
        }
        return $ef391c668eef0729$export$7ecc1a3b11b57dab(function(a) {
            return elemE(a, that);
        })(me);
    };
}
function $ef391c668eef0729$export$5bf96401662340b7(E) {
    return function(a, set) {
        if (set === undefined) {
            var elemE_1 = $ef391c668eef0729$export$5bf96401662340b7(E);
            return function(set) {
                return elemE_1(a, set);
            };
        }
        var values = set.values();
        var e;
        var found = false;
        while(!found && !(e = values.next()).done)found = E.equals(a, e.value);
        return found;
    };
}
var $ef391c668eef0729$export$4aaa3912a3956cb7 = function(O) {
    return function(set) {
        var out = [];
        set.forEach(function(e) {
            return out.push(e);
        });
        return out.sort(O.compare);
    };
};
var $ef391c668eef0729$export$9156e739aa33e19f = 'ReadonlySet';
function $ef391c668eef0729$export$3cb5cd7f7776c81(S) {
    return {
        show: function(s) {
            var entries = [];
            s.forEach(function(a) {
                entries.push(S.show(a));
            });
            return "new Set([".concat(entries.sort().join(', '), "])");
        }
    };
}
function $ef391c668eef0729$export$804fed467fde44e4(E) {
    var subsetE = $ef391c668eef0729$export$af04532ec9ff13d2(E);
    return (0, $3Md1m.fromEquals)(function(x, y) {
        return subsetE(x, y) && subsetE(y, x);
    });
}
var $ef391c668eef0729$export$baca17b4aff42f82 = function(E) {
    return {
        concat: $ef391c668eef0729$export$971dd5b0dfd021b6(E)
    };
};
var $ef391c668eef0729$export$c487aac9f4157837 = function(E) {
    return {
        concat: $ef391c668eef0729$export$baca17b4aff42f82(E).concat,
        empty: $ef391c668eef0729$export$6e22c362a0406a2c
    };
};
var $ef391c668eef0729$export$d379a869a72e4055 = function(E) {
    return {
        concat: $ef391c668eef0729$export$bc86dfbf7795668c(E)
    };
};
var $ef391c668eef0729$export$fdb3296ca0a124e3 = function(E) {
    return {
        concat: $ef391c668eef0729$export$acaf96a27438246b(E)
    };
};
var $ef391c668eef0729$export$571d59b505e6bb4e = $ef391c668eef0729$export$9288e031f1846591;

});

parcelRegister("lV5N9", function(module, exports) {

$parcel$export(module.exports, "iso", () => $ff5369f959674226$export$1aba8f741a0eae06);
$parcel$export(module.exports, "isoAsLens", () => $ff5369f959674226$export$d001ee9513dee7c1);
$parcel$export(module.exports, "lens", () => $ff5369f959674226$export$21cde5187c2605a3);
$parcel$export(module.exports, "isoAsPrism", () => $ff5369f959674226$export$fde8c5b9dff57abc);
$parcel$export(module.exports, "prism", () => $ff5369f959674226$export$e469dcfea9910464);
$parcel$export(module.exports, "isoAsOptional", () => $ff5369f959674226$export$4d3db894cf45abd5);
$parcel$export(module.exports, "optional", () => $ff5369f959674226$export$516e28dec6a4b6d4);
$parcel$export(module.exports, "isoAsTraversal", () => $ff5369f959674226$export$e55a826b3ba968d2);
$parcel$export(module.exports, "traversal", () => $ff5369f959674226$export$8666ce7a134c2314);
$parcel$export(module.exports, "lensAsOptional", () => $ff5369f959674226$export$bae94c671b4dc75d);
$parcel$export(module.exports, "lensAsTraversal", () => $ff5369f959674226$export$e5de01c31c85830c);
$parcel$export(module.exports, "lensComposeLens", () => $ff5369f959674226$export$62d1b5266563d2b6);
$parcel$export(module.exports, "prismComposePrism", () => $ff5369f959674226$export$af9c087537c23eb1);
$parcel$export(module.exports, "lensComposePrism", () => $ff5369f959674226$export$ffffe1ca21811d93);
$parcel$export(module.exports, "optionalComposeOptional", () => $ff5369f959674226$export$8e08893559c32e38);
$parcel$export(module.exports, "prismAsOptional", () => $ff5369f959674226$export$70f4d204f3bdc8bd);
$parcel$export(module.exports, "lensId", () => $ff5369f959674226$export$a4b03755c6673298);
$parcel$export(module.exports, "lensProp", () => $ff5369f959674226$export$a6ba95b157529836);
$parcel$export(module.exports, "lensProps", () => $ff5369f959674226$export$c19575454e66bf5f);
$parcel$export(module.exports, "lensComponent", () => $ff5369f959674226$export$103f2a6258fae742);
$parcel$export(module.exports, "lensAtKey", () => $ff5369f959674226$export$fc68a3bfc89f0b98);
$parcel$export(module.exports, "atReadonlyRecord", () => $ff5369f959674226$export$ba8573d258bae607);
$parcel$export(module.exports, "prismSet", () => $ff5369f959674226$export$97725fa315d6412c);
$parcel$export(module.exports, "prismAsTraversal", () => $ff5369f959674226$export$18564f4597667b6a);
$parcel$export(module.exports, "prismModifyOption", () => $ff5369f959674226$export$ddb3ff54eaa1c530);
$parcel$export(module.exports, "prismModify", () => $ff5369f959674226$export$f545e0bcbe4b5ea7);
$parcel$export(module.exports, "prismComposeLens", () => $ff5369f959674226$export$dad01448ef670850);
$parcel$export(module.exports, "prismFromNullable", () => $ff5369f959674226$export$258cc98aa6d7d21b);
$parcel$export(module.exports, "prismFromPredicate", () => $ff5369f959674226$export$8f316a2f03469694);
$parcel$export(module.exports, "prismSome", () => $ff5369f959674226$export$782e8b2fe031f968);
$parcel$export(module.exports, "prismRight", () => $ff5369f959674226$export$929e170fdd93186c);
$parcel$export(module.exports, "prismLeft", () => $ff5369f959674226$export$97ae81cf28b21f26);
$parcel$export(module.exports, "optionalAsTraversal", () => $ff5369f959674226$export$a595a5197cc37264);
$parcel$export(module.exports, "optionalModifyOption", () => $ff5369f959674226$export$48aae8aebe6d3ee9);
$parcel$export(module.exports, "optionalModify", () => $ff5369f959674226$export$6d575f282c3c1d48);
$parcel$export(module.exports, "optionalIndex", () => $ff5369f959674226$export$47ac94aa95300c6f);
$parcel$export(module.exports, "indexReadonlyArray", () => $ff5369f959674226$export$bb0c054375ca4b0);
$parcel$export(module.exports, "optionalIndexNonEmpty", () => $ff5369f959674226$export$83e62439a4d30c4c);
$parcel$export(module.exports, "indexReadonlyNonEmptyArray", () => $ff5369f959674226$export$165af7b747e6b1f1);
$parcel$export(module.exports, "optionalKey", () => $ff5369f959674226$export$a6c26e1663200bf4);
$parcel$export(module.exports, "indexReadonlyRecord", () => $ff5369f959674226$export$3c3468aec3b83bbf);
$parcel$export(module.exports, "optionalFindFirst", () => $ff5369f959674226$export$220673392b48821b);
$parcel$export(module.exports, "optionalFindFirstNonEmpty", () => $ff5369f959674226$export$cf29cfc68de9a659);
$parcel$export(module.exports, "traversalComposeTraversal", () => $ff5369f959674226$export$2c68ab81171b083f);
$parcel$export(module.exports, "ApplicativeIdentity", () => $ff5369f959674226$export$7c4912ca011fa00e);
$parcel$export(module.exports, "fromTraversable", () => $ff5369f959674226$export$126b5a87c58d3f9c);
$parcel$export(module.exports, "traversalTraverse", () => $ff5369f959674226$export$35db6fcbd934c57);
$parcel$export(module.exports, "index", () => $ff5369f959674226$export$b610b8812bbcded9);
$parcel$export(module.exports, "at", () => $ff5369f959674226$export$493d36ec626b6698);

var $8yI6w = parcelRequire("8yI6w");

var $hDHPV = parcelRequire("hDHPV");

var $72EOc = parcelRequire("72EOc");

var $bxsNd = parcelRequire("bxsNd");

var $2BN86 = parcelRequire("2BN86");

var $30crt = parcelRequire("30crt");
var $ff5369f959674226$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $ff5369f959674226$export$1aba8f741a0eae06 = function(get, reverseGet) {
    return {
        get: get,
        reverseGet: reverseGet
    };
};
var $ff5369f959674226$export$d001ee9513dee7c1 = function(sa) {
    return $ff5369f959674226$export$21cde5187c2605a3(sa.get, (0, $72EOc.flow)(sa.reverseGet, (0, $72EOc.constant)));
};
var $ff5369f959674226$export$fde8c5b9dff57abc = function(sa) {
    return $ff5369f959674226$export$e469dcfea9910464((0, $72EOc.flow)(sa.get, $bxsNd.some), sa.reverseGet);
};
var $ff5369f959674226$export$4d3db894cf45abd5 = function(sa) {
    return $ff5369f959674226$export$516e28dec6a4b6d4((0, $72EOc.flow)(sa.get, $bxsNd.some), (0, $72EOc.flow)(sa.reverseGet, (0, $72EOc.constant)));
};
var $ff5369f959674226$export$e55a826b3ba968d2 = function(sa) {
    return $ff5369f959674226$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return F.map(f(sa.get(s)), function(a) {
                    return sa.reverseGet(a);
                });
            };
        };
    });
};
var $ff5369f959674226$export$21cde5187c2605a3 = function(get, set) {
    return {
        get: get,
        set: set
    };
};
var $ff5369f959674226$export$bae94c671b4dc75d = function(sa) {
    return $ff5369f959674226$export$516e28dec6a4b6d4((0, $72EOc.flow)(sa.get, $bxsNd.some), sa.set);
};
var $ff5369f959674226$export$e5de01c31c85830c = function(sa) {
    return $ff5369f959674226$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return F.map(f(sa.get(s)), function(a) {
                    return sa.set(a)(s);
                });
            };
        };
    });
};
var $ff5369f959674226$export$62d1b5266563d2b6 = function(ab) {
    return function(sa) {
        return $ff5369f959674226$export$21cde5187c2605a3(function(s) {
            return ab.get(sa.get(s));
        }, function(b) {
            return function(s) {
                return sa.set(ab.set(b)(sa.get(s)))(s);
            };
        });
    };
};
var $ff5369f959674226$export$af9c087537c23eb1 = function(ab) {
    return function(sa) {
        return $ff5369f959674226$export$e469dcfea9910464((0, $72EOc.flow)(sa.getOption, $bxsNd.chain(ab.getOption)), (0, $72EOc.flow)(ab.reverseGet, sa.reverseGet));
    };
};
var $ff5369f959674226$export$ffffe1ca21811d93 = function(ab) {
    return function(sa) {
        return $ff5369f959674226$export$8e08893559c32e38($ff5369f959674226$export$70f4d204f3bdc8bd(ab))($ff5369f959674226$export$bae94c671b4dc75d(sa));
    };
};
var $ff5369f959674226$export$a4b03755c6673298 = function() {
    return $ff5369f959674226$export$21cde5187c2605a3((0, $72EOc.identity), (0, $72EOc.constant));
};
var $ff5369f959674226$export$a6ba95b157529836 = function(prop) {
    return function(sa) {
        return $ff5369f959674226$export$21cde5187c2605a3(function(s) {
            return sa.get(s)[prop];
        }, function(ap) {
            return function(s) {
                var _a;
                var oa = sa.get(s);
                if (ap === oa[prop]) return s;
                return sa.set(Object.assign({}, oa, (_a = {}, _a[prop] = ap, _a)))(s);
            };
        });
    };
};
var $ff5369f959674226$export$c19575454e66bf5f = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return function(sa) {
        return $ff5369f959674226$export$21cde5187c2605a3(function(s) {
            var a = sa.get(s);
            var r = {};
            for(var _i = 0, props_1 = props; _i < props_1.length; _i++){
                var k = props_1[_i];
                r[k] = a[k];
            }
            return r;
        }, function(a) {
            return function(s) {
                var oa = sa.get(s);
                for(var _i = 0, props_2 = props; _i < props_2.length; _i++){
                    var k = props_2[_i];
                    if (a[k] !== oa[k]) return sa.set(Object.assign({}, oa, a))(s);
                }
                return s;
            };
        });
    };
};
var $ff5369f959674226$export$103f2a6258fae742 = function(prop) {
    return function(sa) {
        return $ff5369f959674226$export$21cde5187c2605a3(function(s) {
            return sa.get(s)[prop];
        }, function(ap) {
            return function(s) {
                var oa = sa.get(s);
                if (ap === oa[prop]) return s;
                var copy = oa.slice();
                copy[prop] = ap;
                return sa.set(copy)(s);
            };
        });
    };
};
var $ff5369f959674226$export$fc68a3bfc89f0b98 = function(key) {
    return function(sa) {
        return (0, $30crt.pipe)(sa, $ff5369f959674226$export$62d1b5266563d2b6($ff5369f959674226$export$ba8573d258bae607().at(key)));
    };
};
var $ff5369f959674226$export$e469dcfea9910464 = function(getOption, reverseGet) {
    return {
        getOption: getOption,
        reverseGet: reverseGet
    };
};
var $ff5369f959674226$export$70f4d204f3bdc8bd = function(sa) {
    return $ff5369f959674226$export$516e28dec6a4b6d4(sa.getOption, function(a) {
        return $ff5369f959674226$export$97725fa315d6412c(a)(sa);
    });
};
var $ff5369f959674226$export$18564f4597667b6a = function(sa) {
    return $ff5369f959674226$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return (0, $30crt.pipe)(sa.getOption(s), $bxsNd.fold(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), function(a) {
                        return $ff5369f959674226$export$97725fa315d6412c(a)(sa)(s);
                    });
                }));
            };
        };
    });
};
var $ff5369f959674226$export$ddb3ff54eaa1c530 = function(f) {
    return function(sa) {
        return function(s) {
            return (0, $30crt.pipe)(sa.getOption(s), $bxsNd.map(function(o) {
                var n = f(o);
                return n === o ? s : sa.reverseGet(n);
            }));
        };
    };
};
var $ff5369f959674226$export$f545e0bcbe4b5ea7 = function(f) {
    return function(sa) {
        var g = $ff5369f959674226$export$ddb3ff54eaa1c530(f)(sa);
        return function(s) {
            return (0, $30crt.pipe)(g(s), $bxsNd.getOrElse(function() {
                return s;
            }));
        };
    };
};
var $ff5369f959674226$export$97725fa315d6412c = function(a) {
    return $ff5369f959674226$export$f545e0bcbe4b5ea7(function() {
        return a;
    });
};
var $ff5369f959674226$export$dad01448ef670850 = function(ab) {
    return function(sa) {
        return $ff5369f959674226$export$8e08893559c32e38($ff5369f959674226$export$bae94c671b4dc75d(ab))($ff5369f959674226$export$70f4d204f3bdc8bd(sa));
    };
};
var $ff5369f959674226$export$258cc98aa6d7d21b = function() {
    return $ff5369f959674226$export$e469dcfea9910464($bxsNd.fromNullable, (0, $72EOc.identity));
};
var $ff5369f959674226$export$8f316a2f03469694 = function(predicate) {
    return $ff5369f959674226$export$e469dcfea9910464($bxsNd.fromPredicate(predicate), (0, $72EOc.identity));
};
var $ff5369f959674226$export$782e8b2fe031f968 = function() {
    return $ff5369f959674226$export$e469dcfea9910464((0, $72EOc.identity), $bxsNd.some);
};
var $ff5369f959674226$export$929e170fdd93186c = function() {
    return $ff5369f959674226$export$e469dcfea9910464($bxsNd.fromEither, $2BN86.right);
};
var $ff5369f959674226$export$97ae81cf28b21f26 = function() {
    return $ff5369f959674226$export$e469dcfea9910464(function(s) {
        return $2BN86.isLeft(s) ? $bxsNd.some(s.left) : $bxsNd.none;
    }, $2BN86.left);
};
var $ff5369f959674226$export$516e28dec6a4b6d4 = function(getOption, set) {
    return {
        getOption: getOption,
        set: set
    };
};
var $ff5369f959674226$export$a595a5197cc37264 = function(sa) {
    return $ff5369f959674226$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return (0, $30crt.pipe)(sa.getOption(s), $bxsNd.fold(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), function(a) {
                        return sa.set(a)(s);
                    });
                }));
            };
        };
    });
};
var $ff5369f959674226$export$48aae8aebe6d3ee9 = function(f) {
    return function(optional) {
        return function(s) {
            return (0, $30crt.pipe)(optional.getOption(s), $bxsNd.map(function(a) {
                var n = f(a);
                return n === a ? s : optional.set(n)(s);
            }));
        };
    };
};
var $ff5369f959674226$export$6d575f282c3c1d48 = function(f) {
    return function(optional) {
        var g = $ff5369f959674226$export$48aae8aebe6d3ee9(f)(optional);
        return function(s) {
            return (0, $30crt.pipe)(g(s), $bxsNd.getOrElse(function() {
                return s;
            }));
        };
    };
};
var $ff5369f959674226$export$8e08893559c32e38 = function(ab) {
    return function(sa) {
        return $ff5369f959674226$export$516e28dec6a4b6d4((0, $72EOc.flow)(sa.getOption, $bxsNd.chain(ab.getOption)), function(b) {
            return $ff5369f959674226$export$6d575f282c3c1d48(ab.set(b))(sa);
        });
    };
};
var $ff5369f959674226$export$47ac94aa95300c6f = function(i) {
    return function(sa) {
        return (0, $30crt.pipe)(sa, $ff5369f959674226$export$8e08893559c32e38($ff5369f959674226$export$bb0c054375ca4b0().index(i)));
    };
};
var $ff5369f959674226$export$83e62439a4d30c4c = function(i) {
    return function(sa) {
        return (0, $30crt.pipe)(sa, $ff5369f959674226$export$8e08893559c32e38($ff5369f959674226$export$165af7b747e6b1f1().index(i)));
    };
};
var $ff5369f959674226$export$a6c26e1663200bf4 = function(key) {
    return function(sa) {
        return (0, $30crt.pipe)(sa, $ff5369f959674226$export$8e08893559c32e38($ff5369f959674226$export$3c3468aec3b83bbf().index(key)));
    };
};
var $ff5369f959674226$export$220673392b48821b = function(predicate) {
    return $ff5369f959674226$export$516e28dec6a4b6d4($8yI6w.findFirst(predicate), function(a) {
        return function(s) {
            return (0, $30crt.pipe)($8yI6w.findIndex(predicate)(s), $bxsNd.fold(function() {
                return s;
            }, function(i) {
                return $8yI6w.unsafeUpdateAt(i, a, s);
            }));
        };
    });
};
var $ff5369f959674226$var$unsafeUpdateAt = function(i, a, as) {
    if (as[i] === a) return as;
    else {
        var xs = $ff5369f959674226$var$__spreadArray([
            as[0]
        ], as.slice(1), true);
        xs[i] = a;
        return xs;
    }
};
var $ff5369f959674226$export$cf29cfc68de9a659 = function(predicate) {
    return $ff5369f959674226$export$516e28dec6a4b6d4($8yI6w.findFirst(predicate), function(a) {
        return function(as) {
            return (0, $30crt.pipe)($8yI6w.findIndex(predicate)(as), $bxsNd.fold(function() {
                return as;
            }, function(i) {
                return $ff5369f959674226$var$unsafeUpdateAt(i, a, as);
            }));
        };
    });
};
var $ff5369f959674226$export$8666ce7a134c2314 = function(modifyF) {
    return {
        modifyF: modifyF
    };
};
function $ff5369f959674226$export$2c68ab81171b083f(ab) {
    return function(sa) {
        return $ff5369f959674226$export$8666ce7a134c2314(function(F) {
            return function(f) {
                return sa.modifyF(F)(ab.modifyF(F)(f));
            };
        });
    };
}
var $ff5369f959674226$export$7c4912ca011fa00e = {
    URI: 'Identity',
    map: function(fa, f) {
        return f(fa);
    },
    of: (0, $72EOc.identity),
    ap: /* istanbul ignore next */ function(fab, fa) {
        return fab(fa);
    }
};
var $ff5369f959674226$var$isIdentity = function(F) {
    return F.URI === 'Identity';
};
function $ff5369f959674226$export$126b5a87c58d3f9c(T) {
    return function() {
        return $ff5369f959674226$export$8666ce7a134c2314(function(F) {
            // if `F` is `Identity` then `traverseF = map`
            var traverseF = $ff5369f959674226$var$isIdentity(F) ? T.map : T.traverse(F);
            return function(f) {
                return function(s) {
                    return traverseF(s, f);
                };
            };
        });
    };
}
function $ff5369f959674226$export$35db6fcbd934c57(T) {
    return $ff5369f959674226$export$2c68ab81171b083f($ff5369f959674226$export$126b5a87c58d3f9c(T)());
}
var $ff5369f959674226$export$b610b8812bbcded9 = function(index) {
    return {
        index: index
    };
};
var $ff5369f959674226$export$bb0c054375ca4b0 = function() {
    return $ff5369f959674226$export$b610b8812bbcded9(function(i) {
        return $ff5369f959674226$export$516e28dec6a4b6d4(function(as) {
            return $8yI6w.lookup(i, as);
        }, function(a) {
            return function(as) {
                return (0, $30crt.pipe)($8yI6w.lookup(i, as), $bxsNd.fold(function() {
                    return as;
                }, function() {
                    return $8yI6w.unsafeUpdateAt(i, a, as);
                }));
            };
        });
    });
};
var $ff5369f959674226$export$165af7b747e6b1f1 = function() {
    return $ff5369f959674226$export$b610b8812bbcded9(function(i) {
        return $ff5369f959674226$export$516e28dec6a4b6d4(function(as) {
            return $8yI6w.lookup(i, as);
        }, function(a) {
            return function(as) {
                return (0, $30crt.pipe)($8yI6w.lookup(i, as), $bxsNd.fold(function() {
                    return as;
                }, function() {
                    return $ff5369f959674226$var$unsafeUpdateAt(i, a, as);
                }));
            };
        });
    });
};
var $ff5369f959674226$export$3c3468aec3b83bbf = function() {
    return $ff5369f959674226$export$b610b8812bbcded9(function(k) {
        return $ff5369f959674226$export$516e28dec6a4b6d4(function(r) {
            return $hDHPV.lookup(k, r);
        }, function(a) {
            return function(r) {
                if (r[k] === a || $bxsNd.isNone($hDHPV.lookup(k, r))) return r;
                return $hDHPV.insertAt(k, a)(r);
            };
        });
    });
};
var $ff5369f959674226$export$493d36ec626b6698 = function(at) {
    return {
        at: at
    };
};
function $ff5369f959674226$export$ba8573d258bae607() {
    return $ff5369f959674226$export$493d36ec626b6698(function(key) {
        return $ff5369f959674226$export$21cde5187c2605a3(function(r) {
            return $hDHPV.lookup(key, r);
        }, $bxsNd.fold(function() {
            return $hDHPV.deleteAt(key);
        }, function(a) {
            return $hDHPV.insertAt(key, a);
        }));
    });
}

});
parcelRegister("hDHPV", function(module, exports) {

$parcel$export(module.exports, "deleteAt", () => $cd78153388da00d3$export$90f9093465da3136);
$parcel$export(module.exports, "lookup", () => $cd78153388da00d3$export$dfc7155ac0343b8);
$parcel$export(module.exports, "insertAt", () => $cd78153388da00d3$export$9f200c4466975173);

var $3Md1m = parcelRequire("3Md1m");

var $72EOc = parcelRequire("72EOc");

var $cpwuW = parcelRequire("cpwuW");

var $EfnK2 = parcelRequire("EfnK2");

var $1HSKK = parcelRequire("1HSKK");

var $jmlhE = parcelRequire("jmlhE");

var $jNYdc = parcelRequire("jNYdc");
var $cd78153388da00d3$export$6c8271f68d66a228 = function(r) {
    return Object.assign({}, r);
};
var $cd78153388da00d3$export$1a8926de16677683 = function(r) {
    return Object.assign({}, r);
};
var $cd78153388da00d3$export$346677f925de839c = function(r) {
    return Object.keys(r).length;
};
var $cd78153388da00d3$export$dd1bc94b04021eeb = function(r) {
    for(var k in r){
        if ($EfnK2.has.call(r, k)) return false;
    }
    return true;
};
var $cd78153388da00d3$var$keys_ = function(O) {
    return function(r) {
        return Object.keys(r).sort(O.compare);
    };
};
var $cd78153388da00d3$export$ed97f33186d4b816 = /*#__PURE__*/ $cd78153388da00d3$var$keys_($jmlhE.Ord);
function $cd78153388da00d3$export$bb44f104e3c54dae(O) {
    if (typeof O === 'function') return $cd78153388da00d3$export$bb44f104e3c54dae($jmlhE.Ord)(O);
    var keysO = $cd78153388da00d3$var$keys_(O);
    return function(f) {
        return function(r) {
            var out = [];
            for(var _i = 0, _a = keysO(r); _i < _a.length; _i++){
                var key = _a[_i];
                out.push(f(key, r[key]));
            }
            return out;
        };
    };
}
var $cd78153388da00d3$export$4aaa3912a3956cb7 = /*#__PURE__*/ $cd78153388da00d3$export$bb44f104e3c54dae($jmlhE.Ord)(function(k, a) {
    return [
        k,
        a
    ];
});
function $cd78153388da00d3$export$823be24f8766da23(U) {
    return function(r) {
        var sas = $cd78153388da00d3$export$4aaa3912a3956cb7(r);
        var len = sas.length;
        return U.unfold(0, function(b) {
            return b < len ? $EfnK2.some([
                sas[b],
                b + 1
            ]) : $EfnK2.none;
        });
    };
}
var $cd78153388da00d3$export$ff82449ce381c54a = function(k, a) {
    return function(r) {
        if ($EfnK2.has.call(r, k) && r[k] === a) return r;
        var out = Object.assign({}, r);
        out[k] = a;
        return out;
    };
};
var $cd78153388da00d3$export$a4f4bb6b1453fff5 = function(k, r) {
    return $EfnK2.has.call(r, k);
};
function $cd78153388da00d3$export$90f9093465da3136(k) {
    return function(r) {
        if (!$EfnK2.has.call(r, k)) return r;
        var out = Object.assign({}, r);
        delete out[k];
        return out;
    };
}
var $cd78153388da00d3$export$b6d8713d53419d4c = function(k, a) {
    return function(r) {
        if (!$cd78153388da00d3$export$a4f4bb6b1453fff5(k, r)) return $EfnK2.none;
        if (r[k] === a) return $EfnK2.some(r);
        var out = Object.assign({}, r);
        out[k] = a;
        return $EfnK2.some(out);
    };
};
var $cd78153388da00d3$export$cba09f9e3d3e58eb = function(k, f) {
    return function(r) {
        if (!$cd78153388da00d3$export$a4f4bb6b1453fff5(k, r)) return $EfnK2.none;
        var next = f(r[k]);
        if (next === r[k]) return $EfnK2.some(r);
        var out = Object.assign({}, r);
        out[k] = next;
        return $EfnK2.some(out);
    };
};
function $cd78153388da00d3$export$3e41007ebfff0e64(k) {
    var deleteAtk = $cd78153388da00d3$export$90f9093465da3136(k);
    return function(r) {
        var oa = $cd78153388da00d3$export$dfc7155ac0343b8(k, r);
        return $EfnK2.isNone(oa) ? $EfnK2.none : $EfnK2.some([
            oa.value,
            deleteAtk(r)
        ]);
    };
}
function $cd78153388da00d3$export$36e6f76a1d117b8a(E) {
    return function(me, that) {
        if (that === undefined) {
            var isSubrecordE_1 = $cd78153388da00d3$export$36e6f76a1d117b8a(E);
            return function(that) {
                return isSubrecordE_1(that, me);
            };
        }
        for(var k in me){
            if (!$EfnK2.has.call(that, k) || !E.equals(me[k], that[k])) return false;
        }
        return true;
    };
}
function $cd78153388da00d3$export$dfc7155ac0343b8(k, r) {
    if (r === undefined) return function(r) {
        return $cd78153388da00d3$export$dfc7155ac0343b8(k, r);
    };
    return $EfnK2.has.call(r, k) ? $EfnK2.some(r[k]) : $EfnK2.none;
}
var $cd78153388da00d3$export$6e22c362a0406a2c = {};
function $cd78153388da00d3$export$8f07ddce13659f50(f) {
    return function(r) {
        var out = {};
        for(var k in r)if ($EfnK2.has.call(r, k)) out[k] = f(k, r[k]);
        return out;
    };
}
function $cd78153388da00d3$export$871de8747c9eaa88(f) {
    return $cd78153388da00d3$export$8f07ddce13659f50(function(_, a) {
        return f(a);
    });
}
function $cd78153388da00d3$export$bbd3ef8720e22369() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 2) return $cd78153388da00d3$export$bbd3ef8720e22369($jmlhE.Ord).apply(void 0, args);
    var keysO = $cd78153388da00d3$var$keys_(args[0]);
    return function(b, f) {
        return function(fa) {
            var out = b;
            var ks = keysO(fa);
            var len = ks.length;
            for(var i = 0; i < len; i++){
                var k = ks[i];
                out = f(k, out, fa[k]);
            }
            return out;
        };
    };
}
function $cd78153388da00d3$export$18153bb1181268e5(O) {
    if ('compare' in O) {
        var keysO_1 = $cd78153388da00d3$var$keys_(O);
        return function(M) {
            return function(f) {
                return function(fa) {
                    var out = M.empty;
                    var ks = keysO_1(fa);
                    var len = ks.length;
                    for(var i = 0; i < len; i++){
                        var k = ks[i];
                        out = M.concat(out, f(k, fa[k]));
                    }
                    return out;
                };
            };
        };
    }
    return $cd78153388da00d3$export$18153bb1181268e5($jmlhE.Ord)(O);
}
function $cd78153388da00d3$export$ce2b2fe0b88ccd0a() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 2) return $cd78153388da00d3$export$ce2b2fe0b88ccd0a($jmlhE.Ord).apply(void 0, args);
    var keysO = $cd78153388da00d3$var$keys_(args[0]);
    return function(b, f) {
        return function(fa) {
            var out = b;
            var ks = keysO(fa);
            var len = ks.length;
            for(var i = len - 1; i >= 0; i--){
                var k = ks[i];
                out = f(k, fa[k], out);
            }
            return out;
        };
    };
}
var $cd78153388da00d3$export$439306a4dcaafbb9 = function(k, a) {
    var _a;
    return _a = {}, _a[k] = a, _a;
};
function $cd78153388da00d3$export$955fdc0d24efa249(F) {
    var traverseWithIndexOF = $cd78153388da00d3$var$_traverseWithIndex($jmlhE.Ord)(F);
    return function(f) {
        return function(ta) {
            return traverseWithIndexOF(ta, f);
        };
    };
}
function $cd78153388da00d3$export$df3f009e3d155b20(F) {
    var traverseOF = $cd78153388da00d3$export$b3c6f3d9661cffba($jmlhE.Ord)(F);
    return function(f) {
        return function(ta) {
            return traverseOF(ta, f);
        };
    };
}
function $cd78153388da00d3$export$49bb65c2ea163039(F) {
    return $cd78153388da00d3$export$5d141086b2c0bc6($jmlhE.Ord)(F);
}
var $cd78153388da00d3$export$6c36d01819ecdb31 = function(F) {
    var traverseF = $cd78153388da00d3$export$df3f009e3d155b20(F);
    return function(f) {
        return function(fa) {
            return F.map((0, $72EOc.pipe)(fa, traverseF(f)), $cd78153388da00d3$export$8e16b83750b44988);
        };
    };
};
var $cd78153388da00d3$export$2439a3bc02b13b03 = function(F) {
    var traverseF = $cd78153388da00d3$export$df3f009e3d155b20(F);
    return function(f) {
        return function(fa) {
            return F.map((0, $72EOc.pipe)(fa, traverseF(f)), $cd78153388da00d3$export$709f6946f4e97408);
        };
    };
};
function $cd78153388da00d3$export$bc7c0794b9c6f3ba(f) {
    return function(r) {
        var left = {};
        var right = {};
        for(var k in r)if ($EfnK2.has.call(r, k)) {
            var e = f(k, r[k]);
            switch(e._tag){
                case 'Left':
                    left[k] = e.left;
                    break;
                case 'Right':
                    right[k] = e.right;
                    break;
            }
        }
        return (0, $1HSKK.separated)(left, right);
    };
}
function $cd78153388da00d3$export$dad5e500f2bab9bc(predicateWithIndex) {
    return function(r) {
        var left = {};
        var right = {};
        for(var k in r)if ($EfnK2.has.call(r, k)) {
            var a = r[k];
            if (predicateWithIndex(k, a)) right[k] = a;
            else left[k] = a;
        }
        return (0, $1HSKK.separated)(left, right);
    };
}
function $cd78153388da00d3$export$30c5cbe848021e97(f) {
    return function(r) {
        var out = {};
        for(var k in r)if ($EfnK2.has.call(r, k)) {
            var ob = f(k, r[k]);
            if ($EfnK2.isSome(ob)) out[k] = ob.value;
        }
        return out;
    };
}
function $cd78153388da00d3$export$36e42aef19fc7171(predicateWithIndex) {
    return function(fa) {
        var out = {};
        var changed = false;
        for(var key in fa)if ($EfnK2.has.call(fa, key)) {
            var a = fa[key];
            if (predicateWithIndex(key, a)) out[key] = a;
            else changed = true;
        }
        return changed ? out : fa;
    };
}
function $cd78153388da00d3$export$b7d5d9bb9ff52072(M, F) {
    var fromFoldableMapM = $cd78153388da00d3$export$f658682c0065ad25(M, F);
    return function(fka) {
        return fromFoldableMapM(fka, (0, $72EOc.identity));
    };
}
function $cd78153388da00d3$export$f658682c0065ad25(M, F) {
    return function(ta, f) {
        return F.reduce(ta, {}, function(r, a) {
            var _a = f(a), k = _a[0], b = _a[1];
            r[k] = $EfnK2.has.call(r, k) ? M.concat(r[k], b) : b;
            return r;
        });
    };
}
var $cd78153388da00d3$export$9f69d28786a8399c = $cd78153388da00d3$export$4aaa3912a3956cb7;
var $cd78153388da00d3$export$5150077fc2e7c662 = function(fa) {
    var out = {};
    for(var _i = 0, fa_1 = fa; _i < fa_1.length; _i++){
        var a = fa_1[_i];
        out[a[0]] = a[1];
    }
    return out;
};
function $cd78153388da00d3$export$7ecc1a3b11b57dab(predicate) {
    return function(r) {
        for(var k in r){
            if (!predicate(r[k])) return false;
        }
        return true;
    };
}
function $cd78153388da00d3$export$ad14ef4001db2bcd(predicate) {
    return function(r) {
        for(var k in r){
            if (predicate(r[k])) return true;
        }
        return false;
    };
}
function $cd78153388da00d3$export$5bf96401662340b7(E) {
    return function(a, fa) {
        if (fa === undefined) {
            var elemE_1 = $cd78153388da00d3$export$5bf96401662340b7(E);
            return function(fa) {
                return elemE_1(a, fa);
            };
        }
        for(var k in fa){
            if (E.equals(fa[k], a)) return true;
        }
        return false;
    };
}
var $cd78153388da00d3$export$971dd5b0dfd021b6 = function(M) {
    return function(second) {
        return function(first) {
            if ($cd78153388da00d3$export$dd1bc94b04021eeb(first)) return second;
            if ($cd78153388da00d3$export$dd1bc94b04021eeb(second)) return first;
            var out = {};
            for(var k in first)if ($cd78153388da00d3$export$a4f4bb6b1453fff5(k, second)) out[k] = M.concat(first[k], second[k]);
            else out[k] = first[k];
            for(var k in second)if (!$cd78153388da00d3$export$a4f4bb6b1453fff5(k, out)) out[k] = second[k];
            return out;
        };
    };
};
var $cd78153388da00d3$export$bc86dfbf7795668c = function(M) {
    return function(second) {
        return function(first) {
            if ($cd78153388da00d3$export$dd1bc94b04021eeb(first) || $cd78153388da00d3$export$dd1bc94b04021eeb(second)) return $cd78153388da00d3$export$6e22c362a0406a2c;
            var out = {};
            for(var k in first)if ($cd78153388da00d3$export$a4f4bb6b1453fff5(k, second)) out[k] = M.concat(first[k], second[k]);
            return out;
        };
    };
};
var $cd78153388da00d3$export$acaf96a27438246b = function(second) {
    return function(first) {
        if ($cd78153388da00d3$export$dd1bc94b04021eeb(first)) return second;
        if ($cd78153388da00d3$export$dd1bc94b04021eeb(second)) return first;
        var out = {};
        for(var k in first)if (!$cd78153388da00d3$export$a4f4bb6b1453fff5(k, second)) out[k] = first[k];
        for(var k in second)if (!$cd78153388da00d3$export$a4f4bb6b1453fff5(k, first)) out[k] = second[k];
        return out;
    };
};
var $cd78153388da00d3$export$a0135aecf4a782ab = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $cd78153388da00d3$export$871de8747c9eaa88(f));
};
var $cd78153388da00d3$export$45e3e46323e6d66c = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $cd78153388da00d3$export$8f07ddce13659f50(f));
};
var $cd78153388da00d3$export$8eef5fdba9512999 = function(O) {
    var reduceO = $cd78153388da00d3$export$533b26079ad0b4b(O);
    return function(fa, b, f) {
        return (0, $72EOc.pipe)(fa, reduceO(b, f));
    };
};
var $cd78153388da00d3$export$11b0d0e0b70641d9 = function(O) {
    return function(M) {
        var foldMapM = $cd78153388da00d3$export$b66cdc0497d8a99a(O)(M);
        return function(fa, f) {
            return (0, $72EOc.pipe)(fa, foldMapM(f));
        };
    };
};
var $cd78153388da00d3$export$ec882fc9def9e5db = function(O) {
    var reduceRightO = $cd78153388da00d3$export$7fef8bcdbb34f435(O);
    return function(fa, b, f) {
        return (0, $72EOc.pipe)(fa, reduceRightO(b, f));
    };
};
var $cd78153388da00d3$export$ec7439dc64f73058 = function(fa, predicate) {
    return (0, $72EOc.pipe)(fa, $cd78153388da00d3$export$3dea766d36a8935f(predicate));
};
var $cd78153388da00d3$export$e8609d6e184911e6 = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $cd78153388da00d3$export$a04c6c6965dd4709(f));
};
var $cd78153388da00d3$export$8d112ad5a197e16a = function(fa, predicate) {
    return (0, $72EOc.pipe)(fa, $cd78153388da00d3$export$b29f828819edca8d(predicate));
};
var $cd78153388da00d3$export$f721fb25a1c72a8d = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $cd78153388da00d3$export$3117e3f9ececb6bc(f));
};
var $cd78153388da00d3$export$dd5ca3bcbad0b6af = function(O) {
    var reduceWithIndexO = $cd78153388da00d3$export$bbd3ef8720e22369(O);
    return function(fa, b, f) {
        return (0, $72EOc.pipe)(fa, reduceWithIndexO(b, f));
    };
};
var $cd78153388da00d3$export$e08bbf939bdc3250 = function(O) {
    var foldMapWithIndexO = $cd78153388da00d3$export$18153bb1181268e5(O);
    return function(M) {
        var foldMapWithIndexM = foldMapWithIndexO(M);
        return function(fa, f) {
            return (0, $72EOc.pipe)(fa, foldMapWithIndexM(f));
        };
    };
};
var $cd78153388da00d3$export$3b7618311030b1af = function(O) {
    var reduceRightWithIndexO = $cd78153388da00d3$export$ce2b2fe0b88ccd0a(O);
    return function(fa, b, f) {
        return (0, $72EOc.pipe)(fa, reduceRightWithIndexO(b, f));
    };
};
var $cd78153388da00d3$export$18034ec93490e9d2 = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $cd78153388da00d3$export$bc7c0794b9c6f3ba(f));
};
var $cd78153388da00d3$export$31601036bfbf1c76 = function(fa, predicateWithIndex) {
    return (0, $72EOc.pipe)(fa, $cd78153388da00d3$export$dad5e500f2bab9bc(predicateWithIndex));
};
var $cd78153388da00d3$export$ac207938ecd8ddc4 = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $cd78153388da00d3$export$30c5cbe848021e97(f));
};
var $cd78153388da00d3$export$560430393fed15de = function(fa, predicateWithIndex) {
    return (0, $72EOc.pipe)(fa, $cd78153388da00d3$export$36e42aef19fc7171(predicateWithIndex));
};
var $cd78153388da00d3$export$b3c6f3d9661cffba = function(O) {
    var traverseWithIndexO = $cd78153388da00d3$var$_traverseWithIndex(O);
    return function(F) {
        var traverseWithIndexOF = traverseWithIndexO(F);
        return function(ta, f) {
            return traverseWithIndexOF(ta, (0, $72EOc.flow)((0, $72EOc.SK), f));
        };
    };
};
var $cd78153388da00d3$export$5d141086b2c0bc6 = function(O) {
    var traverseO = $cd78153388da00d3$export$b3c6f3d9661cffba(O);
    return function(F) {
        var traverseOF = traverseO(F);
        return function(ta) {
            return traverseOF(ta, (0, $72EOc.identity));
        };
    };
};
var $cd78153388da00d3$var$_traverseWithIndex = function(O) {
    return function(F) {
        var keysO = $cd78153388da00d3$var$keys_(O);
        return function(ta, f) {
            var ks = keysO(ta);
            if (ks.length === 0) return F.of($cd78153388da00d3$export$6e22c362a0406a2c);
            var fr = F.of({});
            var _loop_1 = function(key) {
                fr = F.ap(F.map(fr, function(r) {
                    return function(b) {
                        var _a;
                        return Object.assign({}, r, (_a = {}, _a[key] = b, _a));
                    };
                }), f(key, ta[key]));
            };
            for(var _i = 0, ks_1 = ks; _i < ks_1.length; _i++){
                var key = ks_1[_i];
                _loop_1(key);
            }
            return fr;
        };
    };
};
var $cd78153388da00d3$export$3dea766d36a8935f = function(predicate) {
    return $cd78153388da00d3$export$36e42aef19fc7171(function(_, a) {
        return predicate(a);
    });
};
var $cd78153388da00d3$export$a04c6c6965dd4709 = function(f) {
    return $cd78153388da00d3$export$30c5cbe848021e97(function(_, a) {
        return f(a);
    });
};
var $cd78153388da00d3$export$b29f828819edca8d = function(predicate) {
    return $cd78153388da00d3$export$dad5e500f2bab9bc(function(_, a) {
        return predicate(a);
    });
};
var $cd78153388da00d3$export$3117e3f9ececb6bc = function(f) {
    return $cd78153388da00d3$export$bc7c0794b9c6f3ba(function(_, a) {
        return f(a);
    });
};
function $cd78153388da00d3$export$533b26079ad0b4b() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 1) {
        var reduceWithIndexO_1 = $cd78153388da00d3$export$bbd3ef8720e22369(args[0]);
        return function(b, f) {
            return reduceWithIndexO_1(b, function(_, b, a) {
                return f(b, a);
            });
        };
    }
    return $cd78153388da00d3$export$533b26079ad0b4b($jmlhE.Ord).apply(void 0, args);
}
function $cd78153388da00d3$export$b66cdc0497d8a99a(O) {
    if ('compare' in O) {
        var foldMapWithIndexO_1 = $cd78153388da00d3$export$18153bb1181268e5(O);
        return function(M) {
            var foldMapWithIndexM = foldMapWithIndexO_1(M);
            return function(f) {
                return foldMapWithIndexM(function(_, a) {
                    return f(a);
                });
            };
        };
    }
    return $cd78153388da00d3$export$b66cdc0497d8a99a($jmlhE.Ord)(O);
}
function $cd78153388da00d3$export$7fef8bcdbb34f435() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 1) {
        var reduceRightWithIndexO_1 = $cd78153388da00d3$export$ce2b2fe0b88ccd0a(args[0]);
        return function(b, f) {
            return reduceRightWithIndexO_1(b, function(_, b, a) {
                return f(b, a);
            });
        };
    }
    return $cd78153388da00d3$export$7fef8bcdbb34f435($jmlhE.Ord).apply(void 0, args);
}
var $cd78153388da00d3$export$8e16b83750b44988 = function(r) {
    var out = {};
    for(var k in r)if ($EfnK2.has.call(r, k)) {
        var oa = r[k];
        if ($EfnK2.isSome(oa)) out[k] = oa.value;
    }
    return out;
};
var $cd78153388da00d3$export$709f6946f4e97408 = function(r) {
    var left = {};
    var right = {};
    for(var k in r)if ($EfnK2.has.call(r, k)) {
        var e = r[k];
        if ($EfnK2.isLeft(e)) left[k] = e.left;
        else right[k] = e.right;
    }
    return (0, $1HSKK.separated)(left, right);
};
var $cd78153388da00d3$export$9156e739aa33e19f = 'ReadonlyRecord';
function $cd78153388da00d3$export$3cb5cd7f7776c81(O) {
    if ('compare' in O) return function(S) {
        return {
            show: function(r) {
                var elements = $cd78153388da00d3$export$bb44f104e3c54dae(O)(function(k, a) {
                    return "".concat(JSON.stringify(k), ": ").concat(S.show(a));
                })(r).join(', ');
                return elements === '' ? '{}' : "{ ".concat(elements, " }");
            }
        };
    };
    return $cd78153388da00d3$export$3cb5cd7f7776c81($jmlhE.Ord)(O);
}
function $cd78153388da00d3$export$804fed467fde44e4(E) {
    var isSubrecordE = $cd78153388da00d3$export$36e6f76a1d117b8a(E);
    return (0, $3Md1m.fromEquals)(function(x, y) {
        return isSubrecordE(x)(y) && isSubrecordE(y)(x);
    });
}
function $cd78153388da00d3$export$c2a7ef2cc9b32b31(S) {
    return {
        concat: function(first, second) {
            if ($cd78153388da00d3$export$dd1bc94b04021eeb(first)) return second;
            if ($cd78153388da00d3$export$dd1bc94b04021eeb(second)) return first;
            var r = Object.assign({}, first);
            for(var k in second)if ($EfnK2.has.call(second, k)) r[k] = $EfnK2.has.call(first, k) ? S.concat(first[k], second[k]) : second[k];
            return r;
        },
        empty: $cd78153388da00d3$export$6e22c362a0406a2c
    };
}
var $cd78153388da00d3$export$bd5b6bfc5fa2ee61 = {
    URI: $cd78153388da00d3$export$9156e739aa33e19f,
    map: $cd78153388da00d3$export$a0135aecf4a782ab
};
var $cd78153388da00d3$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $cpwuW.flap)($cd78153388da00d3$export$bd5b6bfc5fa2ee61);
var $cd78153388da00d3$export$9fdffe0fe1e91cad = {
    URI: $cd78153388da00d3$export$9156e739aa33e19f,
    map: $cd78153388da00d3$export$a0135aecf4a782ab,
    mapWithIndex: $cd78153388da00d3$export$45e3e46323e6d66c
};
var $cd78153388da00d3$export$d544f02c7cebdaed = function(O) {
    return {
        URI: $cd78153388da00d3$export$9156e739aa33e19f,
        reduce: $cd78153388da00d3$export$8eef5fdba9512999(O),
        foldMap: $cd78153388da00d3$export$11b0d0e0b70641d9(O),
        reduceRight: $cd78153388da00d3$export$ec882fc9def9e5db(O)
    };
};
var $cd78153388da00d3$export$6c59d75f118e7bc9 = function(O) {
    return {
        URI: $cd78153388da00d3$export$9156e739aa33e19f,
        reduce: $cd78153388da00d3$export$8eef5fdba9512999(O),
        foldMap: $cd78153388da00d3$export$11b0d0e0b70641d9(O),
        reduceRight: $cd78153388da00d3$export$ec882fc9def9e5db(O),
        reduceWithIndex: $cd78153388da00d3$export$dd5ca3bcbad0b6af(O),
        foldMapWithIndex: $cd78153388da00d3$export$e08bbf939bdc3250(O),
        reduceRightWithIndex: $cd78153388da00d3$export$3b7618311030b1af(O)
    };
};
var $cd78153388da00d3$export$4a21ac48141ac3c9 = {
    URI: $cd78153388da00d3$export$9156e739aa33e19f,
    compact: $cd78153388da00d3$export$8e16b83750b44988,
    separate: $cd78153388da00d3$export$709f6946f4e97408
};
var $cd78153388da00d3$export$d00e1c48fb621173 = {
    URI: $cd78153388da00d3$export$9156e739aa33e19f,
    map: $cd78153388da00d3$export$a0135aecf4a782ab,
    compact: $cd78153388da00d3$export$8e16b83750b44988,
    separate: $cd78153388da00d3$export$709f6946f4e97408,
    filter: $cd78153388da00d3$export$ec7439dc64f73058,
    filterMap: $cd78153388da00d3$export$e8609d6e184911e6,
    partition: $cd78153388da00d3$export$8d112ad5a197e16a,
    partitionMap: $cd78153388da00d3$export$f721fb25a1c72a8d
};
var $cd78153388da00d3$export$c29a647071e542ec = {
    URI: $cd78153388da00d3$export$9156e739aa33e19f,
    map: $cd78153388da00d3$export$a0135aecf4a782ab,
    mapWithIndex: $cd78153388da00d3$export$45e3e46323e6d66c,
    compact: $cd78153388da00d3$export$8e16b83750b44988,
    separate: $cd78153388da00d3$export$709f6946f4e97408,
    filter: $cd78153388da00d3$export$ec7439dc64f73058,
    filterMap: $cd78153388da00d3$export$e8609d6e184911e6,
    partition: $cd78153388da00d3$export$8d112ad5a197e16a,
    partitionMap: $cd78153388da00d3$export$f721fb25a1c72a8d,
    filterMapWithIndex: $cd78153388da00d3$export$ac207938ecd8ddc4,
    filterWithIndex: $cd78153388da00d3$export$560430393fed15de,
    partitionMapWithIndex: $cd78153388da00d3$export$18034ec93490e9d2,
    partitionWithIndex: $cd78153388da00d3$export$31601036bfbf1c76
};
var $cd78153388da00d3$export$4e0ffba11065d2c1 = function(O) {
    return {
        URI: $cd78153388da00d3$export$9156e739aa33e19f,
        map: $cd78153388da00d3$export$a0135aecf4a782ab,
        reduce: $cd78153388da00d3$export$8eef5fdba9512999(O),
        foldMap: $cd78153388da00d3$export$11b0d0e0b70641d9(O),
        reduceRight: $cd78153388da00d3$export$ec882fc9def9e5db(O),
        traverse: $cd78153388da00d3$export$b3c6f3d9661cffba(O),
        sequence: $cd78153388da00d3$export$5d141086b2c0bc6(O)
    };
};
var $cd78153388da00d3$export$46b81797a3375b8c = function(O) {
    return {
        URI: $cd78153388da00d3$export$9156e739aa33e19f,
        map: $cd78153388da00d3$export$a0135aecf4a782ab,
        mapWithIndex: $cd78153388da00d3$export$45e3e46323e6d66c,
        reduce: $cd78153388da00d3$export$8eef5fdba9512999(O),
        foldMap: $cd78153388da00d3$export$11b0d0e0b70641d9(O),
        reduceRight: $cd78153388da00d3$export$ec882fc9def9e5db(O),
        reduceWithIndex: $cd78153388da00d3$export$dd5ca3bcbad0b6af(O),
        foldMapWithIndex: $cd78153388da00d3$export$e08bbf939bdc3250(O),
        reduceRightWithIndex: $cd78153388da00d3$export$3b7618311030b1af(O),
        traverse: $cd78153388da00d3$export$b3c6f3d9661cffba(O),
        sequence: $cd78153388da00d3$export$5d141086b2c0bc6(O),
        traverseWithIndex: $cd78153388da00d3$var$_traverseWithIndex(O)
    };
};
var $cd78153388da00d3$export$bb8ef26a634cac7b = function(O) {
    var T = $cd78153388da00d3$export$4e0ffba11065d2c1(O);
    return {
        URI: $cd78153388da00d3$export$9156e739aa33e19f,
        map: $cd78153388da00d3$export$a0135aecf4a782ab,
        reduce: $cd78153388da00d3$export$8eef5fdba9512999(O),
        foldMap: $cd78153388da00d3$export$11b0d0e0b70641d9(O),
        reduceRight: $cd78153388da00d3$export$ec882fc9def9e5db(O),
        traverse: T.traverse,
        sequence: T.sequence,
        compact: $cd78153388da00d3$export$8e16b83750b44988,
        separate: $cd78153388da00d3$export$709f6946f4e97408,
        filter: $cd78153388da00d3$export$ec7439dc64f73058,
        filterMap: $cd78153388da00d3$export$e8609d6e184911e6,
        partition: $cd78153388da00d3$export$8d112ad5a197e16a,
        partitionMap: $cd78153388da00d3$export$f721fb25a1c72a8d,
        wither: (0, $jNYdc.witherDefault)(T, $cd78153388da00d3$export$4a21ac48141ac3c9),
        wilt: (0, $jNYdc.wiltDefault)(T, $cd78153388da00d3$export$4a21ac48141ac3c9)
    };
};
var $cd78153388da00d3$export$baca17b4aff42f82 = function(S) {
    var unionS = $cd78153388da00d3$export$971dd5b0dfd021b6(S);
    return {
        concat: function(first, second) {
            return unionS(second)(first);
        }
    };
};
var $cd78153388da00d3$export$c487aac9f4157837 = function(S) {
    return {
        concat: $cd78153388da00d3$export$baca17b4aff42f82(S).concat,
        empty: $cd78153388da00d3$export$6e22c362a0406a2c
    };
};
var $cd78153388da00d3$export$d379a869a72e4055 = function(S) {
    var intersectionS = $cd78153388da00d3$export$bc86dfbf7795668c(S);
    return {
        concat: function(first, second) {
            return intersectionS(second)(first);
        }
    };
};
var $cd78153388da00d3$export$fdb3296ca0a124e3 = function() {
    return {
        concat: function(first, second) {
            return $cd78153388da00d3$export$acaf96a27438246b(second)(first);
        }
    };
};
var $cd78153388da00d3$export$41404b31838667c9 = {
    URI: $cd78153388da00d3$export$9156e739aa33e19f,
    reduce: /*#__PURE__*/ $cd78153388da00d3$export$8eef5fdba9512999($jmlhE.Ord),
    foldMap: /*#__PURE__*/ $cd78153388da00d3$export$11b0d0e0b70641d9($jmlhE.Ord),
    reduceRight: /*#__PURE__*/ $cd78153388da00d3$export$ec882fc9def9e5db($jmlhE.Ord)
};
var $cd78153388da00d3$export$e8f7d17aaff345cb = {
    URI: $cd78153388da00d3$export$9156e739aa33e19f,
    reduce: /*#__PURE__*/ $cd78153388da00d3$export$8eef5fdba9512999($jmlhE.Ord),
    foldMap: /*#__PURE__*/ $cd78153388da00d3$export$11b0d0e0b70641d9($jmlhE.Ord),
    reduceRight: /*#__PURE__*/ $cd78153388da00d3$export$ec882fc9def9e5db($jmlhE.Ord),
    reduceWithIndex: /*#__PURE__*/ $cd78153388da00d3$export$dd5ca3bcbad0b6af($jmlhE.Ord),
    foldMapWithIndex: /*#__PURE__*/ $cd78153388da00d3$export$e08bbf939bdc3250($jmlhE.Ord),
    reduceRightWithIndex: /*#__PURE__*/ $cd78153388da00d3$export$3b7618311030b1af($jmlhE.Ord)
};
var $cd78153388da00d3$export$a0202666c3bda011 = {
    URI: $cd78153388da00d3$export$9156e739aa33e19f,
    map: $cd78153388da00d3$export$a0135aecf4a782ab,
    reduce: /*#__PURE__*/ $cd78153388da00d3$export$8eef5fdba9512999($jmlhE.Ord),
    foldMap: /*#__PURE__*/ $cd78153388da00d3$export$11b0d0e0b70641d9($jmlhE.Ord),
    reduceRight: /*#__PURE__*/ $cd78153388da00d3$export$ec882fc9def9e5db($jmlhE.Ord),
    traverse: /*#__PURE__*/ $cd78153388da00d3$export$b3c6f3d9661cffba($jmlhE.Ord),
    sequence: $cd78153388da00d3$export$49bb65c2ea163039
};
var $cd78153388da00d3$export$bd7b528d8c36ec41 = {
    URI: $cd78153388da00d3$export$9156e739aa33e19f,
    map: $cd78153388da00d3$export$a0135aecf4a782ab,
    mapWithIndex: $cd78153388da00d3$export$45e3e46323e6d66c,
    reduce: /*#__PURE__*/ $cd78153388da00d3$export$8eef5fdba9512999($jmlhE.Ord),
    foldMap: /*#__PURE__*/ $cd78153388da00d3$export$11b0d0e0b70641d9($jmlhE.Ord),
    reduceRight: /*#__PURE__*/ $cd78153388da00d3$export$ec882fc9def9e5db($jmlhE.Ord),
    reduceWithIndex: /*#__PURE__*/ $cd78153388da00d3$export$dd5ca3bcbad0b6af($jmlhE.Ord),
    foldMapWithIndex: /*#__PURE__*/ $cd78153388da00d3$export$e08bbf939bdc3250($jmlhE.Ord),
    reduceRightWithIndex: /*#__PURE__*/ $cd78153388da00d3$export$3b7618311030b1af($jmlhE.Ord),
    traverse: /*#__PURE__*/ $cd78153388da00d3$export$b3c6f3d9661cffba($jmlhE.Ord),
    sequence: $cd78153388da00d3$export$49bb65c2ea163039,
    traverseWithIndex: /*#__PURE__*/ $cd78153388da00d3$var$_traverseWithIndex($jmlhE.Ord)
};
var $cd78153388da00d3$var$_wither = /*#__PURE__*/ (0, $jNYdc.witherDefault)($cd78153388da00d3$export$a0202666c3bda011, $cd78153388da00d3$export$4a21ac48141ac3c9);
var $cd78153388da00d3$var$_wilt = /*#__PURE__*/ (0, $jNYdc.wiltDefault)($cd78153388da00d3$export$a0202666c3bda011, $cd78153388da00d3$export$4a21ac48141ac3c9);
var $cd78153388da00d3$export$748d317b4c426f96 = {
    URI: $cd78153388da00d3$export$9156e739aa33e19f,
    map: $cd78153388da00d3$export$a0135aecf4a782ab,
    reduce: /*#__PURE__*/ $cd78153388da00d3$export$8eef5fdba9512999($jmlhE.Ord),
    foldMap: /*#__PURE__*/ $cd78153388da00d3$export$11b0d0e0b70641d9($jmlhE.Ord),
    reduceRight: /*#__PURE__*/ $cd78153388da00d3$export$ec882fc9def9e5db($jmlhE.Ord),
    traverse: /*#__PURE__*/ $cd78153388da00d3$export$b3c6f3d9661cffba($jmlhE.Ord),
    sequence: $cd78153388da00d3$export$49bb65c2ea163039,
    compact: $cd78153388da00d3$export$8e16b83750b44988,
    separate: $cd78153388da00d3$export$709f6946f4e97408,
    filter: $cd78153388da00d3$export$ec7439dc64f73058,
    filterMap: $cd78153388da00d3$export$e8609d6e184911e6,
    partition: $cd78153388da00d3$export$8d112ad5a197e16a,
    partitionMap: $cd78153388da00d3$export$f721fb25a1c72a8d,
    wither: $cd78153388da00d3$var$_wither,
    wilt: $cd78153388da00d3$var$_wilt
};
var $cd78153388da00d3$export$9f200c4466975173 = $cd78153388da00d3$export$ff82449ce381c54a;
function $cd78153388da00d3$export$5a15a386532a5ea4(k, r) {
    return $EfnK2.has.call(r === undefined ? this : r, k);
}
var $cd78153388da00d3$export$74b9182b22de2bc1 = {
    URI: $cd78153388da00d3$export$9156e739aa33e19f,
    map: $cd78153388da00d3$export$a0135aecf4a782ab,
    reduce: /*#__PURE__*/ $cd78153388da00d3$export$8eef5fdba9512999($jmlhE.Ord),
    foldMap: /*#__PURE__*/ $cd78153388da00d3$export$11b0d0e0b70641d9($jmlhE.Ord),
    reduceRight: /*#__PURE__*/ $cd78153388da00d3$export$ec882fc9def9e5db($jmlhE.Ord),
    traverse: /*#__PURE__*/ $cd78153388da00d3$export$b3c6f3d9661cffba($jmlhE.Ord),
    sequence: $cd78153388da00d3$export$49bb65c2ea163039,
    compact: $cd78153388da00d3$export$8e16b83750b44988,
    separate: $cd78153388da00d3$export$709f6946f4e97408,
    filter: $cd78153388da00d3$export$ec7439dc64f73058,
    filterMap: $cd78153388da00d3$export$e8609d6e184911e6,
    partition: $cd78153388da00d3$export$8d112ad5a197e16a,
    partitionMap: $cd78153388da00d3$export$f721fb25a1c72a8d,
    mapWithIndex: $cd78153388da00d3$export$45e3e46323e6d66c,
    reduceWithIndex: /*#__PURE__*/ $cd78153388da00d3$export$dd5ca3bcbad0b6af($jmlhE.Ord),
    foldMapWithIndex: /*#__PURE__*/ $cd78153388da00d3$export$e08bbf939bdc3250($jmlhE.Ord),
    reduceRightWithIndex: /*#__PURE__*/ $cd78153388da00d3$export$3b7618311030b1af($jmlhE.Ord),
    filterMapWithIndex: $cd78153388da00d3$export$ac207938ecd8ddc4,
    filterWithIndex: $cd78153388da00d3$export$560430393fed15de,
    partitionMapWithIndex: $cd78153388da00d3$export$18034ec93490e9d2,
    partitionWithIndex: $cd78153388da00d3$export$31601036bfbf1c76,
    traverseWithIndex: /*#__PURE__*/ $cd78153388da00d3$var$_traverseWithIndex($jmlhE.Ord),
    wither: $cd78153388da00d3$var$_wither,
    wilt: $cd78153388da00d3$var$_wilt
};

});
parcelRegister("jmlhE", function(module, exports) {

$parcel$export(module.exports, "Ord", () => $e18094e42952cec8$export$ee8aa95bfab51c5);

var $ecsM6 = parcelRequire("ecsM6");
var $e18094e42952cec8$export$a2050e5b0c4dcf10 = {
    equals: function(first, second) {
        return first === second;
    }
};
var $e18094e42952cec8$export$c16b1dbe8a4166b6 = {
    concat: function(first, second) {
        return first + second;
    }
};
var $e18094e42952cec8$export$6e22c362a0406a2c = '';
var $e18094e42952cec8$export$8f55868b713abdc3 = {
    concat: $e18094e42952cec8$export$c16b1dbe8a4166b6.concat,
    empty: $e18094e42952cec8$export$6e22c362a0406a2c
};
var $e18094e42952cec8$export$ee8aa95bfab51c5 = {
    equals: $e18094e42952cec8$export$a2050e5b0c4dcf10.equals,
    compare: function(first, second) {
        return first < second ? -1 : first > second ? 1 : 0;
    }
};
var $e18094e42952cec8$export$f6a3d19be20f5819 = {
    show: function(s) {
        return JSON.stringify(s);
    }
};
var $e18094e42952cec8$export$844ec244b1367d54 = function(u) {
    return typeof u === 'string';
};
var $e18094e42952cec8$export$d80c591a9e16646 = function(s) {
    return s.toUpperCase();
};
var $e18094e42952cec8$export$84b9399c77df0edf = function(s) {
    return s.toLowerCase();
};
var $e18094e42952cec8$export$77ad94ebf1c2b9ed = function(searchValue, replaceValue) {
    return function(s) {
        return s.replace(searchValue, replaceValue);
    };
};
var $e18094e42952cec8$export$87c2784dc9fc4ab = function(s) {
    return s.trim();
};
var $e18094e42952cec8$export$c5557f40488c48ec = function(s) {
    return s.trimLeft();
};
var $e18094e42952cec8$export$da8e5da96e287379 = function(s) {
    return s.trimRight();
};
var $e18094e42952cec8$export$58adb3bec8346d0f = function(start, end) {
    return function(s) {
        return s.slice(start, end);
    };
};
var $e18094e42952cec8$export$dd1bc94b04021eeb = function(s) {
    return s.length === 0;
};
var $e18094e42952cec8$export$346677f925de839c = function(s) {
    return s.length;
};
var $e18094e42952cec8$export$65980d18b75784e2 = function(separator) {
    return function(s) {
        var out = s.split(separator);
        return (0, $ecsM6.isNonEmpty)(out) ? out : [
            s
        ];
    };
};
var $e18094e42952cec8$export$ee2e0f811dca1807 = function(searchString, position) {
    return function(s) {
        return s.includes(searchString, position);
    };
};
var $e18094e42952cec8$export$68326237475e9a7d = function(searchString, position) {
    return function(s) {
        return s.startsWith(searchString, position);
    };
};
var $e18094e42952cec8$export$10fdab3683b55b22 = function(searchString, position) {
    return function(s) {
        return s.endsWith(searchString, position);
    };
};

});


parcelRegister("2BN86", function(module, exports) {

$parcel$export(module.exports, "left", () => $1e6525975b6cc660$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "right", () => $1e6525975b6cc660$export$79ffe56a765070d2);
$parcel$export(module.exports, "isLeft", () => $1e6525975b6cc660$export$d649b6842e09f2b);

var $9xys1 = parcelRequire("9xys1");

var $aYN4d = parcelRequire("aYN4d");

var $kgj0x = parcelRequire("kgj0x");

var $5CEm3 = parcelRequire("5CEm3");

var $jFfj2 = parcelRequire("jFfj2");

var $72EOc = parcelRequire("72EOc");

var $cpwuW = parcelRequire("cpwuW");

var $EfnK2 = parcelRequire("EfnK2");

var $1HSKK = parcelRequire("1HSKK");

var $jNYdc = parcelRequire("jNYdc");
var $1e6525975b6cc660$export$eabcd2c8791e7bf4 = $EfnK2.left;
var $1e6525975b6cc660$export$79ffe56a765070d2 = $EfnK2.right;
var $1e6525975b6cc660$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $72EOc.dual)(2, function(ma, f) {
    return $1e6525975b6cc660$export$d649b6842e09f2b(ma) ? ma : f(ma.right);
});
var $1e6525975b6cc660$var$_map = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $1e6525975b6cc660$export$871de8747c9eaa88(f));
};
var $1e6525975b6cc660$var$_ap = function(fab, fa) {
    return (0, $72EOc.pipe)(fab, $1e6525975b6cc660$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $1e6525975b6cc660$var$_reduce = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $1e6525975b6cc660$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $1e6525975b6cc660$var$_foldMap = function(M) {
    return function(fa, f) {
        var foldMapM = $1e6525975b6cc660$export$b66cdc0497d8a99a(M);
        return (0, $72EOc.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $1e6525975b6cc660$var$_reduceRight = function(fa, b, f) {
    return (0, $72EOc.pipe)(fa, $1e6525975b6cc660$export$7fef8bcdbb34f435(b, f));
};
var $1e6525975b6cc660$var$_traverse = function(F) {
    var traverseF = $1e6525975b6cc660$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $72EOc.pipe)(ta, traverseF(f));
    };
};
var $1e6525975b6cc660$var$_bimap = function(fa, f, g) {
    return (0, $72EOc.pipe)(fa, $1e6525975b6cc660$export$eb54baf0b342cb1d(f, g));
};
var $1e6525975b6cc660$var$_mapLeft = function(fa, f) {
    return (0, $72EOc.pipe)(fa, $1e6525975b6cc660$export$472de43a55e4aa49(f));
};
/* istanbul ignore next */ var $1e6525975b6cc660$var$_alt = function(fa, that) {
    return (0, $72EOc.pipe)(fa, $1e6525975b6cc660$export$228be17d80722ab(that));
};
/* istanbul ignore next */ var $1e6525975b6cc660$var$_extend = function(wa, f) {
    return (0, $72EOc.pipe)(wa, $1e6525975b6cc660$export$8b58be045bf06082(f));
};
var $1e6525975b6cc660$var$_chainRec = function(a, f) {
    return (0, $5CEm3.tailRec)(f(a), function(e) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(e) ? $1e6525975b6cc660$export$79ffe56a765070d2($1e6525975b6cc660$export$eabcd2c8791e7bf4(e.left)) : $1e6525975b6cc660$export$d649b6842e09f2b(e.right) ? $1e6525975b6cc660$export$eabcd2c8791e7bf4(f(e.right.left)) : $1e6525975b6cc660$export$79ffe56a765070d2($1e6525975b6cc660$export$79ffe56a765070d2(e.right.right));
    });
};
var $1e6525975b6cc660$export$9156e739aa33e19f = 'Either';
var $1e6525975b6cc660$export$3cb5cd7f7776c81 = function(SE, SA) {
    return {
        show: function(ma) {
            return $1e6525975b6cc660$export$d649b6842e09f2b(ma) ? "left(".concat(SE.show(ma.left), ")") : "right(".concat(SA.show(ma.right), ")");
        }
    };
};
var $1e6525975b6cc660$export$804fed467fde44e4 = function(EL, EA) {
    return {
        equals: function(x, y) {
            return x === y || ($1e6525975b6cc660$export$d649b6842e09f2b(x) ? $1e6525975b6cc660$export$d649b6842e09f2b(y) && EL.equals(x.left, y.left) : $1e6525975b6cc660$export$a9d71693f0c1a85d(y) && EA.equals(x.right, y.right));
        }
    };
};
var $1e6525975b6cc660$export$e759a9a7f8d04692 = function(S) {
    return {
        concat: function(x, y) {
            return $1e6525975b6cc660$export$d649b6842e09f2b(y) ? x : $1e6525975b6cc660$export$d649b6842e09f2b(x) ? y : $1e6525975b6cc660$export$79ffe56a765070d2(S.concat(x.right, y.right));
        }
    };
};
var $1e6525975b6cc660$export$cfae3069ac05ff4c = function(M) {
    var empty = $1e6525975b6cc660$export$eabcd2c8791e7bf4(M.empty);
    return {
        URI: $1e6525975b6cc660$export$9156e739aa33e19f,
        _E: undefined,
        compact: function(ma) {
            return $1e6525975b6cc660$export$d649b6842e09f2b(ma) ? ma : ma.right._tag === 'None' ? empty : $1e6525975b6cc660$export$79ffe56a765070d2(ma.right.value);
        },
        separate: function(ma) {
            return $1e6525975b6cc660$export$d649b6842e09f2b(ma) ? (0, $1HSKK.separated)(ma, ma) : $1e6525975b6cc660$export$d649b6842e09f2b(ma.right) ? (0, $1HSKK.separated)($1e6525975b6cc660$export$79ffe56a765070d2(ma.right.left), empty) : (0, $1HSKK.separated)(empty, $1e6525975b6cc660$export$79ffe56a765070d2(ma.right.right));
        }
    };
};
var $1e6525975b6cc660$export$a4e870b0a57ec14e = function(M) {
    var empty = $1e6525975b6cc660$export$eabcd2c8791e7bf4(M.empty);
    var _a = $1e6525975b6cc660$export$cfae3069ac05ff4c(M), compact = _a.compact, separate = _a.separate;
    var filter = function(ma, predicate) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(ma) ? ma : predicate(ma.right) ? ma : empty;
    };
    var partition = function(ma, p) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(ma) ? (0, $1HSKK.separated)(ma, ma) : p(ma.right) ? (0, $1HSKK.separated)(empty, $1e6525975b6cc660$export$79ffe56a765070d2(ma.right)) : (0, $1HSKK.separated)($1e6525975b6cc660$export$79ffe56a765070d2(ma.right), empty);
    };
    return {
        URI: $1e6525975b6cc660$export$9156e739aa33e19f,
        _E: undefined,
        map: $1e6525975b6cc660$var$_map,
        compact: compact,
        separate: separate,
        filter: filter,
        filterMap: function(ma, f) {
            if ($1e6525975b6cc660$export$d649b6842e09f2b(ma)) return ma;
            var ob = f(ma.right);
            return ob._tag === 'None' ? empty : $1e6525975b6cc660$export$79ffe56a765070d2(ob.value);
        },
        partition: partition,
        partitionMap: function(ma, f) {
            if ($1e6525975b6cc660$export$d649b6842e09f2b(ma)) return (0, $1HSKK.separated)(ma, ma);
            var e = f(ma.right);
            return $1e6525975b6cc660$export$d649b6842e09f2b(e) ? (0, $1HSKK.separated)($1e6525975b6cc660$export$79ffe56a765070d2(e.left), empty) : (0, $1HSKK.separated)(empty, $1e6525975b6cc660$export$79ffe56a765070d2(e.right));
        }
    };
};
var $1e6525975b6cc660$export$bb8ef26a634cac7b = function(M) {
    var F_ = $1e6525975b6cc660$export$a4e870b0a57ec14e(M);
    var C = $1e6525975b6cc660$export$cfae3069ac05ff4c(M);
    return {
        URI: $1e6525975b6cc660$export$9156e739aa33e19f,
        _E: undefined,
        map: $1e6525975b6cc660$var$_map,
        compact: F_.compact,
        separate: F_.separate,
        filter: F_.filter,
        filterMap: F_.filterMap,
        partition: F_.partition,
        partitionMap: F_.partitionMap,
        traverse: $1e6525975b6cc660$var$_traverse,
        sequence: $1e6525975b6cc660$export$49bb65c2ea163039,
        reduce: $1e6525975b6cc660$var$_reduce,
        foldMap: $1e6525975b6cc660$var$_foldMap,
        reduceRight: $1e6525975b6cc660$var$_reduceRight,
        wither: (0, $jNYdc.witherDefault)($1e6525975b6cc660$export$a0202666c3bda011, C),
        wilt: (0, $jNYdc.wiltDefault)($1e6525975b6cc660$export$a0202666c3bda011, C)
    };
};
var $1e6525975b6cc660$export$d9540e18497e6036 = function(SE) {
    return {
        URI: $1e6525975b6cc660$export$9156e739aa33e19f,
        _E: undefined,
        map: $1e6525975b6cc660$var$_map,
        ap: function(fab, fa) {
            return $1e6525975b6cc660$export$d649b6842e09f2b(fab) ? $1e6525975b6cc660$export$d649b6842e09f2b(fa) ? $1e6525975b6cc660$export$eabcd2c8791e7bf4(SE.concat(fab.left, fa.left)) : fab : $1e6525975b6cc660$export$d649b6842e09f2b(fa) ? fa : $1e6525975b6cc660$export$79ffe56a765070d2(fab.right(fa.right));
        },
        of: $1e6525975b6cc660$export$ba255e9e49e00608
    };
};
var $1e6525975b6cc660$export$a81dd5ed716f5f73 = function(SE) {
    return {
        URI: $1e6525975b6cc660$export$9156e739aa33e19f,
        _E: undefined,
        map: $1e6525975b6cc660$var$_map,
        alt: function(me, that) {
            if ($1e6525975b6cc660$export$a9d71693f0c1a85d(me)) return me;
            var ea = that();
            return $1e6525975b6cc660$export$d649b6842e09f2b(ea) ? $1e6525975b6cc660$export$eabcd2c8791e7bf4(SE.concat(me.left, ea.left)) : ea;
        }
    };
};
var $1e6525975b6cc660$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(fa) ? fa : $1e6525975b6cc660$export$79ffe56a765070d2(f(fa.right));
    };
};
var $1e6525975b6cc660$export$bd5b6bfc5fa2ee61 = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    map: $1e6525975b6cc660$var$_map
};
var $1e6525975b6cc660$export$6554612db691658e = (0, $72EOc.dual)(2, (0, $cpwuW.as)($1e6525975b6cc660$export$bd5b6bfc5fa2ee61));
var $1e6525975b6cc660$export$9284b360ca18a0fd = (0, $cpwuW.asUnit)($1e6525975b6cc660$export$bd5b6bfc5fa2ee61);
var $1e6525975b6cc660$export$ba255e9e49e00608 = $1e6525975b6cc660$export$79ffe56a765070d2;
var $1e6525975b6cc660$export$59a71046037e6c20 = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    of: $1e6525975b6cc660$export$ba255e9e49e00608
};
var $1e6525975b6cc660$export$321be6e231de8eac = function(fa) {
    return function(fab) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(fab) ? fab : $1e6525975b6cc660$export$d649b6842e09f2b(fa) ? fa : $1e6525975b6cc660$export$79ffe56a765070d2(fab.right(fa.right));
    };
};
var $1e6525975b6cc660$export$2f6ca3d3b1f80bf5 = $1e6525975b6cc660$export$321be6e231de8eac;
var $1e6525975b6cc660$export$efc21ddc6aeb363d = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    map: $1e6525975b6cc660$var$_map,
    ap: $1e6525975b6cc660$var$_ap
};
var $1e6525975b6cc660$export$1279d2b7807629fd = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    map: $1e6525975b6cc660$var$_map,
    ap: $1e6525975b6cc660$var$_ap,
    of: $1e6525975b6cc660$export$ba255e9e49e00608
};
var $1e6525975b6cc660$export$f18d5acc27d70423 = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    map: $1e6525975b6cc660$var$_map,
    ap: $1e6525975b6cc660$var$_ap,
    chain: $1e6525975b6cc660$export$5b8affa63fc6df16
};
var $1e6525975b6cc660$export$fb641926d034ac7d = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    map: $1e6525975b6cc660$var$_map,
    ap: $1e6525975b6cc660$var$_ap,
    of: $1e6525975b6cc660$export$ba255e9e49e00608,
    chain: $1e6525975b6cc660$export$5b8affa63fc6df16
};
var $1e6525975b6cc660$export$533b26079ad0b4b = function(b, f) {
    return function(fa) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(fa) ? b : f(b, fa.right);
    };
};
var $1e6525975b6cc660$export$b66cdc0497d8a99a = function(M) {
    return function(f) {
        return function(fa) {
            return $1e6525975b6cc660$export$d649b6842e09f2b(fa) ? M.empty : f(fa.right);
        };
    };
};
var $1e6525975b6cc660$export$7fef8bcdbb34f435 = function(b, f) {
    return function(fa) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(fa) ? b : f(fa.right, b);
    };
};
var $1e6525975b6cc660$export$41404b31838667c9 = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    reduce: $1e6525975b6cc660$var$_reduce,
    foldMap: $1e6525975b6cc660$var$_foldMap,
    reduceRight: $1e6525975b6cc660$var$_reduceRight
};
var $1e6525975b6cc660$export$df3f009e3d155b20 = function(F) {
    return function(f) {
        return function(ta) {
            return $1e6525975b6cc660$export$d649b6842e09f2b(ta) ? F.of($1e6525975b6cc660$export$eabcd2c8791e7bf4(ta.left)) : F.map(f(ta.right), $1e6525975b6cc660$export$79ffe56a765070d2);
        };
    };
};
var $1e6525975b6cc660$export$49bb65c2ea163039 = function(F) {
    return function(ma) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(ma) ? F.of($1e6525975b6cc660$export$eabcd2c8791e7bf4(ma.left)) : F.map(ma.right, $1e6525975b6cc660$export$79ffe56a765070d2);
    };
};
var $1e6525975b6cc660$export$a0202666c3bda011 = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    map: $1e6525975b6cc660$var$_map,
    reduce: $1e6525975b6cc660$var$_reduce,
    foldMap: $1e6525975b6cc660$var$_foldMap,
    reduceRight: $1e6525975b6cc660$var$_reduceRight,
    traverse: $1e6525975b6cc660$var$_traverse,
    sequence: $1e6525975b6cc660$export$49bb65c2ea163039
};
var $1e6525975b6cc660$export$eb54baf0b342cb1d = function(f, g) {
    return function(fa) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(fa) ? $1e6525975b6cc660$export$eabcd2c8791e7bf4(f(fa.left)) : $1e6525975b6cc660$export$79ffe56a765070d2(g(fa.right));
    };
};
var $1e6525975b6cc660$export$472de43a55e4aa49 = function(f) {
    return function(fa) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(fa) ? $1e6525975b6cc660$export$eabcd2c8791e7bf4(f(fa.left)) : fa;
    };
};
var $1e6525975b6cc660$export$fd0fe42029639505 = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    bimap: $1e6525975b6cc660$var$_bimap,
    mapLeft: $1e6525975b6cc660$var$_mapLeft
};
var $1e6525975b6cc660$export$1517cca7889d6aaa = function(that) {
    return function(fa) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(fa) ? that() : fa;
    };
};
var $1e6525975b6cc660$export$228be17d80722ab = $1e6525975b6cc660$export$1517cca7889d6aaa;
var $1e6525975b6cc660$export$25ba4469a069167 = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    map: $1e6525975b6cc660$var$_map,
    alt: $1e6525975b6cc660$var$_alt
};
var $1e6525975b6cc660$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(wa) ? wa : $1e6525975b6cc660$export$79ffe56a765070d2(f(wa));
    };
};
var $1e6525975b6cc660$export$5b5dd0e212d2a5bc = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    map: $1e6525975b6cc660$var$_map,
    extend: $1e6525975b6cc660$var$_extend
};
var $1e6525975b6cc660$export$be58f7327716329d = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    map: $1e6525975b6cc660$var$_map,
    ap: $1e6525975b6cc660$var$_ap,
    chain: $1e6525975b6cc660$export$5b8affa63fc6df16,
    chainRec: $1e6525975b6cc660$var$_chainRec
};
var $1e6525975b6cc660$export$8bf7aba4a9e09055 = $1e6525975b6cc660$export$eabcd2c8791e7bf4;
var $1e6525975b6cc660$export$5f956d47d0619c3a = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    map: $1e6525975b6cc660$var$_map,
    ap: $1e6525975b6cc660$var$_ap,
    of: $1e6525975b6cc660$export$ba255e9e49e00608,
    chain: $1e6525975b6cc660$export$5b8affa63fc6df16,
    throwError: $1e6525975b6cc660$export$8bf7aba4a9e09055
};
var $1e6525975b6cc660$export$825ea6cb6fc48d49 = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    fromEither: (0, $72EOc.identity)
};
var $1e6525975b6cc660$export$23f31c55d7162b91 = /*#__PURE__*/ (0, $jFfj2.fromPredicate)($1e6525975b6cc660$export$825ea6cb6fc48d49);
var $1e6525975b6cc660$export$172ec0a6ebfeb6fa = /*#__PURE__*/ (0, $jFfj2.fromOption)($1e6525975b6cc660$export$825ea6cb6fc48d49);
var $1e6525975b6cc660$export$d649b6842e09f2b = $EfnK2.isLeft;
var $1e6525975b6cc660$export$a9d71693f0c1a85d = $EfnK2.isRight;
var $1e6525975b6cc660$export$2d55ea551c238330 = function(onLeft, onRight) {
    return function(ma) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(ma) ? onLeft(ma.left) : onRight(ma.right);
    };
};
var $1e6525975b6cc660$export$ccb09033cefa61e8 = $1e6525975b6cc660$export$2d55ea551c238330;
var $1e6525975b6cc660$export$4659b591c19bdf3d = $1e6525975b6cc660$export$2d55ea551c238330;
var $1e6525975b6cc660$export$93e2b83da34ff82a = $1e6525975b6cc660$export$4659b591c19bdf3d;
var $1e6525975b6cc660$export$d8a997ff0e6436f3 = function(onLeft) {
    return function(ma) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(ma) ? onLeft(ma.left) : ma.right;
    };
};
var $1e6525975b6cc660$export$8832081647a02ee7 = $1e6525975b6cc660$export$d8a997ff0e6436f3;
var $1e6525975b6cc660$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $cpwuW.flap)($1e6525975b6cc660$export$bd5b6bfc5fa2ee61);
var $1e6525975b6cc660$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $aYN4d.apFirst)($1e6525975b6cc660$export$efc21ddc6aeb363d);
var $1e6525975b6cc660$export$ac044f4aa9961a4f = $1e6525975b6cc660$export$5f28d9feedcfd46e;
var $1e6525975b6cc660$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $aYN4d.apSecond)($1e6525975b6cc660$export$efc21ddc6aeb363d);
var $1e6525975b6cc660$export$8a00020751233172 = $1e6525975b6cc660$export$ed01bc59c3d06bf3;
var $1e6525975b6cc660$export$3f23594af5f37336 = /*#__PURE__*/ (0, $72EOc.dual)(2, $kgj0x.tap($1e6525975b6cc660$export$f18d5acc27d70423));
var $1e6525975b6cc660$export$2409099f1fc434fb = /*#__PURE__*/ $1e6525975b6cc660$export$5b8affa63fc6df16((0, $72EOc.identity));
var $1e6525975b6cc660$export$bffa455ba8c619a6 = $1e6525975b6cc660$export$2409099f1fc434fb;
var $1e6525975b6cc660$export$ecd5e8ace626722c = /*#__PURE__*/ $1e6525975b6cc660$export$8b58be045bf06082((0, $72EOc.identity));
var $1e6525975b6cc660$export$a907462f448b49f8 = /*#__PURE__*/ (0, $jFfj2.fromOptionK)($1e6525975b6cc660$export$825ea6cb6fc48d49);
var $1e6525975b6cc660$export$12d26179deb6a68a = /*#__PURE__*/ (0, $jFfj2.chainOptionK)($1e6525975b6cc660$export$825ea6cb6fc48d49, $1e6525975b6cc660$export$f18d5acc27d70423);
var $1e6525975b6cc660$export$377cc334277e5c3c = $1e6525975b6cc660$export$12d26179deb6a68a;
/** @internal */ var $1e6525975b6cc660$var$_FromEither = {
    fromEither: $1e6525975b6cc660$export$825ea6cb6fc48d49.fromEither
};
var $1e6525975b6cc660$export$cd139e14432f317b = /*#__PURE__*/ $EfnK2.liftNullable($1e6525975b6cc660$var$_FromEither);
var $1e6525975b6cc660$export$ea4a22f93200df79 = /*#__PURE__*/ $EfnK2.liftOption($1e6525975b6cc660$var$_FromEither);
/** @internal */ var $1e6525975b6cc660$var$_FlatMap = {
    flatMap: $1e6525975b6cc660$export$5b8affa63fc6df16
};
var $1e6525975b6cc660$export$1a0515933c5c84fe = /*#__PURE__*/ $EfnK2.flatMapNullable($1e6525975b6cc660$var$_FromEither, $1e6525975b6cc660$var$_FlatMap);
var $1e6525975b6cc660$export$b5f02b7beb8ed7d8 = /*#__PURE__*/ $EfnK2.flatMapOption($1e6525975b6cc660$var$_FromEither, $1e6525975b6cc660$var$_FlatMap);
var $1e6525975b6cc660$export$30af8ca9498ddf5b = /*#__PURE__*/ (0, $jFfj2.filterOrElse)($1e6525975b6cc660$export$825ea6cb6fc48d49, $1e6525975b6cc660$export$f18d5acc27d70423);
var $1e6525975b6cc660$export$84511cf4503ec9dd = $1e6525975b6cc660$export$30af8ca9498ddf5b;
var $1e6525975b6cc660$export$b0e76d9850c64156 = function(ma) {
    return $1e6525975b6cc660$export$d649b6842e09f2b(ma) ? $1e6525975b6cc660$export$79ffe56a765070d2(ma.left) : $1e6525975b6cc660$export$eabcd2c8791e7bf4(ma.right);
};
var $1e6525975b6cc660$export$efd845e0c87089a6 = function(onLeft) {
    return function(ma) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(ma) ? onLeft(ma.left) : ma;
    };
};
var $1e6525975b6cc660$export$41d1a04d78e7b141 = $1e6525975b6cc660$export$efd845e0c87089a6;
var $1e6525975b6cc660$export$b601f49376b4621a = function(e) {
    return function(a) {
        return a == null ? $1e6525975b6cc660$export$eabcd2c8791e7bf4(e) : $1e6525975b6cc660$export$79ffe56a765070d2(a);
    };
};
var $1e6525975b6cc660$export$d234c058d1d4e435 = function(f, onThrow) {
    try {
        return $1e6525975b6cc660$export$79ffe56a765070d2(f());
    } catch (e) {
        return $1e6525975b6cc660$export$eabcd2c8791e7bf4(onThrow(e));
    }
};
var $1e6525975b6cc660$export$7f3d23c4b0794e72 = function(f, onThrow) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $1e6525975b6cc660$export$d234c058d1d4e435(function() {
            return f.apply(void 0, a);
        }, onThrow);
    };
};
var $1e6525975b6cc660$export$c69ca7b73fad45e1 = function(e) {
    var from = $1e6525975b6cc660$export$b601f49376b4621a(e);
    return function(f) {
        return (0, $72EOc.flow)(f, from);
    };
};
var $1e6525975b6cc660$export$c81f992c08fd0bf3 = function(e) {
    var from = $1e6525975b6cc660$export$c69ca7b73fad45e1(e);
    return function(f) {
        return $1e6525975b6cc660$export$5b8affa63fc6df16(from(f));
    };
};
var $1e6525975b6cc660$export$a0886ed3a572729f = /*#__PURE__*/ $1e6525975b6cc660$export$ccb09033cefa61e8((0, $72EOc.identity), (0, $72EOc.identity));
function $1e6525975b6cc660$export$cc3b967c039ed3e7(e) {
    try {
        return e instanceof Error ? e : new Error(String(e));
    } catch (error) {
        return new Error();
    }
}
function $1e6525975b6cc660$export$5bf96401662340b7(E) {
    return function(a, ma) {
        if (ma === undefined) {
            var elemE_1 = $1e6525975b6cc660$export$5bf96401662340b7(E);
            return function(ma) {
                return elemE_1(a, ma);
            };
        }
        return $1e6525975b6cc660$export$d649b6842e09f2b(ma) ? false : E.equals(a, ma.right);
    };
}
var $1e6525975b6cc660$export$f7e9f41ea797a17 = function(predicate) {
    return function(ma) {
        return $1e6525975b6cc660$export$d649b6842e09f2b(ma) ? false : predicate(ma.right);
    };
};
var $1e6525975b6cc660$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $1e6525975b6cc660$export$ba255e9e49e00608($EfnK2.emptyRecord);
var $1e6525975b6cc660$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $cpwuW.bindTo)($1e6525975b6cc660$export$bd5b6bfc5fa2ee61);
var $1e6525975b6cc660$export$5d537b797c421217 = /*#__PURE__*/ (0, $cpwuW.let)($1e6525975b6cc660$export$bd5b6bfc5fa2ee61);
var $1e6525975b6cc660$export$2385a24977818dd0 = /*#__PURE__*/ $kgj0x.bind($1e6525975b6cc660$export$f18d5acc27d70423);
var $1e6525975b6cc660$export$e0d5b1cbe98976d9 = $1e6525975b6cc660$export$2385a24977818dd0;
var $1e6525975b6cc660$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $aYN4d.apS)($1e6525975b6cc660$export$efc21ddc6aeb363d);
var $1e6525975b6cc660$export$5c01f27714264b3d = $1e6525975b6cc660$export$8cbfc0239f42bb49;
var $1e6525975b6cc660$export$c74b6e34b2b6efb0 = /*#__PURE__*/ $1e6525975b6cc660$export$ba255e9e49e00608($EfnK2.emptyReadonlyArray);
var $1e6525975b6cc660$export$817de7d5ba7e6fab = function(f) {
    return function(as) {
        var e = f(0, $EfnK2.head(as));
        if ($1e6525975b6cc660$export$d649b6842e09f2b(e)) return e;
        var out = [
            e.right
        ];
        for(var i = 1; i < as.length; i++){
            var e_1 = f(i, as[i]);
            if ($1e6525975b6cc660$export$d649b6842e09f2b(e_1)) return e_1;
            out.push(e_1.right);
        }
        return $1e6525975b6cc660$export$79ffe56a765070d2(out);
    };
};
var $1e6525975b6cc660$export$d4e79db5dc14cc1 = function(f) {
    var g = $1e6525975b6cc660$export$817de7d5ba7e6fab(f);
    return function(as) {
        return $EfnK2.isNonEmpty(as) ? g(as) : $1e6525975b6cc660$export$c74b6e34b2b6efb0;
    };
};
var $1e6525975b6cc660$export$104a2841e9cbad06 = $1e6525975b6cc660$export$d4e79db5dc14cc1;
var $1e6525975b6cc660$export$64f39b2a2b79e1b1 = function(f) {
    return $1e6525975b6cc660$export$d4e79db5dc14cc1(function(_, a) {
        return f(a);
    });
};
var $1e6525975b6cc660$export$d330b60315c14cd1 = /*#__PURE__*/ $1e6525975b6cc660$export$64f39b2a2b79e1b1((0, $72EOc.identity));
var $1e6525975b6cc660$export$8e5885f0163d737a = $1e6525975b6cc660$export$5b8affa63fc6df16;
var $1e6525975b6cc660$export$e08e3b67e392101e = $1e6525975b6cc660$export$5b8affa63fc6df16;
var $1e6525975b6cc660$export$e3821ef4970c339c = $1e6525975b6cc660$export$3f23594af5f37336;
var $1e6525975b6cc660$export$5de78197fc44b933 = $1e6525975b6cc660$export$3f23594af5f37336;
function $1e6525975b6cc660$export$27924e57e9afff7f(s, onError) {
    return $1e6525975b6cc660$export$d234c058d1d4e435(function() {
        return JSON.parse(s);
    }, onError);
}
var $1e6525975b6cc660$export$702e019c6853c7a = function(u, onError) {
    return $1e6525975b6cc660$export$d234c058d1d4e435(function() {
        var s = JSON.stringify(u);
        if (typeof s !== 'string') throw new Error('Converting unsupported structure to JSON');
        return s;
    }, onError);
};
var $1e6525975b6cc660$export$5f5be1bb6cd1fded = {
    URI: $1e6525975b6cc660$export$9156e739aa33e19f,
    map: $1e6525975b6cc660$var$_map,
    of: $1e6525975b6cc660$export$ba255e9e49e00608,
    ap: $1e6525975b6cc660$var$_ap,
    chain: $1e6525975b6cc660$export$5b8affa63fc6df16,
    reduce: $1e6525975b6cc660$var$_reduce,
    foldMap: $1e6525975b6cc660$var$_foldMap,
    reduceRight: $1e6525975b6cc660$var$_reduceRight,
    traverse: $1e6525975b6cc660$var$_traverse,
    sequence: $1e6525975b6cc660$export$49bb65c2ea163039,
    bimap: $1e6525975b6cc660$var$_bimap,
    mapLeft: $1e6525975b6cc660$var$_mapLeft,
    alt: $1e6525975b6cc660$var$_alt,
    extend: $1e6525975b6cc660$var$_extend,
    chainRec: $1e6525975b6cc660$var$_chainRec,
    throwError: $1e6525975b6cc660$export$8bf7aba4a9e09055
};
var $1e6525975b6cc660$export$18979a515d2a828e = /*#__PURE__*/ (0, $aYN4d.getApplySemigroup)($1e6525975b6cc660$export$efc21ddc6aeb363d);
var $1e6525975b6cc660$export$1b097547f7ec9bb3 = /*#__PURE__*/ (0, $9xys1.getApplicativeMonoid)($1e6525975b6cc660$export$1279d2b7807629fd);
var $1e6525975b6cc660$export$5c6835227ac7f658 = function(SE, SA) {
    return (0, $aYN4d.getApplySemigroup)($1e6525975b6cc660$export$d9540e18497e6036(SE))(SA);
};
var $1e6525975b6cc660$export$c6554235dd19af66 = function(SE, MA) {
    return (0, $9xys1.getApplicativeMonoid)($1e6525975b6cc660$export$d9540e18497e6036(SE))(MA);
};
function $1e6525975b6cc660$export$6843f928420ce3e4(SE) {
    var ap = $1e6525975b6cc660$export$d9540e18497e6036(SE).ap;
    var alt = $1e6525975b6cc660$export$a81dd5ed716f5f73(SE).alt;
    return {
        URI: $1e6525975b6cc660$export$9156e739aa33e19f,
        _E: undefined,
        map: $1e6525975b6cc660$var$_map,
        of: $1e6525975b6cc660$export$ba255e9e49e00608,
        chain: $1e6525975b6cc660$export$5b8affa63fc6df16,
        bimap: $1e6525975b6cc660$var$_bimap,
        mapLeft: $1e6525975b6cc660$var$_mapLeft,
        reduce: $1e6525975b6cc660$var$_reduce,
        foldMap: $1e6525975b6cc660$var$_foldMap,
        reduceRight: $1e6525975b6cc660$var$_reduceRight,
        extend: $1e6525975b6cc660$var$_extend,
        traverse: $1e6525975b6cc660$var$_traverse,
        sequence: $1e6525975b6cc660$export$49bb65c2ea163039,
        chainRec: $1e6525975b6cc660$var$_chainRec,
        throwError: $1e6525975b6cc660$export$8bf7aba4a9e09055,
        ap: ap,
        alt: alt
    };
}

});
parcelRegister("5CEm3", function(module, exports) {

$parcel$export(module.exports, "tailRec", () => $417fcdfa682964a7$export$2e586eaa876dd2fd);
/**
 * @since 2.0.0
 */ var $417fcdfa682964a7$export$2e586eaa876dd2fd = function(startWith, f) {
    var ab = f(startWith);
    while(ab._tag === 'Left')ab = f(ab.left);
    return ab.right;
};

});




parcelRegister("5kHfR", function(module, exports) {

$parcel$export(module.exports, "asLens", () => $3e205f7f2cd1627f$export$ba6dbfc52e933ec);
$parcel$export(module.exports, "asPrism", () => $3e205f7f2cd1627f$export$6963d4cf5712e556);
$parcel$export(module.exports, "asOptional", () => $3e205f7f2cd1627f$export$81a625dd455a09de);
$parcel$export(module.exports, "asTraversal", () => $3e205f7f2cd1627f$export$ef38eac73d6f828f);
$parcel$export(module.exports, "compose", () => $3e205f7f2cd1627f$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "reverse", () => $3e205f7f2cd1627f$export$66c1ae025e96b4bc);
$parcel$export(module.exports, "modify", () => $3e205f7f2cd1627f$export$3ff57735a52b8713);

var $72EOc = parcelRequire("72EOc");

var $30crt = parcelRequire("30crt");

var $lV5N9 = parcelRequire("lV5N9");
var $3e205f7f2cd1627f$export$1aba8f741a0eae06 = $lV5N9.iso;
var $3e205f7f2cd1627f$export$d560c7e4a29451c2 = function() {
    return $3e205f7f2cd1627f$export$1aba8f741a0eae06((0, $72EOc.identity), (0, $72EOc.identity));
};
var $3e205f7f2cd1627f$export$ba6dbfc52e933ec = $lV5N9.isoAsLens;
var $3e205f7f2cd1627f$export$6963d4cf5712e556 = $lV5N9.isoAsPrism;
var $3e205f7f2cd1627f$export$81a625dd455a09de = $lV5N9.isoAsOptional;
var $3e205f7f2cd1627f$export$ef38eac73d6f828f = $lV5N9.isoAsTraversal;
var $3e205f7f2cd1627f$export$f672e0b6f7222cd7 = function(ab) {
    return function(sa) {
        return $3e205f7f2cd1627f$export$1aba8f741a0eae06((0, $72EOc.flow)(sa.get, ab.get), (0, $72EOc.flow)(ab.reverseGet, sa.reverseGet));
    };
};
var $3e205f7f2cd1627f$export$220ad92d18dabdd7 = $3e205f7f2cd1627f$export$f672e0b6f7222cd7;
var $3e205f7f2cd1627f$export$f5c3e419c6a355ce = function(ab) {
    return (0, $72EOc.flow)($3e205f7f2cd1627f$export$ba6dbfc52e933ec, $lV5N9.lensComposeLens(ab));
};
var $3e205f7f2cd1627f$export$c1dc05e399870f6 = function(ab) {
    return (0, $72EOc.flow)($3e205f7f2cd1627f$export$6963d4cf5712e556, $lV5N9.prismComposePrism(ab));
};
var $3e205f7f2cd1627f$export$323f76c400675c8b = function(ab) {
    return (0, $72EOc.flow)($3e205f7f2cd1627f$export$81a625dd455a09de, $lV5N9.optionalComposeOptional(ab));
};
var $3e205f7f2cd1627f$export$aa978f69e007229f = function(ab) {
    return (0, $72EOc.flow)($3e205f7f2cd1627f$export$ef38eac73d6f828f, $lV5N9.traversalComposeTraversal(ab));
};
var $3e205f7f2cd1627f$export$66c1ae025e96b4bc = function(sa) {
    return $3e205f7f2cd1627f$export$1aba8f741a0eae06(sa.reverseGet, sa.get);
};
var $3e205f7f2cd1627f$export$3ff57735a52b8713 = function(f) {
    return function(sa) {
        return function(s) {
            return sa.reverseGet(f(sa.get(s)));
        };
    };
};
function $3e205f7f2cd1627f$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $30crt.pipe)(sa.get(s), f, function(fa) {
                    return F.map(fa, sa.reverseGet);
                });
            };
        };
    };
}
var $3e205f7f2cd1627f$export$b601f49376b4621a = function(sa) {
    return $3e205f7f2cd1627f$export$c1dc05e399870f6($lV5N9.prismFromNullable())(sa);
};
function $3e205f7f2cd1627f$export$3dea766d36a8935f(predicate) {
    return $3e205f7f2cd1627f$export$c1dc05e399870f6($lV5N9.prismFromPredicate(predicate));
}
var $3e205f7f2cd1627f$export$977f3f6a9323c0f6 = function(prop) {
    return (0, $72EOc.flow)($3e205f7f2cd1627f$export$ba6dbfc52e933ec, $lV5N9.lensProp(prop));
};
var $3e205f7f2cd1627f$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return (0, $72EOc.flow)($3e205f7f2cd1627f$export$ba6dbfc52e933ec, $lV5N9.lensProps.apply($lV5N9, props));
};
var $3e205f7f2cd1627f$export$d8556a2a8f973135 = function(prop) {
    return (0, $72EOc.flow)($3e205f7f2cd1627f$export$ba6dbfc52e933ec, $lV5N9.lensComponent(prop));
};
var $3e205f7f2cd1627f$export$b610b8812bbcded9 = function(i) {
    return (0, $72EOc.flow)($3e205f7f2cd1627f$export$81a625dd455a09de, $lV5N9.optionalIndex(i));
};
var $3e205f7f2cd1627f$export$84162b00c25b711c = function(i) {
    return (0, $72EOc.flow)($3e205f7f2cd1627f$export$81a625dd455a09de, $lV5N9.optionalIndexNonEmpty(i));
};
var $3e205f7f2cd1627f$export$df61b30b684217c0 = function(key) {
    return (0, $72EOc.flow)($3e205f7f2cd1627f$export$81a625dd455a09de, $lV5N9.optionalKey(key));
};
var $3e205f7f2cd1627f$export$976574c443b9185b = function(key) {
    return (0, $72EOc.flow)($3e205f7f2cd1627f$export$ba6dbfc52e933ec, $lV5N9.lensAtKey(key));
};
var $3e205f7f2cd1627f$export$ad14ef4001db2bcd = /*#__PURE__*/ $3e205f7f2cd1627f$export$c1dc05e399870f6(/*#__PURE__*/ $lV5N9.prismSome());
var $3e205f7f2cd1627f$export$79ffe56a765070d2 = /*#__PURE__*/ $3e205f7f2cd1627f$export$c1dc05e399870f6(/*#__PURE__*/ $lV5N9.prismRight());
var $3e205f7f2cd1627f$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $3e205f7f2cd1627f$export$c1dc05e399870f6(/*#__PURE__*/ $lV5N9.prismLeft());
function $3e205f7f2cd1627f$export$df3f009e3d155b20(T) {
    return (0, $72EOc.flow)($3e205f7f2cd1627f$export$ef38eac73d6f828f, $lV5N9.traversalTraverse(T));
}
function $3e205f7f2cd1627f$export$9a2f228bed5035c2(predicate) {
    return $3e205f7f2cd1627f$export$323f76c400675c8b($lV5N9.optionalFindFirst(predicate));
}
function $3e205f7f2cd1627f$export$28e1f787311e0a21(predicate) {
    return $3e205f7f2cd1627f$export$323f76c400675c8b($lV5N9.optionalFindFirstNonEmpty(predicate));
}
var $3e205f7f2cd1627f$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $3e205f7f2cd1627f$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $3e205f7f2cd1627f$var$imap_ = function(ea, ab, ba) {
    return $3e205f7f2cd1627f$export$1aba8f741a0eae06((0, $72EOc.flow)(ea.get, ab), (0, $72EOc.flow)(ba, ea.reverseGet));
};
var $3e205f7f2cd1627f$export$9156e739aa33e19f = 'monocle-ts/Iso';
var $3e205f7f2cd1627f$export$dbdf692cc5737cfd = {
    URI: $3e205f7f2cd1627f$export$9156e739aa33e19f,
    imap: $3e205f7f2cd1627f$var$imap_
};
var $3e205f7f2cd1627f$export$67666a3fb7d250d8 = {
    URI: $3e205f7f2cd1627f$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $3e205f7f2cd1627f$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $3e205f7f2cd1627f$export$3a8840c5b2ecf003 = {
    URI: $3e205f7f2cd1627f$export$9156e739aa33e19f,
    compose: $3e205f7f2cd1627f$export$67666a3fb7d250d8.compose,
    id: $3e205f7f2cd1627f$export$d560c7e4a29451c2
};

});

parcelRegister("2oRqE", function(module, exports) {

$parcel$export(module.exports, "fromAt", () => $1bf74485dbfc7fe3$export$c4dd3e639c7af330);
$parcel$export(module.exports, "fromIso", () => $1bf74485dbfc7fe3$export$3160d47a1ad63980);
/**
 * **This module is experimental**
 *
 * Experimental features are published in order to get early feedback from the community.
 *
 * A feature tagged as _Experimental_ is in a high state of flux, you're at risk of it changing without notice.
 *
 * @since 2.3.0
 */ 
var $bxsNd = parcelRequire("bxsNd");

var $30crt = parcelRequire("30crt");

var $lV5N9 = parcelRequire("lV5N9");

var $4qiTD = parcelRequire("4qiTD");
var $1bf74485dbfc7fe3$export$b610b8812bbcded9 = $lV5N9.index;
var $1bf74485dbfc7fe3$export$c4dd3e639c7af330 = function(at) {
    return $1bf74485dbfc7fe3$export$b610b8812bbcded9(function(i) {
        return $lV5N9.lensComposePrism($lV5N9.prismSome())(at.at(i));
    });
};
var $1bf74485dbfc7fe3$export$3160d47a1ad63980 = function(iso) {
    return function(sia) {
        return $1bf74485dbfc7fe3$export$b610b8812bbcded9(function(i) {
            return (0, $30crt.pipe)(iso, $lV5N9.isoAsOptional, $lV5N9.optionalComposeOptional(sia.index(i)));
        });
    };
};
var $1bf74485dbfc7fe3$export$bb0c054375ca4b0 = $lV5N9.indexReadonlyArray;
var $1bf74485dbfc7fe3$export$165af7b747e6b1f1 = $lV5N9.indexReadonlyNonEmptyArray;
var $1bf74485dbfc7fe3$export$3c3468aec3b83bbf = $lV5N9.indexReadonlyRecord;
var $1bf74485dbfc7fe3$export$92da200d6ddb6846 = function(E) {
    var lookupE = $4qiTD.lookup(E);
    var insertAtE = $4qiTD.insertAt(E);
    return function() {
        return $1bf74485dbfc7fe3$export$b610b8812bbcded9(function(key) {
            return $lV5N9.optional(function(s) {
                return lookupE(key, s);
            }, function(next) {
                var insert = insertAtE(key, next);
                return function(s) {
                    return (0, $30crt.pipe)(lookupE(key, s), $bxsNd.fold(function() {
                        return s;
                    }, function(prev) {
                        return next === prev ? s : insert(s);
                    }));
                };
            });
        });
    };
};
var $1bf74485dbfc7fe3$export$2cd1c249765cd0a4 = $lV5N9.indexReadonlyArray;
var $1bf74485dbfc7fe3$export$720226bf1ef46cb2 = $lV5N9.indexReadonlyRecord;

});

parcelRegister("40vng", function(module, exports) {

$parcel$export(module.exports, "lens", () => $2eaf7fc404ae0997$export$21cde5187c2605a3);
$parcel$export(module.exports, "id", () => $2eaf7fc404ae0997$export$d560c7e4a29451c2);
$parcel$export(module.exports, "asOptional", () => $2eaf7fc404ae0997$export$81a625dd455a09de);
$parcel$export(module.exports, "asTraversal", () => $2eaf7fc404ae0997$export$ef38eac73d6f828f);
$parcel$export(module.exports, "compose", () => $2eaf7fc404ae0997$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "composeLens", () => $2eaf7fc404ae0997$export$f5c3e419c6a355ce);
$parcel$export(module.exports, "composeIso", () => $2eaf7fc404ae0997$export$220ad92d18dabdd7);
$parcel$export(module.exports, "composePrism", () => $2eaf7fc404ae0997$export$c1dc05e399870f6);
$parcel$export(module.exports, "composeOptional", () => $2eaf7fc404ae0997$export$323f76c400675c8b);
$parcel$export(module.exports, "composeTraversal", () => $2eaf7fc404ae0997$export$aa978f69e007229f);
$parcel$export(module.exports, "modify", () => $2eaf7fc404ae0997$export$3ff57735a52b8713);
$parcel$export(module.exports, "modifyF", () => $2eaf7fc404ae0997$export$a28005d3e6beb9a6);
$parcel$export(module.exports, "fromNullable", () => $2eaf7fc404ae0997$export$b601f49376b4621a);
$parcel$export(module.exports, "filter", () => $2eaf7fc404ae0997$export$3dea766d36a8935f);
$parcel$export(module.exports, "prop", () => $2eaf7fc404ae0997$export$977f3f6a9323c0f6);
$parcel$export(module.exports, "props", () => $2eaf7fc404ae0997$export$8128bb6492cf3de7);
$parcel$export(module.exports, "component", () => $2eaf7fc404ae0997$export$d8556a2a8f973135);
$parcel$export(module.exports, "index", () => $2eaf7fc404ae0997$export$b610b8812bbcded9);
$parcel$export(module.exports, "indexNonEmpty", () => $2eaf7fc404ae0997$export$84162b00c25b711c);
$parcel$export(module.exports, "key", () => $2eaf7fc404ae0997$export$df61b30b684217c0);
$parcel$export(module.exports, "atKey", () => $2eaf7fc404ae0997$export$976574c443b9185b);
$parcel$export(module.exports, "some", () => $2eaf7fc404ae0997$export$ad14ef4001db2bcd);
$parcel$export(module.exports, "right", () => $2eaf7fc404ae0997$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $2eaf7fc404ae0997$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "traverse", () => $2eaf7fc404ae0997$export$df3f009e3d155b20);
$parcel$export(module.exports, "findFirst", () => $2eaf7fc404ae0997$export$9a2f228bed5035c2);
$parcel$export(module.exports, "findFirstNonEmpty", () => $2eaf7fc404ae0997$export$28e1f787311e0a21);
$parcel$export(module.exports, "imap", () => $2eaf7fc404ae0997$export$b2517b0ab3a58435);
$parcel$export(module.exports, "URI", () => $2eaf7fc404ae0997$export$9156e739aa33e19f);
$parcel$export(module.exports, "Invariant", () => $2eaf7fc404ae0997$export$dbdf692cc5737cfd);
$parcel$export(module.exports, "Semigroupoid", () => $2eaf7fc404ae0997$export$67666a3fb7d250d8);
$parcel$export(module.exports, "Category", () => $2eaf7fc404ae0997$export$3a8840c5b2ecf003);

var $72EOc = parcelRequire("72EOc");

var $30crt = parcelRequire("30crt");

var $lV5N9 = parcelRequire("lV5N9");
var $2eaf7fc404ae0997$export$21cde5187c2605a3 = $lV5N9.lens;
var $2eaf7fc404ae0997$export$d560c7e4a29451c2 = $lV5N9.lensId;
var $2eaf7fc404ae0997$export$81a625dd455a09de = $lV5N9.lensAsOptional;
var $2eaf7fc404ae0997$export$ef38eac73d6f828f = $lV5N9.lensAsTraversal;
var $2eaf7fc404ae0997$export$f672e0b6f7222cd7 = $lV5N9.lensComposeLens;
var $2eaf7fc404ae0997$export$f5c3e419c6a355ce = $2eaf7fc404ae0997$export$f672e0b6f7222cd7;
var $2eaf7fc404ae0997$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $72EOc.flow)($lV5N9.isoAsLens, $2eaf7fc404ae0997$export$f672e0b6f7222cd7);
var $2eaf7fc404ae0997$export$c1dc05e399870f6 = $lV5N9.lensComposePrism;
var $2eaf7fc404ae0997$export$323f76c400675c8b = function(ab) {
    return (0, $72EOc.flow)($2eaf7fc404ae0997$export$81a625dd455a09de, $lV5N9.optionalComposeOptional(ab));
};
var $2eaf7fc404ae0997$export$aa978f69e007229f = function(ab) {
    return (0, $72EOc.flow)($2eaf7fc404ae0997$export$ef38eac73d6f828f, $lV5N9.traversalComposeTraversal(ab));
};
var $2eaf7fc404ae0997$export$3ff57735a52b8713 = function(f) {
    return function(sa) {
        return function(s) {
            var o = sa.get(s);
            var n = f(o);
            return o === n ? s : sa.set(n)(s);
        };
    };
};
function $2eaf7fc404ae0997$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $30crt.pipe)(sa.get(s), f, function(fa) {
                    return F.map(fa, function(a) {
                        return sa.set(a)(s);
                    });
                });
            };
        };
    };
}
var $2eaf7fc404ae0997$export$b601f49376b4621a = function(sa) {
    return $2eaf7fc404ae0997$export$c1dc05e399870f6($lV5N9.prismFromNullable())(sa);
};
function $2eaf7fc404ae0997$export$3dea766d36a8935f(predicate) {
    return $2eaf7fc404ae0997$export$c1dc05e399870f6($lV5N9.prismFromPredicate(predicate));
}
var $2eaf7fc404ae0997$export$977f3f6a9323c0f6 = $lV5N9.lensProp;
var $2eaf7fc404ae0997$export$8128bb6492cf3de7 = $lV5N9.lensProps;
var $2eaf7fc404ae0997$export$d8556a2a8f973135 = $lV5N9.lensComponent;
var $2eaf7fc404ae0997$export$b610b8812bbcded9 = function(i) {
    return (0, $72EOc.flow)($2eaf7fc404ae0997$export$81a625dd455a09de, $lV5N9.optionalIndex(i));
};
var $2eaf7fc404ae0997$export$84162b00c25b711c = function(i) {
    return (0, $72EOc.flow)($2eaf7fc404ae0997$export$81a625dd455a09de, $lV5N9.optionalIndexNonEmpty(i));
};
var $2eaf7fc404ae0997$export$df61b30b684217c0 = function(key) {
    return (0, $72EOc.flow)($2eaf7fc404ae0997$export$81a625dd455a09de, $lV5N9.optionalKey(key));
};
var $2eaf7fc404ae0997$export$976574c443b9185b = $lV5N9.lensAtKey;
var $2eaf7fc404ae0997$export$ad14ef4001db2bcd = /*#__PURE__*/ $2eaf7fc404ae0997$export$c1dc05e399870f6(/*#__PURE__*/ $lV5N9.prismSome());
var $2eaf7fc404ae0997$export$79ffe56a765070d2 = /*#__PURE__*/ $2eaf7fc404ae0997$export$c1dc05e399870f6(/*#__PURE__*/ $lV5N9.prismRight());
var $2eaf7fc404ae0997$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $2eaf7fc404ae0997$export$c1dc05e399870f6(/*#__PURE__*/ $lV5N9.prismLeft());
function $2eaf7fc404ae0997$export$df3f009e3d155b20(T) {
    return (0, $72EOc.flow)($2eaf7fc404ae0997$export$ef38eac73d6f828f, $lV5N9.traversalTraverse(T));
}
function $2eaf7fc404ae0997$export$9a2f228bed5035c2(predicate) {
    return $2eaf7fc404ae0997$export$323f76c400675c8b($lV5N9.optionalFindFirst(predicate));
}
function $2eaf7fc404ae0997$export$28e1f787311e0a21(predicate) {
    return $2eaf7fc404ae0997$export$323f76c400675c8b($lV5N9.optionalFindFirstNonEmpty(predicate));
}
var $2eaf7fc404ae0997$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $2eaf7fc404ae0997$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $2eaf7fc404ae0997$var$imap_ = function(ea, ab, ba) {
    return $2eaf7fc404ae0997$export$21cde5187c2605a3((0, $72EOc.flow)(ea.get, ab), (0, $72EOc.flow)(ba, ea.set));
};
var $2eaf7fc404ae0997$export$9156e739aa33e19f = 'monocle-ts/Lens';
var $2eaf7fc404ae0997$export$dbdf692cc5737cfd = {
    URI: $2eaf7fc404ae0997$export$9156e739aa33e19f,
    imap: $2eaf7fc404ae0997$var$imap_
};
var $2eaf7fc404ae0997$export$67666a3fb7d250d8 = {
    URI: $2eaf7fc404ae0997$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $2eaf7fc404ae0997$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $2eaf7fc404ae0997$export$3a8840c5b2ecf003 = {
    URI: $2eaf7fc404ae0997$export$9156e739aa33e19f,
    compose: $2eaf7fc404ae0997$export$67666a3fb7d250d8.compose,
    id: $2eaf7fc404ae0997$export$d560c7e4a29451c2
};

});

parcelRegister("43LA8", function(module, exports) {

$parcel$export(module.exports, "asTraversal", () => $2f4c5a010ae2fc94$export$ef38eac73d6f828f);
$parcel$export(module.exports, "compose", () => $2f4c5a010ae2fc94$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "modifyOption", () => $2f4c5a010ae2fc94$export$a2ef9d652875bdfa);
$parcel$export(module.exports, "modify", () => $2f4c5a010ae2fc94$export$3ff57735a52b8713);

var $72EOc = parcelRequire("72EOc");

var $bxsNd = parcelRequire("bxsNd");

var $30crt = parcelRequire("30crt");

var $lV5N9 = parcelRequire("lV5N9");
var $2f4c5a010ae2fc94$export$516e28dec6a4b6d4 = $lV5N9.optional;
var $2f4c5a010ae2fc94$export$d560c7e4a29451c2 = function() {
    return $2f4c5a010ae2fc94$export$516e28dec6a4b6d4($bxsNd.some, (0, $72EOc.constant));
};
var $2f4c5a010ae2fc94$export$ef38eac73d6f828f = $lV5N9.optionalAsTraversal;
var $2f4c5a010ae2fc94$export$f672e0b6f7222cd7 = $lV5N9.optionalComposeOptional;
var $2f4c5a010ae2fc94$export$323f76c400675c8b = $2f4c5a010ae2fc94$export$f672e0b6f7222cd7;
var $2f4c5a010ae2fc94$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $72EOc.flow)($lV5N9.isoAsOptional, $2f4c5a010ae2fc94$export$f672e0b6f7222cd7);
var $2f4c5a010ae2fc94$export$f5c3e419c6a355ce = /*#__PURE__*/ (0, $72EOc.flow)($lV5N9.lensAsOptional, $lV5N9.optionalComposeOptional);
var $2f4c5a010ae2fc94$export$c1dc05e399870f6 = /*#__PURE__*/ (0, $72EOc.flow)($lV5N9.prismAsOptional, $lV5N9.optionalComposeOptional);
var $2f4c5a010ae2fc94$export$aa978f69e007229f = function(ab) {
    return (0, $72EOc.flow)($2f4c5a010ae2fc94$export$ef38eac73d6f828f, $lV5N9.traversalComposeTraversal(ab));
};
var $2f4c5a010ae2fc94$export$a2ef9d652875bdfa = $lV5N9.optionalModifyOption;
var $2f4c5a010ae2fc94$export$b2a7969df3fe0aa3 = function(a) {
    return $2f4c5a010ae2fc94$export$a2ef9d652875bdfa(function() {
        return a;
    });
};
var $2f4c5a010ae2fc94$export$3ff57735a52b8713 = $lV5N9.optionalModify;
function $2f4c5a010ae2fc94$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $30crt.pipe)(sa.getOption(s), $bxsNd.fold(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), function(a) {
                        return sa.set(a)(s);
                    });
                }));
            };
        };
    };
}
var $2f4c5a010ae2fc94$export$b601f49376b4621a = /*#__PURE__*/ $2f4c5a010ae2fc94$export$f672e0b6f7222cd7(/*#__PURE__*/ $lV5N9.prismAsOptional(/*#__PURE__*/ $lV5N9.prismFromNullable()));
function $2f4c5a010ae2fc94$export$3dea766d36a8935f(predicate) {
    return $2f4c5a010ae2fc94$export$f672e0b6f7222cd7($lV5N9.prismAsOptional($lV5N9.prismFromPredicate(predicate)));
}
var $2f4c5a010ae2fc94$export$977f3f6a9323c0f6 = function(prop) {
    return $2f4c5a010ae2fc94$export$f672e0b6f7222cd7((0, $30crt.pipe)($lV5N9.lensId(), $lV5N9.lensProp(prop), $lV5N9.lensAsOptional));
};
var $2f4c5a010ae2fc94$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return $2f4c5a010ae2fc94$export$f672e0b6f7222cd7((0, $30crt.pipe)($lV5N9.lensId(), $lV5N9.lensProps.apply($lV5N9, props), $lV5N9.lensAsOptional));
};
var $2f4c5a010ae2fc94$export$d8556a2a8f973135 = function(prop) {
    return $2f4c5a010ae2fc94$export$f672e0b6f7222cd7((0, $30crt.pipe)($lV5N9.lensId(), $lV5N9.lensComponent(prop), $lV5N9.lensAsOptional));
};
var $2f4c5a010ae2fc94$export$b610b8812bbcded9 = $lV5N9.optionalIndex;
var $2f4c5a010ae2fc94$export$84162b00c25b711c = $lV5N9.optionalIndexNonEmpty;
var $2f4c5a010ae2fc94$export$df61b30b684217c0 = $lV5N9.optionalKey;
var $2f4c5a010ae2fc94$export$976574c443b9185b = function(key) {
    return function(sa) {
        return (0, $30crt.pipe)(sa, $2f4c5a010ae2fc94$export$f672e0b6f7222cd7($lV5N9.lensAsOptional($lV5N9.atReadonlyRecord().at(key))));
    };
};
var $2f4c5a010ae2fc94$export$ad14ef4001db2bcd = /*#__PURE__*/ $2f4c5a010ae2fc94$export$f672e0b6f7222cd7(/*#__PURE__*/ $lV5N9.prismAsOptional(/*#__PURE__*/ $lV5N9.prismSome()));
var $2f4c5a010ae2fc94$export$79ffe56a765070d2 = /*#__PURE__*/ $2f4c5a010ae2fc94$export$f672e0b6f7222cd7(/*#__PURE__*/ $lV5N9.prismAsOptional(/*#__PURE__*/ $lV5N9.prismRight()));
var $2f4c5a010ae2fc94$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $2f4c5a010ae2fc94$export$f672e0b6f7222cd7(/*#__PURE__*/ $lV5N9.prismAsOptional(/*#__PURE__*/ $lV5N9.prismLeft()));
function $2f4c5a010ae2fc94$export$df3f009e3d155b20(T) {
    return (0, $72EOc.flow)($2f4c5a010ae2fc94$export$ef38eac73d6f828f, $lV5N9.traversalTraverse(T));
}
function $2f4c5a010ae2fc94$export$9a2f228bed5035c2(predicate) {
    return $2f4c5a010ae2fc94$export$f672e0b6f7222cd7($lV5N9.optionalFindFirst(predicate));
}
function $2f4c5a010ae2fc94$export$28e1f787311e0a21(predicate) {
    return $2f4c5a010ae2fc94$export$f672e0b6f7222cd7($lV5N9.optionalFindFirstNonEmpty(predicate));
}
var $2f4c5a010ae2fc94$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $2f4c5a010ae2fc94$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $2f4c5a010ae2fc94$var$imap_ = function(ea, ab, ba) {
    return $2f4c5a010ae2fc94$export$516e28dec6a4b6d4((0, $72EOc.flow)(ea.getOption, $bxsNd.map(ab)), (0, $72EOc.flow)(ba, ea.set));
};
var $2f4c5a010ae2fc94$export$9156e739aa33e19f = 'monocle-ts/Optional';
var $2f4c5a010ae2fc94$export$dbdf692cc5737cfd = {
    URI: $2f4c5a010ae2fc94$export$9156e739aa33e19f,
    imap: $2f4c5a010ae2fc94$var$imap_
};
var $2f4c5a010ae2fc94$export$67666a3fb7d250d8 = {
    URI: $2f4c5a010ae2fc94$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $2f4c5a010ae2fc94$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $2f4c5a010ae2fc94$export$3a8840c5b2ecf003 = {
    URI: $2f4c5a010ae2fc94$export$9156e739aa33e19f,
    compose: $2f4c5a010ae2fc94$export$67666a3fb7d250d8.compose,
    id: $2f4c5a010ae2fc94$export$d560c7e4a29451c2
};

});

parcelRegister("ftUJ4", function(module, exports) {

$parcel$export(module.exports, "fromPredicate", () => $b4559109cd54548d$export$23f31c55d7162b91);
$parcel$export(module.exports, "asOptional", () => $b4559109cd54548d$export$81a625dd455a09de);
$parcel$export(module.exports, "asTraversal", () => $b4559109cd54548d$export$ef38eac73d6f828f);
$parcel$export(module.exports, "compose", () => $b4559109cd54548d$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "composeLens", () => $b4559109cd54548d$export$f5c3e419c6a355ce);

var $72EOc = parcelRequire("72EOc");

var $bxsNd = parcelRequire("bxsNd");

var $30crt = parcelRequire("30crt");

var $lV5N9 = parcelRequire("lV5N9");
var $b4559109cd54548d$export$e469dcfea9910464 = $lV5N9.prism;
var $b4559109cd54548d$export$d560c7e4a29451c2 = function() {
    return $b4559109cd54548d$export$e469dcfea9910464($bxsNd.some, (0, $72EOc.identity));
};
var $b4559109cd54548d$export$23f31c55d7162b91 = $lV5N9.prismFromPredicate;
var $b4559109cd54548d$export$81a625dd455a09de = $lV5N9.prismAsOptional;
var $b4559109cd54548d$export$ef38eac73d6f828f = $lV5N9.prismAsTraversal;
var $b4559109cd54548d$export$f672e0b6f7222cd7 = $lV5N9.prismComposePrism;
var $b4559109cd54548d$export$c1dc05e399870f6 = $b4559109cd54548d$export$f672e0b6f7222cd7;
var $b4559109cd54548d$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $72EOc.flow)($lV5N9.isoAsPrism, $b4559109cd54548d$export$f672e0b6f7222cd7);
var $b4559109cd54548d$export$f5c3e419c6a355ce = $lV5N9.prismComposeLens;
var $b4559109cd54548d$export$323f76c400675c8b = function(ab) {
    return (0, $72EOc.flow)($b4559109cd54548d$export$81a625dd455a09de, $lV5N9.optionalComposeOptional(ab));
};
var $b4559109cd54548d$export$aa978f69e007229f = function(ab) {
    return (0, $72EOc.flow)($b4559109cd54548d$export$ef38eac73d6f828f, $lV5N9.traversalComposeTraversal(ab));
};
var $b4559109cd54548d$export$adaa4cf7ef1b65be = $lV5N9.prismSet;
var $b4559109cd54548d$export$a2ef9d652875bdfa = $lV5N9.prismModifyOption;
var $b4559109cd54548d$export$3ff57735a52b8713 = $lV5N9.prismModify;
function $b4559109cd54548d$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $30crt.pipe)(sa.getOption(s), $bxsNd.fold(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), sa.reverseGet);
                }));
            };
        };
    };
}
var $b4559109cd54548d$export$b601f49376b4621a = /*#__PURE__*/ $b4559109cd54548d$export$f672e0b6f7222cd7(/*#__PURE__*/ $lV5N9.prismFromNullable());
function $b4559109cd54548d$export$3dea766d36a8935f(predicate) {
    return $b4559109cd54548d$export$f672e0b6f7222cd7($lV5N9.prismFromPredicate(predicate));
}
var $b4559109cd54548d$export$977f3f6a9323c0f6 = function(prop) {
    return $b4559109cd54548d$export$f5c3e419c6a355ce((0, $30crt.pipe)($lV5N9.lensId(), $lV5N9.lensProp(prop)));
}; // TODO: simplify?
var $b4559109cd54548d$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return $b4559109cd54548d$export$f5c3e419c6a355ce((0, $30crt.pipe)($lV5N9.lensId(), $lV5N9.lensProps.apply($lV5N9, props)));
};
var $b4559109cd54548d$export$d8556a2a8f973135 = function(prop) {
    return $b4559109cd54548d$export$f5c3e419c6a355ce((0, $30crt.pipe)($lV5N9.lensId(), $lV5N9.lensComponent(prop)));
};
var $b4559109cd54548d$export$b610b8812bbcded9 = function(i) {
    return (0, $72EOc.flow)($b4559109cd54548d$export$81a625dd455a09de, $lV5N9.optionalIndex(i));
};
var $b4559109cd54548d$export$84162b00c25b711c = function(i) {
    return (0, $72EOc.flow)($b4559109cd54548d$export$81a625dd455a09de, $lV5N9.optionalIndexNonEmpty(i));
};
var $b4559109cd54548d$export$df61b30b684217c0 = function(key) {
    return (0, $72EOc.flow)($b4559109cd54548d$export$81a625dd455a09de, $lV5N9.optionalKey(key));
};
var $b4559109cd54548d$export$976574c443b9185b = function(key) {
    return function(sa) {
        return $lV5N9.prismComposeLens($lV5N9.atReadonlyRecord().at(key))(sa);
    };
};
var $b4559109cd54548d$export$ad14ef4001db2bcd = /*#__PURE__*/ $b4559109cd54548d$export$f672e0b6f7222cd7(/*#__PURE__*/ $lV5N9.prismSome());
var $b4559109cd54548d$export$79ffe56a765070d2 = /*#__PURE__*/ $b4559109cd54548d$export$f672e0b6f7222cd7(/*#__PURE__*/ $lV5N9.prismRight());
var $b4559109cd54548d$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $b4559109cd54548d$export$f672e0b6f7222cd7(/*#__PURE__*/ $lV5N9.prismLeft());
function $b4559109cd54548d$export$df3f009e3d155b20(T) {
    return (0, $72EOc.flow)($b4559109cd54548d$export$ef38eac73d6f828f, $lV5N9.traversalTraverse(T));
}
function $b4559109cd54548d$export$9a2f228bed5035c2(predicate) {
    return $b4559109cd54548d$export$323f76c400675c8b($lV5N9.optionalFindFirst(predicate));
}
function $b4559109cd54548d$export$28e1f787311e0a21(predicate) {
    return $b4559109cd54548d$export$323f76c400675c8b($lV5N9.optionalFindFirstNonEmpty(predicate));
}
var $b4559109cd54548d$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $b4559109cd54548d$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $b4559109cd54548d$var$imap_ = function(ea, ab, ba) {
    return $b4559109cd54548d$export$e469dcfea9910464((0, $72EOc.flow)(ea.getOption, $bxsNd.map(ab)), (0, $72EOc.flow)(ba, ea.reverseGet));
};
var $b4559109cd54548d$export$9156e739aa33e19f = 'monocle-ts/Prism';
var $b4559109cd54548d$export$dbdf692cc5737cfd = {
    URI: $b4559109cd54548d$export$9156e739aa33e19f,
    imap: $b4559109cd54548d$var$imap_
};
var $b4559109cd54548d$export$67666a3fb7d250d8 = {
    URI: $b4559109cd54548d$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $b4559109cd54548d$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $b4559109cd54548d$export$3a8840c5b2ecf003 = {
    URI: $b4559109cd54548d$export$9156e739aa33e19f,
    compose: $b4559109cd54548d$export$67666a3fb7d250d8.compose,
    id: $b4559109cd54548d$export$d560c7e4a29451c2
};

});

parcelRegister("7NEBD", function(module, exports) {

$parcel$export(module.exports, "fromTraversable", () => $5adc9b83d7d033c2$export$126b5a87c58d3f9c);
$parcel$export(module.exports, "compose", () => $5adc9b83d7d033c2$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "modify", () => $5adc9b83d7d033c2$export$3ff57735a52b8713);
$parcel$export(module.exports, "set", () => $5adc9b83d7d033c2$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "filter", () => $5adc9b83d7d033c2$export$3dea766d36a8935f);

var $fFgN5 = parcelRequire("fFgN5");

var $72EOc = parcelRequire("72EOc");

var $30crt = parcelRequire("30crt");

var $8yI6w = parcelRequire("8yI6w");

var $lV5N9 = parcelRequire("lV5N9");
var $5adc9b83d7d033c2$export$8666ce7a134c2314 = $lV5N9.traversal;
var $5adc9b83d7d033c2$export$d560c7e4a29451c2 = function() {
    return $5adc9b83d7d033c2$export$8666ce7a134c2314(function(_) {
        return function(f) {
            return f;
        };
    });
};
var $5adc9b83d7d033c2$export$126b5a87c58d3f9c = $lV5N9.fromTraversable;
var $5adc9b83d7d033c2$export$f672e0b6f7222cd7 = $lV5N9.traversalComposeTraversal;
var $5adc9b83d7d033c2$export$aa978f69e007229f = $5adc9b83d7d033c2$export$f672e0b6f7222cd7;
var $5adc9b83d7d033c2$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $72EOc.flow)($lV5N9.isoAsTraversal, $5adc9b83d7d033c2$export$f672e0b6f7222cd7);
var $5adc9b83d7d033c2$export$f5c3e419c6a355ce = /*#__PURE__*/ (0, $72EOc.flow)($lV5N9.lensAsTraversal, $lV5N9.traversalComposeTraversal);
var $5adc9b83d7d033c2$export$c1dc05e399870f6 = /*#__PURE__*/ (0, $72EOc.flow)($lV5N9.prismAsTraversal, $lV5N9.traversalComposeTraversal);
var $5adc9b83d7d033c2$export$323f76c400675c8b = /*#__PURE__*/ (0, $72EOc.flow)($lV5N9.optionalAsTraversal, $lV5N9.traversalComposeTraversal);
var $5adc9b83d7d033c2$export$3ff57735a52b8713 = function(f) {
    return function(sa) {
        return sa.modifyF($lV5N9.ApplicativeIdentity)(f);
    };
};
var $5adc9b83d7d033c2$export$adaa4cf7ef1b65be = function(a) {
    return $5adc9b83d7d033c2$export$3ff57735a52b8713(function() {
        return a;
    });
};
var $5adc9b83d7d033c2$export$b601f49376b4621a = function(sa) {
    return $5adc9b83d7d033c2$export$c1dc05e399870f6($lV5N9.prismFromNullable())(sa);
};
function $5adc9b83d7d033c2$export$3dea766d36a8935f(predicate) {
    return $5adc9b83d7d033c2$export$f672e0b6f7222cd7($lV5N9.prismAsTraversal($lV5N9.prismFromPredicate(predicate)));
}
var $5adc9b83d7d033c2$export$977f3f6a9323c0f6 = function(prop) {
    return $5adc9b83d7d033c2$export$f672e0b6f7222cd7((0, $30crt.pipe)($lV5N9.lensId(), $lV5N9.lensProp(prop), $lV5N9.lensAsTraversal));
};
var $5adc9b83d7d033c2$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return $5adc9b83d7d033c2$export$f672e0b6f7222cd7((0, $30crt.pipe)($lV5N9.lensId(), $lV5N9.lensProps.apply($lV5N9, props), $lV5N9.lensAsTraversal));
};
var $5adc9b83d7d033c2$export$d8556a2a8f973135 = function(prop) {
    return $5adc9b83d7d033c2$export$f672e0b6f7222cd7((0, $30crt.pipe)($lV5N9.lensId(), $lV5N9.lensComponent(prop), $lV5N9.lensAsTraversal));
};
var $5adc9b83d7d033c2$export$b610b8812bbcded9 = function(i) {
    return function(sa) {
        return (0, $30crt.pipe)(sa, $5adc9b83d7d033c2$export$f672e0b6f7222cd7($lV5N9.optionalAsTraversal($lV5N9.indexReadonlyArray().index(i))));
    };
};
var $5adc9b83d7d033c2$export$84162b00c25b711c = function(i) {
    return function(sa) {
        return (0, $30crt.pipe)(sa, $5adc9b83d7d033c2$export$f672e0b6f7222cd7($lV5N9.optionalAsTraversal($lV5N9.indexReadonlyNonEmptyArray().index(i))));
    };
};
var $5adc9b83d7d033c2$export$df61b30b684217c0 = function(key) {
    return function(sa) {
        return (0, $30crt.pipe)(sa, $5adc9b83d7d033c2$export$f672e0b6f7222cd7($lV5N9.optionalAsTraversal($lV5N9.indexReadonlyRecord().index(key))));
    };
};
var $5adc9b83d7d033c2$export$976574c443b9185b = function(key) {
    return function(sa) {
        return (0, $30crt.pipe)(sa, $5adc9b83d7d033c2$export$f672e0b6f7222cd7($lV5N9.lensAsTraversal($lV5N9.atReadonlyRecord().at(key))));
    };
};
var $5adc9b83d7d033c2$export$ad14ef4001db2bcd = /*#__PURE__*/ $5adc9b83d7d033c2$export$f672e0b6f7222cd7(/*#__PURE__*/ $lV5N9.prismAsTraversal(/*#__PURE__*/ $lV5N9.prismSome()));
var $5adc9b83d7d033c2$export$79ffe56a765070d2 = /*#__PURE__*/ $5adc9b83d7d033c2$export$f672e0b6f7222cd7(/*#__PURE__*/ $lV5N9.prismAsTraversal(/*#__PURE__*/ $lV5N9.prismRight()));
var $5adc9b83d7d033c2$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $5adc9b83d7d033c2$export$f672e0b6f7222cd7(/*#__PURE__*/ $lV5N9.prismAsTraversal(/*#__PURE__*/ $lV5N9.prismLeft()));
var $5adc9b83d7d033c2$export$df3f009e3d155b20 = $lV5N9.traversalTraverse;
function $5adc9b83d7d033c2$export$9a2f228bed5035c2(predicate) {
    return $5adc9b83d7d033c2$export$323f76c400675c8b($lV5N9.optionalFindFirst(predicate));
}
function $5adc9b83d7d033c2$export$28e1f787311e0a21(predicate) {
    return $5adc9b83d7d033c2$export$323f76c400675c8b($lV5N9.optionalFindFirstNonEmpty(predicate));
}
var $5adc9b83d7d033c2$export$b66cdc0497d8a99a = function(M) {
    return function(f) {
        return function(sa) {
            return sa.modifyF($fFgN5.getApplicative(M))(function(a) {
                return $fFgN5.make(f(a));
            });
        };
    };
};
var $5adc9b83d7d033c2$export$93e2b83da34ff82a = function(M) {
    return $5adc9b83d7d033c2$export$b66cdc0497d8a99a(M)((0, $72EOc.identity));
};
var $5adc9b83d7d033c2$export$2774c37398bee8b2 = function(s) {
    return function(sa) {
        return $5adc9b83d7d033c2$export$b66cdc0497d8a99a($8yI6w.getMonoid())($8yI6w.of)(sa)(s);
    };
};
var $5adc9b83d7d033c2$export$9156e739aa33e19f = 'monocle-ts/Traversal';
var $5adc9b83d7d033c2$export$67666a3fb7d250d8 = {
    URI: $5adc9b83d7d033c2$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $5adc9b83d7d033c2$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $5adc9b83d7d033c2$export$3a8840c5b2ecf003 = {
    URI: $5adc9b83d7d033c2$export$9156e739aa33e19f,
    compose: $5adc9b83d7d033c2$export$67666a3fb7d250d8.compose,
    id: $5adc9b83d7d033c2$export$d560c7e4a29451c2
};

});


parcelRegister("gyqrs", function(module, exports) {

$parcel$export(module.exports, "BASE_STREAM_URL", () => $6f61a4b2d82d43e7$export$7c03f5942efb8a41);
const $6f61a4b2d82d43e7$export$7c03f5942efb8a41 = '/gateway/api/assist/api/ai';

});


parcelRegister("LzBwp", function(module, exports) {

$parcel$export(module.exports, "makeConvoAIStreamRequest", () => $69c89c3d2d0641e2$export$2f20a85d8fafe2d9);

var $iX7e9 = parcelRequire("iX7e9");

var $kAaxz = parcelRequire("kAaxz");

var $hoKUP = parcelRequire("hoKUP");
function $69c89c3d2d0641e2$export$2f20a85d8fafe2d9(requestConfig) {
    const behaviorSubject = new (0, $iX7e9.BehaviorSubject)((0, $kAaxz.getDefaultConvoAIStreamingState)());
    fetch(requestConfig.url, {
        credentials: 'include',
        ...requestConfig.requestInitParams
    }).then((response)=>(0, $hoKUP.readStream)(response)).then(async (stream)=>{
        let bufferContent = '';
        let answerChunkIndex = 0;
        for await (const chunk of stream){
            const state = behaviorSubject.getValue();
            switch(chunk.type){
                case 'ANSWER_PART':
                    bufferContent += chunk.message.content;
                    behaviorSubject.next({
                        ...state,
                        responseState: (0, $kAaxz.ConvoAIResponseState).AnswerPart,
                        content: bufferContent,
                        answerChunkIndex: answerChunkIndex
                    });
                    answerChunkIndex += 1;
                    break;
                case 'CHANNEL_ID':
                    const channelId = chunk.message.content;
                    behaviorSubject.next({
                        ...state,
                        responseState: (0, $kAaxz.ConvoAIResponseState).ChannelId,
                        content: channelId,
                        answerChunkIndex: undefined
                    });
                    break;
                case 'FINAL_RESPONSE':
                    bufferContent = chunk.message.content;
                    behaviorSubject.next({
                        ...state,
                        answerChunkIndex: undefined,
                        responseState: (0, $kAaxz.ConvoAIResponseState).FinalResponse,
                        content: bufferContent
                    });
                    break;
                case 'FOLLOW_UP_QUERIES':
                    behaviorSubject.next({
                        ...state,
                        answerChunkIndex: undefined,
                        followUpContent: chunk.message.follow_ups ?? [],
                        responseState: (0, $kAaxz.ConvoAIResponseState).FollowUp
                    });
                    break;
                case 'ERROR':
                    behaviorSubject.next({
                        ...state,
                        answerChunkIndex: undefined,
                        responseState: (0, $kAaxz.ConvoAIResponseState).Error,
                        error: {
                            ...chunk
                        }
                    });
                    break;
            }
        }
    }).finally(()=>{
        behaviorSubject.complete();
    });
    return behaviorSubject;
}

});
parcelRegister("hoKUP", function(module, exports) {

$parcel$export(module.exports, "readStream", () => $20c346f17ddaccf2$export$e45226161c660403);

var $bddW2 = parcelRequire("bddW2");

var $93WqG = parcelRequire("93WqG");
async function* $20c346f17ddaccf2$export$e45226161c660403(response) {
    // Read the response body only if the status is 200 and the body is not null
    if (response.status === 200 && response.body) try {
        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let buffer = '';
        let done = false;
        while(!done){
            const { value: value, done: doneReading } = await reader.read();
            const decodedValue = decoder.decode(value);
            done = doneReading;
            buffer = `${buffer}${decodedValue}`;
            // Split the buffer by line breaks
            const lines = buffer.split('\n');
            // Process all complete lines, except for the last one (which might be incomplete)
            while(lines.length > 1){
                const line = lines.shift();
                const parsedData = JSON.parse(line);
                yield parsedData;
            }
            // Keep the last (potentially incomplete) line in the buffer
            buffer = lines[0];
        }
        return;
    } catch (parsingError) {
        let errorText = '';
        if (typeof parsingError === 'string') errorText = parsingError.toUpperCase();
        else if (parsingError instanceof Error) errorText = parsingError.message;
        yield {
            type: 'ERROR',
            message: {
                content: `[Stream Error]: ${errorText}. locked status: ${response.body.locked}. statusCode: ${response.status}`,
                message_template: (0, $93WqG.ConvoAIErrorMessage).UNEXPECTED,
                status_code: (0, $93WqG.CONVOAI_DEFAULT_ERROR_CODE)
            }
        };
        return;
    }
    // parse the response body as text which should be safe
    const responseText = await response.text();
    try {
        // try to parse the response body as json
        const responseJson = JSON.parse(responseText);
        // covered HTTP errors only from this doc
        // https://hello.atlassian.net/wiki/spaces/CONVAI/pages/3420210503/Error+message+formats+-+assistance-service
        // Kept for extra error handling security as we migrate to convo-ai from agent service
        yield (0, $bddW2.match)({
            status: response.status,
            body: response.body,
            text: responseText,
            json: responseJson
        }).returnType().with({
            status: 201
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: No answer was generated by Open AI. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $93WqG.ConvoAIErrorMessage).BAD_REQUEST,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).with({
            status: 400
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: BAD_REQUEST or NO_AGENT or EXCEEDING_CONTEXT_LENGTH_ERROR. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $93WqG.ConvoAIErrorMessage).BAD_REQUEST,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).with({
            status: 403
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: FEATURE_DISABLED_ON_SITE or FEATURE_DISABLED or HIPAA_CONTENT_DETECTED. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $93WqG.ConvoAIErrorMessage).BAD_REQUEST,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).with({
            status: 429
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: RATE_LIMIT or OPENAI_RATE_LIMIT_USER_ABUSE. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $93WqG.ConvoAIErrorMessage).RATE_LIMIT,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).with({
            status: 500
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: INTERNAL_SERVER_ERROR. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $93WqG.ConvoAIErrorMessage).UNEXPECTED,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).with({
            body: (0, $bddW2.P).nullish
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[Error]: response.body is missing. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $93WqG.ConvoAIErrorMessage).UNEXPECTED,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).otherwise(({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: OTHER_SERVER_ERROR. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $93WqG.ConvoAIErrorMessage).UNEXPECTED,
                    status_code: response.status
                },
                jsonRawResponse: json
            }));
    } catch (error) {
        yield {
            type: 'ERROR',
            message: {
                content: `[HTTP Error]: UNABLE_TO_PARSE_HTTP_ERROR. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $93WqG.ConvoAIErrorMessage).UNEXPECTED,
                status_code: response.status
            }
        };
    }
}

});


parcelRegister("2864f", function(module, exports) {

$parcel$export(module.exports, "parsePartialConvoAIJsonIfNeeded", () => $b0fe2e92f6e87b5f$export$d2c9dfa182282b6d);

var $aGU6X = parcelRequire("aGU6X");

var $kAaxz = parcelRequire("kAaxz");
function $b0fe2e92f6e87b5f$export$d2c9dfa182282b6d(state, config) {
    if (state.responseState !== (0, $kAaxz.ConvoAIResponseState).Initialization && config.enablePartialJson && state.content) try {
        const parsedContent = (0, $aGU6X.parse)(state.content);
        return {
            ...state,
            content: parsedContent
        };
    } catch (error) {}
    return state;
}

});
parcelRegister("aGU6X", function(module, exports) {
"use strict";
var $7c895a27d7315d26$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7c895a27d7315d26$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7c895a27d7315d26$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Allow = module.exports.MalformedJSON = module.exports.PartialJSON = module.exports.parseJSON = module.exports.parse = void 0;

Object.defineProperty(module.exports, "Allow", {
    enumerable: true,
    get: function() {
        return (parcelRequire("1tDCw")).Allow;
    }
});

$7c895a27d7315d26$var$__exportStar((parcelRequire("1tDCw")), module.exports);
class $7c895a27d7315d26$var$PartialJSON extends Error {
}
module.exports.PartialJSON = $7c895a27d7315d26$var$PartialJSON;
class $7c895a27d7315d26$var$MalformedJSON extends Error {
}
module.exports.MalformedJSON = $7c895a27d7315d26$var$MalformedJSON;
/**
 * Parse incomplete JSON
 * @param {string} jsonString Partial JSON to be parsed
 * @param {number} allowPartial Specify what types are allowed to be partial, see {@link Allow} for details
 * @returns The parsed JSON
 * @throws {PartialJSON} If the JSON is incomplete (related to the `allow` parameter)
 * @throws {MalformedJSON} If the JSON is malformed
 */ function $7c895a27d7315d26$var$parseJSON(jsonString, allowPartial = (parcelRequire("1tDCw")).Allow.ALL) {
    if (typeof jsonString !== "string") throw new TypeError(`expecting str, got ${typeof jsonString}`);
    if (!jsonString.trim()) throw new Error(`${jsonString} is empty`);
    return $7c895a27d7315d26$var$_parseJSON(jsonString.trim(), allowPartial);
}
module.exports.parseJSON = $7c895a27d7315d26$var$parseJSON;
const $7c895a27d7315d26$var$_parseJSON = (jsonString, allow)=>{
    const length = jsonString.length;
    let index = 0;
    const markPartialJSON = (msg)=>{
        throw new $7c895a27d7315d26$var$PartialJSON(`${msg} at position ${index}`);
    };
    const throwMalformedError = (msg)=>{
        throw new $7c895a27d7315d26$var$MalformedJSON(`${msg} at position ${index}`);
    };
    const parseAny = ()=>{
        skipBlank();
        if (index >= length) markPartialJSON("Unexpected end of input");
        if (jsonString[index] === '"') return parseStr();
        if (jsonString[index] === "{") return parseObj();
        if (jsonString[index] === "[") return parseArr();
        if (jsonString.substring(index, index + 4) === "null" || (parcelRequire("1tDCw")).Allow.NULL & allow && length - index < 4 && "null".startsWith(jsonString.substring(index))) {
            index += 4;
            return null;
        }
        if (jsonString.substring(index, index + 4) === "true" || (parcelRequire("1tDCw")).Allow.BOOL & allow && length - index < 4 && "true".startsWith(jsonString.substring(index))) {
            index += 4;
            return true;
        }
        if (jsonString.substring(index, index + 5) === "false" || (parcelRequire("1tDCw")).Allow.BOOL & allow && length - index < 5 && "false".startsWith(jsonString.substring(index))) {
            index += 5;
            return false;
        }
        if (jsonString.substring(index, index + 8) === "Infinity" || (parcelRequire("1tDCw")).Allow.INFINITY & allow && length - index < 8 && "Infinity".startsWith(jsonString.substring(index))) {
            index += 8;
            return Infinity;
        }
        if (jsonString.substring(index, index + 9) === "-Infinity" || (parcelRequire("1tDCw")).Allow._INFINITY & allow && 1 < length - index && length - index < 9 && "-Infinity".startsWith(jsonString.substring(index))) {
            index += 9;
            return -Infinity;
        }
        if (jsonString.substring(index, index + 3) === "NaN" || (parcelRequire("1tDCw")).Allow.NAN & allow && length - index < 3 && "NaN".startsWith(jsonString.substring(index))) {
            index += 3;
            return NaN;
        }
        return parseNum();
    };
    const parseStr = ()=>{
        const start = index;
        let escape = false;
        index++; // skip initial quote
        while(index < length && (jsonString[index] !== '"' || escape && jsonString[index - 1] === "\\")){
            escape = jsonString[index] === "\\" ? !escape : false;
            index++;
        }
        if (jsonString.charAt(index) == '"') try {
            return JSON.parse(jsonString.substring(start, ++index - Number(escape)));
        } catch (e) {
            throwMalformedError(String(e));
        }
        else if ((parcelRequire("1tDCw")).Allow.STR & allow) try {
            return JSON.parse(jsonString.substring(start, index - Number(escape)) + '"');
        } catch (e) {
            // SyntaxError: Invalid escape sequence
            return JSON.parse(jsonString.substring(start, jsonString.lastIndexOf("\\")) + '"');
        }
        markPartialJSON("Unterminated string literal");
    };
    const parseObj = ()=>{
        index++; // skip initial brace
        skipBlank();
        const obj = {};
        try {
            while(jsonString[index] !== "}"){
                skipBlank();
                if (index >= length && (parcelRequire("1tDCw")).Allow.OBJ & allow) return obj;
                const key = parseStr();
                skipBlank();
                index++; // skip colon
                try {
                    const value = parseAny();
                    obj[key] = value;
                } catch (e) {
                    if ((parcelRequire("1tDCw")).Allow.OBJ & allow) return obj;
                    else throw e;
                }
                skipBlank();
                if (jsonString[index] === ",") index++; // skip comma
            }
        } catch (e) {
            if ((parcelRequire("1tDCw")).Allow.OBJ & allow) return obj;
            else markPartialJSON("Expected '}' at end of object");
        }
        index++; // skip final brace
        return obj;
    };
    const parseArr = ()=>{
        index++; // skip initial bracket
        const arr = [];
        try {
            while(jsonString[index] !== "]"){
                arr.push(parseAny());
                skipBlank();
                if (jsonString[index] === ",") index++; // skip comma
            }
        } catch (e) {
            if ((parcelRequire("1tDCw")).Allow.ARR & allow) return arr;
            markPartialJSON("Expected ']' at end of array");
        }
        index++; // skip final bracket
        return arr;
    };
    const parseNum = ()=>{
        if (index === 0) {
            if (jsonString === "-") throwMalformedError("Not sure what '-' is");
            try {
                return JSON.parse(jsonString);
            } catch (e) {
                if ((parcelRequire("1tDCw")).Allow.NUM & allow) try {
                    return JSON.parse(jsonString.substring(0, jsonString.lastIndexOf("e")));
                } catch (e) {}
                throwMalformedError(String(e));
            }
        }
        const start = index;
        if (jsonString[index] === "-") index++;
        while(jsonString[index] && ",]}".indexOf(jsonString[index]) === -1)index++;
        if (index == length && !((parcelRequire("1tDCw")).Allow.NUM & allow)) markPartialJSON("Unterminated number literal");
        try {
            return JSON.parse(jsonString.substring(start, index));
        } catch (e) {
            if (jsonString.substring(start, index) === "-") markPartialJSON("Not sure what '-' is");
            try {
                return JSON.parse(jsonString.substring(start, jsonString.lastIndexOf("e")));
            } catch (e) {
                throwMalformedError(String(e));
            }
        }
    };
    const skipBlank = ()=>{
        while(index < length && " \n\r\t".includes(jsonString[index]))index++;
    };
    return parseAny();
};
const $7c895a27d7315d26$var$parse = $7c895a27d7315d26$var$parseJSON;
module.exports.parse = $7c895a27d7315d26$var$parse;

});
parcelRegister("1tDCw", function(module, exports) {
"use strict";
/**
 * Sometimes you don't allow every type to be partially parsed.
 * For example, you may not want a partial number because it may increase its size gradually before it's complete.
 * In this case, you can use the `Allow` object to control what types you allow to be partially parsed.
 * @module
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Allow = module.exports.ALL = module.exports.COLLECTION = module.exports.ATOM = module.exports.SPECIAL = module.exports.INF = module.exports._INFINITY = module.exports.INFINITY = module.exports.NAN = module.exports.BOOL = module.exports.NULL = module.exports.OBJ = module.exports.ARR = module.exports.NUM = module.exports.STR = void 0;
/**
 * allow partial strings like `"hello \u12` to be parsed as `"hello "`
 */ module.exports.STR = 1;
/**
 * allow partial numbers like `123.` to be parsed as `123`
 */ module.exports.NUM = 2;
/**
 * allow partial arrays like `[1, 2,` to be parsed as `[1, 2]`
 */ module.exports.ARR = 4;
/**
 * allow partial objects like `{"a": 1, "b":` to be parsed as `{"a": 1}`
 */ module.exports.OBJ = 8;
/**
 * allow `nu` to be parsed as `null`
 */ module.exports.NULL = 16;
/**
 * allow `tr` to be parsed as `true`, and `fa` to be parsed as `false`
 */ module.exports.BOOL = 32;
/**
 * allow `Na` to be parsed as `NaN`
 */ module.exports.NAN = 64;
/**
 * allow `Inf` to be parsed as `Infinity`
 */ module.exports.INFINITY = 128;
/**
 * allow `-Inf` to be parsed as `-Infinity`
 */ module.exports._INFINITY = 256;
module.exports.INF = module.exports.INFINITY | module.exports._INFINITY;
module.exports.SPECIAL = module.exports.NULL | module.exports.BOOL | module.exports.INF | module.exports.NAN;
module.exports.ATOM = module.exports.STR | module.exports.NUM | module.exports.SPECIAL;
module.exports.COLLECTION = module.exports.ARR | module.exports.OBJ;
module.exports.ALL = module.exports.ATOM | module.exports.COLLECTION;
/**
 * Control what types you allow to be partially parsed.
 * The default is to allow all types to be partially parsed, which in most casees is the best option.
 * @example
 * If you don't want to allow partial objects, you can use the following code:
 * ```ts
 * import { Allow, parse } from "partial-json";
 * parse(`[{"a": 1, "b": 2}, {"a": 3,`, Allow.ARR); // [ { a: 1, b: 2 } ]
 * ```
 * Or you can use `~` to disallow a type:
 * ```ts
 * parse(`[{"a": 1, "b": 2}, {"a": 3,`, ~Allow.OBJ); // [ { a: 1, b: 2 } ]
 * ```
 * @example
 * If you don't want to allow partial strings, you can use the following code:
 * ```ts
 * import { Allow, parse } from "partial-json";
 * parse(`["complete string", "incompl`, ~Allow.STR); // [ 'complete string' ]
 * ```
 */ module.exports.Allow = {
    STR: module.exports.STR,
    NUM: module.exports.NUM,
    ARR: module.exports.ARR,
    OBJ: module.exports.OBJ,
    NULL: module.exports.NULL,
    BOOL: module.exports.BOOL,
    NAN: module.exports.NAN,
    INFINITY: module.exports.INFINITY,
    _INFINITY: module.exports._INFINITY,
    INF: module.exports.INF,
    SPECIAL: module.exports.SPECIAL,
    ATOM: module.exports.ATOM,
    COLLECTION: module.exports.COLLECTION,
    ALL: module.exports.ALL
};
module.exports.default = module.exports.Allow;

});



parcelRegister("aOfhe", function(module, exports) {

$parcel$export(module.exports, "logConvoAIInfo", () => $ffa31632e87ec23b$export$7eba3e1ed428e5ae);
const $ffa31632e87ec23b$export$7eba3e1ed428e5ae = (message, config, data)=>{
    if (config.enableLocalVerboseLogs) // eslint-disable-next-line no-console
    console.info(`[@atlassian/convo-ai-streaming] [${message}]:`, data);
};

});




//# sourceMappingURL=QuickSummaryStreamingEntryPoint.17c36986.js.map
